
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec720"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec720"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cx8Kh", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $91ff59c6dbf7f798$export$ffb0004e005737fa; }, function (v) { return $91ff59c6dbf7f798$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $91ff59c6dbf7f798$export$34b9dba7ce09269b; }, function (v) { return $91ff59c6dbf7f798$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $91ff59c6dbf7f798$export$25062201e9e25d76; }, function (v) { return $91ff59c6dbf7f798$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $91ff59c6dbf7f798$export$ffb0004e005737fa;
var $91ff59c6dbf7f798$export$34b9dba7ce09269b;
var $91ff59c6dbf7f798$export$25062201e9e25d76;
"use strict";
var $91ff59c6dbf7f798$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $91ff59c6dbf7f798$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $91ff59c6dbf7f798$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $91ff59c6dbf7f798$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$91ff59c6dbf7f798$export$ffb0004e005737fa = $91ff59c6dbf7f798$var$REACT_FRAGMENT_TYPE;
$91ff59c6dbf7f798$export$34b9dba7ce09269b = $91ff59c6dbf7f798$var$jsxProd;
$91ff59c6dbf7f798$export$25062201e9e25d76 = $91ff59c6dbf7f798$var$jsxProd;

});

parcelRegister("ik80y", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $d5704e75ccc6e977$export$9c16c1426311996d; }, function (v) { return $d5704e75ccc6e977$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $d5704e75ccc6e977$export$dca3b0875bd9a954; }, function (v) { return $d5704e75ccc6e977$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d5704e75ccc6e977$export$16fa2f45be04daa8; }, function (v) { return $d5704e75ccc6e977$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d5704e75ccc6e977$export$ffb0004e005737fa; }, function (v) { return $d5704e75ccc6e977$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d5704e75ccc6e977$export$e2c29f18771995cb; }, function (v) { return $d5704e75ccc6e977$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d5704e75ccc6e977$export$221d75b3f55bb0bd; }, function (v) { return $d5704e75ccc6e977$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d5704e75ccc6e977$export$5f8d39834fd61797; }, function (v) { return $d5704e75ccc6e977$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d5704e75ccc6e977$export$74bf444e3cd11ea5; }, function (v) { return $d5704e75ccc6e977$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $d5704e75ccc6e977$export$1ced07cd6b1985ce; }, function (v) { return $d5704e75ccc6e977$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $d5704e75ccc6e977$export$abd8e32b826d7ea7; }, function (v) { return $d5704e75ccc6e977$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $d5704e75ccc6e977$export$69a3209f1a06c04d; }, function (v) { return $d5704e75ccc6e977$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $d5704e75ccc6e977$export$8c538325882c7eec; }, function (v) { return $d5704e75ccc6e977$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d5704e75ccc6e977$export$e530037191fcd5d7; }, function (v) { return $d5704e75ccc6e977$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d5704e75ccc6e977$export$fd42f52fd3ae1109; }, function (v) { return $d5704e75ccc6e977$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d5704e75ccc6e977$export$c8a8987d4410bf2d; }, function (v) { return $d5704e75ccc6e977$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $d5704e75ccc6e977$export$7d1e3a5e95ceca43; }, function (v) { return $d5704e75ccc6e977$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d5704e75ccc6e977$export$257a8862b851cb5b; }, function (v) { return $d5704e75ccc6e977$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d5704e75ccc6e977$export$a8257692ac88316c; }, function (v) { return $d5704e75ccc6e977$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d5704e75ccc6e977$export$488013bae63b21da; }, function (v) { return $d5704e75ccc6e977$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d5704e75ccc6e977$export$7c73462e0d25e514; }, function (v) { return $d5704e75ccc6e977$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $d5704e75ccc6e977$export$7568632d0d33d16d; }, function (v) { return $d5704e75ccc6e977$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $d5704e75ccc6e977$export$f93f40ac0ca7e3a8; }, function (v) { return $d5704e75ccc6e977$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $d5704e75ccc6e977$export$1f96ae73734a86cc; }, function (v) { return $d5704e75ccc6e977$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $d5704e75ccc6e977$export$9a47ced3238df325; }, function (v) { return $d5704e75ccc6e977$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d5704e75ccc6e977$export$35808ee640e87ca7; }, function (v) { return $d5704e75ccc6e977$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d5704e75ccc6e977$export$fae74005e78b1a27; }, function (v) { return $d5704e75ccc6e977$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d5704e75ccc6e977$export$dc8fbce3eb94dc1e; }, function (v) { return $d5704e75ccc6e977$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $d5704e75ccc6e977$export$6a7bc4e911dc01cf; }, function (v) { return $d5704e75ccc6e977$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $d5704e75ccc6e977$export$6d9c69b0de29b591; }, function (v) { return $d5704e75ccc6e977$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $d5704e75ccc6e977$export$7f54fc3180508a52; }, function (v) { return $d5704e75ccc6e977$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $d5704e75ccc6e977$export$f680877a34711e37; }, function (v) { return $d5704e75ccc6e977$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d5704e75ccc6e977$export$d5a552a76deda3c2; }, function (v) { return $d5704e75ccc6e977$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $d5704e75ccc6e977$export$aaabe4eda9ed9969; }, function (v) { return $d5704e75ccc6e977$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d5704e75ccc6e977$export$e5c5a5f917a5871c; }, function (v) { return $d5704e75ccc6e977$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d5704e75ccc6e977$export$1538c33de8887b59; }, function (v) { return $d5704e75ccc6e977$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $d5704e75ccc6e977$export$fca7f784ae7a249a; }, function (v) { return $d5704e75ccc6e977$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $d5704e75ccc6e977$export$13e3392192263954; }, function (v) { return $d5704e75ccc6e977$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d5704e75ccc6e977$export$b8f5890fc79d6aca; }, function (v) { return $d5704e75ccc6e977$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d5704e75ccc6e977$export$60241385465d0a34; }, function (v) { return $d5704e75ccc6e977$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $d5704e75ccc6e977$export$306c0aa65ff9ec16; }, function (v) { return $d5704e75ccc6e977$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $d5704e75ccc6e977$export$7b286972b8d8ccbf; }, function (v) { return $d5704e75ccc6e977$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $d5704e75ccc6e977$export$83d89fbfd8236492; }, function (v) { return $d5704e75ccc6e977$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d5704e75ccc6e977$export$9c16c1426311996d;
var $d5704e75ccc6e977$export$dca3b0875bd9a954;
var $d5704e75ccc6e977$export$16fa2f45be04daa8;
var $d5704e75ccc6e977$export$ffb0004e005737fa;
var $d5704e75ccc6e977$export$e2c29f18771995cb;
var $d5704e75ccc6e977$export$221d75b3f55bb0bd;
var $d5704e75ccc6e977$export$5f8d39834fd61797;
var $d5704e75ccc6e977$export$74bf444e3cd11ea5;
var $d5704e75ccc6e977$export$1ced07cd6b1985ce;
var $d5704e75ccc6e977$export$abd8e32b826d7ea7;
var $d5704e75ccc6e977$export$69a3209f1a06c04d;
var $d5704e75ccc6e977$export$8c538325882c7eec;
var $d5704e75ccc6e977$export$e530037191fcd5d7;
var $d5704e75ccc6e977$export$fd42f52fd3ae1109;
var $d5704e75ccc6e977$export$c8a8987d4410bf2d;
var $d5704e75ccc6e977$export$7d1e3a5e95ceca43;
var $d5704e75ccc6e977$export$257a8862b851cb5b;
var $d5704e75ccc6e977$export$a8257692ac88316c;
var $d5704e75ccc6e977$export$488013bae63b21da;
var $d5704e75ccc6e977$export$7c73462e0d25e514;
var $d5704e75ccc6e977$export$7568632d0d33d16d;
var $d5704e75ccc6e977$export$f93f40ac0ca7e3a8;
var $d5704e75ccc6e977$export$1f96ae73734a86cc;
var $d5704e75ccc6e977$export$9a47ced3238df325;
var $d5704e75ccc6e977$export$35808ee640e87ca7;
var $d5704e75ccc6e977$export$fae74005e78b1a27;
var $d5704e75ccc6e977$export$dc8fbce3eb94dc1e;
var $d5704e75ccc6e977$export$6a7bc4e911dc01cf;
var $d5704e75ccc6e977$export$6d9c69b0de29b591;
var $d5704e75ccc6e977$export$7f54fc3180508a52;
var $d5704e75ccc6e977$export$f680877a34711e37;
var $d5704e75ccc6e977$export$d5a552a76deda3c2;
var $d5704e75ccc6e977$export$aaabe4eda9ed9969;
var $d5704e75ccc6e977$export$e5c5a5f917a5871c;
var $d5704e75ccc6e977$export$1538c33de8887b59;
var $d5704e75ccc6e977$export$fca7f784ae7a249a;
var $d5704e75ccc6e977$export$13e3392192263954;
var $d5704e75ccc6e977$export$b8f5890fc79d6aca;
var $d5704e75ccc6e977$export$60241385465d0a34;
var $d5704e75ccc6e977$export$306c0aa65ff9ec16;
var $d5704e75ccc6e977$export$7b286972b8d8ccbf;
var $d5704e75ccc6e977$export$83d89fbfd8236492;
"use strict";
var $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d5704e75ccc6e977$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d5704e75ccc6e977$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d5704e75ccc6e977$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d5704e75ccc6e977$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d5704e75ccc6e977$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d5704e75ccc6e977$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d5704e75ccc6e977$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d5704e75ccc6e977$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d5704e75ccc6e977$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d5704e75ccc6e977$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $d5704e75ccc6e977$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $d5704e75ccc6e977$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d5704e75ccc6e977$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d5704e75ccc6e977$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d5704e75ccc6e977$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d5704e75ccc6e977$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $d5704e75ccc6e977$var$assign = Object.assign, $d5704e75ccc6e977$var$emptyObject = {};
function $d5704e75ccc6e977$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $d5704e75ccc6e977$var$emptyObject;
    this.updater = updater || $d5704e75ccc6e977$var$ReactNoopUpdateQueue;
}
$d5704e75ccc6e977$var$Component.prototype.isReactComponent = {};
$d5704e75ccc6e977$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$d5704e75ccc6e977$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $d5704e75ccc6e977$var$ComponentDummy() {}
$d5704e75ccc6e977$var$ComponentDummy.prototype = $d5704e75ccc6e977$var$Component.prototype;
function $d5704e75ccc6e977$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $d5704e75ccc6e977$var$emptyObject;
    this.updater = updater || $d5704e75ccc6e977$var$ReactNoopUpdateQueue;
}
var $d5704e75ccc6e977$var$pureComponentPrototype = $d5704e75ccc6e977$var$PureComponent.prototype = new $d5704e75ccc6e977$var$ComponentDummy();
$d5704e75ccc6e977$var$pureComponentPrototype.constructor = $d5704e75ccc6e977$var$PureComponent;
$d5704e75ccc6e977$var$assign($d5704e75ccc6e977$var$pureComponentPrototype, $d5704e75ccc6e977$var$Component.prototype);
$d5704e75ccc6e977$var$pureComponentPrototype.isPureReactComponent = !0;
var $d5704e75ccc6e977$var$isArrayImpl = Array.isArray;
function $d5704e75ccc6e977$var$noop() {}
var $d5704e75ccc6e977$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $d5704e75ccc6e977$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $d5704e75ccc6e977$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $d5704e75ccc6e977$var$cloneAndReplaceKey(oldElement, newKey) {
    return $d5704e75ccc6e977$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $d5704e75ccc6e977$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE;
}
function $d5704e75ccc6e977$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $d5704e75ccc6e977$var$userProvidedKeyEscapeRegex = /\/+/g;
function $d5704e75ccc6e977$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $d5704e75ccc6e977$var$escape("" + element.key) : index.toString(36);
}
function $d5704e75ccc6e977$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($d5704e75ccc6e977$var$noop, $d5704e75ccc6e977$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $d5704e75ccc6e977$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $d5704e75ccc6e977$var$REACT_ELEMENT_TYPE:
                case $d5704e75ccc6e977$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $d5704e75ccc6e977$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $d5704e75ccc6e977$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $d5704e75ccc6e977$var$getElementKey(children, 0) : nameSoFar, $d5704e75ccc6e977$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($d5704e75ccc6e977$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $d5704e75ccc6e977$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($d5704e75ccc6e977$var$isValidElement(callback) && (callback = $d5704e75ccc6e977$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($d5704e75ccc6e977$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($d5704e75ccc6e977$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $d5704e75ccc6e977$var$getElementKey(nameSoFar, i), invokeCallback += $d5704e75ccc6e977$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $d5704e75ccc6e977$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $d5704e75ccc6e977$var$getElementKey(nameSoFar, i++), invokeCallback += $d5704e75ccc6e977$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $d5704e75ccc6e977$var$mapIntoArray($d5704e75ccc6e977$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $d5704e75ccc6e977$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $d5704e75ccc6e977$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $d5704e75ccc6e977$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $d5704e75ccc6e977$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $d5704e75ccc6e977$var$Children = {
    map: $d5704e75ccc6e977$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $d5704e75ccc6e977$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $d5704e75ccc6e977$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $d5704e75ccc6e977$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$d5704e75ccc6e977$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$d5704e75ccc6e977$export$9c16c1426311996d = $d5704e75ccc6e977$var$REACT_ACTIVITY_TYPE;
$d5704e75ccc6e977$export$dca3b0875bd9a954 = $d5704e75ccc6e977$var$Children;
$d5704e75ccc6e977$export$16fa2f45be04daa8 = $d5704e75ccc6e977$var$Component;
$d5704e75ccc6e977$export$ffb0004e005737fa = $d5704e75ccc6e977$var$REACT_FRAGMENT_TYPE;
$d5704e75ccc6e977$export$e2c29f18771995cb = $d5704e75ccc6e977$var$REACT_PROFILER_TYPE;
$d5704e75ccc6e977$export$221d75b3f55bb0bd = $d5704e75ccc6e977$var$PureComponent;
$d5704e75ccc6e977$export$5f8d39834fd61797 = $d5704e75ccc6e977$var$REACT_STRICT_MODE_TYPE;
$d5704e75ccc6e977$export$74bf444e3cd11ea5 = $d5704e75ccc6e977$var$REACT_SUSPENSE_TYPE;
$d5704e75ccc6e977$export$1ced07cd6b1985ce = $d5704e75ccc6e977$var$ReactSharedInternals;
$d5704e75ccc6e977$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $d5704e75ccc6e977$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$d5704e75ccc6e977$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$d5704e75ccc6e977$export$8c538325882c7eec = function() {
    return null;
};
$d5704e75ccc6e977$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $d5704e75ccc6e977$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$d5704e75ccc6e977$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $d5704e75ccc6e977$var$ReactElement(element.type, key, props);
};
$d5704e75ccc6e977$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $d5704e75ccc6e977$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $d5704e75ccc6e977$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$d5704e75ccc6e977$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$d5704e75ccc6e977$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $d5704e75ccc6e977$var$ReactElement(type, key, props);
};
$d5704e75ccc6e977$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d5704e75ccc6e977$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$d5704e75ccc6e977$export$a8257692ac88316c = $d5704e75ccc6e977$var$isValidElement;
$d5704e75ccc6e977$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $d5704e75ccc6e977$var$lazyInitializer
    };
};
$d5704e75ccc6e977$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $d5704e75ccc6e977$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$d5704e75ccc6e977$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $d5704e75ccc6e977$var$ReactSharedInternals.T, currentTransition = {};
    $d5704e75ccc6e977$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $d5704e75ccc6e977$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($d5704e75ccc6e977$var$noop, $d5704e75ccc6e977$var$reportGlobalError);
    } catch (error) {
        $d5704e75ccc6e977$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d5704e75ccc6e977$var$ReactSharedInternals.T = prevTransition;
    }
};
$d5704e75ccc6e977$export$f93f40ac0ca7e3a8 = function() {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useCacheRefresh();
};
$d5704e75ccc6e977$export$1f96ae73734a86cc = function(usable) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.use(usable);
};
$d5704e75ccc6e977$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$d5704e75ccc6e977$export$35808ee640e87ca7 = function(callback, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$d5704e75ccc6e977$export$fae74005e78b1a27 = function(Context) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useContext(Context);
};
$d5704e75ccc6e977$export$dc8fbce3eb94dc1e = function() {};
$d5704e75ccc6e977$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$d5704e75ccc6e977$export$6d9c69b0de29b591 = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useEffect(create, deps);
};
$d5704e75ccc6e977$export$7f54fc3180508a52 = function(callback) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$d5704e75ccc6e977$export$f680877a34711e37 = function() {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useId();
};
$d5704e75ccc6e977$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$d5704e75ccc6e977$export$aaabe4eda9ed9969 = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$d5704e75ccc6e977$export$e5c5a5f917a5871c = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$d5704e75ccc6e977$export$1538c33de8887b59 = function(create, deps) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useMemo(create, deps);
};
$d5704e75ccc6e977$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$d5704e75ccc6e977$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$d5704e75ccc6e977$export$b8f5890fc79d6aca = function(initialValue) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useRef(initialValue);
};
$d5704e75ccc6e977$export$60241385465d0a34 = function(initialState) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useState(initialState);
};
$d5704e75ccc6e977$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$d5704e75ccc6e977$export$7b286972b8d8ccbf = function() {
    return $d5704e75ccc6e977$var$ReactSharedInternals.H.useTransition();
};
$d5704e75ccc6e977$export$83d89fbfd8236492 = "19.2.3";

});

parcelRegister("a8X8z", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $76288626b30e899c$export$882461b6382ed46c; }, function (v) { return $76288626b30e899c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $76288626b30e899c$export$757ceba2d55c277e; }, function (v) { return $76288626b30e899c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $76288626b30e899c$export$83d89fbfd8236492; }, function (v) { return $76288626b30e899c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $76288626b30e899c$export$882461b6382ed46c;
var $76288626b30e899c$export$757ceba2d55c277e;
var $76288626b30e899c$export$83d89fbfd8236492;
"use strict";

var $33s19 = parcelRequire("33s19");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $76288626b30e899c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $76288626b30e899c$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $76288626b30e899c$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $76288626b30e899c$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $76288626b30e899c$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $76288626b30e899c$var$assertIsMounted(fiber) {
    if ($76288626b30e899c$var$getNearestMountedFiber(fiber) !== fiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
}
function $76288626b30e899c$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $76288626b30e899c$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $76288626b30e899c$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $76288626b30e899c$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($76288626b30e899c$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($76288626b30e899c$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $76288626b30e899c$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $76288626b30e899c$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $76288626b30e899c$var$assign = Object.assign, $76288626b30e899c$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $76288626b30e899c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $76288626b30e899c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $76288626b30e899c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $76288626b30e899c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $76288626b30e899c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $76288626b30e899c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $76288626b30e899c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $76288626b30e899c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $76288626b30e899c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $76288626b30e899c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $76288626b30e899c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $76288626b30e899c$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $76288626b30e899c$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $76288626b30e899c$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $76288626b30e899c$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $76288626b30e899c$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$76288626b30e899c$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $76288626b30e899c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $76288626b30e899c$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $76288626b30e899c$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $76288626b30e899c$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $76288626b30e899c$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $76288626b30e899c$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $76288626b30e899c$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $76288626b30e899c$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $76288626b30e899c$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $76288626b30e899c$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $76288626b30e899c$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $76288626b30e899c$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $76288626b30e899c$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $76288626b30e899c$var$getComponentNameFromType(type.type) || "Memo";
        case $76288626b30e899c$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $76288626b30e899c$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $76288626b30e899c$var$isArrayImpl = Array.isArray, $76288626b30e899c$var$ReactSharedInternals = $7fPBF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $76288626b30e899c$var$ReactDOMSharedInternals = $fw0lo.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $76288626b30e899c$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $76288626b30e899c$var$valueStack = [], $76288626b30e899c$var$index = -1;
function $76288626b30e899c$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $76288626b30e899c$var$pop(cursor) {
    0 > $76288626b30e899c$var$index || (cursor.current = $76288626b30e899c$var$valueStack[$76288626b30e899c$var$index], $76288626b30e899c$var$valueStack[$76288626b30e899c$var$index] = null, $76288626b30e899c$var$index--);
}
function $76288626b30e899c$var$push(cursor, value) {
    $76288626b30e899c$var$index++;
    $76288626b30e899c$var$valueStack[$76288626b30e899c$var$index] = cursor.current;
    cursor.current = value;
}
var $76288626b30e899c$var$contextStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$contextFiberStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$rootInstanceStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$hostTransitionProviderCursor = $76288626b30e899c$var$createCursor(null);
function $76288626b30e899c$var$pushHostContainer(fiber, nextRootInstance) {
    $76288626b30e899c$var$push($76288626b30e899c$var$rootInstanceStackCursor, nextRootInstance);
    $76288626b30e899c$var$push($76288626b30e899c$var$contextFiberStackCursor, fiber);
    $76288626b30e899c$var$push($76288626b30e899c$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $76288626b30e899c$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $76288626b30e899c$var$getOwnHostContext(nextRootInstance), fiber = $76288626b30e899c$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $76288626b30e899c$var$pop($76288626b30e899c$var$contextStackCursor);
    $76288626b30e899c$var$push($76288626b30e899c$var$contextStackCursor, fiber);
}
function $76288626b30e899c$var$popHostContainer() {
    $76288626b30e899c$var$pop($76288626b30e899c$var$contextStackCursor);
    $76288626b30e899c$var$pop($76288626b30e899c$var$contextFiberStackCursor);
    $76288626b30e899c$var$pop($76288626b30e899c$var$rootInstanceStackCursor);
}
function $76288626b30e899c$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $76288626b30e899c$var$push($76288626b30e899c$var$hostTransitionProviderCursor, fiber);
    var context = $76288626b30e899c$var$contextStackCursor.current;
    var JSCompiler_inline_result = $76288626b30e899c$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($76288626b30e899c$var$push($76288626b30e899c$var$contextFiberStackCursor, fiber), $76288626b30e899c$var$push($76288626b30e899c$var$contextStackCursor, JSCompiler_inline_result));
}
function $76288626b30e899c$var$popHostContext(fiber) {
    $76288626b30e899c$var$contextFiberStackCursor.current === fiber && ($76288626b30e899c$var$pop($76288626b30e899c$var$contextStackCursor), $76288626b30e899c$var$pop($76288626b30e899c$var$contextFiberStackCursor));
    $76288626b30e899c$var$hostTransitionProviderCursor.current === fiber && ($76288626b30e899c$var$pop($76288626b30e899c$var$hostTransitionProviderCursor), $76288626b30e899c$var$HostTransitionContext._currentValue = $76288626b30e899c$var$sharedNotPendingObject);
}
var $76288626b30e899c$var$prefix, $76288626b30e899c$var$suffix;
function $76288626b30e899c$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $76288626b30e899c$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $76288626b30e899c$var$prefix = match && match[1] || "";
        $76288626b30e899c$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $76288626b30e899c$var$prefix + name + $76288626b30e899c$var$suffix;
}
var $76288626b30e899c$var$reentry = !1;
function $76288626b30e899c$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $76288626b30e899c$var$reentry) return "";
    $76288626b30e899c$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $76288626b30e899c$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $76288626b30e899c$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $76288626b30e899c$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $76288626b30e899c$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $76288626b30e899c$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $76288626b30e899c$var$describeBuiltInComponentFrame("Suspense Fallback") : $76288626b30e899c$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $76288626b30e899c$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $76288626b30e899c$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $76288626b30e899c$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $76288626b30e899c$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $76288626b30e899c$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $76288626b30e899c$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $76288626b30e899c$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $76288626b30e899c$var$hasOwnProperty = Object.prototype.hasOwnProperty, $76288626b30e899c$var$scheduleCallback$3 = $33s19.unstable_scheduleCallback, $76288626b30e899c$var$cancelCallback$1 = $33s19.unstable_cancelCallback, $76288626b30e899c$var$shouldYield = $33s19.unstable_shouldYield, $76288626b30e899c$var$requestPaint = $33s19.unstable_requestPaint, $76288626b30e899c$var$now = $33s19.unstable_now, $76288626b30e899c$var$getCurrentPriorityLevel = $33s19.unstable_getCurrentPriorityLevel, $76288626b30e899c$var$ImmediatePriority = $33s19.unstable_ImmediatePriority, $76288626b30e899c$var$UserBlockingPriority = $33s19.unstable_UserBlockingPriority, $76288626b30e899c$var$NormalPriority$1 = $33s19.unstable_NormalPriority, $76288626b30e899c$var$LowPriority = $33s19.unstable_LowPriority, $76288626b30e899c$var$IdlePriority = $33s19.unstable_IdlePriority, $76288626b30e899c$var$log$1 = $33s19.log, $76288626b30e899c$var$unstable_setDisableYieldValue = $33s19.unstable_setDisableYieldValue, $76288626b30e899c$var$rendererID = null, $76288626b30e899c$var$injectedHook = null;
function $76288626b30e899c$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $76288626b30e899c$var$log$1 && $76288626b30e899c$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.setStrictMode) try {
        $76288626b30e899c$var$injectedHook.setStrictMode($76288626b30e899c$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $76288626b30e899c$var$clz32 = Math.clz32 ? Math.clz32 : $76288626b30e899c$var$clz32Fallback, $76288626b30e899c$var$log = Math.log, $76288626b30e899c$var$LN2 = Math.LN2;
function $76288626b30e899c$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($76288626b30e899c$var$log(x) / $76288626b30e899c$var$LN2 | 0) | 0;
}
var $76288626b30e899c$var$nextTransitionUpdateLane = 256, $76288626b30e899c$var$nextTransitionDeferredLane = 262144, $76288626b30e899c$var$nextRetryLane = 4194304;
function $76288626b30e899c$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $76288626b30e899c$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $76288626b30e899c$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $76288626b30e899c$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $76288626b30e899c$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $76288626b30e899c$var$claimNextRetryLane() {
    var lane = $76288626b30e899c$var$nextRetryLane;
    $76288626b30e899c$var$nextRetryLane <<= 1;
    0 === ($76288626b30e899c$var$nextRetryLane & 62914560) && ($76288626b30e899c$var$nextRetryLane = 4194304);
    return lane;
}
function $76288626b30e899c$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $76288626b30e899c$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $76288626b30e899c$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $76288626b30e899c$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $76288626b30e899c$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $76288626b30e899c$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $76288626b30e899c$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $76288626b30e899c$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $76288626b30e899c$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $76288626b30e899c$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $76288626b30e899c$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $76288626b30e899c$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $76288626b30e899c$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $76288626b30e899c$var$resolveUpdatePriority() {
    var updatePriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $76288626b30e899c$var$getEventPriority(updatePriority.type);
}
function $76288626b30e899c$var$runWithPriority(priority, fn) {
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        return $76288626b30e899c$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $76288626b30e899c$var$randomKey = Math.random().toString(36).slice(2), $76288626b30e899c$var$internalInstanceKey = "__reactFiber$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalPropsKey = "__reactProps$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalContainerInstanceKey = "__reactContainer$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalEventHandlersKey = "__reactEvents$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalEventHandlerListenersKey = "__reactListeners$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalEventHandlesSetKey = "__reactHandles$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalRootNodeResourcesKey = "__reactResources$" + $76288626b30e899c$var$randomKey, $76288626b30e899c$var$internalHoistableMarker = "__reactMarker$" + $76288626b30e899c$var$randomKey;
function $76288626b30e899c$var$detachDeletedInstance(node) {
    delete node[$76288626b30e899c$var$internalInstanceKey];
    delete node[$76288626b30e899c$var$internalPropsKey];
    delete node[$76288626b30e899c$var$internalEventHandlersKey];
    delete node[$76288626b30e899c$var$internalEventHandlerListenersKey];
    delete node[$76288626b30e899c$var$internalEventHandlesSetKey];
}
function $76288626b30e899c$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$76288626b30e899c$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$76288626b30e899c$var$internalContainerInstanceKey] || parentNode[$76288626b30e899c$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $76288626b30e899c$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$76288626b30e899c$var$internalInstanceKey]) return parentNode;
                targetNode = $76288626b30e899c$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $76288626b30e899c$var$getInstanceFromNode(node) {
    if (node = node[$76288626b30e899c$var$internalInstanceKey] || node[$76288626b30e899c$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $76288626b30e899c$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($76288626b30e899c$var$formatProdErrorMessage(33));
}
function $76288626b30e899c$var$getResourcesFromRoot(root) {
    var resources = root[$76288626b30e899c$var$internalRootNodeResourcesKey];
    resources || (resources = root[$76288626b30e899c$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $76288626b30e899c$var$markNodeAsHoistable(node) {
    node[$76288626b30e899c$var$internalHoistableMarker] = !0;
}
var $76288626b30e899c$var$allNativeEvents = new Set(), $76288626b30e899c$var$registrationNameDependencies = {};
function $76288626b30e899c$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $76288626b30e899c$var$registerDirectEvent(registrationName, dependencies);
    $76288626b30e899c$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $76288626b30e899c$var$registerDirectEvent(registrationName, dependencies) {
    $76288626b30e899c$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$76288626b30e899c$var$allNativeEvents.add(dependencies[registrationName]);
}
var $76288626b30e899c$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $76288626b30e899c$var$illegalAttributeNameCache = {}, $76288626b30e899c$var$validatedAttributeNameCache = {};
function $76288626b30e899c$var$isAttributeNameSafe(attributeName) {
    if ($76288626b30e899c$var$hasOwnProperty.call($76288626b30e899c$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($76288626b30e899c$var$hasOwnProperty.call($76288626b30e899c$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($76288626b30e899c$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $76288626b30e899c$var$validatedAttributeNameCache[attributeName] = !0;
    $76288626b30e899c$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $76288626b30e899c$var$setValueForAttribute(node, name, value) {
    if ($76288626b30e899c$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $76288626b30e899c$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $76288626b30e899c$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $76288626b30e899c$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $76288626b30e899c$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $76288626b30e899c$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $76288626b30e899c$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $76288626b30e899c$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $76288626b30e899c$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $76288626b30e899c$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $76288626b30e899c$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $76288626b30e899c$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $76288626b30e899c$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $76288626b30e899c$var$getToStringValue(value);
        } else element.value !== "" + $76288626b30e899c$var$getToStringValue(value) && (element.value = "" + $76288626b30e899c$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $76288626b30e899c$var$setDefaultValue(element, type, $76288626b30e899c$var$getToStringValue(value)) : null != defaultValue ? $76288626b30e899c$var$setDefaultValue(element, type, $76288626b30e899c$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $76288626b30e899c$var$getToStringValue(name) : element.removeAttribute("name");
}
function $76288626b30e899c$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $76288626b30e899c$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $76288626b30e899c$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $76288626b30e899c$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $76288626b30e899c$var$track(element);
}
function $76288626b30e899c$var$setDefaultValue(node, type, value) {
    "number" === type && $76288626b30e899c$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $76288626b30e899c$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $76288626b30e899c$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $76288626b30e899c$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $76288626b30e899c$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $76288626b30e899c$var$getToStringValue(defaultValue) : "";
}
function $76288626b30e899c$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($76288626b30e899c$var$formatProdErrorMessage(92));
            if ($76288626b30e899c$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($76288626b30e899c$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $76288626b30e899c$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $76288626b30e899c$var$track(element);
}
function $76288626b30e899c$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $76288626b30e899c$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $76288626b30e899c$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $76288626b30e899c$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $76288626b30e899c$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($76288626b30e899c$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $76288626b30e899c$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $76288626b30e899c$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $76288626b30e899c$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $76288626b30e899c$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $76288626b30e899c$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $76288626b30e899c$var$sanitizeURL(url) {
    return $76288626b30e899c$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $76288626b30e899c$var$noop$1() {}
var $76288626b30e899c$var$currentReplayingEvent = null;
function $76288626b30e899c$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $76288626b30e899c$var$restoreTarget = null, $76288626b30e899c$var$restoreQueue = null;
function $76288626b30e899c$var$restoreStateOfTarget(target) {
    var internalInstance = $76288626b30e899c$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$76288626b30e899c$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $76288626b30e899c$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$76288626b30e899c$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($76288626b30e899c$var$formatProdErrorMessage(90));
                            $76288626b30e899c$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $76288626b30e899c$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $76288626b30e899c$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $76288626b30e899c$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $76288626b30e899c$var$isInsideEventHandler = !1;
function $76288626b30e899c$var$batchedUpdates$1(fn, a, b) {
    if ($76288626b30e899c$var$isInsideEventHandler) return fn(a, b);
    $76288626b30e899c$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($76288626b30e899c$var$isInsideEventHandler = !1, null !== $76288626b30e899c$var$restoreTarget || null !== $76288626b30e899c$var$restoreQueue) {
            if ($76288626b30e899c$var$flushSyncWork$1(), $76288626b30e899c$var$restoreTarget && (a = $76288626b30e899c$var$restoreTarget, fn = $76288626b30e899c$var$restoreQueue, $76288626b30e899c$var$restoreQueue = $76288626b30e899c$var$restoreTarget = null, $76288626b30e899c$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$76288626b30e899c$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $76288626b30e899c$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$76288626b30e899c$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $76288626b30e899c$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $76288626b30e899c$var$passiveBrowserEventsSupported = !1;
if ($76288626b30e899c$var$canUseDOM) try {
    var $76288626b30e899c$var$options = {};
    Object.defineProperty($76288626b30e899c$var$options, "passive", {
        get: function() {
            $76288626b30e899c$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $76288626b30e899c$var$options, $76288626b30e899c$var$options);
    window.removeEventListener("test", $76288626b30e899c$var$options, $76288626b30e899c$var$options);
} catch (e) {
    $76288626b30e899c$var$passiveBrowserEventsSupported = !1;
}
var $76288626b30e899c$var$root = null, $76288626b30e899c$var$startText = null, $76288626b30e899c$var$fallbackText = null;
function $76288626b30e899c$var$getData() {
    if ($76288626b30e899c$var$fallbackText) return $76288626b30e899c$var$fallbackText;
    var start, startValue = $76288626b30e899c$var$startText, startLength = startValue.length, end, endValue = "value" in $76288626b30e899c$var$root ? $76288626b30e899c$var$root.value : $76288626b30e899c$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $76288626b30e899c$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $76288626b30e899c$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $76288626b30e899c$var$functionThatReturnsTrue() {
    return !0;
}
function $76288626b30e899c$var$functionThatReturnsFalse() {
    return !1;
}
function $76288626b30e899c$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $76288626b30e899c$var$functionThatReturnsTrue : $76288626b30e899c$var$functionThatReturnsFalse;
        this.isPropagationStopped = $76288626b30e899c$var$functionThatReturnsFalse;
        return this;
    }
    $76288626b30e899c$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $76288626b30e899c$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $76288626b30e899c$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $76288626b30e899c$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $76288626b30e899c$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $76288626b30e899c$var$SyntheticEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$EventInterface), $76288626b30e899c$var$UIEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    view: 0,
    detail: 0
}), $76288626b30e899c$var$SyntheticUIEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$UIEventInterface), $76288626b30e899c$var$lastMovementX, $76288626b30e899c$var$lastMovementY, $76288626b30e899c$var$lastMouseEvent, $76288626b30e899c$var$MouseEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $76288626b30e899c$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $76288626b30e899c$var$lastMouseEvent && ($76288626b30e899c$var$lastMouseEvent && "mousemove" === event.type ? ($76288626b30e899c$var$lastMovementX = event.screenX - $76288626b30e899c$var$lastMouseEvent.screenX, $76288626b30e899c$var$lastMovementY = event.screenY - $76288626b30e899c$var$lastMouseEvent.screenY) : $76288626b30e899c$var$lastMovementY = $76288626b30e899c$var$lastMovementX = 0, $76288626b30e899c$var$lastMouseEvent = event);
        return $76288626b30e899c$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $76288626b30e899c$var$lastMovementY;
    }
}), $76288626b30e899c$var$SyntheticMouseEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$MouseEventInterface), $76288626b30e899c$var$DragEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$MouseEventInterface, {
    dataTransfer: 0
}), $76288626b30e899c$var$SyntheticDragEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$DragEventInterface), $76288626b30e899c$var$FocusEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    relatedTarget: 0
}), $76288626b30e899c$var$SyntheticFocusEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$FocusEventInterface), $76288626b30e899c$var$AnimationEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $76288626b30e899c$var$SyntheticAnimationEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$AnimationEventInterface), $76288626b30e899c$var$ClipboardEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $76288626b30e899c$var$SyntheticClipboardEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$ClipboardEventInterface), $76288626b30e899c$var$CompositionEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    data: 0
}), $76288626b30e899c$var$SyntheticCompositionEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$CompositionEventInterface), $76288626b30e899c$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $76288626b30e899c$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $76288626b30e899c$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $76288626b30e899c$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $76288626b30e899c$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $76288626b30e899c$var$getEventModifierState() {
    return $76288626b30e899c$var$modifierStateGetter;
}
var $76288626b30e899c$var$KeyboardEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $76288626b30e899c$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $76288626b30e899c$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $76288626b30e899c$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $76288626b30e899c$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $76288626b30e899c$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $76288626b30e899c$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $76288626b30e899c$var$SyntheticKeyboardEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$KeyboardEventInterface), $76288626b30e899c$var$PointerEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $76288626b30e899c$var$SyntheticPointerEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$PointerEventInterface), $76288626b30e899c$var$TouchEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $76288626b30e899c$var$getEventModifierState
}), $76288626b30e899c$var$SyntheticTouchEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$TouchEventInterface), $76288626b30e899c$var$TransitionEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $76288626b30e899c$var$SyntheticTransitionEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$TransitionEventInterface), $76288626b30e899c$var$WheelEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $76288626b30e899c$var$SyntheticWheelEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$WheelEventInterface), $76288626b30e899c$var$ToggleEventInterface = $76288626b30e899c$var$assign({}, $76288626b30e899c$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $76288626b30e899c$var$SyntheticToggleEvent = $76288626b30e899c$var$createSyntheticEvent($76288626b30e899c$var$ToggleEventInterface), $76288626b30e899c$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $76288626b30e899c$var$canUseCompositionEvent = $76288626b30e899c$var$canUseDOM && "CompositionEvent" in window, $76288626b30e899c$var$documentMode = null;
$76288626b30e899c$var$canUseDOM && "documentMode" in document && ($76288626b30e899c$var$documentMode = document.documentMode);
var $76288626b30e899c$var$canUseTextInputEvent = $76288626b30e899c$var$canUseDOM && "TextEvent" in window && !$76288626b30e899c$var$documentMode, $76288626b30e899c$var$useFallbackCompositionData = $76288626b30e899c$var$canUseDOM && (!$76288626b30e899c$var$canUseCompositionEvent || $76288626b30e899c$var$documentMode && 8 < $76288626b30e899c$var$documentMode && 11 >= $76288626b30e899c$var$documentMode), $76288626b30e899c$var$SPACEBAR_CHAR = String.fromCharCode(32), $76288626b30e899c$var$hasSpaceKeypress = !1;
function $76288626b30e899c$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $76288626b30e899c$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $76288626b30e899c$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $76288626b30e899c$var$isComposing = !1;
function $76288626b30e899c$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $76288626b30e899c$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $76288626b30e899c$var$hasSpaceKeypress = !0;
            return $76288626b30e899c$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $76288626b30e899c$var$SPACEBAR_CHAR && $76288626b30e899c$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $76288626b30e899c$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($76288626b30e899c$var$isComposing) return "compositionend" === domEventName || !$76288626b30e899c$var$canUseCompositionEvent && $76288626b30e899c$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $76288626b30e899c$var$getData(), $76288626b30e899c$var$fallbackText = $76288626b30e899c$var$startText = $76288626b30e899c$var$root = null, $76288626b30e899c$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $76288626b30e899c$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $76288626b30e899c$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $76288626b30e899c$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$76288626b30e899c$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $76288626b30e899c$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $76288626b30e899c$var$restoreTarget ? $76288626b30e899c$var$restoreQueue ? $76288626b30e899c$var$restoreQueue.push(target) : $76288626b30e899c$var$restoreQueue = [
        target
    ] : $76288626b30e899c$var$restoreTarget = target;
    inst = $76288626b30e899c$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $76288626b30e899c$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $76288626b30e899c$var$activeElement$1 = null, $76288626b30e899c$var$activeElementInst$1 = null;
function $76288626b30e899c$var$runEventInBatch(dispatchQueue) {
    $76288626b30e899c$var$processDispatchQueue(dispatchQueue, 0);
}
function $76288626b30e899c$var$getInstIfValueChanged(targetInst) {
    var targetNode = $76288626b30e899c$var$getNodeFromInstance(targetInst);
    if ($76288626b30e899c$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $76288626b30e899c$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $76288626b30e899c$var$isInputEventSupported = !1;
if ($76288626b30e899c$var$canUseDOM) {
    var $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286;
    if ($76288626b30e899c$var$canUseDOM) {
        var $76288626b30e899c$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$76288626b30e899c$var$isSupported$jscomp$inline_427) {
            var $76288626b30e899c$var$element$jscomp$inline_428 = document.createElement("div");
            $76288626b30e899c$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $76288626b30e899c$var$isSupported$jscomp$inline_427 = "function" === typeof $76288626b30e899c$var$element$jscomp$inline_428.oninput;
        }
        $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286 = $76288626b30e899c$var$isSupported$jscomp$inline_427;
    } else $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286 = !1;
    $76288626b30e899c$var$isInputEventSupported = $76288626b30e899c$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $76288626b30e899c$var$stopWatchingForValueChange() {
    $76288626b30e899c$var$activeElement$1 && ($76288626b30e899c$var$activeElement$1.detachEvent("onpropertychange", $76288626b30e899c$var$handlePropertyChange), $76288626b30e899c$var$activeElementInst$1 = $76288626b30e899c$var$activeElement$1 = null);
}
function $76288626b30e899c$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $76288626b30e899c$var$getInstIfValueChanged($76288626b30e899c$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $76288626b30e899c$var$createAndAccumulateChangeEvent(dispatchQueue, $76288626b30e899c$var$activeElementInst$1, nativeEvent, $76288626b30e899c$var$getEventTarget(nativeEvent));
        $76288626b30e899c$var$batchedUpdates$1($76288626b30e899c$var$runEventInBatch, dispatchQueue);
    }
}
function $76288626b30e899c$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($76288626b30e899c$var$stopWatchingForValueChange(), $76288626b30e899c$var$activeElement$1 = target, $76288626b30e899c$var$activeElementInst$1 = targetInst, $76288626b30e899c$var$activeElement$1.attachEvent("onpropertychange", $76288626b30e899c$var$handlePropertyChange)) : "focusout" === domEventName && $76288626b30e899c$var$stopWatchingForValueChange();
}
function $76288626b30e899c$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $76288626b30e899c$var$getInstIfValueChanged($76288626b30e899c$var$activeElementInst$1);
}
function $76288626b30e899c$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $76288626b30e899c$var$getInstIfValueChanged(targetInst);
}
function $76288626b30e899c$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $76288626b30e899c$var$getInstIfValueChanged(targetInst);
}
function $76288626b30e899c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $76288626b30e899c$var$objectIs = "function" === typeof Object.is ? Object.is : $76288626b30e899c$var$is;
function $76288626b30e899c$var$shallowEqual(objA, objB) {
    if ($76288626b30e899c$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$76288626b30e899c$var$hasOwnProperty.call(objB, currentKey) || !$76288626b30e899c$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $76288626b30e899c$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $76288626b30e899c$var$getNodeForCharacterOffset(root, offset) {
    var node = $76288626b30e899c$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $76288626b30e899c$var$getLeafNode(node);
    }
}
function $76288626b30e899c$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $76288626b30e899c$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $76288626b30e899c$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $76288626b30e899c$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $76288626b30e899c$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $76288626b30e899c$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $76288626b30e899c$var$skipSelectionChangeEvent = $76288626b30e899c$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $76288626b30e899c$var$activeElement = null, $76288626b30e899c$var$activeElementInst = null, $76288626b30e899c$var$lastSelection = null, $76288626b30e899c$var$mouseDown = !1;
function $76288626b30e899c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $76288626b30e899c$var$mouseDown || null == $76288626b30e899c$var$activeElement || $76288626b30e899c$var$activeElement !== $76288626b30e899c$var$getActiveElement(doc) || (doc = $76288626b30e899c$var$activeElement, "selectionStart" in doc && $76288626b30e899c$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $76288626b30e899c$var$lastSelection && $76288626b30e899c$var$shallowEqual($76288626b30e899c$var$lastSelection, doc) || ($76288626b30e899c$var$lastSelection = doc, doc = $76288626b30e899c$var$accumulateTwoPhaseListeners($76288626b30e899c$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $76288626b30e899c$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $76288626b30e899c$var$activeElement)));
}
function $76288626b30e899c$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $76288626b30e899c$var$vendorPrefixes = {
    animationend: $76288626b30e899c$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $76288626b30e899c$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $76288626b30e899c$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $76288626b30e899c$var$makePrefixMap("Transition", "TransitionEnd")
}, $76288626b30e899c$var$prefixedEventNames = {}, $76288626b30e899c$var$style = {};
$76288626b30e899c$var$canUseDOM && ($76288626b30e899c$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $76288626b30e899c$var$vendorPrefixes.animationend.animation, delete $76288626b30e899c$var$vendorPrefixes.animationiteration.animation, delete $76288626b30e899c$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $76288626b30e899c$var$vendorPrefixes.transitionend.transition);
function $76288626b30e899c$var$getVendorPrefixedEventName(eventName) {
    if ($76288626b30e899c$var$prefixedEventNames[eventName]) return $76288626b30e899c$var$prefixedEventNames[eventName];
    if (!$76288626b30e899c$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $76288626b30e899c$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $76288626b30e899c$var$style) return $76288626b30e899c$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $76288626b30e899c$var$ANIMATION_END = $76288626b30e899c$var$getVendorPrefixedEventName("animationend"), $76288626b30e899c$var$ANIMATION_ITERATION = $76288626b30e899c$var$getVendorPrefixedEventName("animationiteration"), $76288626b30e899c$var$ANIMATION_START = $76288626b30e899c$var$getVendorPrefixedEventName("animationstart"), $76288626b30e899c$var$TRANSITION_RUN = $76288626b30e899c$var$getVendorPrefixedEventName("transitionrun"), $76288626b30e899c$var$TRANSITION_START = $76288626b30e899c$var$getVendorPrefixedEventName("transitionstart"), $76288626b30e899c$var$TRANSITION_CANCEL = $76288626b30e899c$var$getVendorPrefixedEventName("transitioncancel"), $76288626b30e899c$var$TRANSITION_END = $76288626b30e899c$var$getVendorPrefixedEventName("transitionend"), $76288626b30e899c$var$topLevelEventsToReactNames = new Map(), $76288626b30e899c$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$76288626b30e899c$var$simpleEventPluginEvents.push("scrollEnd");
function $76288626b30e899c$var$registerSimpleEvent(domEventName, reactName) {
    $76288626b30e899c$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $76288626b30e899c$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $76288626b30e899c$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $76288626b30e899c$var$concurrentQueues = [], $76288626b30e899c$var$concurrentQueuesIndex = 0, $76288626b30e899c$var$concurrentlyUpdatedLanes = 0;
function $76288626b30e899c$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $76288626b30e899c$var$concurrentQueuesIndex, i = $76288626b30e899c$var$concurrentlyUpdatedLanes = $76288626b30e899c$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        var queue = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        var update = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        var lane = $76288626b30e899c$var$concurrentQueues[i];
        $76288626b30e899c$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $76288626b30e899c$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $76288626b30e899c$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = fiber;
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = queue;
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = update;
    $76288626b30e899c$var$concurrentQueues[$76288626b30e899c$var$concurrentQueuesIndex++] = lane;
    $76288626b30e899c$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $76288626b30e899c$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
}
function $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $76288626b30e899c$var$enqueueUpdate$1(fiber, null, null, lane);
    return $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
}
function $76288626b30e899c$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $76288626b30e899c$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $76288626b30e899c$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $76288626b30e899c$var$nestedUpdateCount) throw $76288626b30e899c$var$nestedUpdateCount = 0, $76288626b30e899c$var$rootWithNestedUpdates = null, Error($76288626b30e899c$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $76288626b30e899c$var$emptyContextObject = {};
function $76288626b30e899c$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $76288626b30e899c$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $76288626b30e899c$var$FiberNode(tag, pendingProps, key, mode);
}
function $76288626b30e899c$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $76288626b30e899c$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $76288626b30e899c$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $76288626b30e899c$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $76288626b30e899c$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $76288626b30e899c$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $76288626b30e899c$var$isHostHoistableType(type, pendingProps, $76288626b30e899c$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $76288626b30e899c$var$REACT_ACTIVITY_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $76288626b30e899c$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $76288626b30e899c$var$REACT_FRAGMENT_TYPE:
            return $76288626b30e899c$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $76288626b30e899c$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $76288626b30e899c$var$REACT_PROFILER_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $76288626b30e899c$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $76288626b30e899c$var$REACT_SUSPENSE_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $76288626b30e899c$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $76288626b30e899c$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $76288626b30e899c$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $76288626b30e899c$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $76288626b30e899c$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $76288626b30e899c$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $76288626b30e899c$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($76288626b30e899c$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $76288626b30e899c$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $76288626b30e899c$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $76288626b30e899c$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $76288626b30e899c$var$createFiberFromText(content, mode, lanes) {
    content = $76288626b30e899c$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $76288626b30e899c$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $76288626b30e899c$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $76288626b30e899c$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $76288626b30e899c$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $76288626b30e899c$var$CapturedStacks = new WeakMap();
function $76288626b30e899c$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $76288626b30e899c$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $76288626b30e899c$var$getStackByFiberInDevAndProd(source)
        };
        $76288626b30e899c$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $76288626b30e899c$var$getStackByFiberInDevAndProd(source)
    };
}
var $76288626b30e899c$var$forkStack = [], $76288626b30e899c$var$forkStackIndex = 0, $76288626b30e899c$var$treeForkProvider = null, $76288626b30e899c$var$treeForkCount = 0, $76288626b30e899c$var$idStack = [], $76288626b30e899c$var$idStackIndex = 0, $76288626b30e899c$var$treeContextProvider = null, $76288626b30e899c$var$treeContextId = 1, $76288626b30e899c$var$treeContextOverflow = "";
function $76288626b30e899c$var$pushTreeFork(workInProgress, totalChildren) {
    $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex++] = $76288626b30e899c$var$treeForkCount;
    $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex++] = $76288626b30e899c$var$treeForkProvider;
    $76288626b30e899c$var$treeForkProvider = workInProgress;
    $76288626b30e899c$var$treeForkCount = totalChildren;
}
function $76288626b30e899c$var$pushTreeId(workInProgress, totalChildren, index) {
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextId;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextOverflow;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextProvider;
    $76288626b30e899c$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $76288626b30e899c$var$treeContextId;
    workInProgress = $76288626b30e899c$var$treeContextOverflow;
    var baseLength = 32 - $76288626b30e899c$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $76288626b30e899c$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $76288626b30e899c$var$treeContextId = 1 << 32 - $76288626b30e899c$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $76288626b30e899c$var$treeContextOverflow = length + workInProgress;
    } else $76288626b30e899c$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $76288626b30e899c$var$treeContextOverflow = workInProgress;
}
function $76288626b30e899c$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($76288626b30e899c$var$pushTreeFork(workInProgress, 1), $76288626b30e899c$var$pushTreeId(workInProgress, 1, 0));
}
function $76288626b30e899c$var$popTreeContext(workInProgress) {
    for(; workInProgress === $76288626b30e899c$var$treeForkProvider;)$76288626b30e899c$var$treeForkProvider = $76288626b30e899c$var$forkStack[--$76288626b30e899c$var$forkStackIndex], $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex] = null, $76288626b30e899c$var$treeForkCount = $76288626b30e899c$var$forkStack[--$76288626b30e899c$var$forkStackIndex], $76288626b30e899c$var$forkStack[$76288626b30e899c$var$forkStackIndex] = null;
    for(; workInProgress === $76288626b30e899c$var$treeContextProvider;)$76288626b30e899c$var$treeContextProvider = $76288626b30e899c$var$idStack[--$76288626b30e899c$var$idStackIndex], $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex] = null, $76288626b30e899c$var$treeContextOverflow = $76288626b30e899c$var$idStack[--$76288626b30e899c$var$idStackIndex], $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex] = null, $76288626b30e899c$var$treeContextId = $76288626b30e899c$var$idStack[--$76288626b30e899c$var$idStackIndex], $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex] = null;
}
function $76288626b30e899c$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextId;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextOverflow;
    $76288626b30e899c$var$idStack[$76288626b30e899c$var$idStackIndex++] = $76288626b30e899c$var$treeContextProvider;
    $76288626b30e899c$var$treeContextId = suspendedContext.id;
    $76288626b30e899c$var$treeContextOverflow = suspendedContext.overflow;
    $76288626b30e899c$var$treeContextProvider = workInProgress;
}
var $76288626b30e899c$var$hydrationParentFiber = null, $76288626b30e899c$var$nextHydratableInstance = null, $76288626b30e899c$var$isHydrating = !1, $76288626b30e899c$var$hydrationErrors = null, $76288626b30e899c$var$rootOrSingletonContext = !1, $76288626b30e899c$var$HydrationMismatchException = Error($76288626b30e899c$var$formatProdErrorMessage(519));
function $76288626b30e899c$var$throwOnHydrationMismatch(fiber) {
    var error = Error($76288626b30e899c$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $76288626b30e899c$var$queueHydrationError($76288626b30e899c$var$createCapturedValueAtFiber(error, fiber));
    throw $76288626b30e899c$var$HydrationMismatchException;
}
function $76288626b30e899c$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$76288626b30e899c$var$internalInstanceKey] = fiber;
    instance[$76288626b30e899c$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $76288626b30e899c$var$listenToNonDelegatedEvent("cancel", instance);
            $76288626b30e899c$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $76288626b30e899c$var$mediaEventTypes.length; type++)$76288626b30e899c$var$listenToNonDelegatedEvent($76288626b30e899c$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", instance);
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", instance);
            $76288626b30e899c$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", instance), $76288626b30e899c$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $76288626b30e899c$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($76288626b30e899c$var$listenToNonDelegatedEvent("beforetoggle", instance), $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $76288626b30e899c$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $76288626b30e899c$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $76288626b30e899c$var$noop$1), instance = !0) : instance = !1;
    instance || $76288626b30e899c$var$throwOnHydrationMismatch(fiber, !0);
}
function $76288626b30e899c$var$popToNextHostParent(fiber) {
    for($76288626b30e899c$var$hydrationParentFiber = fiber.return; $76288626b30e899c$var$hydrationParentFiber;)switch($76288626b30e899c$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $76288626b30e899c$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $76288626b30e899c$var$rootOrSingletonContext = !0;
            return;
        default:
            $76288626b30e899c$var$hydrationParentFiber = $76288626b30e899c$var$hydrationParentFiber.return;
    }
}
function $76288626b30e899c$var$popHydrationState(fiber) {
    if (fiber !== $76288626b30e899c$var$hydrationParentFiber) return !1;
    if (!$76288626b30e899c$var$isHydrating) return $76288626b30e899c$var$popToNextHostParent(fiber), $76288626b30e899c$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $76288626b30e899c$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $76288626b30e899c$var$nextHydratableInstance && $76288626b30e899c$var$throwOnHydrationMismatch(fiber);
    $76288626b30e899c$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(317));
        $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(317));
        $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $76288626b30e899c$var$nextHydratableInstance, $76288626b30e899c$var$isSingletonScope(fiber.type) ? (fiber = $76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton, $76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton = null, $76288626b30e899c$var$nextHydratableInstance = fiber) : $76288626b30e899c$var$nextHydratableInstance = tag) : $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$hydrationParentFiber ? $76288626b30e899c$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $76288626b30e899c$var$resetHydrationState() {
    $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$hydrationParentFiber = null;
    $76288626b30e899c$var$isHydrating = !1;
}
function $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $76288626b30e899c$var$hydrationErrors;
    null !== queuedErrors && (null === $76288626b30e899c$var$workInProgressRootRecoverableErrors ? $76288626b30e899c$var$workInProgressRootRecoverableErrors = queuedErrors : $76288626b30e899c$var$workInProgressRootRecoverableErrors.push.apply($76288626b30e899c$var$workInProgressRootRecoverableErrors, queuedErrors), $76288626b30e899c$var$hydrationErrors = null);
    return queuedErrors;
}
function $76288626b30e899c$var$queueHydrationError(error) {
    null === $76288626b30e899c$var$hydrationErrors ? $76288626b30e899c$var$hydrationErrors = [
        error
    ] : $76288626b30e899c$var$hydrationErrors.push(error);
}
var $76288626b30e899c$var$valueCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$currentlyRenderingFiber$1 = null, $76288626b30e899c$var$lastContextDependency = null;
function $76288626b30e899c$var$pushProvider(providerFiber, context, nextValue) {
    $76288626b30e899c$var$push($76288626b30e899c$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $76288626b30e899c$var$popProvider(context) {
    context._currentValue = $76288626b30e899c$var$valueCursor.current;
    $76288626b30e899c$var$pop($76288626b30e899c$var$valueCursor);
}
function $76288626b30e899c$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $76288626b30e899c$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $76288626b30e899c$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $76288626b30e899c$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($76288626b30e899c$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $76288626b30e899c$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $76288626b30e899c$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($76288626b30e899c$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($76288626b30e899c$var$HostTransitionContext) : current = [
                $76288626b30e899c$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $76288626b30e899c$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $76288626b30e899c$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$76288626b30e899c$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $76288626b30e899c$var$prepareToReadContext(workInProgress) {
    $76288626b30e899c$var$currentlyRenderingFiber$1 = workInProgress;
    $76288626b30e899c$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $76288626b30e899c$var$readContext(context) {
    return $76288626b30e899c$var$readContextForConsumer($76288626b30e899c$var$currentlyRenderingFiber$1, context);
}
function $76288626b30e899c$var$readContextDuringReconciliation(consumer, context) {
    null === $76288626b30e899c$var$currentlyRenderingFiber$1 && $76288626b30e899c$var$prepareToReadContext(consumer);
    return $76288626b30e899c$var$readContextForConsumer(consumer, context);
}
function $76288626b30e899c$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $76288626b30e899c$var$lastContextDependency) {
        if (null === consumer) throw Error($76288626b30e899c$var$formatProdErrorMessage(308));
        $76288626b30e899c$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$lastContextDependency.next = context;
    return value;
}
var $76288626b30e899c$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $76288626b30e899c$var$scheduleCallback$2 = $33s19.unstable_scheduleCallback, $76288626b30e899c$var$NormalPriority = $33s19.unstable_NormalPriority, $76288626b30e899c$var$CacheContext = {
    $$typeof: $76288626b30e899c$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $76288626b30e899c$var$createCache() {
    return {
        controller: new $76288626b30e899c$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $76288626b30e899c$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $76288626b30e899c$var$scheduleCallback$2($76288626b30e899c$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $76288626b30e899c$var$currentEntangledListeners = null, $76288626b30e899c$var$currentEntangledPendingCount = 0, $76288626b30e899c$var$currentEntangledLane = 0, $76288626b30e899c$var$currentEntangledActionThenable = null;
function $76288626b30e899c$var$entangleAsyncAction(transition, thenable) {
    if (null === $76288626b30e899c$var$currentEntangledListeners) {
        var entangledListeners = $76288626b30e899c$var$currentEntangledListeners = [];
        $76288626b30e899c$var$currentEntangledPendingCount = 0;
        $76288626b30e899c$var$currentEntangledLane = $76288626b30e899c$var$requestTransitionLane();
        $76288626b30e899c$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $76288626b30e899c$var$currentEntangledPendingCount++;
    thenable.then($76288626b30e899c$var$pingEngtangledActionScope, $76288626b30e899c$var$pingEngtangledActionScope);
    return thenable;
}
function $76288626b30e899c$var$pingEngtangledActionScope() {
    if (0 === --$76288626b30e899c$var$currentEntangledPendingCount && null !== $76288626b30e899c$var$currentEntangledListeners) {
        null !== $76288626b30e899c$var$currentEntangledActionThenable && ($76288626b30e899c$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $76288626b30e899c$var$currentEntangledListeners;
        $76288626b30e899c$var$currentEntangledListeners = null;
        $76288626b30e899c$var$currentEntangledLane = 0;
        $76288626b30e899c$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $76288626b30e899c$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $76288626b30e899c$var$prevOnStartTransitionFinish = $76288626b30e899c$var$ReactSharedInternals.S;
$76288626b30e899c$var$ReactSharedInternals.S = function(transition, returnValue) {
    $76288626b30e899c$var$globalMostRecentTransitionTime = $76288626b30e899c$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $76288626b30e899c$var$entangleAsyncAction(transition, returnValue);
    null !== $76288626b30e899c$var$prevOnStartTransitionFinish && $76288626b30e899c$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $76288626b30e899c$var$resumedCache = $76288626b30e899c$var$createCursor(null);
function $76288626b30e899c$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $76288626b30e899c$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $76288626b30e899c$var$workInProgressRoot.pooledCache;
}
function $76288626b30e899c$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $76288626b30e899c$var$push($76288626b30e899c$var$resumedCache, $76288626b30e899c$var$resumedCache.current) : $76288626b30e899c$var$push($76288626b30e899c$var$resumedCache, prevCachePool.pool);
}
function $76288626b30e899c$var$getSuspendedCache() {
    var cacheFromPool = $76288626b30e899c$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $76288626b30e899c$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $76288626b30e899c$var$SuspenseException = Error($76288626b30e899c$var$formatProdErrorMessage(460)), $76288626b30e899c$var$SuspenseyCommitException = Error($76288626b30e899c$var$formatProdErrorMessage(474)), $76288626b30e899c$var$SuspenseActionException = Error($76288626b30e899c$var$formatProdErrorMessage(542)), $76288626b30e899c$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $76288626b30e899c$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $76288626b30e899c$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($76288626b30e899c$var$noop$1, $76288626b30e899c$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $76288626b30e899c$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($76288626b30e899c$var$noop$1, $76288626b30e899c$var$noop$1);
            else {
                thenableState = $76288626b30e899c$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($76288626b30e899c$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $76288626b30e899c$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $76288626b30e899c$var$suspendedThenable = thenable;
            throw $76288626b30e899c$var$SuspenseException;
    }
}
function $76288626b30e899c$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $76288626b30e899c$var$suspendedThenable = x, $76288626b30e899c$var$SuspenseException;
        throw x;
    }
}
var $76288626b30e899c$var$suspendedThenable = null;
function $76288626b30e899c$var$getSuspendedThenable() {
    if (null === $76288626b30e899c$var$suspendedThenable) throw Error($76288626b30e899c$var$formatProdErrorMessage(459));
    var thenable = $76288626b30e899c$var$suspendedThenable;
    $76288626b30e899c$var$suspendedThenable = null;
    return thenable;
}
function $76288626b30e899c$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $76288626b30e899c$var$SuspenseException || rejectedReason === $76288626b30e899c$var$SuspenseActionException) throw Error($76288626b30e899c$var$formatProdErrorMessage(483));
}
var $76288626b30e899c$var$thenableState$1 = null, $76288626b30e899c$var$thenableIndexCounter$1 = 0;
function $76288626b30e899c$var$unwrapThenable(thenable) {
    var index = $76288626b30e899c$var$thenableIndexCounter$1;
    $76288626b30e899c$var$thenableIndexCounter$1 += 1;
    null === $76288626b30e899c$var$thenableState$1 && ($76288626b30e899c$var$thenableState$1 = []);
    return $76288626b30e899c$var$trackUsedThenable($76288626b30e899c$var$thenableState$1, thenable, index);
}
function $76288626b30e899c$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $76288626b30e899c$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($76288626b30e899c$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($76288626b30e899c$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $76288626b30e899c$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $76288626b30e899c$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $76288626b30e899c$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $76288626b30e899c$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $76288626b30e899c$var$REACT_LAZY_TYPE && $76288626b30e899c$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $76288626b30e899c$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $76288626b30e899c$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $76288626b30e899c$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $76288626b30e899c$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $76288626b30e899c$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $76288626b30e899c$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    return lanes = $76288626b30e899c$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $76288626b30e899c$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    return newChild = $76288626b30e899c$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild) || $76288626b30e899c$var$getIteratorFn(newChild)) return newChild = $76288626b30e899c$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild) || $76288626b30e899c$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild) || $76288626b30e899c$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($76288626b30e899c$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $76288626b30e899c$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $76288626b30e899c$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $76288626b30e899c$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $76288626b30e899c$var$REACT_LAZY_TYPE && $76288626b30e899c$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $76288626b30e899c$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $76288626b30e899c$var$REACT_FRAGMENT_TYPE ? (lanes = $76288626b30e899c$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $76288626b30e899c$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $76288626b30e899c$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $76288626b30e899c$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $76288626b30e899c$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $76288626b30e899c$var$REACT_LAZY_TYPE:
                    return newChild = $76288626b30e899c$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($76288626b30e899c$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($76288626b30e899c$var$getIteratorFn(newChild)) {
                key = $76288626b30e899c$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($76288626b30e899c$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $76288626b30e899c$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $76288626b30e899c$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $76288626b30e899c$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $76288626b30e899c$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $76288626b30e899c$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $76288626b30e899c$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $76288626b30e899c$var$SuspenseException || x === $76288626b30e899c$var$SuspenseActionException) throw x;
            var fiber = $76288626b30e899c$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $76288626b30e899c$var$reconcileChildFibers = $76288626b30e899c$var$createChildReconciler(!0), $76288626b30e899c$var$mountChildFibers = $76288626b30e899c$var$createChildReconciler(!1), $76288626b30e899c$var$hasForceUpdate = !1;
function $76288626b30e899c$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $76288626b30e899c$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $76288626b30e899c$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $76288626b30e899c$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($76288626b30e899c$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
        $76288626b30e899c$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $76288626b30e899c$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $76288626b30e899c$var$getRootForUpdatedFiber(fiber);
}
function $76288626b30e899c$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $76288626b30e899c$var$markRootEntangled(root, lane);
    }
}
function $76288626b30e899c$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $76288626b30e899c$var$didReadFromEntangledAsyncAction = !1;
function $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($76288626b30e899c$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $76288626b30e899c$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $76288626b30e899c$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $76288626b30e899c$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $76288626b30e899c$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($76288626b30e899c$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $76288626b30e899c$var$currentEntangledLane && ($76288626b30e899c$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $76288626b30e899c$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $76288626b30e899c$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $76288626b30e899c$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $76288626b30e899c$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($76288626b30e899c$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $76288626b30e899c$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$76288626b30e899c$var$callCallback(callbacks[updateQueue], context);
}
var $76288626b30e899c$var$currentTreeHiddenStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$prevEntangledRenderLanesCursor = $76288626b30e899c$var$createCursor(0);
function $76288626b30e899c$var$pushHiddenContext(fiber, context) {
    fiber = $76288626b30e899c$var$entangledRenderLanes;
    $76288626b30e899c$var$push($76288626b30e899c$var$prevEntangledRenderLanesCursor, fiber);
    $76288626b30e899c$var$push($76288626b30e899c$var$currentTreeHiddenStackCursor, context);
    $76288626b30e899c$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $76288626b30e899c$var$reuseHiddenContextOnStack() {
    $76288626b30e899c$var$push($76288626b30e899c$var$prevEntangledRenderLanesCursor, $76288626b30e899c$var$entangledRenderLanes);
    $76288626b30e899c$var$push($76288626b30e899c$var$currentTreeHiddenStackCursor, $76288626b30e899c$var$currentTreeHiddenStackCursor.current);
}
function $76288626b30e899c$var$popHiddenContext() {
    $76288626b30e899c$var$entangledRenderLanes = $76288626b30e899c$var$prevEntangledRenderLanesCursor.current;
    $76288626b30e899c$var$pop($76288626b30e899c$var$currentTreeHiddenStackCursor);
    $76288626b30e899c$var$pop($76288626b30e899c$var$prevEntangledRenderLanesCursor);
}
var $76288626b30e899c$var$suspenseHandlerStackCursor = $76288626b30e899c$var$createCursor(null), $76288626b30e899c$var$shellBoundary = null;
function $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current & 1);
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, handler);
    null === $76288626b30e899c$var$shellBoundary && (null === current || null !== $76288626b30e899c$var$currentTreeHiddenStackCursor.current ? $76288626b30e899c$var$shellBoundary = handler : null !== current.memoizedState && ($76288626b30e899c$var$shellBoundary = handler));
}
function $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current);
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, fiber);
    null === $76288626b30e899c$var$shellBoundary && ($76288626b30e899c$var$shellBoundary = fiber);
}
function $76288626b30e899c$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current), $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, fiber), null === $76288626b30e899c$var$shellBoundary && ($76288626b30e899c$var$shellBoundary = fiber)) : $76288626b30e899c$var$reuseSuspenseHandlerOnStack(fiber);
}
function $76288626b30e899c$var$reuseSuspenseHandlerOnStack() {
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current);
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseHandlerStackCursor, $76288626b30e899c$var$suspenseHandlerStackCursor.current);
}
function $76288626b30e899c$var$popSuspenseHandler(fiber) {
    $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseHandlerStackCursor);
    $76288626b30e899c$var$shellBoundary === fiber && ($76288626b30e899c$var$shellBoundary = null);
    $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor);
}
var $76288626b30e899c$var$suspenseStackCursor = $76288626b30e899c$var$createCursor(0);
function $76288626b30e899c$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $76288626b30e899c$var$isSuspenseInstancePending(state) || $76288626b30e899c$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $76288626b30e899c$var$renderLanes = 0, $76288626b30e899c$var$currentlyRenderingFiber = null, $76288626b30e899c$var$currentHook = null, $76288626b30e899c$var$workInProgressHook = null, $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !1, $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $76288626b30e899c$var$localIdCounter = 0, $76288626b30e899c$var$thenableIndexCounter = 0, $76288626b30e899c$var$thenableState = null, $76288626b30e899c$var$globalClientIdCounter = 0;
function $76288626b30e899c$var$throwInvalidHookError() {
    throw Error($76288626b30e899c$var$formatProdErrorMessage(321));
}
function $76288626b30e899c$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$76288626b30e899c$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $76288626b30e899c$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $76288626b30e899c$var$renderLanes = nextRenderLanes;
    $76288626b30e899c$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $76288626b30e899c$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $76288626b30e899c$var$HooksDispatcherOnMount : $76288626b30e899c$var$HooksDispatcherOnUpdate;
    $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $76288626b30e899c$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $76288626b30e899c$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $76288626b30e899c$var$finishRenderingHooks(current) {
    $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $76288626b30e899c$var$currentHook && null !== $76288626b30e899c$var$currentHook.next;
    $76288626b30e899c$var$renderLanes = 0;
    $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$currentHook = $76288626b30e899c$var$currentlyRenderingFiber = null;
    $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !1;
    $76288626b30e899c$var$thenableIndexCounter = 0;
    $76288626b30e899c$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($76288626b30e899c$var$formatProdErrorMessage(300));
    null === current || $76288626b30e899c$var$didReceiveUpdate || (current = current.dependencies, null !== current && $76288626b30e899c$var$checkIfContextChanged(current) && ($76288626b30e899c$var$didReceiveUpdate = !0));
}
function $76288626b30e899c$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $76288626b30e899c$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass && ($76288626b30e899c$var$thenableState = null);
        $76288626b30e899c$var$thenableIndexCounter = 0;
        $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($76288626b30e899c$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $76288626b30e899c$var$TransitionAwareHostComponent() {
    var dispatcher = $76288626b30e899c$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $76288626b30e899c$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $76288626b30e899c$var$currentHook ? $76288626b30e899c$var$currentHook.memoizedState : null) !== dispatcher && ($76288626b30e899c$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $76288626b30e899c$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $76288626b30e899c$var$localIdCounter;
    $76288626b30e899c$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $76288626b30e899c$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $76288626b30e899c$var$resetHooksOnUnwind(workInProgress) {
    if ($76288626b30e899c$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !1;
    }
    $76288626b30e899c$var$renderLanes = 0;
    $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$currentHook = $76288626b30e899c$var$currentlyRenderingFiber = null;
    $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $76288626b30e899c$var$thenableIndexCounter = $76288626b30e899c$var$localIdCounter = 0;
    $76288626b30e899c$var$thenableState = null;
}
function $76288626b30e899c$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $76288626b30e899c$var$workInProgressHook ? $76288626b30e899c$var$currentlyRenderingFiber.memoizedState = $76288626b30e899c$var$workInProgressHook = hook : $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$workInProgressHook.next = hook;
    return $76288626b30e899c$var$workInProgressHook;
}
function $76288626b30e899c$var$updateWorkInProgressHook() {
    if (null === $76288626b30e899c$var$currentHook) {
        var nextCurrentHook = $76288626b30e899c$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $76288626b30e899c$var$currentHook.next;
    var nextWorkInProgressHook = null === $76288626b30e899c$var$workInProgressHook ? $76288626b30e899c$var$currentlyRenderingFiber.memoizedState : $76288626b30e899c$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $76288626b30e899c$var$workInProgressHook = nextWorkInProgressHook, $76288626b30e899c$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $76288626b30e899c$var$currentlyRenderingFiber.alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(467));
            throw Error($76288626b30e899c$var$formatProdErrorMessage(310));
        }
        $76288626b30e899c$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $76288626b30e899c$var$currentHook.memoizedState,
            baseState: $76288626b30e899c$var$currentHook.baseState,
            baseQueue: $76288626b30e899c$var$currentHook.baseQueue,
            queue: $76288626b30e899c$var$currentHook.queue,
            next: null
        };
        null === $76288626b30e899c$var$workInProgressHook ? $76288626b30e899c$var$currentlyRenderingFiber.memoizedState = $76288626b30e899c$var$workInProgressHook = nextCurrentHook : $76288626b30e899c$var$workInProgressHook = $76288626b30e899c$var$workInProgressHook.next = nextCurrentHook;
    }
    return $76288626b30e899c$var$workInProgressHook;
}
function $76288626b30e899c$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $76288626b30e899c$var$useThenable(thenable) {
    var index = $76288626b30e899c$var$thenableIndexCounter;
    $76288626b30e899c$var$thenableIndexCounter += 1;
    null === $76288626b30e899c$var$thenableState && ($76288626b30e899c$var$thenableState = []);
    thenable = $76288626b30e899c$var$trackUsedThenable($76288626b30e899c$var$thenableState, thenable, index);
    index = $76288626b30e899c$var$currentlyRenderingFiber;
    null === (null === $76288626b30e899c$var$workInProgressHook ? index.memoizedState : $76288626b30e899c$var$workInProgressHook.next) && (index = index.alternate, $76288626b30e899c$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $76288626b30e899c$var$HooksDispatcherOnMount : $76288626b30e899c$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $76288626b30e899c$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $76288626b30e899c$var$useThenable(usable);
        if (usable.$$typeof === $76288626b30e899c$var$REACT_CONTEXT_TYPE) return $76288626b30e899c$var$readContext(usable);
    }
    throw Error($76288626b30e899c$var$formatProdErrorMessage(438, String(usable)));
}
function $76288626b30e899c$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $76288626b30e899c$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $76288626b30e899c$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $76288626b30e899c$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $76288626b30e899c$var$updateReducer(reducer) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    return $76288626b30e899c$var$updateReducerImpl(hook, $76288626b30e899c$var$currentHook, reducer);
}
function $76288626b30e899c$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($76288626b30e899c$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($76288626b30e899c$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($76288626b30e899c$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $76288626b30e899c$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($76288626b30e899c$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $76288626b30e899c$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $76288626b30e899c$var$currentlyRenderingFiber.lanes |= revertLane, $76288626b30e899c$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $76288626b30e899c$var$currentlyRenderingFiber.lanes |= updateLane, $76288626b30e899c$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$76288626b30e899c$var$objectIs(pendingQueue, hook.memoizedState) && ($76288626b30e899c$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $76288626b30e899c$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $76288626b30e899c$var$rerenderReducer(reducer) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($76288626b30e899c$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $76288626b30e899c$var$objectIs(newState, hook.memoizedState) || ($76288626b30e899c$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $76288626b30e899c$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $76288626b30e899c$var$currentlyRenderingFiber, hook = $76288626b30e899c$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $76288626b30e899c$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($76288626b30e899c$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$76288626b30e899c$var$objectIs(($76288626b30e899c$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $76288626b30e899c$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $76288626b30e899c$var$updateEffect($76288626b30e899c$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $76288626b30e899c$var$workInProgressHook && $76288626b30e899c$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $76288626b30e899c$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $76288626b30e899c$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $76288626b30e899c$var$workInProgressRoot) throw Error($76288626b30e899c$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($76288626b30e899c$var$renderLanes & 127) || $76288626b30e899c$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $76288626b30e899c$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $76288626b30e899c$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $76288626b30e899c$var$checkIfSnapshotChanged(inst) && $76288626b30e899c$var$forceStoreRerender(fiber);
}
function $76288626b30e899c$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $76288626b30e899c$var$checkIfSnapshotChanged(inst) && $76288626b30e899c$var$forceStoreRerender(fiber);
    });
}
function $76288626b30e899c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$76288626b30e899c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $76288626b30e899c$var$forceStoreRerender(fiber) {
    var root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $76288626b30e899c$var$mountStateImpl(initialState) {
    var hook = $76288626b30e899c$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $76288626b30e899c$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $76288626b30e899c$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $76288626b30e899c$var$updateReducerImpl(hook, $76288626b30e899c$var$currentHook, "function" === typeof reducer ? reducer : $76288626b30e899c$var$basicStateReducer);
}
function $76288626b30e899c$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($76288626b30e899c$var$isRenderPhaseUpdate(fiber)) throw Error($76288626b30e899c$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $76288626b30e899c$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $76288626b30e899c$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $76288626b30e899c$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T, currentTransition = {};
        $76288626b30e899c$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $76288626b30e899c$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $76288626b30e899c$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $76288626b30e899c$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $76288626b30e899c$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $76288626b30e899c$var$onActionError(actionQueue, node, error$66);
    }
}
function $76288626b30e899c$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $76288626b30e899c$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $76288626b30e899c$var$onActionError(actionQueue, node, error);
    }) : $76288626b30e899c$var$onActionSuccess(actionQueue, node, returnValue);
}
function $76288626b30e899c$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $76288626b30e899c$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $76288626b30e899c$var$runActionStateAction(actionQueue, nextState)));
}
function $76288626b30e899c$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $76288626b30e899c$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $76288626b30e899c$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $76288626b30e899c$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $76288626b30e899c$var$mountActionState(action, initialStateProp) {
    if ($76288626b30e899c$var$isHydrating) {
        var ssrFormState = $76288626b30e899c$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $76288626b30e899c$var$currentlyRenderingFiber;
                if ($76288626b30e899c$var$isHydrating) {
                    if ($76288626b30e899c$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $76288626b30e899c$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $76288626b30e899c$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $76288626b30e899c$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $76288626b30e899c$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $76288626b30e899c$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $76288626b30e899c$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $76288626b30e899c$var$dispatchSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $76288626b30e899c$var$mountStateImpl(!1);
    inRootOrSingleton = $76288626b30e899c$var$dispatchOptimisticSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $76288626b30e899c$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $76288626b30e899c$var$dispatchActionState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $76288626b30e899c$var$updateActionState(action) {
    var stateHook = $76288626b30e899c$var$updateWorkInProgressHook();
    return $76288626b30e899c$var$updateActionStateImpl(stateHook, $76288626b30e899c$var$currentHook, action);
}
function $76288626b30e899c$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $76288626b30e899c$var$updateReducerImpl(stateHook, currentStateHook, $76288626b30e899c$var$actionStateReducer)[0];
    stateHook = $76288626b30e899c$var$updateReducer($76288626b30e899c$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $76288626b30e899c$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $76288626b30e899c$var$SuspenseException) throw $76288626b30e899c$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $76288626b30e899c$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($76288626b30e899c$var$currentlyRenderingFiber.flags |= 2048, $76288626b30e899c$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $76288626b30e899c$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $76288626b30e899c$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $76288626b30e899c$var$rerenderActionState(action) {
    var stateHook = $76288626b30e899c$var$updateWorkInProgressHook(), currentStateHook = $76288626b30e899c$var$currentHook;
    if (null !== currentStateHook) return $76288626b30e899c$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $76288626b30e899c$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $76288626b30e899c$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $76288626b30e899c$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $76288626b30e899c$var$updateRef() {
    return $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
}
function $76288626b30e899c$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $76288626b30e899c$var$mountWorkInProgressHook();
    $76288626b30e899c$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $76288626b30e899c$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $76288626b30e899c$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $76288626b30e899c$var$currentHook && null !== deps && $76288626b30e899c$var$areHookInputsEqual(deps, $76288626b30e899c$var$currentHook.memoizedState.deps) ? hook.memoizedState = $76288626b30e899c$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($76288626b30e899c$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $76288626b30e899c$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $76288626b30e899c$var$mountEffect(create, deps) {
    $76288626b30e899c$var$mountEffectImpl(8390656, 8, create, deps);
}
function $76288626b30e899c$var$updateEffect(create, deps) {
    $76288626b30e899c$var$updateEffectImpl(2048, 8, create, deps);
}
function $76288626b30e899c$var$useEffectEventImpl(payload) {
    $76288626b30e899c$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $76288626b30e899c$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $76288626b30e899c$var$createFunctionComponentUpdateQueue(), $76288626b30e899c$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $76288626b30e899c$var$updateEvent(callback) {
    var ref = $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
    $76288626b30e899c$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($76288626b30e899c$var$executionContext & 2)) throw Error($76288626b30e899c$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $76288626b30e899c$var$updateInsertionEffect(create, deps) {
    return $76288626b30e899c$var$updateEffectImpl(4, 2, create, deps);
}
function $76288626b30e899c$var$updateLayoutEffect(create, deps) {
    return $76288626b30e899c$var$updateEffectImpl(4, 4, create, deps);
}
function $76288626b30e899c$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $76288626b30e899c$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $76288626b30e899c$var$updateEffectImpl(4, 4, $76288626b30e899c$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $76288626b30e899c$var$mountDebugValue() {}
function $76288626b30e899c$var$updateCallback(callback, deps) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $76288626b30e899c$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $76288626b30e899c$var$updateMemo(nextCreate, deps) {
    var hook = $76288626b30e899c$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $76288626b30e899c$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($76288626b30e899c$var$renderLanes & 1073741824) && 0 === ($76288626b30e899c$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $76288626b30e899c$var$requestDeferredLane();
    $76288626b30e899c$var$currentlyRenderingFiber.lanes |= hook;
    $76288626b30e899c$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $76288626b30e899c$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($76288626b30e899c$var$objectIs(value, prevValue)) return value;
    if (null !== $76288626b30e899c$var$currentTreeHiddenStackCursor.current) return hook = $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue), $76288626b30e899c$var$objectIs(hook, prevValue) || ($76288626b30e899c$var$didReceiveUpdate = !0), hook;
    if (0 === ($76288626b30e899c$var$renderLanes & 42) || 0 !== ($76288626b30e899c$var$renderLanes & 1073741824) && 0 === ($76288626b30e899c$var$workInProgressRootRenderLanes & 261930)) return $76288626b30e899c$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $76288626b30e899c$var$requestDeferredLane();
    $76288626b30e899c$var$currentlyRenderingFiber.lanes |= hook;
    $76288626b30e899c$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $76288626b30e899c$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    $76288626b30e899c$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T, currentTransition = {};
    $76288626b30e899c$var$ReactSharedInternals.T = currentTransition;
    $76288626b30e899c$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $76288626b30e899c$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $76288626b30e899c$var$chainThenableValue(returnValue, finishedState);
            $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $76288626b30e899c$var$requestUpdateLane(fiber));
        } else $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, finishedState, $76288626b30e899c$var$requestUpdateLane(fiber));
    } catch (error) {
        $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $76288626b30e899c$var$requestUpdateLane());
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $76288626b30e899c$var$noop() {}
function $76288626b30e899c$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($76288626b30e899c$var$formatProdErrorMessage(476));
    var queue = $76288626b30e899c$var$ensureFormComponentIsStateful(formFiber).queue;
    $76288626b30e899c$var$startTransition(formFiber, queue, pendingState, $76288626b30e899c$var$sharedNotPendingObject, null === action ? $76288626b30e899c$var$noop : function() {
        $76288626b30e899c$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $76288626b30e899c$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $76288626b30e899c$var$sharedNotPendingObject,
        baseState: $76288626b30e899c$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $76288626b30e899c$var$basicStateReducer,
            lastRenderedState: $76288626b30e899c$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $76288626b30e899c$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $76288626b30e899c$var$requestFormReset$1(formFiber) {
    var stateHook = $76288626b30e899c$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $76288626b30e899c$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $76288626b30e899c$var$requestUpdateLane());
}
function $76288626b30e899c$var$useHostTransitionStatus() {
    return $76288626b30e899c$var$readContext($76288626b30e899c$var$HostTransitionContext);
}
function $76288626b30e899c$var$updateId() {
    return $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
}
function $76288626b30e899c$var$updateRefresh() {
    return $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
}
function $76288626b30e899c$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $76288626b30e899c$var$requestUpdateLane();
                fiber = $76288626b30e899c$var$createUpdate(lane);
                var root$69 = $76288626b30e899c$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($76288626b30e899c$var$scheduleUpdateOnFiber(root$69, provider, lane), $76288626b30e899c$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $76288626b30e899c$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $76288626b30e899c$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $76288626b30e899c$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $76288626b30e899c$var$isRenderPhaseUpdate(fiber) ? $76288626b30e899c$var$enqueueRenderPhaseUpdate(queue, action) : (action = $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($76288626b30e899c$var$scheduleUpdateOnFiber(action, fiber, lane), $76288626b30e899c$var$entangleTransitionUpdate(action, queue, lane)));
}
function $76288626b30e899c$var$dispatchSetState(fiber, queue, action) {
    var lane = $76288626b30e899c$var$requestUpdateLane();
    $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $76288626b30e899c$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($76288626b30e899c$var$isRenderPhaseUpdate(fiber)) $76288626b30e899c$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($76288626b30e899c$var$objectIs(eagerState, currentState)) return $76288626b30e899c$var$enqueueUpdate$1(fiber, queue, update, 0), null === $76288626b30e899c$var$workInProgressRoot && $76288626b30e899c$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $76288626b30e899c$var$scheduleUpdateOnFiber(action, fiber, lane), $76288626b30e899c$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $76288626b30e899c$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $76288626b30e899c$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($76288626b30e899c$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($76288626b30e899c$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $76288626b30e899c$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $76288626b30e899c$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $76288626b30e899c$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $76288626b30e899c$var$currentlyRenderingFiber || null !== alternate && alternate === $76288626b30e899c$var$currentlyRenderingFiber;
}
function $76288626b30e899c$var$enqueueRenderPhaseUpdate(queue, update) {
    $76288626b30e899c$var$didScheduleRenderPhaseUpdateDuringThisPass = $76288626b30e899c$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $76288626b30e899c$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $76288626b30e899c$var$markRootEntangled(root, lane);
    }
}
var $76288626b30e899c$var$ContextOnlyDispatcher = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: $76288626b30e899c$var$throwInvalidHookError,
    useContext: $76288626b30e899c$var$throwInvalidHookError,
    useEffect: $76288626b30e899c$var$throwInvalidHookError,
    useImperativeHandle: $76288626b30e899c$var$throwInvalidHookError,
    useLayoutEffect: $76288626b30e899c$var$throwInvalidHookError,
    useInsertionEffect: $76288626b30e899c$var$throwInvalidHookError,
    useMemo: $76288626b30e899c$var$throwInvalidHookError,
    useReducer: $76288626b30e899c$var$throwInvalidHookError,
    useRef: $76288626b30e899c$var$throwInvalidHookError,
    useState: $76288626b30e899c$var$throwInvalidHookError,
    useDebugValue: $76288626b30e899c$var$throwInvalidHookError,
    useDeferredValue: $76288626b30e899c$var$throwInvalidHookError,
    useTransition: $76288626b30e899c$var$throwInvalidHookError,
    useSyncExternalStore: $76288626b30e899c$var$throwInvalidHookError,
    useId: $76288626b30e899c$var$throwInvalidHookError,
    useHostTransitionStatus: $76288626b30e899c$var$throwInvalidHookError,
    useFormState: $76288626b30e899c$var$throwInvalidHookError,
    useActionState: $76288626b30e899c$var$throwInvalidHookError,
    useOptimistic: $76288626b30e899c$var$throwInvalidHookError,
    useMemoCache: $76288626b30e899c$var$throwInvalidHookError,
    useCacheRefresh: $76288626b30e899c$var$throwInvalidHookError
};
$76288626b30e899c$var$ContextOnlyDispatcher.useEffectEvent = $76288626b30e899c$var$throwInvalidHookError;
var $76288626b30e899c$var$HooksDispatcherOnMount = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: function(callback, deps) {
        $76288626b30e899c$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $76288626b30e899c$var$readContext,
    useEffect: $76288626b30e899c$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $76288626b30e899c$var$mountEffectImpl(4194308, 4, $76288626b30e899c$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $76288626b30e899c$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $76288626b30e899c$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($76288626b30e899c$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $76288626b30e899c$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $76288626b30e899c$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $76288626b30e899c$var$dispatchReducerAction.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $76288626b30e899c$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $76288626b30e899c$var$dispatchSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $76288626b30e899c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        return $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $76288626b30e899c$var$mountStateImpl(!1);
        stateHook = $76288626b30e899c$var$startTransition.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $76288626b30e899c$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $76288626b30e899c$var$currentlyRenderingFiber, hook = $76288626b30e899c$var$mountWorkInProgressHook();
        if ($76288626b30e899c$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($76288626b30e899c$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $76288626b30e899c$var$workInProgressRoot) throw Error($76288626b30e899c$var$formatProdErrorMessage(349));
            0 !== ($76288626b30e899c$var$workInProgressRootRenderLanes & 127) || $76288626b30e899c$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $76288626b30e899c$var$mountEffect($76288626b30e899c$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $76288626b30e899c$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $76288626b30e899c$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook(), identifierPrefix = $76288626b30e899c$var$workInProgressRoot.identifierPrefix;
        if ($76288626b30e899c$var$isHydrating) {
            var JSCompiler_inline_result = $76288626b30e899c$var$treeContextOverflow;
            var idWithLeadingBit = $76288626b30e899c$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $76288626b30e899c$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $76288626b30e899c$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $76288626b30e899c$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $76288626b30e899c$var$useHostTransitionStatus,
    useFormState: $76288626b30e899c$var$mountActionState,
    useActionState: $76288626b30e899c$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $76288626b30e899c$var$dispatchOptimisticSetState.bind(null, $76288626b30e899c$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $76288626b30e899c$var$useMemoCache,
    useCacheRefresh: function() {
        return $76288626b30e899c$var$mountWorkInProgressHook().memoizedState = $76288626b30e899c$var$refreshCache.bind(null, $76288626b30e899c$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $76288626b30e899c$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($76288626b30e899c$var$executionContext & 2)) throw Error($76288626b30e899c$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $76288626b30e899c$var$HooksDispatcherOnUpdate = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: $76288626b30e899c$var$updateCallback,
    useContext: $76288626b30e899c$var$readContext,
    useEffect: $76288626b30e899c$var$updateEffect,
    useImperativeHandle: $76288626b30e899c$var$updateImperativeHandle,
    useInsertionEffect: $76288626b30e899c$var$updateInsertionEffect,
    useLayoutEffect: $76288626b30e899c$var$updateLayoutEffect,
    useMemo: $76288626b30e899c$var$updateMemo,
    useReducer: $76288626b30e899c$var$updateReducer,
    useRef: $76288626b30e899c$var$updateRef,
    useState: function() {
        return $76288626b30e899c$var$updateReducer($76288626b30e899c$var$basicStateReducer);
    },
    useDebugValue: $76288626b30e899c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        return $76288626b30e899c$var$updateDeferredValueImpl(hook, $76288626b30e899c$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $76288626b30e899c$var$updateReducer($76288626b30e899c$var$basicStateReducer)[0], start = $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $76288626b30e899c$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $76288626b30e899c$var$updateSyncExternalStore,
    useId: $76288626b30e899c$var$updateId,
    useHostTransitionStatus: $76288626b30e899c$var$useHostTransitionStatus,
    useFormState: $76288626b30e899c$var$updateActionState,
    useActionState: $76288626b30e899c$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        return $76288626b30e899c$var$updateOptimisticImpl(hook, $76288626b30e899c$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $76288626b30e899c$var$useMemoCache,
    useCacheRefresh: $76288626b30e899c$var$updateRefresh
};
$76288626b30e899c$var$HooksDispatcherOnUpdate.useEffectEvent = $76288626b30e899c$var$updateEvent;
var $76288626b30e899c$var$HooksDispatcherOnRerender = {
    readContext: $76288626b30e899c$var$readContext,
    use: $76288626b30e899c$var$use,
    useCallback: $76288626b30e899c$var$updateCallback,
    useContext: $76288626b30e899c$var$readContext,
    useEffect: $76288626b30e899c$var$updateEffect,
    useImperativeHandle: $76288626b30e899c$var$updateImperativeHandle,
    useInsertionEffect: $76288626b30e899c$var$updateInsertionEffect,
    useLayoutEffect: $76288626b30e899c$var$updateLayoutEffect,
    useMemo: $76288626b30e899c$var$updateMemo,
    useReducer: $76288626b30e899c$var$rerenderReducer,
    useRef: $76288626b30e899c$var$updateRef,
    useState: function() {
        return $76288626b30e899c$var$rerenderReducer($76288626b30e899c$var$basicStateReducer);
    },
    useDebugValue: $76288626b30e899c$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        return null === $76288626b30e899c$var$currentHook ? $76288626b30e899c$var$mountDeferredValueImpl(hook, value, initialValue) : $76288626b30e899c$var$updateDeferredValueImpl(hook, $76288626b30e899c$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $76288626b30e899c$var$rerenderReducer($76288626b30e899c$var$basicStateReducer)[0], start = $76288626b30e899c$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $76288626b30e899c$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $76288626b30e899c$var$updateSyncExternalStore,
    useId: $76288626b30e899c$var$updateId,
    useHostTransitionStatus: $76288626b30e899c$var$useHostTransitionStatus,
    useFormState: $76288626b30e899c$var$rerenderActionState,
    useActionState: $76288626b30e899c$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $76288626b30e899c$var$updateWorkInProgressHook();
        if (null !== $76288626b30e899c$var$currentHook) return $76288626b30e899c$var$updateOptimisticImpl(hook, $76288626b30e899c$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $76288626b30e899c$var$useMemoCache,
    useCacheRefresh: $76288626b30e899c$var$updateRefresh
};
$76288626b30e899c$var$HooksDispatcherOnRerender.useEffectEvent = $76288626b30e899c$var$updateEvent;
function $76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $76288626b30e899c$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $76288626b30e899c$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $76288626b30e899c$var$requestUpdateLane(), update = $76288626b30e899c$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $76288626b30e899c$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($76288626b30e899c$var$scheduleUpdateOnFiber(payload, inst, lane), $76288626b30e899c$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $76288626b30e899c$var$requestUpdateLane(), update = $76288626b30e899c$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $76288626b30e899c$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($76288626b30e899c$var$scheduleUpdateOnFiber(payload, inst, lane), $76288626b30e899c$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $76288626b30e899c$var$requestUpdateLane(), update = $76288626b30e899c$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $76288626b30e899c$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($76288626b30e899c$var$scheduleUpdateOnFiber(callback, inst, lane), $76288626b30e899c$var$entangleTransitions(callback, inst, lane));
    }
};
function $76288626b30e899c$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$76288626b30e899c$var$shallowEqual(oldProps, newProps) || !$76288626b30e899c$var$shallowEqual(oldState, newState) : !0;
}
function $76288626b30e899c$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $76288626b30e899c$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $76288626b30e899c$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $76288626b30e899c$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $76288626b30e899c$var$defaultOnUncaughtError(error) {
    $76288626b30e899c$var$reportGlobalError(error);
}
function $76288626b30e899c$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $76288626b30e899c$var$defaultOnRecoverableError(error) {
    $76288626b30e899c$var$reportGlobalError(error);
}
function $76288626b30e899c$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $76288626b30e899c$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $76288626b30e899c$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $76288626b30e899c$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $76288626b30e899c$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $76288626b30e899c$var$createClassErrorUpdate(lane) {
    lane = $76288626b30e899c$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $76288626b30e899c$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $76288626b30e899c$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $76288626b30e899c$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed ? $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $76288626b30e899c$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $76288626b30e899c$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $76288626b30e899c$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $76288626b30e899c$var$shellBoundary ? $76288626b30e899c$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $76288626b30e899c$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $76288626b30e899c$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $76288626b30e899c$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $76288626b30e899c$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($76288626b30e899c$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $76288626b30e899c$var$attachPingListener(root, value, rootRenderLanes);
        $76288626b30e899c$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($76288626b30e899c$var$isHydrating) return returnFiber = $76288626b30e899c$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $76288626b30e899c$var$HydrationMismatchException && (root = Error($76288626b30e899c$var$formatProdErrorMessage(422), {
        cause: value
    }), $76288626b30e899c$var$queueHydrationError($76288626b30e899c$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $76288626b30e899c$var$HydrationMismatchException && (returnFiber = Error($76288626b30e899c$var$formatProdErrorMessage(423), {
        cause: value
    }), $76288626b30e899c$var$queueHydrationError($76288626b30e899c$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $76288626b30e899c$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $76288626b30e899c$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $76288626b30e899c$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($76288626b30e899c$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $76288626b30e899c$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $76288626b30e899c$var$workInProgressRootConcurrentErrors ? $76288626b30e899c$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $76288626b30e899c$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $76288626b30e899c$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $76288626b30e899c$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $76288626b30e899c$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed || !$76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $76288626b30e899c$var$createClassErrorUpdate(rootRenderLanes), $76288626b30e899c$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $76288626b30e899c$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $76288626b30e899c$var$SelectiveHydrationException = Error($76288626b30e899c$var$formatProdErrorMessage(461)), $76288626b30e899c$var$didReceiveUpdate = !1;
function $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $76288626b30e899c$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $76288626b30e899c$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    nextProps = $76288626b30e899c$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $76288626b30e899c$var$checkDidRenderIdHook();
    if (null !== current && !$76288626b30e899c$var$didReceiveUpdate) return $76288626b30e899c$var$bailoutHooks(current, workInProgress, renderLanes), $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $76288626b30e899c$var$isHydrating && key && $76288626b30e899c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$76288626b30e899c$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $76288626b30e899c$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $76288626b30e899c$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $76288626b30e899c$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $76288626b30e899c$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $76288626b30e899c$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($76288626b30e899c$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($76288626b30e899c$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($76288626b30e899c$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $76288626b30e899c$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $76288626b30e899c$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $76288626b30e899c$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $76288626b30e899c$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $76288626b30e899c$var$pushHiddenContext(workInProgress, prevState) : $76288626b30e899c$var$reuseHiddenContextOnStack(), $76288626b30e899c$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $76288626b30e899c$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($76288626b30e899c$var$pushTransition(workInProgress, prevState.cachePool), $76288626b30e899c$var$pushHiddenContext(workInProgress, prevState), $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $76288626b30e899c$var$pushTransition(workInProgress, null), $76288626b30e899c$var$reuseHiddenContextOnStack(), $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress));
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $76288626b30e899c$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $76288626b30e899c$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $76288626b30e899c$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $76288626b30e899c$var$pushTransition(workInProgress, null);
    $76288626b30e899c$var$reuseHiddenContextOnStack();
    $76288626b30e899c$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $76288626b30e899c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $76288626b30e899c$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $76288626b30e899c$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $76288626b30e899c$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($76288626b30e899c$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $76288626b30e899c$var$bailoutOffscreenComponent(null, current);
            $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $76288626b30e899c$var$nextHydratableInstance) ? (current = $76288626b30e899c$var$canHydrateHydrationBoundary(current, $76288626b30e899c$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $76288626b30e899c$var$treeContextProvider ? {
                    id: $76288626b30e899c$var$treeContextId,
                    overflow: $76288626b30e899c$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $76288626b30e899c$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $76288626b30e899c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($76288626b30e899c$var$formatProdErrorMessage(558));
        } else if ($76288626b30e899c$var$didReceiveUpdate || $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $76288626b30e899c$var$didReceiveUpdate || didSuspend) {
            nextProps = $76288626b30e899c$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $76288626b30e899c$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $76288626b30e899c$var$enqueueConcurrentRenderForLane(current, dehydrated), $76288626b30e899c$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $76288626b30e899c$var$SelectiveHydrationException;
            $76288626b30e899c$var$renderDidSuspendDelayIfPossible();
            workInProgress = $76288626b30e899c$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(dehydrated.nextSibling), $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$isHydrating = !0, $76288626b30e899c$var$hydrationErrors = null, $76288626b30e899c$var$rootOrSingletonContext = !1, null !== current && $76288626b30e899c$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $76288626b30e899c$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $76288626b30e899c$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $76288626b30e899c$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($76288626b30e899c$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $76288626b30e899c$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    Component = $76288626b30e899c$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $76288626b30e899c$var$checkDidRenderIdHook();
    if (null !== current && !$76288626b30e899c$var$didReceiveUpdate) return $76288626b30e899c$var$bailoutHooks(current, workInProgress, renderLanes), $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $76288626b30e899c$var$isHydrating && nextProps && $76288626b30e899c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $76288626b30e899c$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $76288626b30e899c$var$finishRenderingHooks(current);
    Component = $76288626b30e899c$var$checkDidRenderIdHook();
    if (null !== current && !$76288626b30e899c$var$didReceiveUpdate) return $76288626b30e899c$var$bailoutHooks(current, workInProgress, renderLanes), $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $76288626b30e899c$var$isHydrating && Component && $76288626b30e899c$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $76288626b30e899c$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $76288626b30e899c$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $76288626b30e899c$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $76288626b30e899c$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $76288626b30e899c$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $76288626b30e899c$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $76288626b30e899c$var$readContext(contextType) : $76288626b30e899c$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $76288626b30e899c$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $76288626b30e899c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $76288626b30e899c$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $76288626b30e899c$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $76288626b30e899c$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $76288626b30e899c$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $76288626b30e899c$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $76288626b30e899c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $76288626b30e899c$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $76288626b30e899c$var$hasForceUpdate || $76288626b30e899c$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $76288626b30e899c$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $76288626b30e899c$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $76288626b30e899c$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $76288626b30e899c$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $76288626b30e899c$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $76288626b30e899c$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $76288626b30e899c$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $76288626b30e899c$var$hasForceUpdate || null !== current && null !== current.dependencies && $76288626b30e899c$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($76288626b30e899c$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $76288626b30e899c$var$hasForceUpdate || $76288626b30e899c$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $76288626b30e899c$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $76288626b30e899c$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $76288626b30e899c$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $76288626b30e899c$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $76288626b30e899c$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $76288626b30e899c$var$resetHydrationState();
    workInProgress.flags |= 256;
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $76288626b30e899c$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $76288626b30e899c$var$getSuspendedCache()
    };
}
function $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $76288626b30e899c$var$workInProgressDeferredLane);
    return current;
}
function $76288626b30e899c$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($76288626b30e899c$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($76288626b30e899c$var$isHydrating) {
            showFallback ? $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $76288626b30e899c$var$nextHydratableInstance) ? (current = $76288626b30e899c$var$canHydrateHydrationBoundary(current, $76288626b30e899c$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $76288626b30e899c$var$treeContextProvider ? {
                    id: $76288626b30e899c$var$treeContextId,
                    overflow: $76288626b30e899c$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $76288626b30e899c$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            $76288626b30e899c$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $76288626b30e899c$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $76288626b30e899c$var$SUSPENDED_MARKER, $76288626b30e899c$var$bailoutOffscreenComponent(null, nextProps);
        $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $76288626b30e899c$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $76288626b30e899c$var$SUSPENDED_MARKER, workInProgress = $76288626b30e899c$var$bailoutOffscreenComponent(null, nextProps));
        else if ($76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress), $76288626b30e899c$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($76288626b30e899c$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $76288626b30e899c$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($76288626b30e899c$var$didReceiveUpdate || $76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $76288626b30e899c$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $76288626b30e899c$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $76288626b30e899c$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $76288626b30e899c$var$enqueueConcurrentRenderForLane(current, nextProps), $76288626b30e899c$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $76288626b30e899c$var$SelectiveHydrationException;
            $76288626b30e899c$var$isSuspenseInstancePending(nextPrimaryChildren) || $76288626b30e899c$var$renderDidSuspendDelayIfPossible();
            workInProgress = $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $76288626b30e899c$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(nextPrimaryChildren.nextSibling), $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$isHydrating = !0, $76288626b30e899c$var$hydrationErrors = null, $76288626b30e899c$var$rootOrSingletonContext = !1, null !== current && $76288626b30e899c$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $76288626b30e899c$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $76288626b30e899c$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $76288626b30e899c$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $76288626b30e899c$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $76288626b30e899c$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $76288626b30e899c$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $76288626b30e899c$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $76288626b30e899c$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $76288626b30e899c$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $76288626b30e899c$var$SUSPENDED_MARKER, $76288626b30e899c$var$bailoutOffscreenComponent(current.child, nextProps);
    $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $76288626b30e899c$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $76288626b30e899c$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $76288626b30e899c$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $76288626b30e899c$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $76288626b30e899c$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $76288626b30e899c$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $76288626b30e899c$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $76288626b30e899c$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $76288626b30e899c$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $76288626b30e899c$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $76288626b30e899c$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, suspenseContext);
    $76288626b30e899c$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $76288626b30e899c$var$isHydrating ? $76288626b30e899c$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $76288626b30e899c$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $76288626b30e899c$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $76288626b30e899c$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $76288626b30e899c$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $76288626b30e899c$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $76288626b30e899c$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($76288626b30e899c$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $76288626b30e899c$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $76288626b30e899c$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $76288626b30e899c$var$checkIfContextChanged(current) ? !0 : !1;
}
function $76288626b30e899c$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, current.memoizedState.cache);
            $76288626b30e899c$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $76288626b30e899c$var$pushHostContext(workInProgress);
            break;
        case 4:
            $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $76288626b30e899c$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $76288626b30e899c$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $76288626b30e899c$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $76288626b30e899c$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($76288626b30e899c$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $76288626b30e899c$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $76288626b30e899c$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, current.memoizedState.cache);
    }
    return $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $76288626b30e899c$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $76288626b30e899c$var$didReceiveUpdate = !0;
        else {
            if (!$76288626b30e899c$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $76288626b30e899c$var$didReceiveUpdate = !1, $76288626b30e899c$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $76288626b30e899c$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $76288626b30e899c$var$didReceiveUpdate = !1, $76288626b30e899c$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $76288626b30e899c$var$pushTreeId(workInProgress, $76288626b30e899c$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $76288626b30e899c$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $76288626b30e899c$var$shouldConstruct(current) ? (props = $76288626b30e899c$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $76288626b30e899c$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $76288626b30e899c$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $76288626b30e899c$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $76288626b30e899c$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $76288626b30e899c$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $76288626b30e899c$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $76288626b30e899c$var$getComponentNameFromType(current) || current;
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $76288626b30e899c$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $76288626b30e899c$var$resolveClassComponentProps(props, workInProgress.pendingProps), $76288626b30e899c$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($76288626b30e899c$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $76288626b30e899c$var$cloneUpdateQueue(current, workInProgress);
                $76288626b30e899c$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, props);
                props !== prevState.cache && $76288626b30e899c$var$propagateContextChanges(workInProgress, [
                    $76288626b30e899c$var$CacheContext
                ], renderLanes, !0);
                $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $76288626b30e899c$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $76288626b30e899c$var$createCapturedValueAtFiber(Error($76288626b30e899c$var$formatProdErrorMessage(424)), workInProgress);
                        $76288626b30e899c$var$queueHydrationError($$typeof);
                        workInProgress = $76288626b30e899c$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(current.firstChild);
                        $76288626b30e899c$var$hydrationParentFiber = workInProgress;
                        $76288626b30e899c$var$isHydrating = !0;
                        $76288626b30e899c$var$hydrationErrors = null;
                        $76288626b30e899c$var$rootOrSingletonContext = !0;
                        renderLanes = $76288626b30e899c$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $76288626b30e899c$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $76288626b30e899c$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $76288626b30e899c$var$markRef(current, workInProgress), null === current ? (renderLanes = $76288626b30e899c$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $76288626b30e899c$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $76288626b30e899c$var$getOwnerDocumentFromRootContainer($76288626b30e899c$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$76288626b30e899c$var$internalInstanceKey] = workInProgress, props[$76288626b30e899c$var$internalPropsKey] = current, $76288626b30e899c$var$setInitialProperties(props, renderLanes, current), $76288626b30e899c$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $76288626b30e899c$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $76288626b30e899c$var$pushHostContext(workInProgress), null === current && $76288626b30e899c$var$isHydrating && (props = workInProgress.stateNode = $76288626b30e899c$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $76288626b30e899c$var$rootInstanceStackCursor.current), $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$rootOrSingletonContext = !0, $$typeof = $76288626b30e899c$var$nextHydratableInstance, $76288626b30e899c$var$isSingletonScope(workInProgress.type) ? ($76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(props.firstChild)) : $76288626b30e899c$var$nextHydratableInstance = $$typeof), $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $76288626b30e899c$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $76288626b30e899c$var$isHydrating) {
                if ($$typeof = props = $76288626b30e899c$var$nextHydratableInstance) props = $76288626b30e899c$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $76288626b30e899c$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = $76288626b30e899c$var$getNextHydratable(props.firstChild), $76288626b30e899c$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            }
            $76288626b30e899c$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $76288626b30e899c$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $76288626b30e899c$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $76288626b30e899c$var$renderWithHooks(current, workInProgress, $76288626b30e899c$var$TransitionAwareHostComponent, null, null, renderLanes), $76288626b30e899c$var$HostTransitionContext._currentValue = $$typeof);
            $76288626b30e899c$var$markRef(current, workInProgress);
            $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $76288626b30e899c$var$isHydrating) {
                if (current = renderLanes = $76288626b30e899c$var$nextHydratableInstance) renderLanes = $76288626b30e899c$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $76288626b30e899c$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $76288626b30e899c$var$hydrationParentFiber = workInProgress, $76288626b30e899c$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $76288626b30e899c$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $76288626b30e899c$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $76288626b30e899c$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $76288626b30e899c$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $76288626b30e899c$var$pushProvider(workInProgress, workInProgress.type, props.value), $76288626b30e899c$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $76288626b30e899c$var$prepareToReadContext(workInProgress), $$typeof = $76288626b30e899c$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $76288626b30e899c$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $76288626b30e899c$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $76288626b30e899c$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $76288626b30e899c$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $76288626b30e899c$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $76288626b30e899c$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $76288626b30e899c$var$prepareToReadContext(workInProgress), props = $76288626b30e899c$var$readContext($76288626b30e899c$var$CacheContext), null === current ? ($$typeof = $76288626b30e899c$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $76288626b30e899c$var$workInProgressRoot, prevState = $76288626b30e899c$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $76288626b30e899c$var$initializeUpdateQueue(workInProgress), $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($76288626b30e899c$var$cloneUpdateQueue(current, workInProgress), $76288626b30e899c$var$processUpdateQueue(workInProgress, null, null, renderLanes), $76288626b30e899c$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, props)) : (props = prevState.cache, $76288626b30e899c$var$pushProvider(workInProgress, $76288626b30e899c$var$CacheContext, props), props !== $$typeof.cache && $76288626b30e899c$var$propagateContextChanges(workInProgress, [
                $76288626b30e899c$var$CacheContext
            ], renderLanes, !0))), $76288626b30e899c$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($76288626b30e899c$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $76288626b30e899c$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($76288626b30e899c$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $76288626b30e899c$var$suspendedThenable = $76288626b30e899c$var$noopSuspenseyCommitThenable, $76288626b30e899c$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $76288626b30e899c$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$76288626b30e899c$var$preloadResource(resource)) {
        if ($76288626b30e899c$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $76288626b30e899c$var$suspendedThenable = $76288626b30e899c$var$noopSuspenseyCommitThenable, $76288626b30e899c$var$SuspenseyCommitException;
    }
}
function $76288626b30e899c$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $76288626b30e899c$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $76288626b30e899c$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $76288626b30e899c$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$76288626b30e899c$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $76288626b30e899c$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $76288626b30e899c$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $76288626b30e899c$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 1:
            return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext);
            $76288626b30e899c$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $76288626b30e899c$var$popHydrationState(workInProgress) ? $76288626b30e899c$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable());
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($76288626b30e899c$var$markUpdate(workInProgress), null !== nextResource ? ($76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($76288626b30e899c$var$markUpdate(workInProgress), $76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($76288626b30e899c$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $76288626b30e899c$var$markUpdate(workInProgress), $76288626b30e899c$var$bubbleProperties(workInProgress), $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $76288626b30e899c$var$popHostContext(workInProgress);
            renderLanes = $76288626b30e899c$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $76288626b30e899c$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(166));
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $76288626b30e899c$var$contextStackCursor.current;
                $76288626b30e899c$var$popHydrationState(workInProgress) ? $76288626b30e899c$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $76288626b30e899c$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $76288626b30e899c$var$markUpdate(workInProgress));
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $76288626b30e899c$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $76288626b30e899c$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(166));
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $76288626b30e899c$var$contextStackCursor.current;
                if ($76288626b30e899c$var$popHydrationState(workInProgress)) $76288626b30e899c$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $76288626b30e899c$var$getOwnerDocumentFromRootContainer($76288626b30e899c$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    nextResource[$76288626b30e899c$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($76288626b30e899c$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $76288626b30e899c$var$markUpdate(workInProgress);
                }
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            $76288626b30e899c$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $76288626b30e899c$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(166));
                current = $76288626b30e899c$var$rootInstanceStackCursor.current;
                if ($76288626b30e899c$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $76288626b30e899c$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $76288626b30e899c$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $76288626b30e899c$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $76288626b30e899c$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$76288626b30e899c$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $76288626b30e899c$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($76288626b30e899c$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($76288626b30e899c$var$formatProdErrorMessage(557));
                        current[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    } else $76288626b30e899c$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $76288626b30e899c$var$popSuspenseHandler(workInProgress), workInProgress;
                    $76288626b30e899c$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($76288626b30e899c$var$formatProdErrorMessage(558));
            }
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $76288626b30e899c$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(317));
                        type[$76288626b30e899c$var$internalInstanceKey] = workInProgress;
                    } else $76288626b30e899c$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $76288626b30e899c$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $76288626b30e899c$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $76288626b30e899c$var$popSuspenseHandler(workInProgress), workInProgress;
                    $76288626b30e899c$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $76288626b30e899c$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $76288626b30e899c$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $76288626b30e899c$var$popHostContainer(), null === current && $76288626b30e899c$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 10:
            return $76288626b30e899c$var$popProvider(workInProgress.type), $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 19:
            $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $76288626b30e899c$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $76288626b30e899c$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $76288626b30e899c$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$76288626b30e899c$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, $76288626b30e899c$var$suspenseStackCursor.current & 1 | 2);
                            $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $76288626b30e899c$var$now() > $76288626b30e899c$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $76288626b30e899c$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $76288626b30e899c$var$scheduleRetryEffect(workInProgress, current), $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$76288626b30e899c$var$isHydrating) return $76288626b30e899c$var$bubbleProperties(workInProgress), null;
                    } else 2 * $76288626b30e899c$var$now() - newProps.renderingStartTime > $76288626b30e899c$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $76288626b30e899c$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $76288626b30e899c$var$now(), current.sibling = null, renderLanes = $76288626b30e899c$var$suspenseStackCursor.current, $76288626b30e899c$var$push($76288626b30e899c$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $76288626b30e899c$var$isHydrating && $76288626b30e899c$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $76288626b30e899c$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $76288626b30e899c$var$popSuspenseHandler(workInProgress), $76288626b30e899c$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($76288626b30e899c$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $76288626b30e899c$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $76288626b30e899c$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $76288626b30e899c$var$pop($76288626b30e899c$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext), $76288626b30e899c$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($76288626b30e899c$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $76288626b30e899c$var$unwindWork(current, workInProgress) {
    $76288626b30e899c$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext), $76288626b30e899c$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $76288626b30e899c$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $76288626b30e899c$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(340));
                $76288626b30e899c$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $76288626b30e899c$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($76288626b30e899c$var$formatProdErrorMessage(340));
                $76288626b30e899c$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor), null;
        case 4:
            return $76288626b30e899c$var$popHostContainer(), null;
        case 10:
            return $76288626b30e899c$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $76288626b30e899c$var$popSuspenseHandler(workInProgress), $76288626b30e899c$var$popHiddenContext(), null !== current && $76288626b30e899c$var$pop($76288626b30e899c$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $76288626b30e899c$var$unwindInterruptedWork(current, interruptedWork) {
    $76288626b30e899c$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext);
            $76288626b30e899c$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $76288626b30e899c$var$popHostContext(interruptedWork);
            break;
        case 4:
            $76288626b30e899c$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $76288626b30e899c$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $76288626b30e899c$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $76288626b30e899c$var$pop($76288626b30e899c$var$suspenseStackCursor);
            break;
        case 10:
            $76288626b30e899c$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $76288626b30e899c$var$popSuspenseHandler(interruptedWork);
            $76288626b30e899c$var$popHiddenContext();
            null !== current && $76288626b30e899c$var$pop($76288626b30e899c$var$resumedCache);
            break;
        case 24:
            $76288626b30e899c$var$popProvider($76288626b30e899c$var$CacheContext);
    }
}
function $76288626b30e899c$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $76288626b30e899c$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $76288626b30e899c$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $76288626b30e899c$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $76288626b30e899c$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $76288626b30e899c$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $76288626b30e899c$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $76288626b30e899c$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $76288626b30e899c$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$76288626b30e899c$var$internalPropsKey] = newProps;
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $76288626b30e899c$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $76288626b30e899c$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $76288626b30e899c$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $76288626b30e899c$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $76288626b30e899c$var$noop$1));
    else if (4 !== tag && (27 === tag && $76288626b30e899c$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $76288626b30e899c$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $76288626b30e899c$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($76288626b30e899c$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$76288626b30e899c$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $76288626b30e899c$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $76288626b30e899c$var$setInitialProperties(singleton, type, props);
        singleton[$76288626b30e899c$var$internalInstanceKey] = finishedWork;
        singleton[$76288626b30e899c$var$internalPropsKey] = props;
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $76288626b30e899c$var$offscreenSubtreeIsHidden = !1, $76288626b30e899c$var$offscreenSubtreeWasHidden = !1, $76288626b30e899c$var$needsFormReset = !1, $76288626b30e899c$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $76288626b30e899c$var$nextEffect = null;
function $76288626b30e899c$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $76288626b30e899c$var$eventsEnabled = $76288626b30e899c$var$_enabled;
    root = $76288626b30e899c$var$getActiveElementDeep(root);
    if ($76288626b30e899c$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $76288626b30e899c$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $76288626b30e899c$var$_enabled = !1;
    for($76288626b30e899c$var$nextEffect = firstChild; null !== $76288626b30e899c$var$nextEffect;)if (firstChild = $76288626b30e899c$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $76288626b30e899c$var$nextEffect = root;
    else for(; null !== $76288626b30e899c$var$nextEffect;){
        firstChild = $76288626b30e899c$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $76288626b30e899c$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $76288626b30e899c$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $76288626b30e899c$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $76288626b30e899c$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($76288626b30e899c$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $76288626b30e899c$var$nextEffect = root;
            break;
        }
        $76288626b30e899c$var$nextEffect = firstChild.return;
    }
}
function $76288626b30e899c$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $76288626b30e899c$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $76288626b30e899c$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $76288626b30e899c$var$commitClassCallbacks(finishedWork);
            flags & 512 && $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $76288626b30e899c$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $76288626b30e899c$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $76288626b30e899c$var$commitHostMount(finishedWork);
            flags & 512 && $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $76288626b30e899c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $76288626b30e899c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $76288626b30e899c$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $76288626b30e899c$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $76288626b30e899c$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $76288626b30e899c$var$offscreenSubtreeWasHidden;
                prevProps = $76288626b30e899c$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $76288626b30e899c$var$offscreenSubtreeWasHidden;
                $76288626b30e899c$var$offscreenSubtreeIsHidden = flags;
                ($76288626b30e899c$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $76288626b30e899c$var$offscreenSubtreeIsHidden = prevProps;
                $76288626b30e899c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $76288626b30e899c$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $76288626b30e899c$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $76288626b30e899c$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $76288626b30e899c$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $76288626b30e899c$var$hostParent = null, $76288626b30e899c$var$hostParentIsContainer = !1;
function $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$76288626b30e899c$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $76288626b30e899c$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.onCommitFiberUnmount) try {
        $76288626b30e899c$var$injectedHook.onCommitFiberUnmount($76288626b30e899c$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $76288626b30e899c$var$hostParent, prevHostParentIsContainer = $76288626b30e899c$var$hostParentIsContainer;
            $76288626b30e899c$var$isSingletonScope(deletedFiber.type) && ($76288626b30e899c$var$hostParent = deletedFiber.stateNode, $76288626b30e899c$var$hostParentIsContainer = !1);
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$releaseSingletonInstance(deletedFiber.stateNode);
            $76288626b30e899c$var$hostParent = prevHostParent;
            $76288626b30e899c$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $76288626b30e899c$var$hostParent;
            prevHostParentIsContainer = $76288626b30e899c$var$hostParentIsContainer;
            $76288626b30e899c$var$hostParent = null;
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$hostParent = prevHostParent;
            $76288626b30e899c$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $76288626b30e899c$var$hostParent) {
                if ($76288626b30e899c$var$hostParentIsContainer) try {
                    (9 === $76288626b30e899c$var$hostParent.nodeType ? $76288626b30e899c$var$hostParent.body : "HTML" === $76288626b30e899c$var$hostParent.nodeName ? $76288626b30e899c$var$hostParent.ownerDocument.body : $76288626b30e899c$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $76288626b30e899c$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $76288626b30e899c$var$hostParent && ($76288626b30e899c$var$hostParentIsContainer ? (finishedRoot = $76288626b30e899c$var$hostParent, $76288626b30e899c$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $76288626b30e899c$var$retryIfBlockedOn(finishedRoot)) : $76288626b30e899c$var$clearHydrationBoundary($76288626b30e899c$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $76288626b30e899c$var$hostParent;
            prevHostParentIsContainer = $76288626b30e899c$var$hostParentIsContainer;
            $76288626b30e899c$var$hostParent = deletedFiber.stateNode.containerInfo;
            $76288626b30e899c$var$hostParentIsContainer = !0;
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$hostParent = prevHostParent;
            $76288626b30e899c$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $76288626b30e899c$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $76288626b30e899c$var$offscreenSubtreeWasHidden || ($76288626b30e899c$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $76288626b30e899c$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $76288626b30e899c$var$offscreenSubtreeWasHidden = (prevHostParent = $76288626b30e899c$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $76288626b30e899c$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $76288626b30e899c$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $76288626b30e899c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $76288626b30e899c$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $76288626b30e899c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $76288626b30e899c$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $76288626b30e899c$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $76288626b30e899c$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $76288626b30e899c$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $76288626b30e899c$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $76288626b30e899c$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $76288626b30e899c$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($76288626b30e899c$var$isSingletonScope(parent.type)) {
                        $76288626b30e899c$var$hostParent = parent.stateNode;
                        $76288626b30e899c$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $76288626b30e899c$var$hostParent = parent.stateNode;
                    $76288626b30e899c$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $76288626b30e899c$var$hostParent = parent.stateNode.containerInfo;
                    $76288626b30e899c$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $76288626b30e899c$var$hostParent) throw Error($76288626b30e899c$var$formatProdErrorMessage(160));
        $76288626b30e899c$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $76288626b30e899c$var$hostParent = null;
        $76288626b30e899c$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $76288626b30e899c$var$currentHoistableRoot = null;
function $76288626b30e899c$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($76288626b30e899c$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $76288626b30e899c$var$commitHookEffectListMount(3, finishedWork), $76288626b30e899c$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            flags & 64 && $76288626b30e899c$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$76288626b30e899c$var$internalHoistableMarker] || currentResource[$76288626b30e899c$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $76288626b30e899c$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$76288626b30e899c$var$internalInstanceKey] = finishedWork;
                                        $76288626b30e899c$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $76288626b30e899c$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $76288626b30e899c$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $76288626b30e899c$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $76288626b30e899c$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($76288626b30e899c$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$76288626b30e899c$var$internalInstanceKey] = finishedWork;
                                $76288626b30e899c$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $76288626b30e899c$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $76288626b30e899c$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $76288626b30e899c$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $76288626b30e899c$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $76288626b30e899c$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $76288626b30e899c$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($76288626b30e899c$var$offscreenSubtreeWasHidden || null === current || $76288626b30e899c$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $76288626b30e899c$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $76288626b30e899c$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($76288626b30e899c$var$needsFormReset = !0);
            break;
        case 6:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($76288626b30e899c$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $76288626b30e899c$var$tagCaches = null;
            hoistableRoot = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$currentHoistableRoot = $76288626b30e899c$var$getHoistableRoot(root.containerInfo);
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$currentHoistableRoot = hoistableRoot;
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $76288626b30e899c$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $76288626b30e899c$var$needsFormReset && ($76288626b30e899c$var$needsFormReset = !1, $76288626b30e899c$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$currentHoistableRoot = $76288626b30e899c$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            $76288626b30e899c$var$currentHoistableRoot = flags;
            break;
        case 12:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($76288626b30e899c$var$globalMostRecentFallbackTime = $76288626b30e899c$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $76288626b30e899c$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $76288626b30e899c$var$offscreenSubtreeWasHidden;
            $76288626b30e899c$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $76288626b30e899c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $76288626b30e899c$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $76288626b30e899c$var$offscreenSubtreeIsHidden || $76288626b30e899c$var$offscreenSubtreeWasHidden || $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $76288626b30e899c$var$hideOrUnhideDehydratedBoundary(instance, !0) : $76288626b30e899c$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $76288626b30e899c$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $76288626b30e899c$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $76288626b30e899c$var$recursivelyTraverseMutationEffects(root, finishedWork), $76288626b30e899c$var$commitReconciliationEffects(finishedWork);
    }
}
function $76288626b30e899c$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($76288626b30e899c$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($76288626b30e899c$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $76288626b30e899c$var$getHostSibling(finishedWork);
                    $76288626b30e899c$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($76288626b30e899c$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $76288626b30e899c$var$getHostSibling(finishedWork);
                    $76288626b30e899c$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $76288626b30e899c$var$getHostSibling(finishedWork);
                    $76288626b30e899c$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $76288626b30e899c$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $76288626b30e899c$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $76288626b30e899c$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $76288626b30e899c$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $76288626b30e899c$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $76288626b30e899c$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $76288626b30e899c$var$safelyDetachRef(finishedWork, finishedWork.return);
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $76288626b30e899c$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$76288626b30e899c$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $76288626b30e899c$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $76288626b30e899c$var$commitClassCallbacks(finishedWork);
                $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $76288626b30e899c$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $76288626b30e899c$var$commitHostMount(finishedWork);
                $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $76288626b30e899c$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $76288626b30e899c$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $76288626b30e899c$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $76288626b30e899c$var$releaseCache(previousCache));
}
function $76288626b30e899c$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $76288626b30e899c$var$releaseCache(current));
}
function $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $76288626b30e899c$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $76288626b30e899c$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $76288626b30e899c$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $76288626b30e899c$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $76288626b30e899c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $76288626b30e899c$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $76288626b30e899c$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $76288626b30e899c$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $76288626b30e899c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $76288626b30e899c$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $76288626b30e899c$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $76288626b30e899c$var$suspenseyCommitFlag = 8192;
function $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $76288626b30e899c$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $76288626b30e899c$var$suspenseyCommitFlag && null !== fiber.memoizedState && $76288626b30e899c$var$suspendResource(suspendedState, $76288626b30e899c$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $76288626b30e899c$var$currentHoistableRoot;
            $76288626b30e899c$var$currentHoistableRoot = $76288626b30e899c$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $76288626b30e899c$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $76288626b30e899c$var$suspenseyCommitFlag, $76288626b30e899c$var$suspenseyCommitFlag = 16777216, $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $76288626b30e899c$var$suspenseyCommitFlag = previousHoistableRoot) : $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $76288626b30e899c$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $76288626b30e899c$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $76288626b30e899c$var$nextEffect = childToDelete;
            $76288626b30e899c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $76288626b30e899c$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$76288626b30e899c$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $76288626b30e899c$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $76288626b30e899c$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $76288626b30e899c$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $76288626b30e899c$var$nextEffect = childToDelete;
            $76288626b30e899c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $76288626b30e899c$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $76288626b30e899c$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $76288626b30e899c$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $76288626b30e899c$var$nextEffect;){
        var fiber = $76288626b30e899c$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $76288626b30e899c$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $76288626b30e899c$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $76288626b30e899c$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $76288626b30e899c$var$nextEffect;){
            cache = $76288626b30e899c$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $76288626b30e899c$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $76288626b30e899c$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $76288626b30e899c$var$nextEffect = sibling;
                break a;
            }
            $76288626b30e899c$var$nextEffect = returnFiber;
        }
    }
}
var $76288626b30e899c$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $76288626b30e899c$var$readContext($76288626b30e899c$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $76288626b30e899c$var$readContext($76288626b30e899c$var$CacheContext).controller.signal;
    }
}, $76288626b30e899c$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $76288626b30e899c$var$executionContext = 0, $76288626b30e899c$var$workInProgressRoot = null, $76288626b30e899c$var$workInProgress = null, $76288626b30e899c$var$workInProgressRootRenderLanes = 0, $76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings = !1, $76288626b30e899c$var$workInProgressRootIsPrerendering = !1, $76288626b30e899c$var$workInProgressRootDidAttachPingListener = !1, $76288626b30e899c$var$entangledRenderLanes = 0, $76288626b30e899c$var$workInProgressRootExitStatus = 0, $76288626b30e899c$var$workInProgressRootSkippedLanes = 0, $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes = 0, $76288626b30e899c$var$workInProgressRootPingedLanes = 0, $76288626b30e899c$var$workInProgressDeferredLane = 0, $76288626b30e899c$var$workInProgressSuspendedRetryLanes = 0, $76288626b30e899c$var$workInProgressRootConcurrentErrors = null, $76288626b30e899c$var$workInProgressRootRecoverableErrors = null, $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $76288626b30e899c$var$globalMostRecentFallbackTime = 0, $76288626b30e899c$var$globalMostRecentTransitionTime = 0, $76288626b30e899c$var$workInProgressRootRenderTargetTime = Infinity, $76288626b30e899c$var$workInProgressTransitions = null, $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed = null, $76288626b30e899c$var$pendingEffectsStatus = 0, $76288626b30e899c$var$pendingEffectsRoot = null, $76288626b30e899c$var$pendingFinishedWork = null, $76288626b30e899c$var$pendingEffectsLanes = 0, $76288626b30e899c$var$pendingEffectsRemainingLanes = 0, $76288626b30e899c$var$pendingPassiveTransitions = null, $76288626b30e899c$var$pendingRecoverableErrors = null, $76288626b30e899c$var$nestedUpdateCount = 0, $76288626b30e899c$var$rootWithNestedUpdates = null;
function $76288626b30e899c$var$requestUpdateLane() {
    return 0 !== ($76288626b30e899c$var$executionContext & 2) && 0 !== $76288626b30e899c$var$workInProgressRootRenderLanes ? $76288626b30e899c$var$workInProgressRootRenderLanes & -$76288626b30e899c$var$workInProgressRootRenderLanes : null !== $76288626b30e899c$var$ReactSharedInternals.T ? $76288626b30e899c$var$requestTransitionLane() : $76288626b30e899c$var$resolveUpdatePriority();
}
function $76288626b30e899c$var$requestDeferredLane() {
    if (0 === $76288626b30e899c$var$workInProgressDeferredLane) {
        if (0 === ($76288626b30e899c$var$workInProgressRootRenderLanes & 536870912) || $76288626b30e899c$var$isHydrating) {
            var lane = $76288626b30e899c$var$nextTransitionDeferredLane;
            $76288626b30e899c$var$nextTransitionDeferredLane <<= 1;
            0 === ($76288626b30e899c$var$nextTransitionDeferredLane & 3932160) && ($76288626b30e899c$var$nextTransitionDeferredLane = 262144);
            $76288626b30e899c$var$workInProgressDeferredLane = lane;
        } else $76288626b30e899c$var$workInProgressDeferredLane = 536870912;
    }
    lane = $76288626b30e899c$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $76288626b30e899c$var$workInProgressDeferredLane;
}
function $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $76288626b30e899c$var$workInProgressRoot && (2 === $76288626b30e899c$var$workInProgressSuspendedReason || 9 === $76288626b30e899c$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $76288626b30e899c$var$prepareFreshStack(root, 0), $76288626b30e899c$var$markRootSuspended(root, $76288626b30e899c$var$workInProgressRootRenderLanes, $76288626b30e899c$var$workInProgressDeferredLane, !1);
    $76288626b30e899c$var$markRootUpdated$1(root, lane);
    if (0 === ($76288626b30e899c$var$executionContext & 2) || root !== $76288626b30e899c$var$workInProgressRoot) root === $76288626b30e899c$var$workInProgressRoot && (0 === ($76288626b30e899c$var$executionContext & 2) && ($76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $76288626b30e899c$var$workInProgressRootExitStatus && $76288626b30e899c$var$markRootSuspended(root, $76288626b30e899c$var$workInProgressRootRenderLanes, $76288626b30e899c$var$workInProgressDeferredLane, !1)), $76288626b30e899c$var$ensureRootIsScheduled(root);
}
function $76288626b30e899c$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($76288626b30e899c$var$executionContext & 6)) throw Error($76288626b30e899c$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $76288626b30e899c$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $76288626b30e899c$var$renderRootConcurrent(root$jscomp$0, lanes) : $76288626b30e899c$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $76288626b30e899c$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $76288626b30e899c$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$76288626b30e899c$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $76288626b30e899c$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $76288626b30e899c$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($76288626b30e899c$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $76288626b30e899c$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($76288626b30e899c$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $76288626b30e899c$var$workInProgressRootRecoverableErrors;
                            $76288626b30e899c$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $76288626b30e899c$var$workInProgressRootRecoverableErrors ? $76288626b30e899c$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $76288626b30e899c$var$workInProgressRootRecoverableErrors.push.apply($76288626b30e899c$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $76288626b30e899c$var$prepareFreshStack(root$jscomp$0, 0);
                $76288626b30e899c$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($76288626b30e899c$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $76288626b30e899c$var$markRootSuspended(shouldTimeSlice, lanes, $76288626b30e899c$var$workInProgressDeferredLane, !$76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $76288626b30e899c$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($76288626b30e899c$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $76288626b30e899c$var$globalMostRecentFallbackTime + 300 - $76288626b30e899c$var$now(), 10 < exitStatus)) {
                    $76288626b30e899c$var$markRootSuspended(shouldTimeSlice, lanes, $76288626b30e899c$var$workInProgressDeferredLane, !$76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $76288626b30e899c$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $76288626b30e899c$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $76288626b30e899c$var$scheduleTimeout($76288626b30e899c$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $76288626b30e899c$var$workInProgressRootRecoverableErrors, $76288626b30e899c$var$workInProgressTransitions, $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $76288626b30e899c$var$workInProgressDeferredLane, $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes, $76288626b30e899c$var$workInProgressSuspendedRetryLanes, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $76288626b30e899c$var$commitRootWhenReady(shouldTimeSlice, forceSync, $76288626b30e899c$var$workInProgressRootRecoverableErrors, $76288626b30e899c$var$workInProgressTransitions, $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $76288626b30e899c$var$workInProgressDeferredLane, $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes, $76288626b30e899c$var$workInProgressSuspendedRetryLanes, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $76288626b30e899c$var$ensureRootIsScheduled(root$jscomp$0);
}
function $76288626b30e899c$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $76288626b30e899c$var$noop$1
        };
        $76288626b30e899c$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $76288626b30e899c$var$globalMostRecentFallbackTime - $76288626b30e899c$var$now() : (lanes & 4194048) === lanes ? $76288626b30e899c$var$globalMostRecentTransitionTime - $76288626b30e899c$var$now() : 0;
        timeoutOffset = $76288626b30e899c$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $76288626b30e899c$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($76288626b30e899c$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $76288626b30e899c$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $76288626b30e899c$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $76288626b30e899c$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$76288626b30e899c$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $76288626b30e899c$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$76288626b30e899c$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $76288626b30e899c$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $76288626b30e899c$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $76288626b30e899c$var$flushSyncWork$1() {
    return 0 === ($76288626b30e899c$var$executionContext & 6) ? ($76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $76288626b30e899c$var$resetWorkInProgressStack() {
    if (null !== $76288626b30e899c$var$workInProgress) {
        if (0 === $76288626b30e899c$var$workInProgressSuspendedReason) var interruptedWork = $76288626b30e899c$var$workInProgress.return;
        else interruptedWork = $76288626b30e899c$var$workInProgress, $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null, $76288626b30e899c$var$resetHooksOnUnwind(interruptedWork), $76288626b30e899c$var$thenableState$1 = null, $76288626b30e899c$var$thenableIndexCounter$1 = 0, interruptedWork = $76288626b30e899c$var$workInProgress;
        for(; null !== interruptedWork;)$76288626b30e899c$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $76288626b30e899c$var$workInProgress = null;
    }
}
function $76288626b30e899c$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $76288626b30e899c$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $76288626b30e899c$var$pendingEffectsLanes = 0;
    $76288626b30e899c$var$resetWorkInProgressStack();
    $76288626b30e899c$var$workInProgressRoot = root;
    $76288626b30e899c$var$workInProgress = timeoutHandle = $76288626b30e899c$var$createWorkInProgress(root.current, null);
    $76288626b30e899c$var$workInProgressRootRenderLanes = lanes;
    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
    $76288626b30e899c$var$workInProgressThrownValue = null;
    $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $76288626b30e899c$var$workInProgressRootIsPrerendering = $76288626b30e899c$var$checkIfRootIsPrerendering(root, lanes);
    $76288626b30e899c$var$workInProgressRootDidAttachPingListener = !1;
    $76288626b30e899c$var$workInProgressSuspendedRetryLanes = $76288626b30e899c$var$workInProgressDeferredLane = $76288626b30e899c$var$workInProgressRootPingedLanes = $76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes = $76288626b30e899c$var$workInProgressRootSkippedLanes = $76288626b30e899c$var$workInProgressRootExitStatus = 0;
    $76288626b30e899c$var$workInProgressRootRecoverableErrors = $76288626b30e899c$var$workInProgressRootConcurrentErrors = null;
    $76288626b30e899c$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $76288626b30e899c$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $76288626b30e899c$var$entangledRenderLanes = lanes;
    $76288626b30e899c$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $76288626b30e899c$var$handleThrow(root, thrownValue) {
    $76288626b30e899c$var$currentlyRenderingFiber = null;
    $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$ContextOnlyDispatcher;
    thrownValue === $76288626b30e899c$var$SuspenseException || thrownValue === $76288626b30e899c$var$SuspenseActionException ? (thrownValue = $76288626b30e899c$var$getSuspendedThenable(), $76288626b30e899c$var$workInProgressSuspendedReason = 3) : thrownValue === $76288626b30e899c$var$SuspenseyCommitException ? (thrownValue = $76288626b30e899c$var$getSuspendedThenable(), $76288626b30e899c$var$workInProgressSuspendedReason = 4) : $76288626b30e899c$var$workInProgressSuspendedReason = thrownValue === $76288626b30e899c$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $76288626b30e899c$var$workInProgressThrownValue = thrownValue;
    null === $76288626b30e899c$var$workInProgress && ($76288626b30e899c$var$workInProgressRootExitStatus = 1, $76288626b30e899c$var$logUncaughtError(root, $76288626b30e899c$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $76288626b30e899c$var$shouldRemainOnPreviousScreen() {
    var handler = $76288626b30e899c$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($76288626b30e899c$var$workInProgressRootRenderLanes & 4194048) === $76288626b30e899c$var$workInProgressRootRenderLanes ? null === $76288626b30e899c$var$shellBoundary ? !0 : !1 : ($76288626b30e899c$var$workInProgressRootRenderLanes & 62914560) === $76288626b30e899c$var$workInProgressRootRenderLanes || 0 !== ($76288626b30e899c$var$workInProgressRootRenderLanes & 536870912) ? handler === $76288626b30e899c$var$shellBoundary : !1;
}
function $76288626b30e899c$var$pushDispatcher() {
    var prevDispatcher = $76288626b30e899c$var$ReactSharedInternals.H;
    $76288626b30e899c$var$ReactSharedInternals.H = $76288626b30e899c$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $76288626b30e899c$var$ContextOnlyDispatcher : prevDispatcher;
}
function $76288626b30e899c$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $76288626b30e899c$var$ReactSharedInternals.A;
    $76288626b30e899c$var$ReactSharedInternals.A = $76288626b30e899c$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $76288626b30e899c$var$renderDidSuspendDelayIfPossible() {
    $76288626b30e899c$var$workInProgressRootExitStatus = 4;
    $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings || ($76288626b30e899c$var$workInProgressRootRenderLanes & 4194048) !== $76288626b30e899c$var$workInProgressRootRenderLanes && null !== $76288626b30e899c$var$suspenseHandlerStackCursor.current || ($76288626b30e899c$var$workInProgressRootIsPrerendering = !0);
    0 === ($76288626b30e899c$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($76288626b30e899c$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $76288626b30e899c$var$workInProgressRoot || $76288626b30e899c$var$markRootSuspended($76288626b30e899c$var$workInProgressRoot, $76288626b30e899c$var$workInProgressRootRenderLanes, $76288626b30e899c$var$workInProgressDeferredLane, !1);
}
function $76288626b30e899c$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $76288626b30e899c$var$executionContext;
    $76288626b30e899c$var$executionContext |= 2;
    var prevDispatcher = $76288626b30e899c$var$pushDispatcher(), prevAsyncDispatcher = $76288626b30e899c$var$pushAsyncDispatcher();
    if ($76288626b30e899c$var$workInProgressRoot !== root || $76288626b30e899c$var$workInProgressRootRenderLanes !== lanes) $76288626b30e899c$var$workInProgressTransitions = null, $76288626b30e899c$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $76288626b30e899c$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $76288626b30e899c$var$workInProgressSuspendedReason && null !== $76288626b30e899c$var$workInProgress) {
            var unitOfWork = $76288626b30e899c$var$workInProgress, thrownValue = $76288626b30e899c$var$workInProgressThrownValue;
            switch($76288626b30e899c$var$workInProgressSuspendedReason){
                case 8:
                    $76288626b30e899c$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $76288626b30e899c$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $76288626b30e899c$var$workInProgressSuspendedReason;
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $76288626b30e899c$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $76288626b30e899c$var$workInProgressSuspendedReason, $76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $76288626b30e899c$var$workLoopSync();
        exitStatus = $76288626b30e899c$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $76288626b30e899c$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null;
    $76288626b30e899c$var$executionContext = prevExecutionContext;
    $76288626b30e899c$var$ReactSharedInternals.H = prevDispatcher;
    $76288626b30e899c$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $76288626b30e899c$var$workInProgress && ($76288626b30e899c$var$workInProgressRoot = null, $76288626b30e899c$var$workInProgressRootRenderLanes = 0, $76288626b30e899c$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $76288626b30e899c$var$workLoopSync() {
    for(; null !== $76288626b30e899c$var$workInProgress;)$76288626b30e899c$var$performUnitOfWork($76288626b30e899c$var$workInProgress);
}
function $76288626b30e899c$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $76288626b30e899c$var$executionContext;
    $76288626b30e899c$var$executionContext |= 2;
    var prevDispatcher = $76288626b30e899c$var$pushDispatcher(), prevAsyncDispatcher = $76288626b30e899c$var$pushAsyncDispatcher();
    $76288626b30e899c$var$workInProgressRoot !== root || $76288626b30e899c$var$workInProgressRootRenderLanes !== lanes ? ($76288626b30e899c$var$workInProgressTransitions = null, $76288626b30e899c$var$workInProgressRootRenderTargetTime = $76288626b30e899c$var$now() + 500, $76288626b30e899c$var$prepareFreshStack(root, lanes)) : $76288626b30e899c$var$workInProgressRootIsPrerendering = $76288626b30e899c$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $76288626b30e899c$var$workInProgressSuspendedReason && null !== $76288626b30e899c$var$workInProgress) {
            lanes = $76288626b30e899c$var$workInProgress;
            var thrownValue = $76288626b30e899c$var$workInProgressThrownValue;
            b: switch($76288626b30e899c$var$workInProgressSuspendedReason){
                case 1:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($76288626b30e899c$var$isThenableResolved(thrownValue)) {
                        $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                        $76288626b30e899c$var$workInProgressThrownValue = null;
                        $76288626b30e899c$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $76288626b30e899c$var$workInProgressSuspendedReason && 9 !== $76288626b30e899c$var$workInProgressSuspendedReason || $76288626b30e899c$var$workInProgressRoot !== root || ($76288626b30e899c$var$workInProgressSuspendedReason = 7);
                        $76288626b30e899c$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $76288626b30e899c$var$isThenableResolved(thrownValue) ? ($76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$replaySuspendedUnitOfWork(lanes)) : ($76288626b30e899c$var$workInProgressSuspendedReason = 0, $76288626b30e899c$var$workInProgressThrownValue = null, $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($76288626b30e899c$var$workInProgress.tag){
                        case 26:
                            resource = $76288626b30e899c$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $76288626b30e899c$var$workInProgress;
                            if (resource ? $76288626b30e899c$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                                $76288626b30e899c$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $76288626b30e899c$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($76288626b30e899c$var$workInProgress = returnFiber, $76288626b30e899c$var$completeUnitOfWork(returnFiber)) : $76288626b30e899c$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $76288626b30e899c$var$workInProgressSuspendedReason = 0;
                    $76288626b30e899c$var$workInProgressThrownValue = null;
                    $76288626b30e899c$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $76288626b30e899c$var$resetWorkInProgressStack();
                    $76288626b30e899c$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(462));
            }
        }
        $76288626b30e899c$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $76288626b30e899c$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null;
    $76288626b30e899c$var$ReactSharedInternals.H = prevDispatcher;
    $76288626b30e899c$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $76288626b30e899c$var$executionContext = prevExecutionContext;
    if (null !== $76288626b30e899c$var$workInProgress) return 0;
    $76288626b30e899c$var$workInProgressRoot = null;
    $76288626b30e899c$var$workInProgressRootRenderLanes = 0;
    $76288626b30e899c$var$finishQueueingConcurrentUpdates();
    return $76288626b30e899c$var$workInProgressRootExitStatus;
}
function $76288626b30e899c$var$workLoopConcurrentByScheduler() {
    for(; null !== $76288626b30e899c$var$workInProgress && !$76288626b30e899c$var$shouldYield();)$76288626b30e899c$var$performUnitOfWork($76288626b30e899c$var$workInProgress);
}
function $76288626b30e899c$var$performUnitOfWork(unitOfWork) {
    var next = $76288626b30e899c$var$beginWork(unitOfWork.alternate, unitOfWork, $76288626b30e899c$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $76288626b30e899c$var$completeUnitOfWork(unitOfWork) : $76288626b30e899c$var$workInProgress = next;
}
function $76288626b30e899c$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $76288626b30e899c$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $76288626b30e899c$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $76288626b30e899c$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $76288626b30e899c$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $76288626b30e899c$var$resetHooksOnUnwind(next);
        default:
            $76288626b30e899c$var$unwindInterruptedWork(current, next), next = $76288626b30e899c$var$workInProgress = $76288626b30e899c$var$resetWorkInProgress(next, $76288626b30e899c$var$entangledRenderLanes), next = $76288626b30e899c$var$beginWork(current, next, $76288626b30e899c$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $76288626b30e899c$var$completeUnitOfWork(unitOfWork) : $76288626b30e899c$var$workInProgress = next;
}
function $76288626b30e899c$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $76288626b30e899c$var$lastContextDependency = $76288626b30e899c$var$currentlyRenderingFiber$1 = null;
    $76288626b30e899c$var$resetHooksOnUnwind(unitOfWork);
    $76288626b30e899c$var$thenableState$1 = null;
    $76288626b30e899c$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($76288626b30e899c$var$throwException(root, returnFiber, unitOfWork, thrownValue, $76288626b30e899c$var$workInProgressRootRenderLanes)) {
            $76288626b30e899c$var$workInProgressRootExitStatus = 1;
            $76288626b30e899c$var$logUncaughtError(root, $76288626b30e899c$var$createCapturedValueAtFiber(thrownValue, root.current));
            $76288626b30e899c$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $76288626b30e899c$var$workInProgress = returnFiber, error;
        $76288626b30e899c$var$workInProgressRootExitStatus = 1;
        $76288626b30e899c$var$logUncaughtError(root, $76288626b30e899c$var$createCapturedValueAtFiber(thrownValue, root.current));
        $76288626b30e899c$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($76288626b30e899c$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($76288626b30e899c$var$workInProgressRootIsPrerendering || 0 !== ($76288626b30e899c$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $76288626b30e899c$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $76288626b30e899c$var$unwindUnitOfWork(unitOfWork, root);
    } else $76288626b30e899c$var$completeUnitOfWork(unitOfWork);
}
function $76288626b30e899c$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $76288626b30e899c$var$unwindUnitOfWork(completedWork, $76288626b30e899c$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $76288626b30e899c$var$completeWork(completedWork.alternate, completedWork, $76288626b30e899c$var$entangledRenderLanes);
        if (null !== next) {
            $76288626b30e899c$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $76288626b30e899c$var$workInProgress = completedWork;
            return;
        }
        $76288626b30e899c$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootExitStatus = 5);
}
function $76288626b30e899c$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $76288626b30e899c$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $76288626b30e899c$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $76288626b30e899c$var$workInProgress = unitOfWork;
            return;
        }
        $76288626b30e899c$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $76288626b30e899c$var$workInProgressRootExitStatus = 6;
    $76288626b30e899c$var$workInProgress = null;
}
function $76288626b30e899c$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $76288626b30e899c$var$flushPendingEffects();
    while (0 !== $76288626b30e899c$var$pendingEffectsStatus);
    if (0 !== ($76288626b30e899c$var$executionContext & 6)) throw Error($76288626b30e899c$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($76288626b30e899c$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $76288626b30e899c$var$concurrentlyUpdatedLanes;
        $76288626b30e899c$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $76288626b30e899c$var$workInProgressRoot && ($76288626b30e899c$var$workInProgress = $76288626b30e899c$var$workInProgressRoot = null, $76288626b30e899c$var$workInProgressRootRenderLanes = 0);
        $76288626b30e899c$var$pendingFinishedWork = finishedWork;
        $76288626b30e899c$var$pendingEffectsRoot = root;
        $76288626b30e899c$var$pendingEffectsLanes = lanes;
        $76288626b30e899c$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $76288626b30e899c$var$pendingPassiveTransitions = transitions;
        $76288626b30e899c$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $76288626b30e899c$var$scheduleCallback$1($76288626b30e899c$var$NormalPriority$1, function() {
            $76288626b30e899c$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $76288626b30e899c$var$ReactSharedInternals.T;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            transitions = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $76288626b30e899c$var$executionContext;
            $76288626b30e899c$var$executionContext |= 4;
            try {
                $76288626b30e899c$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $76288626b30e899c$var$executionContext = spawnedLane, $76288626b30e899c$var$ReactDOMSharedInternals.p = transitions, $76288626b30e899c$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $76288626b30e899c$var$pendingEffectsStatus = 1;
        $76288626b30e899c$var$flushMutationEffects();
        $76288626b30e899c$var$flushLayoutEffects();
        $76288626b30e899c$var$flushSpawnedWork();
    }
}
function $76288626b30e899c$var$flushMutationEffects() {
    if (1 === $76288626b30e899c$var$pendingEffectsStatus) {
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        var root = $76288626b30e899c$var$pendingEffectsRoot, finishedWork = $76288626b30e899c$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $76288626b30e899c$var$ReactSharedInternals.T;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $76288626b30e899c$var$executionContext;
            $76288626b30e899c$var$executionContext |= 4;
            try {
                $76288626b30e899c$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $76288626b30e899c$var$selectionInformation, curFocusedElem = $76288626b30e899c$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $76288626b30e899c$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $76288626b30e899c$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $76288626b30e899c$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $76288626b30e899c$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $76288626b30e899c$var$_enabled = !!$76288626b30e899c$var$eventsEnabled;
                $76288626b30e899c$var$selectionInformation = $76288626b30e899c$var$eventsEnabled = null;
            } finally{
                $76288626b30e899c$var$executionContext = prevExecutionContext, $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $76288626b30e899c$var$pendingEffectsStatus = 2;
    }
}
function $76288626b30e899c$var$flushLayoutEffects() {
    if (2 === $76288626b30e899c$var$pendingEffectsStatus) {
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        var root = $76288626b30e899c$var$pendingEffectsRoot, finishedWork = $76288626b30e899c$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $76288626b30e899c$var$ReactSharedInternals.T;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $76288626b30e899c$var$executionContext;
            $76288626b30e899c$var$executionContext |= 4;
            try {
                $76288626b30e899c$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $76288626b30e899c$var$executionContext = prevExecutionContext, $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $76288626b30e899c$var$pendingEffectsStatus = 3;
    }
}
function $76288626b30e899c$var$flushSpawnedWork() {
    if (4 === $76288626b30e899c$var$pendingEffectsStatus || 3 === $76288626b30e899c$var$pendingEffectsStatus) {
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        $76288626b30e899c$var$requestPaint();
        var root = $76288626b30e899c$var$pendingEffectsRoot, finishedWork = $76288626b30e899c$var$pendingFinishedWork, lanes = $76288626b30e899c$var$pendingEffectsLanes, recoverableErrors = $76288626b30e899c$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $76288626b30e899c$var$pendingEffectsStatus = 5 : ($76288626b30e899c$var$pendingEffectsStatus = 0, $76288626b30e899c$var$pendingFinishedWork = $76288626b30e899c$var$pendingEffectsRoot = null, $76288626b30e899c$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $76288626b30e899c$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.onCommitFiberRoot) try {
            $76288626b30e899c$var$injectedHook.onCommitFiberRoot($76288626b30e899c$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $76288626b30e899c$var$ReactSharedInternals.T;
            remainingLanes = $76288626b30e899c$var$ReactDOMSharedInternals.p;
            $76288626b30e899c$var$ReactDOMSharedInternals.p = 2;
            $76288626b30e899c$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $76288626b30e899c$var$ReactSharedInternals.T = finishedWork, $76288626b30e899c$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($76288626b30e899c$var$pendingEffectsLanes & 3) && $76288626b30e899c$var$flushPendingEffects();
        $76288626b30e899c$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $76288626b30e899c$var$rootWithNestedUpdates ? $76288626b30e899c$var$nestedUpdateCount++ : ($76288626b30e899c$var$nestedUpdateCount = 0, $76288626b30e899c$var$rootWithNestedUpdates = root) : $76288626b30e899c$var$nestedUpdateCount = 0;
        $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $76288626b30e899c$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $76288626b30e899c$var$releaseCache(remainingLanes)));
}
function $76288626b30e899c$var$flushPendingEffects() {
    $76288626b30e899c$var$flushMutationEffects();
    $76288626b30e899c$var$flushLayoutEffects();
    $76288626b30e899c$var$flushSpawnedWork();
    return $76288626b30e899c$var$flushPassiveEffects();
}
function $76288626b30e899c$var$flushPassiveEffects() {
    if (5 !== $76288626b30e899c$var$pendingEffectsStatus) return !1;
    var root = $76288626b30e899c$var$pendingEffectsRoot, remainingLanes = $76288626b30e899c$var$pendingEffectsRemainingLanes;
    $76288626b30e899c$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $76288626b30e899c$var$lanesToEventPriority($76288626b30e899c$var$pendingEffectsLanes), prevTransition = $76288626b30e899c$var$ReactSharedInternals.T, previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        $76288626b30e899c$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $76288626b30e899c$var$ReactSharedInternals.T = null;
        renderPriority = $76288626b30e899c$var$pendingPassiveTransitions;
        $76288626b30e899c$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $76288626b30e899c$var$pendingEffectsRoot, lanes = $76288626b30e899c$var$pendingEffectsLanes;
        $76288626b30e899c$var$pendingEffectsStatus = 0;
        $76288626b30e899c$var$pendingFinishedWork = $76288626b30e899c$var$pendingEffectsRoot = null;
        $76288626b30e899c$var$pendingEffectsLanes = 0;
        if (0 !== ($76288626b30e899c$var$executionContext & 6)) throw Error($76288626b30e899c$var$formatProdErrorMessage(331));
        var prevExecutionContext = $76288626b30e899c$var$executionContext;
        $76288626b30e899c$var$executionContext |= 4;
        $76288626b30e899c$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $76288626b30e899c$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $76288626b30e899c$var$executionContext = prevExecutionContext;
        $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($76288626b30e899c$var$injectedHook && "function" === typeof $76288626b30e899c$var$injectedHook.onPostCommitFiberRoot) try {
            $76288626b30e899c$var$injectedHook.onPostCommitFiberRoot($76288626b30e899c$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = prevTransition, $76288626b30e899c$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $76288626b30e899c$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $76288626b30e899c$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $76288626b30e899c$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $76288626b30e899c$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($76288626b30e899c$var$markRootUpdated$1(rootFiber, 2), $76288626b30e899c$var$ensureRootIsScheduled(rootFiber));
}
function $76288626b30e899c$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $76288626b30e899c$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $76288626b30e899c$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed || !$76288626b30e899c$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $76288626b30e899c$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $76288626b30e899c$var$createClassErrorUpdate(2);
                instance = $76288626b30e899c$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($76288626b30e899c$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $76288626b30e899c$var$markRootUpdated$1(instance, 2), $76288626b30e899c$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $76288626b30e899c$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $76288626b30e899c$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($76288626b30e899c$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $76288626b30e899c$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $76288626b30e899c$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $76288626b30e899c$var$workInProgressRoot === root && ($76288626b30e899c$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $76288626b30e899c$var$workInProgressRootExitStatus || 3 === $76288626b30e899c$var$workInProgressRootExitStatus && ($76288626b30e899c$var$workInProgressRootRenderLanes & 62914560) === $76288626b30e899c$var$workInProgressRootRenderLanes && 300 > $76288626b30e899c$var$now() - $76288626b30e899c$var$globalMostRecentFallbackTime ? 0 === ($76288626b30e899c$var$executionContext & 2) && $76288626b30e899c$var$prepareFreshStack(root, 0) : $76288626b30e899c$var$workInProgressRootPingedLanes |= pingedLanes, $76288626b30e899c$var$workInProgressSuspendedRetryLanes === $76288626b30e899c$var$workInProgressRootRenderLanes && ($76288626b30e899c$var$workInProgressSuspendedRetryLanes = 0));
    $76288626b30e899c$var$ensureRootIsScheduled(root);
}
function $76288626b30e899c$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $76288626b30e899c$var$claimNextRetryLane());
    boundaryFiber = $76288626b30e899c$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($76288626b30e899c$var$markRootUpdated$1(boundaryFiber, retryLane), $76288626b30e899c$var$ensureRootIsScheduled(boundaryFiber));
}
function $76288626b30e899c$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $76288626b30e899c$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $76288626b30e899c$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $76288626b30e899c$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $76288626b30e899c$var$scheduleCallback$1(priorityLevel, callback) {
    return $76288626b30e899c$var$scheduleCallback$3(priorityLevel, callback);
}
var $76288626b30e899c$var$firstScheduledRoot = null, $76288626b30e899c$var$lastScheduledRoot = null, $76288626b30e899c$var$didScheduleMicrotask = !1, $76288626b30e899c$var$mightHavePendingSyncWork = !1, $76288626b30e899c$var$isFlushingWork = !1, $76288626b30e899c$var$currentEventTransitionLane = 0;
function $76288626b30e899c$var$ensureRootIsScheduled(root) {
    root !== $76288626b30e899c$var$lastScheduledRoot && null === root.next && (null === $76288626b30e899c$var$lastScheduledRoot ? $76288626b30e899c$var$firstScheduledRoot = $76288626b30e899c$var$lastScheduledRoot = root : $76288626b30e899c$var$lastScheduledRoot = $76288626b30e899c$var$lastScheduledRoot.next = root);
    $76288626b30e899c$var$mightHavePendingSyncWork = !0;
    $76288626b30e899c$var$didScheduleMicrotask || ($76288626b30e899c$var$didScheduleMicrotask = !0, $76288626b30e899c$var$scheduleImmediateRootScheduleTask());
}
function $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$76288626b30e899c$var$isFlushingWork && $76288626b30e899c$var$mightHavePendingSyncWork) {
        $76288626b30e899c$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $76288626b30e899c$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $76288626b30e899c$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $76288626b30e899c$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $76288626b30e899c$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $76288626b30e899c$var$getNextLanes(root$170, root$170 === $76288626b30e899c$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $76288626b30e899c$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $76288626b30e899c$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $76288626b30e899c$var$isFlushingWork = !1;
    }
}
function $76288626b30e899c$var$processRootScheduleInImmediateTask() {
    $76288626b30e899c$var$processRootScheduleInMicrotask();
}
function $76288626b30e899c$var$processRootScheduleInMicrotask() {
    $76288626b30e899c$var$mightHavePendingSyncWork = $76288626b30e899c$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $76288626b30e899c$var$currentEventTransitionLane && $76288626b30e899c$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $76288626b30e899c$var$currentEventTransitionLane);
    for(var currentTime = $76288626b30e899c$var$now(), prev = null, root = $76288626b30e899c$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $76288626b30e899c$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $76288626b30e899c$var$firstScheduledRoot = next : prev.next = next, null === next && ($76288626b30e899c$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $76288626b30e899c$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $76288626b30e899c$var$pendingEffectsStatus && 5 !== $76288626b30e899c$var$pendingEffectsStatus || $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $76288626b30e899c$var$currentEventTransitionLane && ($76288626b30e899c$var$currentEventTransitionLane = 0);
}
function $76288626b30e899c$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $76288626b30e899c$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $76288626b30e899c$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $76288626b30e899c$var$workInProgressRoot;
    suspendedLanes = $76288626b30e899c$var$workInProgressRootRenderLanes;
    suspendedLanes = $76288626b30e899c$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $76288626b30e899c$var$workInProgressSuspendedReason || 9 === $76288626b30e899c$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $76288626b30e899c$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $76288626b30e899c$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $76288626b30e899c$var$cancelCallback$1(pingedLanes);
        switch($76288626b30e899c$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $76288626b30e899c$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $76288626b30e899c$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $76288626b30e899c$var$IdlePriority;
                break;
            default:
                suspendedLanes = $76288626b30e899c$var$NormalPriority$1;
        }
        pingedLanes = $76288626b30e899c$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $76288626b30e899c$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $76288626b30e899c$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $76288626b30e899c$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $76288626b30e899c$var$pendingEffectsStatus && 5 !== $76288626b30e899c$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($76288626b30e899c$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $76288626b30e899c$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $76288626b30e899c$var$getNextLanes(root, root === $76288626b30e899c$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $76288626b30e899c$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $76288626b30e899c$var$scheduleTaskForRootDuringMicrotask(root, $76288626b30e899c$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $76288626b30e899c$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $76288626b30e899c$var$performSyncWorkOnRoot(root, lanes) {
    if ($76288626b30e899c$var$flushPendingEffects()) return null;
    $76288626b30e899c$var$performWorkOnRoot(root, lanes, !0);
}
function $76288626b30e899c$var$scheduleImmediateRootScheduleTask() {
    $76288626b30e899c$var$scheduleMicrotask(function() {
        0 !== ($76288626b30e899c$var$executionContext & 6) ? $76288626b30e899c$var$scheduleCallback$3($76288626b30e899c$var$ImmediatePriority, $76288626b30e899c$var$processRootScheduleInImmediateTask) : $76288626b30e899c$var$processRootScheduleInMicrotask();
    });
}
function $76288626b30e899c$var$requestTransitionLane() {
    if (0 === $76288626b30e899c$var$currentEventTransitionLane) {
        var actionScopeLane = $76288626b30e899c$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $76288626b30e899c$var$nextTransitionUpdateLane, $76288626b30e899c$var$nextTransitionUpdateLane <<= 1, 0 === ($76288626b30e899c$var$nextTransitionUpdateLane & 261888) && ($76288626b30e899c$var$nextTransitionUpdateLane = 256));
        $76288626b30e899c$var$currentEventTransitionLane = actionScopeLane;
    }
    return $76288626b30e899c$var$currentEventTransitionLane;
}
function $76288626b30e899c$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $76288626b30e899c$var$sanitizeURL("" + actionProp);
}
function $76288626b30e899c$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $76288626b30e899c$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $76288626b30e899c$var$coerceFormActionProp((nativeEventTarget[$76288626b30e899c$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$76288626b30e899c$var$internalPropsKey] || null) ? $76288626b30e899c$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $76288626b30e899c$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $76288626b30e899c$var$currentEventTransitionLane) {
                                var formData = submitter ? $76288626b30e899c$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $76288626b30e899c$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $76288626b30e899c$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $76288626b30e899c$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $76288626b30e899c$var$i$jscomp$inline_1577 = 0; $76288626b30e899c$var$i$jscomp$inline_1577 < $76288626b30e899c$var$simpleEventPluginEvents.length; $76288626b30e899c$var$i$jscomp$inline_1577++){
    var $76288626b30e899c$var$eventName$jscomp$inline_1578 = $76288626b30e899c$var$simpleEventPluginEvents[$76288626b30e899c$var$i$jscomp$inline_1577], $76288626b30e899c$var$domEventName$jscomp$inline_1579 = $76288626b30e899c$var$eventName$jscomp$inline_1578.toLowerCase(), $76288626b30e899c$var$capitalizedEvent$jscomp$inline_1580 = $76288626b30e899c$var$eventName$jscomp$inline_1578[0].toUpperCase() + $76288626b30e899c$var$eventName$jscomp$inline_1578.slice(1);
    $76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$domEventName$jscomp$inline_1579, "on" + $76288626b30e899c$var$capitalizedEvent$jscomp$inline_1580);
}
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$ANIMATION_END, "onAnimationEnd");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$ANIMATION_ITERATION, "onAnimationIteration");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$ANIMATION_START, "onAnimationStart");
$76288626b30e899c$var$registerSimpleEvent("dblclick", "onDoubleClick");
$76288626b30e899c$var$registerSimpleEvent("focusin", "onFocus");
$76288626b30e899c$var$registerSimpleEvent("focusout", "onBlur");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_RUN, "onTransitionRun");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_START, "onTransitionStart");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_CANCEL, "onTransitionCancel");
$76288626b30e899c$var$registerSimpleEvent($76288626b30e899c$var$TRANSITION_END, "onTransitionEnd");
$76288626b30e899c$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$76288626b30e899c$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$76288626b30e899c$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$76288626b30e899c$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$76288626b30e899c$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$76288626b30e899c$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$76288626b30e899c$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $76288626b30e899c$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $76288626b30e899c$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($76288626b30e899c$var$mediaEventTypes));
function $76288626b30e899c$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $76288626b30e899c$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $76288626b30e899c$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $76288626b30e899c$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$76288626b30e899c$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$76288626b30e899c$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($76288626b30e899c$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $76288626b30e899c$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $76288626b30e899c$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $76288626b30e899c$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $76288626b30e899c$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$76288626b30e899c$var$listeningMarker]) {
        rootContainerElement[$76288626b30e899c$var$listeningMarker] = !0;
        $76288626b30e899c$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($76288626b30e899c$var$nonDelegatedEvents.has(domEventName) || $76288626b30e899c$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $76288626b30e899c$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$76288626b30e899c$var$listeningMarker] || (ownerDocument[$76288626b30e899c$var$listeningMarker] = !0, $76288626b30e899c$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $76288626b30e899c$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($76288626b30e899c$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $76288626b30e899c$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $76288626b30e899c$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $76288626b30e899c$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$76288626b30e899c$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $76288626b30e899c$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $76288626b30e899c$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $76288626b30e899c$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $76288626b30e899c$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $76288626b30e899c$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $76288626b30e899c$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticTouchEvent;
                        break;
                    case $76288626b30e899c$var$ANIMATION_END:
                    case $76288626b30e899c$var$ANIMATION_ITERATION:
                    case $76288626b30e899c$var$ANIMATION_START:
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticAnimationEvent;
                        break;
                    case $76288626b30e899c$var$TRANSITION_END:
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $76288626b30e899c$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $76288626b30e899c$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($76288626b30e899c$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $76288626b30e899c$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($76288626b30e899c$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$76288626b30e899c$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $76288626b30e899c$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $76288626b30e899c$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $76288626b30e899c$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $76288626b30e899c$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $76288626b30e899c$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $76288626b30e899c$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $76288626b30e899c$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $76288626b30e899c$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $76288626b30e899c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $76288626b30e899c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $76288626b30e899c$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $76288626b30e899c$var$getTargetInstForChangeEvent;
                else if ($76288626b30e899c$var$isTextInputElement(reactName)) {
                    if ($76288626b30e899c$var$isInputEventSupported) getTargetInstFunc = $76288626b30e899c$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $76288626b30e899c$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $76288626b30e899c$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $76288626b30e899c$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $76288626b30e899c$var$getTargetInstForChangeEvent) : getTargetInstFunc = $76288626b30e899c$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $76288626b30e899c$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $76288626b30e899c$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $76288626b30e899c$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($76288626b30e899c$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $76288626b30e899c$var$activeElement = handleEventFunc, $76288626b30e899c$var$activeElementInst = targetInst, $76288626b30e899c$var$lastSelection = null;
                    break;
                case "focusout":
                    $76288626b30e899c$var$lastSelection = $76288626b30e899c$var$activeElementInst = $76288626b30e899c$var$activeElement = null;
                    break;
                case "mousedown":
                    $76288626b30e899c$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $76288626b30e899c$var$mouseDown = !1;
                    $76288626b30e899c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($76288626b30e899c$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $76288626b30e899c$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($76288626b30e899c$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $76288626b30e899c$var$isComposing ? $76288626b30e899c$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($76288626b30e899c$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($76288626b30e899c$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $76288626b30e899c$var$isComposing && (fallbackData = $76288626b30e899c$var$getData()) : ($76288626b30e899c$var$root = nativeEventTarget, $76288626b30e899c$var$startText = "value" in $76288626b30e899c$var$root ? $76288626b30e899c$var$root.value : $76288626b30e899c$var$root.textContent, $76288626b30e899c$var$isComposing = !0)), handleEventFunc = $76288626b30e899c$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $76288626b30e899c$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $76288626b30e899c$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $76288626b30e899c$var$canUseTextInputEvent ? $76288626b30e899c$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $76288626b30e899c$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $76288626b30e899c$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $76288626b30e899c$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $76288626b30e899c$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $76288626b30e899c$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $76288626b30e899c$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $76288626b30e899c$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $76288626b30e899c$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($76288626b30e899c$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $76288626b30e899c$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($76288626b30e899c$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $76288626b30e899c$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $76288626b30e899c$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $76288626b30e899c$var$getListener(target, registrationName), null != stateNode && listeners.unshift($76288626b30e899c$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $76288626b30e899c$var$getListener(target, registrationName), null != stateNode && listeners.push($76288626b30e899c$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $76288626b30e899c$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $76288626b30e899c$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $76288626b30e899c$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($76288626b30e899c$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($76288626b30e899c$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $76288626b30e899c$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $76288626b30e899c$var$normalizeMarkupForTextOrAttribute(clientText);
    return $76288626b30e899c$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $76288626b30e899c$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $76288626b30e899c$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $76288626b30e899c$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $76288626b30e899c$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $76288626b30e899c$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $76288626b30e899c$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $76288626b30e899c$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $76288626b30e899c$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $76288626b30e899c$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $76288626b30e899c$var$setProp(domElement, tag, "name", props.name, props, null), $76288626b30e899c$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $76288626b30e899c$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $76288626b30e899c$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($76288626b30e899c$var$setProp(domElement, tag, "encType", props.encType, props, null), $76288626b30e899c$var$setProp(domElement, tag, "method", props.method, props, null), $76288626b30e899c$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $76288626b30e899c$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $76288626b30e899c$var$noop$1);
            break;
        case "onScroll":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($76288626b30e899c$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($76288626b30e899c$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $76288626b30e899c$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $76288626b30e899c$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", domElement);
            $76288626b30e899c$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $76288626b30e899c$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $76288626b30e899c$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $76288626b30e899c$var$aliases.get(key) || key, $76288626b30e899c$var$setValueForAttribute(domElement, key, value);
    }
}
function $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $76288626b30e899c$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($76288626b30e899c$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($76288626b30e899c$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $76288626b30e899c$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $76288626b30e899c$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $76288626b30e899c$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $76288626b30e899c$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$76288626b30e899c$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$76288626b30e899c$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $76288626b30e899c$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $76288626b30e899c$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                    default:
                        $76288626b30e899c$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $76288626b30e899c$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $76288626b30e899c$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $76288626b30e899c$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $76288626b30e899c$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $76288626b30e899c$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $76288626b30e899c$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $76288626b30e899c$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($76288626b30e899c$var$formatProdErrorMessage(91));
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $76288626b30e899c$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $76288626b30e899c$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("cancel", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $76288626b30e899c$var$mediaEventTypes.length; hasSrc++)$76288626b30e899c$var$listenToNonDelegatedEvent($76288626b30e899c$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", domElement);
            $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $76288626b30e899c$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $76288626b30e899c$var$listenToNonDelegatedEvent("error", domElement), $76288626b30e899c$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($76288626b30e899c$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $76288626b30e899c$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $76288626b30e899c$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $76288626b30e899c$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $76288626b30e899c$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $76288626b30e899c$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $76288626b30e899c$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $76288626b30e899c$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $76288626b30e899c$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $76288626b30e899c$var$updateOptions(domElement, !!lastProps, tag, !0) : $76288626b30e899c$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($76288626b30e899c$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $76288626b30e899c$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $76288626b30e899c$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $76288626b30e899c$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($76288626b30e899c$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $76288626b30e899c$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($76288626b30e899c$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $76288626b30e899c$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $76288626b30e899c$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $76288626b30e899c$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $76288626b30e899c$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $76288626b30e899c$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $76288626b30e899c$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $76288626b30e899c$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $76288626b30e899c$var$eventsEnabled = null, $76288626b30e899c$var$selectionInformation = null;
function $76288626b30e899c$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $76288626b30e899c$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $76288626b30e899c$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $76288626b30e899c$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $76288626b30e899c$var$currentPopstateTransitionEvent = null;
function $76288626b30e899c$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $76288626b30e899c$var$currentPopstateTransitionEvent) return !1;
        $76288626b30e899c$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $76288626b30e899c$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $76288626b30e899c$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $76288626b30e899c$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $76288626b30e899c$var$localPromise = "function" === typeof Promise ? Promise : void 0, $76288626b30e899c$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $76288626b30e899c$var$localPromise ? function(callback) {
    return $76288626b30e899c$var$localPromise.resolve(null).then(callback).catch($76288626b30e899c$var$handleErrorInNextTick);
} : $76288626b30e899c$var$scheduleTimeout;
function $76288626b30e899c$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $76288626b30e899c$var$isSingletonScope(type) {
    return "head" === type;
}
function $76288626b30e899c$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $76288626b30e899c$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $76288626b30e899c$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $76288626b30e899c$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$76288626b30e899c$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $76288626b30e899c$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $76288626b30e899c$var$retryIfBlockedOn(hydrationInstance);
}
function $76288626b30e899c$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $76288626b30e899c$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $76288626b30e899c$var$clearContainerSparingly(node);
                $76288626b30e899c$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $76288626b30e899c$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$76288626b30e899c$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $76288626b30e899c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $76288626b30e899c$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $76288626b30e899c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $76288626b30e899c$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $76288626b30e899c$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $76288626b30e899c$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $76288626b30e899c$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $76288626b30e899c$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $76288626b30e899c$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $76288626b30e899c$var$previousHydratableOnEnteringScopedSingleton = null;
function $76288626b30e899c$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $76288626b30e899c$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $76288626b30e899c$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $76288626b30e899c$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $76288626b30e899c$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($76288626b30e899c$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(451));
    }
}
function $76288626b30e899c$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $76288626b30e899c$var$detachDeletedInstance(instance);
}
var $76288626b30e899c$var$preloadPropsMap = new Map(), $76288626b30e899c$var$preconnectsSet = new Set();
function $76288626b30e899c$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $76288626b30e899c$var$previousDispatcher = $76288626b30e899c$var$ReactDOMSharedInternals.d;
$76288626b30e899c$var$ReactDOMSharedInternals.d = {
    f: $76288626b30e899c$var$flushSyncWork,
    r: $76288626b30e899c$var$requestFormReset,
    D: $76288626b30e899c$var$prefetchDNS,
    C: $76288626b30e899c$var$preconnect,
    L: $76288626b30e899c$var$preload,
    m: $76288626b30e899c$var$preloadModule,
    X: $76288626b30e899c$var$preinitScript,
    S: $76288626b30e899c$var$preinitStyle,
    M: $76288626b30e899c$var$preinitModuleScript
};
function $76288626b30e899c$var$flushSyncWork() {
    var previousWasRendering = $76288626b30e899c$var$previousDispatcher.f(), wasRendering = $76288626b30e899c$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $76288626b30e899c$var$requestFormReset(form) {
    var formInst = $76288626b30e899c$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $76288626b30e899c$var$requestFormReset$1(formInst) : $76288626b30e899c$var$previousDispatcher.r(form);
}
var $76288626b30e899c$var$globalDocument = "undefined" === typeof document ? null : document;
function $76288626b30e899c$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $76288626b30e899c$var$preconnectsSet.has(limitedEscapedHref) || ($76288626b30e899c$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $76288626b30e899c$var$setInitialProperties(href, "link", rel), $76288626b30e899c$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $76288626b30e899c$var$prefetchDNS(href) {
    $76288626b30e899c$var$previousDispatcher.D(href);
    $76288626b30e899c$var$preconnectAs("dns-prefetch", href, null);
}
function $76288626b30e899c$var$preconnect(href, crossOrigin) {
    $76288626b30e899c$var$previousDispatcher.C(href, crossOrigin);
    $76288626b30e899c$var$preconnectAs("preconnect", href, crossOrigin);
}
function $76288626b30e899c$var$preload(href, as, options) {
    $76288626b30e899c$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $76288626b30e899c$var$getStyleKey(href);
                break;
            case "script":
                key = $76288626b30e899c$var$getScriptKey(href);
        }
        $76288626b30e899c$var$preloadPropsMap.has(key) || (href = $76288626b30e899c$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $76288626b30e899c$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $76288626b30e899c$var$setInitialProperties(as, "link", href), $76288626b30e899c$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $76288626b30e899c$var$preloadModule(href, options) {
    $76288626b30e899c$var$previousDispatcher.m(href, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $76288626b30e899c$var$getScriptKey(href);
        }
        if (!$76288626b30e899c$var$preloadPropsMap.has(key) && (href = $76288626b30e899c$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $76288626b30e899c$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $76288626b30e899c$var$setInitialProperties(as, "link", href);
            $76288626b30e899c$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $76288626b30e899c$var$preinitStyle(href, precedence, options) {
    $76288626b30e899c$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $76288626b30e899c$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $76288626b30e899c$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $76288626b30e899c$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $76288626b30e899c$var$markNodeAsHoistable(link);
                $76288626b30e899c$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $76288626b30e899c$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $76288626b30e899c$var$preinitScript(src, options) {
    $76288626b30e899c$var$previousDispatcher.X(src, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $76288626b30e899c$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $76288626b30e899c$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key)), resource || (src = $76288626b30e899c$var$assign({
            src: src,
            async: !0
        }, options), (options = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $76288626b30e899c$var$markNodeAsHoistable(resource), $76288626b30e899c$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $76288626b30e899c$var$preinitModuleScript(src, options) {
    $76288626b30e899c$var$previousDispatcher.M(src, options);
    var ownerDocument = $76288626b30e899c$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $76288626b30e899c$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $76288626b30e899c$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(key)), resource || (src = $76288626b30e899c$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $76288626b30e899c$var$markNodeAsHoistable(resource), $76288626b30e899c$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $76288626b30e899c$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $76288626b30e899c$var$rootInstanceStackCursor.current) ? $76288626b30e899c$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($76288626b30e899c$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $76288626b30e899c$var$getStyleKey(pendingProps.href), pendingProps = $76288626b30e899c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $76288626b30e899c$var$getStyleKey(pendingProps.href);
                var styles$243 = $76288626b30e899c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $76288626b30e899c$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $76288626b30e899c$var$preloadPropsMap.set(type, pendingProps), styles$243 || $76288626b30e899c$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($76288626b30e899c$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($76288626b30e899c$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $76288626b30e899c$var$getScriptKey(pendingProps), pendingProps = $76288626b30e899c$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(444, type));
    }
}
function $76288626b30e899c$var$getStyleKey(href) {
    return 'href="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $76288626b30e899c$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $76288626b30e899c$var$stylesheetPropsFromRawProps(rawProps) {
    return $76288626b30e899c$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $76288626b30e899c$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $76288626b30e899c$var$setInitialProperties(key, "link", preloadProps), $76288626b30e899c$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $76288626b30e899c$var$getScriptKey(src) {
    return '[src="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $76288626b30e899c$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $76288626b30e899c$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $76288626b30e899c$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $76288626b30e899c$var$markNodeAsHoistable(instance), instance;
            var styleProps = $76288626b30e899c$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $76288626b30e899c$var$markNodeAsHoistable(instance);
            $76288626b30e899c$var$setInitialProperties(instance, "style", styleProps);
            $76288626b30e899c$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $76288626b30e899c$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $76288626b30e899c$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $76288626b30e899c$var$stylesheetPropsFromRawProps(props);
            (styleProps = $76288626b30e899c$var$preloadPropsMap.get(styleProps)) && $76288626b30e899c$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $76288626b30e899c$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $76288626b30e899c$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $76288626b30e899c$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $76288626b30e899c$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($76288626b30e899c$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $76288626b30e899c$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $76288626b30e899c$var$preloadPropsMap.get(instance$249)) instance = $76288626b30e899c$var$assign({}, props), $76288626b30e899c$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $76288626b30e899c$var$markNodeAsHoistable(styleProps);
            $76288626b30e899c$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($76288626b30e899c$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $76288626b30e899c$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $76288626b30e899c$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $76288626b30e899c$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $76288626b30e899c$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $76288626b30e899c$var$tagCaches = null;
function $76288626b30e899c$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $76288626b30e899c$var$tagCaches) {
        var cache = new Map();
        var caches = $76288626b30e899c$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $76288626b30e899c$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$76288626b30e899c$var$internalHoistableMarker] || node[$76288626b30e899c$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $76288626b30e899c$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $76288626b30e899c$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $76288626b30e899c$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $76288626b30e899c$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $76288626b30e899c$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($76288626b30e899c$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $76288626b30e899c$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $76288626b30e899c$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $76288626b30e899c$var$stylesheetPropsFromRawProps(props);
            (key = $76288626b30e899c$var$preloadPropsMap.get(key)) && $76288626b30e899c$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $76288626b30e899c$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $76288626b30e899c$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $76288626b30e899c$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $76288626b30e899c$var$estimatedBytesWithinLimit = 0;
function $76288626b30e899c$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $76288626b30e899c$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $76288626b30e899c$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $76288626b30e899c$var$estimatedBytesWithinLimit && ($76288626b30e899c$var$estimatedBytesWithinLimit = 62500 * $76288626b30e899c$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $76288626b30e899c$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $76288626b30e899c$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $76288626b30e899c$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $76288626b30e899c$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $76288626b30e899c$var$precedencesByRoot = null;
function $76288626b30e899c$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $76288626b30e899c$var$precedencesByRoot = new Map(), resources.forEach($76288626b30e899c$var$insertStylesheetIntoRoot, state), $76288626b30e899c$var$precedencesByRoot = null, $76288626b30e899c$var$onUnsuspend.call(state));
}
function $76288626b30e899c$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $76288626b30e899c$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $76288626b30e899c$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $76288626b30e899c$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $76288626b30e899c$var$HostTransitionContext = {
    $$typeof: $76288626b30e899c$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $76288626b30e899c$var$sharedNotPendingObject,
    _currentValue2: $76288626b30e899c$var$sharedNotPendingObject,
    _threadCount: 0
};
function $76288626b30e899c$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $76288626b30e899c$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $76288626b30e899c$var$createLaneMap(0);
    this.hiddenUpdates = $76288626b30e899c$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $76288626b30e899c$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $76288626b30e899c$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $76288626b30e899c$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $76288626b30e899c$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $76288626b30e899c$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $76288626b30e899c$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $76288626b30e899c$var$emptyContextObject;
    parentComponent = $76288626b30e899c$var$emptyContextObject;
    return parentComponent;
}
function $76288626b30e899c$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $76288626b30e899c$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $76288626b30e899c$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $76288626b30e899c$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($76288626b30e899c$var$scheduleUpdateOnFiber(element, rootFiber, lane), $76288626b30e899c$var$entangleTransitions(element, rootFiber, lane));
}
function $76288626b30e899c$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $76288626b30e899c$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $76288626b30e899c$var$markRetryLaneImpl(fiber, retryLane);
}
function $76288626b30e899c$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $76288626b30e899c$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $76288626b30e899c$var$requestUpdateLane();
        lane = $76288626b30e899c$var$getBumpedLaneForHydrationByLane(lane);
        var root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, lane);
        $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $76288626b30e899c$var$_enabled = !0;
function $76288626b30e899c$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T;
    $76288626b30e899c$var$ReactSharedInternals.T = null;
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        $76288626b30e899c$var$ReactDOMSharedInternals.p = 2, $76288626b30e899c$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $76288626b30e899c$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $76288626b30e899c$var$ReactSharedInternals.T;
    $76288626b30e899c$var$ReactSharedInternals.T = null;
    var previousPriority = $76288626b30e899c$var$ReactDOMSharedInternals.p;
    try {
        $76288626b30e899c$var$ReactDOMSharedInternals.p = 8, $76288626b30e899c$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $76288626b30e899c$var$ReactDOMSharedInternals.p = previousPriority, $76288626b30e899c$var$ReactSharedInternals.T = prevTransition;
    }
}
function $76288626b30e899c$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($76288626b30e899c$var$_enabled) {
        var blockedOn = $76288626b30e899c$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $76288626b30e899c$var$return_targetInst, targetContainer), $76288626b30e899c$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($76288626b30e899c$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($76288626b30e899c$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $76288626b30e899c$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $76288626b30e899c$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $76288626b30e899c$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $76288626b30e899c$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $76288626b30e899c$var$ensureRootIsScheduled(fiber);
                                0 === ($76288626b30e899c$var$executionContext & 6) && ($76288626b30e899c$var$workInProgressRootRenderTargetTime = $76288626b30e899c$var$now() + 500, $76288626b30e899c$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $76288626b30e899c$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $76288626b30e899c$var$scheduleUpdateOnFiber(root, fiber, 2), $76288626b30e899c$var$flushSyncWork$1(), $76288626b30e899c$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $76288626b30e899c$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $76288626b30e899c$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $76288626b30e899c$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $76288626b30e899c$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $76288626b30e899c$var$getEventTarget(nativeEvent);
    return $76288626b30e899c$var$findInstanceBlockingTarget(nativeEvent);
}
var $76288626b30e899c$var$return_targetInst = null;
function $76288626b30e899c$var$findInstanceBlockingTarget(targetNode) {
    $76288626b30e899c$var$return_targetInst = null;
    targetNode = $76288626b30e899c$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $76288626b30e899c$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $76288626b30e899c$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $76288626b30e899c$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $76288626b30e899c$var$return_targetInst = targetNode;
    return null;
}
function $76288626b30e899c$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($76288626b30e899c$var$getCurrentPriorityLevel()){
                case $76288626b30e899c$var$ImmediatePriority:
                    return 2;
                case $76288626b30e899c$var$UserBlockingPriority:
                    return 8;
                case $76288626b30e899c$var$NormalPriority$1:
                case $76288626b30e899c$var$LowPriority:
                    return 32;
                case $76288626b30e899c$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $76288626b30e899c$var$hasScheduledReplayAttempt = !1, $76288626b30e899c$var$queuedFocus = null, $76288626b30e899c$var$queuedDrag = null, $76288626b30e899c$var$queuedMouse = null, $76288626b30e899c$var$queuedPointers = new Map(), $76288626b30e899c$var$queuedPointerCaptures = new Map(), $76288626b30e899c$var$queuedExplicitHydrationTargets = [], $76288626b30e899c$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $76288626b30e899c$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $76288626b30e899c$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $76288626b30e899c$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $76288626b30e899c$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $76288626b30e899c$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $76288626b30e899c$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $76288626b30e899c$var$getInstanceFromNode(blockedOn), null !== blockedOn && $76288626b30e899c$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $76288626b30e899c$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $76288626b30e899c$var$queuedFocus = $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $76288626b30e899c$var$queuedDrag = $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $76288626b30e899c$var$queuedMouse = $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $76288626b30e899c$var$queuedPointers.set(pointerId, $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $76288626b30e899c$var$queuedPointerCaptures.set(pointerId, $76288626b30e899c$var$accumulateOrCreateContinuousQueuedReplayableEvent($76288626b30e899c$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $76288626b30e899c$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $76288626b30e899c$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $76288626b30e899c$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $76288626b30e899c$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $76288626b30e899c$var$runWithPriority(queuedTarget.priority, function() {
                        $76288626b30e899c$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $76288626b30e899c$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $76288626b30e899c$var$runWithPriority(queuedTarget.priority, function() {
                        $76288626b30e899c$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $76288626b30e899c$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $76288626b30e899c$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $76288626b30e899c$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $76288626b30e899c$var$currentReplayingEvent = null;
        } else return targetContainers = $76288626b30e899c$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $76288626b30e899c$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $76288626b30e899c$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $76288626b30e899c$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $76288626b30e899c$var$replayUnblockedEvents() {
    $76288626b30e899c$var$hasScheduledReplayAttempt = !1;
    null !== $76288626b30e899c$var$queuedFocus && $76288626b30e899c$var$attemptReplayContinuousQueuedEvent($76288626b30e899c$var$queuedFocus) && ($76288626b30e899c$var$queuedFocus = null);
    null !== $76288626b30e899c$var$queuedDrag && $76288626b30e899c$var$attemptReplayContinuousQueuedEvent($76288626b30e899c$var$queuedDrag) && ($76288626b30e899c$var$queuedDrag = null);
    null !== $76288626b30e899c$var$queuedMouse && $76288626b30e899c$var$attemptReplayContinuousQueuedEvent($76288626b30e899c$var$queuedMouse) && ($76288626b30e899c$var$queuedMouse = null);
    $76288626b30e899c$var$queuedPointers.forEach($76288626b30e899c$var$attemptReplayContinuousQueuedEventInMap);
    $76288626b30e899c$var$queuedPointerCaptures.forEach($76288626b30e899c$var$attemptReplayContinuousQueuedEventInMap);
}
function $76288626b30e899c$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $76288626b30e899c$var$hasScheduledReplayAttempt || ($76288626b30e899c$var$hasScheduledReplayAttempt = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $76288626b30e899c$var$replayUnblockedEvents)));
}
var $76288626b30e899c$var$lastScheduledReplayQueue = null;
function $76288626b30e899c$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $76288626b30e899c$var$lastScheduledReplayQueue !== formReplayingQueue && ($76288626b30e899c$var$lastScheduledReplayQueue = formReplayingQueue, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, function() {
        $76288626b30e899c$var$lastScheduledReplayQueue === formReplayingQueue && ($76288626b30e899c$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $76288626b30e899c$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $76288626b30e899c$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $76288626b30e899c$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $76288626b30e899c$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $76288626b30e899c$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $76288626b30e899c$var$queuedFocus && $76288626b30e899c$var$scheduleCallbackIfUnblocked($76288626b30e899c$var$queuedFocus, unblocked);
    null !== $76288626b30e899c$var$queuedDrag && $76288626b30e899c$var$scheduleCallbackIfUnblocked($76288626b30e899c$var$queuedDrag, unblocked);
    null !== $76288626b30e899c$var$queuedMouse && $76288626b30e899c$var$scheduleCallbackIfUnblocked($76288626b30e899c$var$queuedMouse, unblocked);
    $76288626b30e899c$var$queuedPointers.forEach(unblock);
    $76288626b30e899c$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $76288626b30e899c$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $76288626b30e899c$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $76288626b30e899c$var$queuedExplicitHydrationTargets.length && (i = $76288626b30e899c$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$76288626b30e899c$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $76288626b30e899c$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$76288626b30e899c$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $76288626b30e899c$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$76288626b30e899c$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $76288626b30e899c$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $76288626b30e899c$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $76288626b30e899c$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $76288626b30e899c$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$76288626b30e899c$var$ReactDOMHydrationRoot.prototype.render = $76288626b30e899c$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($76288626b30e899c$var$formatProdErrorMessage(409));
    var current = root.current, lane = $76288626b30e899c$var$requestUpdateLane();
    $76288626b30e899c$var$updateContainerImpl(current, lane, children, root, null, null);
};
$76288626b30e899c$var$ReactDOMHydrationRoot.prototype.unmount = $76288626b30e899c$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $76288626b30e899c$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $76288626b30e899c$var$flushSyncWork$1();
        container[$76288626b30e899c$var$internalContainerInstanceKey] = null;
    }
};
function $76288626b30e899c$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$76288626b30e899c$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $76288626b30e899c$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $76288626b30e899c$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $76288626b30e899c$var$queuedExplicitHydrationTargets[i].priority; i++);
        $76288626b30e899c$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $76288626b30e899c$var$attemptExplicitHydrationTarget(target);
    }
};
var $76288626b30e899c$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $7fPBF.version;
if ("19.2.3" !== $76288626b30e899c$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($76288626b30e899c$var$formatProdErrorMessage(527, $76288626b30e899c$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.3"));
$76288626b30e899c$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($76288626b30e899c$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($76288626b30e899c$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $76288626b30e899c$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $76288626b30e899c$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $76288626b30e899c$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $76288626b30e899c$var$ReactSharedInternals,
    reconcilerVersion: "19.2.3"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $76288626b30e899c$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$76288626b30e899c$var$hook$jscomp$inline_2348.isDisabled && $76288626b30e899c$var$hook$jscomp$inline_2348.supportsFiber) try {
        $76288626b30e899c$var$rendererID = $76288626b30e899c$var$hook$jscomp$inline_2348.inject($76288626b30e899c$var$internals$jscomp$inline_2347), $76288626b30e899c$var$injectedHook = $76288626b30e899c$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$76288626b30e899c$export$882461b6382ed46c = function(container, options) {
    if (!$76288626b30e899c$var$isValidContainer(container)) throw Error($76288626b30e899c$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $76288626b30e899c$var$defaultOnUncaughtError, onCaughtError = $76288626b30e899c$var$defaultOnCaughtError, onRecoverableError = $76288626b30e899c$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $76288626b30e899c$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $76288626b30e899c$var$defaultOnDefaultTransitionIndicator);
    container[$76288626b30e899c$var$internalContainerInstanceKey] = options.current;
    $76288626b30e899c$var$listenToAllSupportedEvents(container);
    return new $76288626b30e899c$var$ReactDOMRoot(options);
};
$76288626b30e899c$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$76288626b30e899c$var$isValidContainer(container)) throw Error($76288626b30e899c$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $76288626b30e899c$var$defaultOnUncaughtError, onCaughtError = $76288626b30e899c$var$defaultOnCaughtError, onRecoverableError = $76288626b30e899c$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $76288626b30e899c$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $76288626b30e899c$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $76288626b30e899c$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $76288626b30e899c$var$requestUpdateLane();
    isStrictMode = $76288626b30e899c$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $76288626b30e899c$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $76288626b30e899c$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $76288626b30e899c$var$markRootUpdated$1(initialChildren, options);
    $76288626b30e899c$var$ensureRootIsScheduled(initialChildren);
    container[$76288626b30e899c$var$internalContainerInstanceKey] = initialChildren.current;
    $76288626b30e899c$var$listenToAllSupportedEvents(container);
    return new $76288626b30e899c$var$ReactDOMHydrationRoot(initialChildren);
};
$76288626b30e899c$export$83d89fbfd8236492 = "19.2.3";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i4zJ6"));

});
parcelRegister("i4zJ6", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d284504346e22df2$export$c4744153514ff05d; }, function (v) { return $d284504346e22df2$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d284504346e22df2$export$3e506c1ccc9cc1a7; }, function (v) { return $d284504346e22df2$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d284504346e22df2$export$e26fe2ed2fa76875; }, function (v) { return $d284504346e22df2$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d284504346e22df2$export$502329bbf4b505b1; }, function (v) { return $d284504346e22df2$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d284504346e22df2$export$6e3807111c4874c4; }, function (v) { return $d284504346e22df2$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d284504346e22df2$export$c27134553091fb3a; }, function (v) { return $d284504346e22df2$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d284504346e22df2$export$33ee1acdc04fd2a2; }, function (v) { return $d284504346e22df2$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d284504346e22df2$export$b00a404bbd5edef2; }, function (v) { return $d284504346e22df2$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d284504346e22df2$export$d66a1c1c77bd778b; }, function (v) { return $d284504346e22df2$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d284504346e22df2$export$d3dfb8e4810cb555; }, function (v) { return $d284504346e22df2$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d284504346e22df2$export$72fdf0e06517287b; }, function (v) { return $d284504346e22df2$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d284504346e22df2$export$816d2913ae6b83b1; }, function (v) { return $d284504346e22df2$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d284504346e22df2$export$61bcfe829111a1d0; }, function (v) { return $d284504346e22df2$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d284504346e22df2$export$7ee8c9beb337bc3f; }, function (v) { return $d284504346e22df2$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d284504346e22df2$export$b5836b71941fa3ed; }, function (v) { return $d284504346e22df2$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d284504346e22df2$export$cf845f2c119da08a; }, function (v) { return $d284504346e22df2$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d284504346e22df2$export$c4744153514ff05d;
var $d284504346e22df2$export$3e506c1ccc9cc1a7;
var $d284504346e22df2$export$e26fe2ed2fa76875;
var $d284504346e22df2$export$502329bbf4b505b1;
var $d284504346e22df2$export$6e3807111c4874c4;
var $d284504346e22df2$export$c27134553091fb3a;
var $d284504346e22df2$export$33ee1acdc04fd2a2;
var $d284504346e22df2$export$b00a404bbd5edef2;
var $d284504346e22df2$export$d66a1c1c77bd778b;
var $d284504346e22df2$export$d3dfb8e4810cb555;
var $d284504346e22df2$export$72fdf0e06517287b;
var $d284504346e22df2$export$816d2913ae6b83b1;
var $d284504346e22df2$export$61bcfe829111a1d0;
var $d284504346e22df2$export$7ee8c9beb337bc3f;
var $d284504346e22df2$export$b5836b71941fa3ed;
var $d284504346e22df2$export$cf845f2c119da08a;
"use strict";
function $d284504346e22df2$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $d284504346e22df2$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $d284504346e22df2$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $d284504346e22df2$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $d284504346e22df2$var$compare(left, last)) rightIndex < length && 0 > $d284504346e22df2$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $d284504346e22df2$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $d284504346e22df2$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$d284504346e22df2$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d284504346e22df2$var$localPerformance = performance;
    $d284504346e22df2$export$c4744153514ff05d = function() {
        return $d284504346e22df2$var$localPerformance.now();
    };
} else {
    var $d284504346e22df2$var$localDate = Date, $d284504346e22df2$var$initialTime = $d284504346e22df2$var$localDate.now();
    $d284504346e22df2$export$c4744153514ff05d = function() {
        return $d284504346e22df2$var$localDate.now() - $d284504346e22df2$var$initialTime;
    };
}
var $d284504346e22df2$var$taskQueue = [], $d284504346e22df2$var$timerQueue = [], $d284504346e22df2$var$taskIdCounter = 1, $d284504346e22df2$var$currentTask = null, $d284504346e22df2$var$currentPriorityLevel = 3, $d284504346e22df2$var$isPerformingWork = !1, $d284504346e22df2$var$isHostCallbackScheduled = !1, $d284504346e22df2$var$isHostTimeoutScheduled = !1, $d284504346e22df2$var$needsPaint = !1, $d284504346e22df2$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $d284504346e22df2$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $d284504346e22df2$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $d284504346e22df2$var$advanceTimers(currentTime) {
    for(var timer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue); null !== timer;){
        if (null === timer.callback) $d284504346e22df2$var$pop($d284504346e22df2$var$timerQueue);
        else if (timer.startTime <= currentTime) $d284504346e22df2$var$pop($d284504346e22df2$var$timerQueue), timer.sortIndex = timer.expirationTime, $d284504346e22df2$var$push($d284504346e22df2$var$taskQueue, timer);
        else break;
        timer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue);
    }
}
function $d284504346e22df2$var$handleTimeout(currentTime) {
    $d284504346e22df2$var$isHostTimeoutScheduled = !1;
    $d284504346e22df2$var$advanceTimers(currentTime);
    if (!$d284504346e22df2$var$isHostCallbackScheduled) {
        if (null !== $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue)) $d284504346e22df2$var$isHostCallbackScheduled = !0, $d284504346e22df2$var$isMessageLoopRunning || ($d284504346e22df2$var$isMessageLoopRunning = !0, $d284504346e22df2$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue);
            null !== firstTimer && $d284504346e22df2$var$requestHostTimeout($d284504346e22df2$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $d284504346e22df2$var$isMessageLoopRunning = !1, $d284504346e22df2$var$taskTimeoutID = -1, $d284504346e22df2$var$frameInterval = 5, $d284504346e22df2$var$startTime = -1;
function $d284504346e22df2$var$shouldYieldToHost() {
    return $d284504346e22df2$var$needsPaint ? !0 : $d284504346e22df2$export$c4744153514ff05d() - $d284504346e22df2$var$startTime < $d284504346e22df2$var$frameInterval ? !1 : !0;
}
function $d284504346e22df2$var$performWorkUntilDeadline() {
    $d284504346e22df2$var$needsPaint = !1;
    if ($d284504346e22df2$var$isMessageLoopRunning) {
        var currentTime = $d284504346e22df2$export$c4744153514ff05d();
        $d284504346e22df2$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $d284504346e22df2$var$isHostCallbackScheduled = !1;
                $d284504346e22df2$var$isHostTimeoutScheduled && ($d284504346e22df2$var$isHostTimeoutScheduled = !1, $d284504346e22df2$var$localClearTimeout($d284504346e22df2$var$taskTimeoutID), $d284504346e22df2$var$taskTimeoutID = -1);
                $d284504346e22df2$var$isPerformingWork = !0;
                var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
                try {
                    b: {
                        $d284504346e22df2$var$advanceTimers(currentTime);
                        for($d284504346e22df2$var$currentTask = $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue); null !== $d284504346e22df2$var$currentTask && !($d284504346e22df2$var$currentTask.expirationTime > currentTime && $d284504346e22df2$var$shouldYieldToHost());){
                            var callback = $d284504346e22df2$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $d284504346e22df2$var$currentTask.callback = null;
                                $d284504346e22df2$var$currentPriorityLevel = $d284504346e22df2$var$currentTask.priorityLevel;
                                var continuationCallback = callback($d284504346e22df2$var$currentTask.expirationTime <= currentTime);
                                currentTime = $d284504346e22df2$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $d284504346e22df2$var$currentTask.callback = continuationCallback;
                                    $d284504346e22df2$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $d284504346e22df2$var$currentTask === $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue) && $d284504346e22df2$var$pop($d284504346e22df2$var$taskQueue);
                                $d284504346e22df2$var$advanceTimers(currentTime);
                            } else $d284504346e22df2$var$pop($d284504346e22df2$var$taskQueue);
                            $d284504346e22df2$var$currentTask = $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue);
                        }
                        if (null !== $d284504346e22df2$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue);
                            null !== firstTimer && $d284504346e22df2$var$requestHostTimeout($d284504346e22df2$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $d284504346e22df2$var$currentTask = null, $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel, $d284504346e22df2$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $d284504346e22df2$var$schedulePerformWorkUntilDeadline() : $d284504346e22df2$var$isMessageLoopRunning = !1;
        }
    }
}
var $d284504346e22df2$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $d284504346e22df2$var$localSetImmediate) $d284504346e22df2$var$schedulePerformWorkUntilDeadline = function() {
    $d284504346e22df2$var$localSetImmediate($d284504346e22df2$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d284504346e22df2$var$channel = new MessageChannel(), $d284504346e22df2$var$port = $d284504346e22df2$var$channel.port2;
    $d284504346e22df2$var$channel.port1.onmessage = $d284504346e22df2$var$performWorkUntilDeadline;
    $d284504346e22df2$var$schedulePerformWorkUntilDeadline = function() {
        $d284504346e22df2$var$port.postMessage(null);
    };
} else $d284504346e22df2$var$schedulePerformWorkUntilDeadline = function() {
    $d284504346e22df2$var$localSetTimeout($d284504346e22df2$var$performWorkUntilDeadline, 0);
};
function $d284504346e22df2$var$requestHostTimeout(callback, ms) {
    $d284504346e22df2$var$taskTimeoutID = $d284504346e22df2$var$localSetTimeout(function() {
        callback($d284504346e22df2$export$c4744153514ff05d());
    }, ms);
}
$d284504346e22df2$export$3e506c1ccc9cc1a7 = 5;
$d284504346e22df2$export$e26fe2ed2fa76875 = 1;
$d284504346e22df2$export$502329bbf4b505b1 = 4;
$d284504346e22df2$export$6e3807111c4874c4 = 3;
$d284504346e22df2$export$c27134553091fb3a = null;
$d284504346e22df2$export$33ee1acdc04fd2a2 = 2;
$d284504346e22df2$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$d284504346e22df2$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d284504346e22df2$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$d284504346e22df2$export$d3dfb8e4810cb555 = function() {
    return $d284504346e22df2$var$currentPriorityLevel;
};
$d284504346e22df2$export$72fdf0e06517287b = function(eventHandler) {
    switch($d284504346e22df2$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    $d284504346e22df2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d284504346e22df2$export$816d2913ae6b83b1 = function() {
    $d284504346e22df2$var$needsPaint = !0;
};
$d284504346e22df2$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    $d284504346e22df2$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d284504346e22df2$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $d284504346e22df2$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $d284504346e22df2$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $d284504346e22df2$var$push($d284504346e22df2$var$timerQueue, priorityLevel), null === $d284504346e22df2$var$peek($d284504346e22df2$var$taskQueue) && priorityLevel === $d284504346e22df2$var$peek($d284504346e22df2$var$timerQueue) && ($d284504346e22df2$var$isHostTimeoutScheduled ? ($d284504346e22df2$var$localClearTimeout($d284504346e22df2$var$taskTimeoutID), $d284504346e22df2$var$taskTimeoutID = -1) : $d284504346e22df2$var$isHostTimeoutScheduled = !0, $d284504346e22df2$var$requestHostTimeout($d284504346e22df2$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $d284504346e22df2$var$push($d284504346e22df2$var$taskQueue, priorityLevel), $d284504346e22df2$var$isHostCallbackScheduled || $d284504346e22df2$var$isPerformingWork || ($d284504346e22df2$var$isHostCallbackScheduled = !0, $d284504346e22df2$var$isMessageLoopRunning || ($d284504346e22df2$var$isMessageLoopRunning = !0, $d284504346e22df2$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$d284504346e22df2$export$b5836b71941fa3ed = $d284504346e22df2$var$shouldYieldToHost;
$d284504346e22df2$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $d284504346e22df2$var$currentPriorityLevel;
        $d284504346e22df2$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $d284504346e22df2$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ik80y"));

});

parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("bsyIp"));

});
parcelRegister("bsyIp", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $857d3cfd292f62db$export$69ce8ef3fe5cead0; }, function (v) { return $857d3cfd292f62db$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $857d3cfd292f62db$export$d39a5bbd09211389; }, function (v) { return $857d3cfd292f62db$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $857d3cfd292f62db$export$cd75ccfd720a3cd4; }, function (v) { return $857d3cfd292f62db$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $857d3cfd292f62db$export$a0816fa17a9e79be; }, function (v) { return $857d3cfd292f62db$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $857d3cfd292f62db$export$7292efcadded39f3; }, function (v) { return $857d3cfd292f62db$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $857d3cfd292f62db$export$da407abadb9b8f86; }, function (v) { return $857d3cfd292f62db$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $857d3cfd292f62db$export$314cfea32580671c; }, function (v) { return $857d3cfd292f62db$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $857d3cfd292f62db$export$513ccb98c53b8039; }, function (v) { return $857d3cfd292f62db$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $857d3cfd292f62db$export$dbca993bc2d264a; }, function (v) { return $857d3cfd292f62db$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $857d3cfd292f62db$export$4797a8006f0655d0; }, function (v) { return $857d3cfd292f62db$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $857d3cfd292f62db$export$c78a37762a8d58e1; }, function (v) { return $857d3cfd292f62db$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $857d3cfd292f62db$export$606f11b2eb45ecc6; }, function (v) { return $857d3cfd292f62db$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $857d3cfd292f62db$export$f7e8a0bf92324b1e; }, function (v) { return $857d3cfd292f62db$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $857d3cfd292f62db$export$83d89fbfd8236492; }, function (v) { return $857d3cfd292f62db$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $857d3cfd292f62db$export$69ce8ef3fe5cead0;
var $857d3cfd292f62db$export$d39a5bbd09211389;
var $857d3cfd292f62db$export$cd75ccfd720a3cd4;
var $857d3cfd292f62db$export$a0816fa17a9e79be;
var $857d3cfd292f62db$export$7292efcadded39f3;
var $857d3cfd292f62db$export$da407abadb9b8f86;
var $857d3cfd292f62db$export$314cfea32580671c;
var $857d3cfd292f62db$export$513ccb98c53b8039;
var $857d3cfd292f62db$export$dbca993bc2d264a;
var $857d3cfd292f62db$export$4797a8006f0655d0;
var $857d3cfd292f62db$export$c78a37762a8d58e1;
var $857d3cfd292f62db$export$606f11b2eb45ecc6;
var $857d3cfd292f62db$export$f7e8a0bf92324b1e;
var $857d3cfd292f62db$export$83d89fbfd8236492;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $857d3cfd292f62db$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $857d3cfd292f62db$var$noop() {}
var $857d3cfd292f62db$var$Internals = {
    d: {
        f: $857d3cfd292f62db$var$noop,
        r: function() {
            throw Error($857d3cfd292f62db$var$formatProdErrorMessage(522));
        },
        D: $857d3cfd292f62db$var$noop,
        C: $857d3cfd292f62db$var$noop,
        L: $857d3cfd292f62db$var$noop,
        m: $857d3cfd292f62db$var$noop,
        X: $857d3cfd292f62db$var$noop,
        S: $857d3cfd292f62db$var$noop,
        M: $857d3cfd292f62db$var$noop
    },
    p: 0,
    findDOMNode: null
}, $857d3cfd292f62db$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $857d3cfd292f62db$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $857d3cfd292f62db$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $857d3cfd292f62db$var$ReactSharedInternals = $7fPBF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $857d3cfd292f62db$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$857d3cfd292f62db$export$69ce8ef3fe5cead0 = $857d3cfd292f62db$var$Internals;
$857d3cfd292f62db$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($857d3cfd292f62db$var$formatProdErrorMessage(299));
    return $857d3cfd292f62db$var$createPortal$1(children, container, null, key);
};
$857d3cfd292f62db$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $857d3cfd292f62db$var$ReactSharedInternals.T, previousUpdatePriority = $857d3cfd292f62db$var$Internals.p;
    try {
        if ($857d3cfd292f62db$var$ReactSharedInternals.T = null, $857d3cfd292f62db$var$Internals.p = 2, fn) return fn();
    } finally{
        $857d3cfd292f62db$var$ReactSharedInternals.T = previousTransition, $857d3cfd292f62db$var$Internals.p = previousUpdatePriority, $857d3cfd292f62db$var$Internals.d.f();
    }
};
$857d3cfd292f62db$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $857d3cfd292f62db$var$Internals.d.C(href, options));
};
$857d3cfd292f62db$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $857d3cfd292f62db$var$Internals.d.D(href);
};
$857d3cfd292f62db$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $857d3cfd292f62db$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $857d3cfd292f62db$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$857d3cfd292f62db$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $857d3cfd292f62db$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $857d3cfd292f62db$var$Internals.d.M(href);
    }
};
$857d3cfd292f62db$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(as, options.crossOrigin);
        $857d3cfd292f62db$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$857d3cfd292f62db$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $857d3cfd292f62db$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $857d3cfd292f62db$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $857d3cfd292f62db$var$Internals.d.m(href);
    }
};
$857d3cfd292f62db$export$4797a8006f0655d0 = function(form) {
    $857d3cfd292f62db$var$Internals.d.r(form);
};
$857d3cfd292f62db$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$857d3cfd292f62db$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $857d3cfd292f62db$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$857d3cfd292f62db$export$f7e8a0bf92324b1e = function() {
    return $857d3cfd292f62db$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$857d3cfd292f62db$export$83d89fbfd8236492 = "19.2.3";

});



parcelRegister("i5uoL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $d2b0461a7763531f$export$bf730a2d8bf68b42; }, function (v) { return $d2b0461a7763531f$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2b0461a7763531f$export$bf730a2d8bf68b42;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $d2b0461a7763531f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2b0461a7763531f$var$objectIs = "function" === typeof Object.is ? Object.is : $d2b0461a7763531f$var$is, $d2b0461a7763531f$var$useSyncExternalStore = $7fPBF.useSyncExternalStore, $d2b0461a7763531f$var$useRef = $7fPBF.useRef, $d2b0461a7763531f$var$useEffect = $7fPBF.useEffect, $d2b0461a7763531f$var$useMemo = $7fPBF.useMemo, $d2b0461a7763531f$var$useDebugValue = $7fPBF.useDebugValue;
$d2b0461a7763531f$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2b0461a7763531f$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2b0461a7763531f$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2b0461a7763531f$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2b0461a7763531f$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2b0461a7763531f$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2b0461a7763531f$var$useDebugValue(value);
    return value;
};

});

parcelRegister("lzq3r", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("kPsoI")).then(()=>parcelRequire('3GJ3v'));

});
parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $e1310d314a52f4ec$exports = {};
$parcel$extendImportMap({
    "kPsoI": "web-vitals.c75b2b1a.js"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("cx8Kh"));


parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};
'use strict';
function $f11ec298ebcca059$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f11ec298ebcca059$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f11ec298ebcca059$var$checkDCE();

$f11ec298ebcca059$exports = (parcelRequire("a8X8z"));



// src/utils/formatProdErrorMessage.ts
function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $78916fc80cd27125$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $78916fc80cd27125$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $78916fc80cd27125$var$symbol_observable_default = $78916fc80cd27125$var$$$observable;
// src/utils/actionTypes.ts
var $78916fc80cd27125$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $78916fc80cd27125$var$ActionTypes = {
    INIT: `@@redux/INIT${$78916fc80cd27125$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$78916fc80cd27125$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$78916fc80cd27125$var$randomString()}`
};
var $78916fc80cd27125$export$4219e499db7ca678 = $78916fc80cd27125$var$ActionTypes;
// src/utils/isPlainObject.ts
function $78916fc80cd27125$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $78916fc80cd27125$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($78916fc80cd27125$var$isDate(val)) return "date";
    if ($78916fc80cd27125$var$isError(val)) return "error";
    const constructorName = $78916fc80cd27125$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $78916fc80cd27125$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $78916fc80cd27125$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $78916fc80cd27125$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $78916fc80cd27125$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(1));
        return enhancer($78916fc80cd27125$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$78916fc80cd27125$export$53b83ca8eaab0383(action)) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $78916fc80cd27125$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$78916fc80cd27125$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $78916fc80cd27125$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$78916fc80cd27125$var$symbol_observable_default]: observable
    };
    return store;
}
function $78916fc80cd27125$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $78916fc80cd27125$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $78916fc80cd27125$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $78916fc80cd27125$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $78916fc80cd27125$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$78916fc80cd27125$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$78916fc80cd27125$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $78916fc80cd27125$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $78916fc80cd27125$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $78916fc80cd27125$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($78916fc80cd27125$var$formatProdErrorMessage(13));
    });
}
function $78916fc80cd27125$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $78916fc80cd27125$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $78916fc80cd27125$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $78916fc80cd27125$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($78916fc80cd27125$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $78916fc80cd27125$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $78916fc80cd27125$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $78916fc80cd27125$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($78916fc80cd27125$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $78916fc80cd27125$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, store), {
                dispatch: dispatch
            });
        };
}
// src/utils/isAction.ts
function $78916fc80cd27125$export$b956e38827fca970(action) {
    return $78916fc80cd27125$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $7d97e02cb028d0b8$var$__defProp = Object.defineProperty;
var $7d97e02cb028d0b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7d97e02cb028d0b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7d97e02cb028d0b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7d97e02cb028d0b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $7d97e02cb028d0b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7d97e02cb028d0b8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7d97e02cb028d0b8$var$__hasOwnProp.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    if ($7d97e02cb028d0b8$var$__getOwnPropSymbols) {
        for (var prop of $7d97e02cb028d0b8$var$__getOwnPropSymbols(b))if ($7d97e02cb028d0b8$var$__propIsEnum.call(b, prop)) $7d97e02cb028d0b8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $7d97e02cb028d0b8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $7d97e02cb028d0b8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $7d97e02cb028d0b8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $7d97e02cb028d0b8$var$errors = [];
function $7d97e02cb028d0b8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $7d97e02cb028d0b8$var$O = Object;
var $7d97e02cb028d0b8$var$getPrototypeOf = $7d97e02cb028d0b8$var$O.getPrototypeOf;
var $7d97e02cb028d0b8$var$CONSTRUCTOR = "constructor";
var $7d97e02cb028d0b8$var$PROTOTYPE = "prototype";
var $7d97e02cb028d0b8$var$CONFIGURABLE = "configurable";
var $7d97e02cb028d0b8$var$ENUMERABLE = "enumerable";
var $7d97e02cb028d0b8$var$WRITABLE = "writable";
var $7d97e02cb028d0b8$var$VALUE = "value";
var $7d97e02cb028d0b8$export$541ac630993a4c84 = (value)=>!!value && !!value[$7d97e02cb028d0b8$var$DRAFT_STATE];
function $7d97e02cb028d0b8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $7d97e02cb028d0b8$var$isPlainObject(value) || $7d97e02cb028d0b8$var$isArray(value) || !!value[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] || !!((_a = value[$7d97e02cb028d0b8$var$CONSTRUCTOR]) == null ? void 0 : _a[$7d97e02cb028d0b8$export$6ee2082928bcb0ee]) || $7d97e02cb028d0b8$var$isMap(value) || $7d97e02cb028d0b8$var$isSet(value);
}
var $7d97e02cb028d0b8$var$objectCtorString = $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE][$7d97e02cb028d0b8$var$CONSTRUCTOR].toString();
var $7d97e02cb028d0b8$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $7d97e02cb028d0b8$var$isPlainObject(value) {
    if (!value || !$7d97e02cb028d0b8$var$isObjectish(value)) return false;
    const proto = $7d97e02cb028d0b8$var$getPrototypeOf(value);
    if (proto === null || proto === $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE]) return true;
    const Ctor = $7d97e02cb028d0b8$var$O.hasOwnProperty.call(proto, $7d97e02cb028d0b8$var$CONSTRUCTOR) && proto[$7d97e02cb028d0b8$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$7d97e02cb028d0b8$var$isFunction(Ctor)) return false;
    let ctorString = $7d97e02cb028d0b8$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $7d97e02cb028d0b8$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $7d97e02cb028d0b8$var$objectCtorString;
}
function $7d97e02cb028d0b8$export$22e8af3f75a010e3(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(15, value);
    return value[$7d97e02cb028d0b8$var$DRAFT_STATE].base_;
}
function $7d97e02cb028d0b8$var$each(obj, iter, strict = true) {
    if ($7d97e02cb028d0b8$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $7d97e02cb028d0b8$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $7d97e02cb028d0b8$var$getArchtype(thing) {
    const state = thing[$7d97e02cb028d0b8$var$DRAFT_STATE];
    return state ? state.type_ : $7d97e02cb028d0b8$var$isArray(thing) ? 1 /* Array */  : $7d97e02cb028d0b8$var$isMap(thing) ? 2 /* Map */  : $7d97e02cb028d0b8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $7d97e02cb028d0b8$var$has = (thing, prop, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $7d97e02cb028d0b8$var$O[$7d97e02cb028d0b8$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $7d97e02cb028d0b8$var$get = (thing, prop, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $7d97e02cb028d0b8$var$set = (thing, propOrOldValue, value, type = $7d97e02cb028d0b8$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $7d97e02cb028d0b8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $7d97e02cb028d0b8$var$isArray = Array.isArray;
var $7d97e02cb028d0b8$var$isMap = (target)=>target instanceof Map;
var $7d97e02cb028d0b8$var$isSet = (target)=>target instanceof Set;
var $7d97e02cb028d0b8$var$isObjectish = (target)=>typeof target === "object";
var $7d97e02cb028d0b8$var$isFunction = (target)=>typeof target === "function";
var $7d97e02cb028d0b8$var$isBoolean = (target)=>typeof target === "boolean";
var $7d97e02cb028d0b8$var$getProxyDraft = (value)=>{
    if (!$7d97e02cb028d0b8$var$isObjectish(value)) return null;
    return value == null ? void 0 : value[$7d97e02cb028d0b8$var$DRAFT_STATE];
};
var $7d97e02cb028d0b8$var$latest = (state)=>state.copy_ || state.base_;
var $7d97e02cb028d0b8$var$getValue = (value)=>{
    var _a;
    const proxyDraft = $7d97e02cb028d0b8$var$getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var $7d97e02cb028d0b8$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $7d97e02cb028d0b8$var$shallowCopy(base, strict) {
    if ($7d97e02cb028d0b8$var$isMap(base)) return new Map(base);
    if ($7d97e02cb028d0b8$var$isSet(base)) return new Set(base);
    if ($7d97e02cb028d0b8$var$isArray(base)) return Array[$7d97e02cb028d0b8$var$PROTOTYPE].slice.call(base);
    const isPlain = $7d97e02cb028d0b8$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $7d97e02cb028d0b8$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$7d97e02cb028d0b8$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$7d97e02cb028d0b8$var$WRITABLE] === false) {
                desc[$7d97e02cb028d0b8$var$WRITABLE] = true;
                desc[$7d97e02cb028d0b8$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$7d97e02cb028d0b8$var$CONFIGURABLE]: true,
                [$7d97e02cb028d0b8$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$7d97e02cb028d0b8$var$ENUMERABLE]: desc[$7d97e02cb028d0b8$var$ENUMERABLE],
                [$7d97e02cb028d0b8$var$VALUE]: base[key]
            };
        }
        return $7d97e02cb028d0b8$var$O.create($7d97e02cb028d0b8$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $7d97e02cb028d0b8$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $7d97e02cb028d0b8$var$__spreadValues({}, base);
        const obj = $7d97e02cb028d0b8$var$O.create(proto);
        return $7d97e02cb028d0b8$var$O.assign(obj, base);
    }
}
function $7d97e02cb028d0b8$export$792f3d81ea979f55(obj, deep = false) {
    if ($7d97e02cb028d0b8$var$isFrozen(obj) || $7d97e02cb028d0b8$export$541ac630993a4c84(obj) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
    if ($7d97e02cb028d0b8$var$getArchtype(obj) > 1) $7d97e02cb028d0b8$var$O.defineProperties(obj, {
        set: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        add: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        clear: $7d97e02cb028d0b8$var$dontMutateMethodOverride,
        delete: $7d97e02cb028d0b8$var$dontMutateMethodOverride
    });
    $7d97e02cb028d0b8$var$O.freeze(obj);
    if (deep) $7d97e02cb028d0b8$var$each(obj, (_key, value)=>{
        $7d97e02cb028d0b8$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $7d97e02cb028d0b8$var$dontMutateFrozenCollections() {
    $7d97e02cb028d0b8$var$die(2);
}
var $7d97e02cb028d0b8$var$dontMutateMethodOverride = {
    [$7d97e02cb028d0b8$var$VALUE]: $7d97e02cb028d0b8$var$dontMutateFrozenCollections
};
function $7d97e02cb028d0b8$var$isFrozen(obj) {
    if (obj === null || !$7d97e02cb028d0b8$var$isObjectish(obj)) return true;
    return $7d97e02cb028d0b8$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $7d97e02cb028d0b8$var$PluginMapSet = "MapSet";
var $7d97e02cb028d0b8$var$PluginPatches = "Patches";
var $7d97e02cb028d0b8$var$plugins = {};
function $7d97e02cb028d0b8$var$getPlugin(pluginKey) {
    const plugin = $7d97e02cb028d0b8$var$plugins[pluginKey];
    if (!plugin) $7d97e02cb028d0b8$var$die(0, pluginKey);
    return plugin;
}
var $7d97e02cb028d0b8$var$isPluginLoaded = (pluginKey)=>!!$7d97e02cb028d0b8$var$plugins[pluginKey];
function $7d97e02cb028d0b8$var$loadPlugin(pluginKey, implementation) {
    if (!$7d97e02cb028d0b8$var$plugins[pluginKey]) $7d97e02cb028d0b8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $7d97e02cb028d0b8$var$currentScope;
var $7d97e02cb028d0b8$var$getCurrentScope = ()=>$7d97e02cb028d0b8$var$currentScope;
var $7d97e02cb028d0b8$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $7d97e02cb028d0b8$var$isPluginLoaded($7d97e02cb028d0b8$var$PluginMapSet) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet) : void 0
    });
function $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $7d97e02cb028d0b8$var$revokeScope(scope) {
    $7d97e02cb028d0b8$var$leaveScope(scope);
    scope.drafts_.forEach($7d97e02cb028d0b8$var$revokeDraft);
    scope.drafts_ = null;
}
function $7d97e02cb028d0b8$var$leaveScope(scope) {
    if (scope === $7d97e02cb028d0b8$var$currentScope) $7d97e02cb028d0b8$var$currentScope = scope.parent_;
}
var $7d97e02cb028d0b8$var$enterScope = (immer2)=>$7d97e02cb028d0b8$var$currentScope = $7d97e02cb028d0b8$var$createScope($7d97e02cb028d0b8$var$currentScope, immer2);
function $7d97e02cb028d0b8$var$revokeDraft(draft) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $7d97e02cb028d0b8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].modified_) {
            $7d97e02cb028d0b8$var$revokeScope(scope);
            $7d97e02cb028d0b8$var$die(4);
        }
        if ($7d97e02cb028d0b8$export$16e3aed3edb85946(result)) result = $7d97e02cb028d0b8$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$7d97e02cb028d0b8$var$DRAFT_STATE].base_, result, scope);
    } else result = $7d97e02cb028d0b8$var$finalize(scope, baseDraft);
    $7d97e02cb028d0b8$var$maybeFreeze(scope, result, true);
    $7d97e02cb028d0b8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $7d97e02cb028d0b8$export$45b790e32b2810ee ? result : void 0;
}
function $7d97e02cb028d0b8$var$finalize(rootScope, value) {
    if ($7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $7d97e02cb028d0b8$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$7d97e02cb028d0b8$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $7d97e02cb028d0b8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(value, deep);
}
function $7d97e02cb028d0b8$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $7d97e02cb028d0b8$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $7d97e02cb028d0b8$var$EMPTY_LOCATIONS_RESULT = [];
function $7d97e02cb028d0b8$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = $7d97e02cb028d0b8$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $7d97e02cb028d0b8$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $7d97e02cb028d0b8$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $7d97e02cb028d0b8$var$each(parentCopy, (key, value)=>{
            if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : $7d97e02cb028d0b8$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$7d97e02cb028d0b8$var$set(parentCopy, location, finalizedValue, parentType);
}
function $7d97e02cb028d0b8$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !$7d97e02cb028d0b8$var$isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
        $7d97e02cb028d0b8$var$updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $7d97e02cb028d0b8$var$generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $7d97e02cb028d0b8$var$markStateFinalized(state);
    }
}
function $7d97e02cb028d0b8$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
        const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if ($7d97e02cb028d0b8$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $7d97e02cb028d0b8$var$prepareCopy(target);
            const finalizedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
            $7d97e02cb028d0b8$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = $7d97e02cb028d0b8$var$latest(target);
        if ($7d97e02cb028d0b8$var$get(targetCopy, key, target.type_) === value) {
            if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) $7d97e02cb028d0b8$var$handleValue($7d97e02cb028d0b8$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
        }
    });
}
function $7d97e02cb028d0b8$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($7d97e02cb028d0b8$export$541ac630993a4c84(target) || handledSet.has(target) || !$7d97e02cb028d0b8$export$16e3aed3edb85946(target) || $7d97e02cb028d0b8$var$isFrozen(target)) return target;
    handledSet.add(target);
    $7d97e02cb028d0b8$var$each(target, (key, value)=>{
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(value)) {
            const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if ($7d97e02cb028d0b8$var$isSameScope(state, rootScope)) {
                const updatedValue = $7d97e02cb028d0b8$var$getFinalValue(state);
                $7d97e02cb028d0b8$var$set(target, key, updatedValue, target.type_);
                $7d97e02cb028d0b8$var$markStateFinalized(state);
            }
        } else if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) $7d97e02cb028d0b8$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $7d97e02cb028d0b8$var$createProxyProxy(base, parent) {
    const baseIsArray = $7d97e02cb028d0b8$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $7d97e02cb028d0b8$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $7d97e02cb028d0b8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $7d97e02cb028d0b8$var$objectTraps = {
    get (state, prop) {
        if (prop === $7d97e02cb028d0b8$var$DRAFT_STATE) return state;
        const source = $7d97e02cb028d0b8$var$latest(state);
        if (!$7d97e02cb028d0b8$var$has(source, prop, state.type_)) return $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
        if (value === $7d97e02cb028d0b8$var$peek(state.base_, prop)) {
            $7d97e02cb028d0b8$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $7d97e02cb028d0b8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($7d97e02cb028d0b8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto($7d97e02cb028d0b8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $7d97e02cb028d0b8$var$peek($7d97e02cb028d0b8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$7d97e02cb028d0b8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($7d97e02cb028d0b8$var$is(value, current2) && (value !== void 0 || $7d97e02cb028d0b8$var$has(state.base_, prop, state.type_))) return true;
            $7d97e02cb028d0b8$var$prepareCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $7d97e02cb028d0b8$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $7d97e02cb028d0b8$var$prepareCopy(state);
        if ($7d97e02cb028d0b8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $7d97e02cb028d0b8$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $7d97e02cb028d0b8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$7d97e02cb028d0b8$var$WRITABLE]: true,
            [$7d97e02cb028d0b8$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$7d97e02cb028d0b8$var$ENUMERABLE]: desc[$7d97e02cb028d0b8$var$ENUMERABLE],
            [$7d97e02cb028d0b8$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $7d97e02cb028d0b8$var$die(11);
    },
    getPrototypeOf (state) {
        return $7d97e02cb028d0b8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $7d97e02cb028d0b8$var$die(12);
    }
};
var $7d97e02cb028d0b8$var$arrayTraps = {};
$7d97e02cb028d0b8$var$each($7d97e02cb028d0b8$var$objectTraps, (key, fn)=>{
    $7d97e02cb028d0b8$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
});
$7d97e02cb028d0b8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $7d97e02cb028d0b8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$7d97e02cb028d0b8$var$arrayTraps.set = function(state, prop, value) {
    return $7d97e02cb028d0b8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $7d97e02cb028d0b8$var$peek(draft, prop) {
    const state = draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
    const source = state ? $7d97e02cb028d0b8$var$latest(state) : draft;
    return source[prop];
}
function $7d97e02cb028d0b8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop);
    return desc ? $7d97e02cb028d0b8$var$VALUE in desc ? desc[$7d97e02cb028d0b8$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $7d97e02cb028d0b8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $7d97e02cb028d0b8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $7d97e02cb028d0b8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $7d97e02cb028d0b8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $7d97e02cb028d0b8$var$markChanged(state.parent_);
    }
}
function $7d97e02cb028d0b8$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $7d97e02cb028d0b8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $7d97e02cb028d0b8$export$aaadc6ff0f822719 = class {
    createDraft(base) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(base)) $7d97e02cb028d0b8$var$die(8);
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) base = $7d97e02cb028d0b8$export$97aac956da55dae9(base);
        const scope = $7d97e02cb028d0b8$var$enterScope(this);
        const proxy = $7d97e02cb028d0b8$var$createProxy(scope, base, void 0);
        proxy[$7d97e02cb028d0b8$var$DRAFT_STATE].isManual_ = true;
        $7d97e02cb028d0b8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$7d97e02cb028d0b8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $7d97e02cb028d0b8$var$die(9);
        const { scope_: scope } = state;
        $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
        return $7d97e02cb028d0b8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches).applyPatches_;
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($7d97e02cb028d0b8$var$isFunction(base) && !$7d97e02cb028d0b8$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$7d97e02cb028d0b8$var$isFunction(recipe)) $7d97e02cb028d0b8$var$die(6);
            if (patchListener !== void 0 && !$7d97e02cb028d0b8$var$isFunction(patchListener)) $7d97e02cb028d0b8$var$die(7);
            let result;
            if ($7d97e02cb028d0b8$export$16e3aed3edb85946(base)) {
                const scope = $7d97e02cb028d0b8$var$enterScope(this);
                const proxy = $7d97e02cb028d0b8$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $7d97e02cb028d0b8$var$revokeScope(scope);
                    else $7d97e02cb028d0b8$var$leaveScope(scope);
                }
                $7d97e02cb028d0b8$var$usePatchesInScope(scope, patchListener);
                return $7d97e02cb028d0b8$var$processResult(result, scope);
            } else if (!base || !$7d97e02cb028d0b8$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $7d97e02cb028d0b8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $7d97e02cb028d0b8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $7d97e02cb028d0b8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($7d97e02cb028d0b8$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($7d97e02cb028d0b8$var$isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
};
function $7d97e02cb028d0b8$var$createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = $7d97e02cb028d0b8$var$isMap(value) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet).proxyMap_(value, parent) : $7d97e02cb028d0b8$var$isSet(value) ? $7d97e02cb028d0b8$var$getPlugin($7d97e02cb028d0b8$var$PluginMapSet).proxySet_(value, parent) : $7d97e02cb028d0b8$var$createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : $7d97e02cb028d0b8$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) $7d97e02cb028d0b8$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $7d97e02cb028d0b8$export$97aac956da55dae9(value) {
    if (!$7d97e02cb028d0b8$export$541ac630993a4c84(value)) $7d97e02cb028d0b8$var$die(10, value);
    return $7d97e02cb028d0b8$var$currentImpl(value);
}
function $7d97e02cb028d0b8$var$currentImpl(value) {
    if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(value) || $7d97e02cb028d0b8$var$isFrozen(value)) return value;
    const state = value[$7d97e02cb028d0b8$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $7d97e02cb028d0b8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $7d97e02cb028d0b8$var$shallowCopy(value, true);
    $7d97e02cb028d0b8$var$each(copy, (key, childValue)=>{
        $7d97e02cb028d0b8$var$set(copy, key, $7d97e02cb028d0b8$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $7d97e02cb028d0b8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if ("key_" in state && state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = $7d97e02cb028d0b8$var$getProxyDraft($7d97e02cb028d0b8$var$get(parentCopy, state.key_));
            const valueAtKey = $7d97e02cb028d0b8$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $7d97e02cb028d0b8$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $7d97e02cb028d0b8$var$get(current2, key);
            if (!$7d97e02cb028d0b8$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            if ((assigned_ == null ? void 0 : assigned_.get(i.toString())) && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[$7d97e02cb028d0b8$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $7d97e02cb028d0b8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $7d97e02cb028d0b8$var$get(base_, key, type_);
            const value = $7d97e02cb028d0b8$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $7d97e02cb028d0b8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $7d97e02cb028d0b8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $7d97e02cb028d0b8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $7d97e02cb028d0b8$var$CONSTRUCTOR)) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                if ($7d97e02cb028d0b8$var$isFunction(base) && p === $7d97e02cb028d0b8$var$PROTOTYPE) $7d97e02cb028d0b8$var$die(errorOffset + 3);
                base = $7d97e02cb028d0b8$var$get(base, p);
                if (!$7d97e02cb028d0b8$var$isObjectish(base)) $7d97e02cb028d0b8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $7d97e02cb028d0b8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $7d97e02cb028d0b8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $7d97e02cb028d0b8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$7d97e02cb028d0b8$export$16e3aed3edb85946(obj)) return obj;
        if ($7d97e02cb028d0b8$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($7d97e02cb028d0b8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($7d97e02cb028d0b8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($7d97e02cb028d0b8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($7d97e02cb028d0b8$var$has(obj, $7d97e02cb028d0b8$export$6ee2082928bcb0ee)) cloned[$7d97e02cb028d0b8$export$6ee2082928bcb0ee] = obj[$7d97e02cb028d0b8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($7d97e02cb028d0b8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $7d97e02cb028d0b8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$7d97e02cb028d0b8$var$latest(state).has(key) || $7d97e02cb028d0b8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareMapCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $7d97e02cb028d0b8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            $7d97e02cb028d0b8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $7d97e02cb028d0b8$var$latest(state).get(key);
            if (state.finalized_ || !$7d97e02cb028d0b8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$7d97e02cb028d0b8$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        get size() {
            return $7d97e02cb028d0b8$var$latest(this[$7d97e02cb028d0b8$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $7d97e02cb028d0b8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($7d97e02cb028d0b8$var$latest(state).size) {
                prepareSetCopy(state);
                $7d97e02cb028d0b8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$7d97e02cb028d0b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($7d97e02cb028d0b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
        constructor(target, parent){
            super();
            this[$7d97e02cb028d0b8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $7d97e02cb028d0b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$7d97e02cb028d0b8$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($7d97e02cb028d0b8$export$16e3aed3edb85946(value)) {
                    const draft = $7d97e02cb028d0b8$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $7d97e02cb028d0b8$var$die(3, JSON.stringify($7d97e02cb028d0b8$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($7d97e02cb028d0b8$var$getValue(value));
            });
        }
    }
    $7d97e02cb028d0b8$var$loadPlugin($7d97e02cb028d0b8$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/immer.ts
var $7d97e02cb028d0b8$var$immer = new $7d97e02cb028d0b8$export$aaadc6ff0f822719();
var $7d97e02cb028d0b8$export$b46cabe22e78bc00 = $7d97e02cb028d0b8$var$immer.produce;
var $7d97e02cb028d0b8$export$4da66d41c9492c78 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.produceWithPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$573f26f60825c493 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setAutoFreeze.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$333ce65961cbe047 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setUseStrictShallowCopy.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$1045b3be3904c489 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.setUseStrictIteration.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.applyPatches.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$3c3214997190395f = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.createDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c60f5e69c521b528 = /* @__PURE__ */ $7d97e02cb028d0b8$var$immer.finishDraft.bind($7d97e02cb028d0b8$var$immer);
var $7d97e02cb028d0b8$export$c05b21e3257751e5 = (value)=>value;
var $7d97e02cb028d0b8$export$20f911b3f8cf0b74 = (value)=>value;


var $8098b29b64296697$var$__defProp = Object.defineProperty;
var $8098b29b64296697$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8098b29b64296697$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8098b29b64296697$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8098b29b64296697$var$__defNormalProp = (obj, key, value)=>key in obj ? $8098b29b64296697$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8098b29b64296697$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8098b29b64296697$var$__hasOwnProp.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    if ($8098b29b64296697$var$__getOwnPropSymbols) {
        for (var prop of $8098b29b64296697$var$__getOwnPropSymbols(b))if ($8098b29b64296697$var$__propIsEnum.call(b, prop)) $8098b29b64296697$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8098b29b64296697$var$__publicField = (obj, key, value)=>{
    $8098b29b64296697$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $8098b29b64296697$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $8098b29b64296697$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $8098b29b64296697$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $8098b29b64296697$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($8098b29b64296697$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $8098b29b64296697$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $8098b29b64296697$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $8098b29b64296697$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $8098b29b64296697$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $8098b29b64296697$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $8098b29b64296697$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $8098b29b64296697$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $8098b29b64296697$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, $8098b29b64296697$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $8098b29b64296697$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $8098b29b64296697$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $8098b29b64296697$var$$REVISION = 0;
var $8098b29b64296697$var$CURRENT_TRACKER = null;
var $8098b29b64296697$var$Cell = class {
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $8098b29b64296697$var$CURRENT_TRACKER == null || $8098b29b64296697$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$8098b29b64296697$var$$REVISION;
    }
    constructor(initialValue, isEqual = $8098b29b64296697$var$tripleEq){
        $8098b29b64296697$var$__publicField(this, "revision", $8098b29b64296697$var$$REVISION);
        $8098b29b64296697$var$__publicField(this, "_value");
        $8098b29b64296697$var$__publicField(this, "_lastValue");
        $8098b29b64296697$var$__publicField(this, "_isEqual", $8098b29b64296697$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
};
function $8098b29b64296697$var$tripleEq(a, b) {
    return a === b;
}
var $8098b29b64296697$var$TrackingCache = class {
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $8098b29b64296697$var$CURRENT_TRACKER;
            $8098b29b64296697$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $8098b29b64296697$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $8098b29b64296697$var$CURRENT_TRACKER == null || $8098b29b64296697$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
    constructor(fn){
        $8098b29b64296697$var$__publicField(this, "_cachedValue");
        $8098b29b64296697$var$__publicField(this, "_cachedRevision", -1);
        $8098b29b64296697$var$__publicField(this, "_deps", []);
        $8098b29b64296697$var$__publicField(this, "hits", 0);
        $8098b29b64296697$var$__publicField(this, "fn");
        this.fn = fn;
    }
};
function $8098b29b64296697$var$getValue(cell) {
    if (!(cell instanceof $8098b29b64296697$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $8098b29b64296697$var$setValue(storage, value) {
    if (!(storage instanceof $8098b29b64296697$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $8098b29b64296697$var$createCell(initialValue, isEqual = $8098b29b64296697$var$tripleEq) {
    return new $8098b29b64296697$var$Cell(initialValue, isEqual);
}
function $8098b29b64296697$var$createCache(fn) {
    $8098b29b64296697$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $8098b29b64296697$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $8098b29b64296697$var$neverEq = (a, b)=>false;
function $8098b29b64296697$var$createTag() {
    return $8098b29b64296697$var$createCell(null, $8098b29b64296697$var$neverEq);
}
function $8098b29b64296697$var$dirtyTag(tag, value) {
    $8098b29b64296697$var$setValue(tag, value);
}
var $8098b29b64296697$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $8098b29b64296697$var$createTag();
    $8098b29b64296697$var$getValue(tag);
};
var $8098b29b64296697$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $8098b29b64296697$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $8098b29b64296697$var$REDUX_PROXY_LABEL = Symbol();
var $8098b29b64296697$var$nextId = 0;
var $8098b29b64296697$var$proto = Object.getPrototypeOf({});
var $8098b29b64296697$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $8098b29b64296697$var$__publicField(this, "proxy", new Proxy(this, $8098b29b64296697$var$objectProxyHandler));
        $8098b29b64296697$var$__publicField(this, "tag", $8098b29b64296697$var$createTag());
        $8098b29b64296697$var$__publicField(this, "tags", {});
        $8098b29b64296697$var$__publicField(this, "children", {});
        $8098b29b64296697$var$__publicField(this, "collectionTag", null);
        $8098b29b64296697$var$__publicField(this, "id", $8098b29b64296697$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $8098b29b64296697$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $8098b29b64296697$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $8098b29b64296697$var$createNode(childValue);
                if (childNode.tag) $8098b29b64296697$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $8098b29b64296697$var$createTag();
                    tag.value = childValue;
                }
                $8098b29b64296697$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $8098b29b64296697$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $8098b29b64296697$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $8098b29b64296697$var$__publicField(this, "proxy", new Proxy([
            this
        ], $8098b29b64296697$var$arrayProxyHandler));
        $8098b29b64296697$var$__publicField(this, "tag", $8098b29b64296697$var$createTag());
        $8098b29b64296697$var$__publicField(this, "tags", {});
        $8098b29b64296697$var$__publicField(this, "children", {});
        $8098b29b64296697$var$__publicField(this, "collectionTag", null);
        $8098b29b64296697$var$__publicField(this, "id", $8098b29b64296697$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $8098b29b64296697$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $8098b29b64296697$var$consumeCollection(node);
        return $8098b29b64296697$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $8098b29b64296697$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $8098b29b64296697$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $8098b29b64296697$var$objectProxyHandler.has(node, prop);
    }
};
function $8098b29b64296697$var$createNode(value) {
    if (Array.isArray(value)) return new $8098b29b64296697$var$ArrayTreeNode(value);
    return new $8098b29b64296697$var$ObjectTreeNode(value);
}
function $8098b29b64296697$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $8098b29b64296697$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $8098b29b64296697$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $8098b29b64296697$var$dirtyCollection(node);
            $8098b29b64296697$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $8098b29b64296697$var$updateNode(childNode, newChildValue);
        else {
            $8098b29b64296697$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $8098b29b64296697$var$deleteNode(node) {
    if (node.tag) $8098b29b64296697$var$dirtyTag(node.tag, null);
    $8098b29b64296697$var$dirtyCollection(node);
    for(const key in node.tags)$8098b29b64296697$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$8098b29b64296697$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $8098b29b64296697$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $8098b29b64296697$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $8098b29b64296697$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $8098b29b64296697$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $8098b29b64296697$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $8098b29b64296697$export$3f025202a230c6dd = (a, b)=>a === b;
function $8098b29b64296697$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $8098b29b64296697$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $8098b29b64296697$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $8098b29b64296697$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $8098b29b64296697$var$createSingletonCache(comparator) : $8098b29b64296697$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $8098b29b64296697$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $8098b29b64296697$export$c8f9cf88d9fdee55(func) {
    const node = $8098b29b64296697$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $8098b29b64296697$var$createCacheKeyComparator($8098b29b64296697$export$3f025202a230c6dd);
    const cache = $8098b29b64296697$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $8098b29b64296697$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $8098b29b64296697$var$StrongRef = class {
    deref() {
        return this.value;
    }
    constructor(value){
        this.value = value;
    }
};
var $8098b29b64296697$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $8098b29b64296697$var$StrongRef;
var $8098b29b64296697$var$UNTERMINATED = 0;
var $8098b29b64296697$var$TERMINATED = 1;
function $8098b29b64296697$var$createCacheNode() {
    return {
        s: $8098b29b64296697$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $8098b29b64296697$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $8098b29b64296697$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $8098b29b64296697$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $8098b29b64296697$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $8098b29b64296697$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $8098b29b64296697$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $8098b29b64296697$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $8098b29b64296697$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $8098b29b64296697$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $8098b29b64296697$var$__spreadValues($8098b29b64296697$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $8098b29b64296697$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $8098b29b64296697$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $8098b29b64296697$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $8098b29b64296697$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $8098b29b64296697$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $8098b29b64296697$export$595d22ed68ca2841 = /* @__PURE__ */ $8098b29b64296697$export$5943f4447f6ef248($8098b29b64296697$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $8098b29b64296697$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $8098b29b64296697$export$595d22ed68ca2841)=>{
    $8098b29b64296697$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$8098b29b64296697$export$75979cfcd91bf38f
});


// src/index.ts
function $a08349f8b4900e5d$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $a08349f8b4900e5d$export$dd164f5517779f15 = $a08349f8b4900e5d$var$createThunkMiddleware();
var $a08349f8b4900e5d$export$16d06542a1949d9e = $a08349f8b4900e5d$var$createThunkMiddleware;


var $15d924278321bdfd$var$__defProp = Object.defineProperty;
var $15d924278321bdfd$var$__defProps = Object.defineProperties;
var $15d924278321bdfd$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $15d924278321bdfd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $15d924278321bdfd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $15d924278321bdfd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $15d924278321bdfd$var$__defNormalProp = (obj, key, value)=>key in obj ? $15d924278321bdfd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $15d924278321bdfd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($15d924278321bdfd$var$__hasOwnProp.call(b, prop)) $15d924278321bdfd$var$__defNormalProp(a, prop, b[prop]);
    if ($15d924278321bdfd$var$__getOwnPropSymbols) {
        for (var prop of $15d924278321bdfd$var$__getOwnPropSymbols(b))if ($15d924278321bdfd$var$__propIsEnum.call(b, prop)) $15d924278321bdfd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $15d924278321bdfd$var$__spreadProps = (a, b)=>$15d924278321bdfd$var$__defProps(a, $15d924278321bdfd$var$__getOwnPropDescs(b));
var $15d924278321bdfd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($15d924278321bdfd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $15d924278321bdfd$var$__getOwnPropSymbols) {
        for (var prop of $15d924278321bdfd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $15d924278321bdfd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $15d924278321bdfd$var$__publicField = (obj, key, value)=>$15d924278321bdfd$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var $15d924278321bdfd$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $8098b29b64296697$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $7d97e02cb028d0b8$export$541ac630993a4c84)(value) ? (0, $7d97e02cb028d0b8$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $15d924278321bdfd$export$a5d3c27355e35910 = /* @__PURE__ */ $15d924278321bdfd$export$aab6de9e3dbb1473((0, $8098b29b64296697$export$8402dc26d96f6902));
// src/devtoolsExtension.ts
var $15d924278321bdfd$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $78916fc80cd27125$export$f672e0b6f7222cd7;
    return (0, $78916fc80cd27125$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $15d924278321bdfd$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $15d924278321bdfd$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($15d924278321bdfd$export$378fa86b259c0280(0));
            return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $78916fc80cd27125$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $15d924278321bdfd$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $15d924278321bdfd$var$hasMatchFunction(action);
}
function $15d924278321bdfd$export$ebd532f9034651f3(action) {
    return (0, $78916fc80cd27125$export$b956e38827fca970)(action) && Object.keys(action).every($15d924278321bdfd$var$isValidKey);
}
function $15d924278321bdfd$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $15d924278321bdfd$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $15d924278321bdfd$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $15d924278321bdfd$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $15d924278321bdfd$export$1908877435b1d5e9 = class _Tuple extends Array {
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
};
function $15d924278321bdfd$var$freezeDraftable(val) {
    return (0, $7d97e02cb028d0b8$export$16e3aed3edb85946)(val) ? (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $15d924278321bdfd$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $15d924278321bdfd$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $15d924278321bdfd$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $15d924278321bdfd$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $15d924278321bdfd$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $15d924278321bdfd$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $78916fc80cd27125$export$53b83ca8eaab0383)(val);
}
function $15d924278321bdfd$export$ada5dca0b571bc7(value, path = "", isSerializable = $15d924278321bdfd$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $15d924278321bdfd$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $15d924278321bdfd$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $15d924278321bdfd$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$15d924278321bdfd$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $15d924278321bdfd$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $15d924278321bdfd$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $15d924278321bdfd$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $15d924278321bdfd$export$1908877435b1d5e9();
        if (thunk) {
            if ($15d924278321bdfd$var$isBoolean(thunk)) middlewareArray.push((0, $a08349f8b4900e5d$export$dd164f5517779f15));
            else middlewareArray.push((0, $a08349f8b4900e5d$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $15d924278321bdfd$export$8fb31c0f05df007b = "RTK_autoBatch";
var $15d924278321bdfd$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$15d924278321bdfd$export$8fb31c0f05df007b]: true
            }
        });
var $15d924278321bdfd$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $15d924278321bdfd$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $15d924278321bdfd$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $15d924278321bdfd$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$15d924278321bdfd$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $15d924278321bdfd$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $15d924278321bdfd$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($15d924278321bdfd$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $15d924278321bdfd$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $15d924278321bdfd$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $78916fc80cd27125$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $78916fc80cd27125$export$66e4520cdb265d18)(reducer);
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $78916fc80cd27125$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $15d924278321bdfd$var$composeWithDevTools($15d924278321bdfd$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $78916fc80cd27125$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $15d924278321bdfd$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $78916fc80cd27125$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $15d924278321bdfd$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($15d924278321bdfd$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $15d924278321bdfd$var$isStateFunction(x) {
    return typeof x === "function";
}
function $15d924278321bdfd$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $15d924278321bdfd$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($15d924278321bdfd$var$isStateFunction(initialState)) getInitialState = ()=>$15d924278321bdfd$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $15d924278321bdfd$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $7d97e02cb028d0b8$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7d97e02cb028d0b8$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $15d924278321bdfd$var$matches = (matcher, action)=>{
    if ($15d924278321bdfd$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $15d924278321bdfd$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$15d924278321bdfd$var$matches(matcher, action));
    };
}
function $15d924278321bdfd$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $15d924278321bdfd$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $15d924278321bdfd$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$872dec21e9a69476()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $15d924278321bdfd$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$fcc3388fb56de601()(asyncThunks[0]);
    return $15d924278321bdfd$export$9dd1fb32974da385($15d924278321bdfd$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $15d924278321bdfd$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$1da80a6ef1307441()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $15d924278321bdfd$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$15d924278321bdfd$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$15d924278321bdfd$var$isAsyncThunkArray(asyncThunks)) return $15d924278321bdfd$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $15d924278321bdfd$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $15d924278321bdfd$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $15d924278321bdfd$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $15d924278321bdfd$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $15d924278321bdfd$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $15d924278321bdfd$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $15d924278321bdfd$var$__publicField(this, "_type");
    }
};
var $15d924278321bdfd$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $15d924278321bdfd$var$__publicField(this, "_type");
    }
};
var $15d924278321bdfd$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $15d924278321bdfd$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $15d924278321bdfd$var$externalAbortMessage = "External signal was aborted";
var $15d924278321bdfd$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $15d924278321bdfd$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $15d924278321bdfd$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $15d924278321bdfd$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($15d924278321bdfd$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($15d924278321bdfd$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($15d924278321bdfd$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $15d924278321bdfd$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $15d924278321bdfd$var$RejectWithValue) throw result;
                                if (result instanceof $15d924278321bdfd$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $15d924278321bdfd$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($15d924278321bdfd$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $15d924278321bdfd$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $15d924278321bdfd$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $15d924278321bdfd$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $15d924278321bdfd$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $15d924278321bdfd$export$343355ed40c51c46 = {
    [$15d924278321bdfd$var$asyncThunkSymbol]: $15d924278321bdfd$export$6abd22dc03e5063f
};
var $15d924278321bdfd$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($15d924278321bdfd$export$23a094319a4b586 || {});
function $15d924278321bdfd$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $15d924278321bdfd$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$15d924278321bdfd$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($15d924278321bdfd$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($15d924278321bdfd$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($15d924278321bdfd$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($15d924278321bdfd$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $15d924278321bdfd$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $15d924278321bdfd$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $15d924278321bdfd$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $15d924278321bdfd$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $15d924278321bdfd$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $15d924278321bdfd$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $15d924278321bdfd$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $15d924278321bdfd$var$wrapSelector(selector, selectState, ()=>$15d924278321bdfd$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $15d924278321bdfd$var$__spreadProps($15d924278321bdfd$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $15d924278321bdfd$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $15d924278321bdfd$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $15d924278321bdfd$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $15d924278321bdfd$export$affdea4146de9cf5();
function $15d924278321bdfd$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $15d924278321bdfd$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $15d924278321bdfd$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $15d924278321bdfd$export$309c7a02b0b0bc62(type, prepareCallback) : $15d924278321bdfd$export$309c7a02b0b0bc62(type));
}
function $15d924278321bdfd$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $15d924278321bdfd$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $15d924278321bdfd$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($15d924278321bdfd$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $15d924278321bdfd$var$noop,
        pending: pending || $15d924278321bdfd$var$noop,
        rejected: rejected || $15d924278321bdfd$var$noop,
        settled: settled || $15d924278321bdfd$var$noop
    });
}
function $15d924278321bdfd$var$noop() {}
// src/entities/entity_state.ts
function $15d924278321bdfd$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $15d924278321bdfd$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($15d924278321bdfd$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $15d924278321bdfd$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $15d924278321bdfd$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $15d924278321bdfd$var$isDraftTyped = (0, $7d97e02cb028d0b8$export$541ac630993a4c84);
function $15d924278321bdfd$var$createSingleArgumentStateOperator(mutator) {
    const operator = $15d924278321bdfd$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $15d924278321bdfd$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $15d924278321bdfd$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($15d924278321bdfd$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $7d97e02cb028d0b8$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $15d924278321bdfd$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $15d924278321bdfd$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $15d924278321bdfd$var$getCurrent(value) {
    return (0, $7d97e02cb028d0b8$export$541ac630993a4c84)(value) ? (0, $7d97e02cb028d0b8$export$97aac956da55dae9)(value) : value;
}
function $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $15d924278321bdfd$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $15d924278321bdfd$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $15d924278321bdfd$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $15d924278321bdfd$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$15d924278321bdfd$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $15d924278321bdfd$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably),
        removeOne: $15d924278321bdfd$var$createStateOperator(removeOneMutably),
        removeMany: $15d924278321bdfd$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $15d924278321bdfd$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $15d924278321bdfd$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $15d924278321bdfd$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $15d924278321bdfd$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $15d924278321bdfd$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $15d924278321bdfd$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $15d924278321bdfd$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $15d924278321bdfd$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $15d924278321bdfd$var$getCurrent(state.entities);
        const currentIds = $15d924278321bdfd$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $15d924278321bdfd$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $15d924278321bdfd$var$createStateOperator(addOneMutably),
        updateOne: $15d924278321bdfd$var$createStateOperator(updateOneMutably),
        upsertOne: $15d924278321bdfd$var$createStateOperator(upsertOneMutably),
        setOne: $15d924278321bdfd$var$createStateOperator(setOneMutably),
        setMany: $15d924278321bdfd$var$createStateOperator(setManyMutably),
        setAll: $15d924278321bdfd$var$createStateOperator(setAllMutably),
        addMany: $15d924278321bdfd$var$createStateOperator(addManyMutably),
        updateMany: $15d924278321bdfd$var$createStateOperator(updateManyMutably),
        upsertMany: $15d924278321bdfd$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $15d924278321bdfd$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $15d924278321bdfd$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $15d924278321bdfd$var$createSortedStateAdapter(selectId, sortComparer) : $15d924278321bdfd$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $15d924278321bdfd$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $15d924278321bdfd$var$createSelectorsFactory();
    return $15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues($15d924278321bdfd$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $15d924278321bdfd$var$task = "task";
var $15d924278321bdfd$var$listener = "listener";
var $15d924278321bdfd$var$completed = "completed";
var $15d924278321bdfd$var$cancelled = "cancelled";
var $15d924278321bdfd$var$taskCancelled = `task-${$15d924278321bdfd$var$cancelled}`;
var $15d924278321bdfd$var$taskCompleted = `task-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$var$listenerCancelled = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$cancelled}`;
var $15d924278321bdfd$var$listenerCompleted = `${$15d924278321bdfd$var$listener}-${$15d924278321bdfd$var$completed}`;
var $15d924278321bdfd$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $15d924278321bdfd$var$__publicField(this, "name", "TaskAbortError");
        $15d924278321bdfd$var$__publicField(this, "message");
        this.message = `${$15d924278321bdfd$var$task} ${$15d924278321bdfd$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $15d924278321bdfd$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($15d924278321bdfd$export$378fa86b259c0280(32));
};
var $15d924278321bdfd$var$noop2 = ()=>{};
var $15d924278321bdfd$var$catchRejection = (promise, onError = $15d924278321bdfd$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $15d924278321bdfd$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $15d924278321bdfd$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason);
};
function $15d924278321bdfd$var$raceWithSignal(signal, promise) {
    let cleanup = $15d924278321bdfd$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $15d924278321bdfd$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $15d924278321bdfd$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $15d924278321bdfd$var$noop2;
    });
}
var $15d924278321bdfd$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $15d924278321bdfd$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $15d924278321bdfd$var$createPause = (signal)=>{
    return (promise)=>{
        return $15d924278321bdfd$var$catchRejection($15d924278321bdfd$var$raceWithSignal(signal, promise).then((output)=>{
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        }));
    };
};
var $15d924278321bdfd$var$createDelay = (signal)=>{
    const pause = $15d924278321bdfd$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $15d924278321bdfd$var$assign } = Object;
var $15d924278321bdfd$var$INTERNAL_NIL_TOKEN = {};
var $15d924278321bdfd$var$alm = "listenerMiddleware";
var $15d924278321bdfd$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$15d924278321bdfd$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $15d924278321bdfd$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $15d924278321bdfd$var$runTask(async ()=>{
            $15d924278321bdfd$var$validateActive(parentAbortSignal);
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $15d924278321bdfd$var$createPause(childAbortController.signal),
                delay: $15d924278321bdfd$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $15d924278321bdfd$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($15d924278321bdfd$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($15d924278321bdfd$var$noop2));
        return {
            result: $15d924278321bdfd$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($15d924278321bdfd$var$taskCancelled);
            }
        };
    };
};
var $15d924278321bdfd$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $15d924278321bdfd$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $15d924278321bdfd$var$raceWithSignal(signal, Promise.race(promises));
            $15d924278321bdfd$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$15d924278321bdfd$var$catchRejection(take(predicate, timeout));
};
var $15d924278321bdfd$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $15d924278321bdfd$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($15d924278321bdfd$export$378fa86b259c0280(21));
    $15d924278321bdfd$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $15d924278321bdfd$var$createListenerEntry = /* @__PURE__ */ $15d924278321bdfd$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $15d924278321bdfd$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($15d924278321bdfd$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$15d924278321bdfd$var$createListenerEntry
});
var $15d924278321bdfd$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $15d924278321bdfd$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $15d924278321bdfd$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($15d924278321bdfd$var$listenerCancelled);
    });
};
var $15d924278321bdfd$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$15d924278321bdfd$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $15d924278321bdfd$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $15d924278321bdfd$export$f03a6b845d3fb58b = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/add`), {
    withTypes: ()=>$15d924278321bdfd$export$f03a6b845d3fb58b
});
var $15d924278321bdfd$export$b1b8022855fb2b71 = /* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/removeAll`);
var $15d924278321bdfd$export$b03e9483f936dccb = /* @__PURE__ */ $15d924278321bdfd$var$assign(/* @__PURE__ */ $15d924278321bdfd$export$309c7a02b0b0bc62(`${$15d924278321bdfd$var$alm}/remove`), {
    withTypes: ()=>$15d924278321bdfd$export$b03e9483f936dccb
});
var $15d924278321bdfd$var$defaultErrorHandler = (...args)=>{
    console.error(`${$15d924278321bdfd$var$alm}/error`, ...args);
};
var $15d924278321bdfd$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $15d924278321bdfd$var$defaultErrorHandler } = middlewareOptions;
    $15d924278321bdfd$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $15d924278321bdfd$var$findListenerEntry(listenerMap, options)) != null ? _a : $15d924278321bdfd$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $15d924278321bdfd$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $15d924278321bdfd$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $15d924278321bdfd$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $15d924278321bdfd$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $15d924278321bdfd$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $15d924278321bdfd$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $15d924278321bdfd$var$createDelay(internalTaskController.signal),
                pause: $15d924278321bdfd$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $15d924278321bdfd$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($15d924278321bdfd$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($15d924278321bdfd$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $15d924278321bdfd$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $15d924278321bdfd$export$cb1bdac908fed7f)) $15d924278321bdfd$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($15d924278321bdfd$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $15d924278321bdfd$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $78916fc80cd27125$export$b956e38827fca970)(action)) return next(action);
                if ($15d924278321bdfd$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($15d924278321bdfd$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($15d924278321bdfd$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $15d924278321bdfd$var$INTERNAL_NIL_TOKEN) throw new Error($15d924278321bdfd$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $15d924278321bdfd$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $15d924278321bdfd$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $15d924278321bdfd$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $15d924278321bdfd$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $15d924278321bdfd$export$4bb1606a79445586 = ()=>{
    const instanceId = $15d924278321bdfd$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($15d924278321bdfd$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $15d924278321bdfd$var$getOrInsertComputed(middlewareMap, middleware2, $15d924278321bdfd$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$15d924278321bdfd$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $78916fc80cd27125$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $15d924278321bdfd$export$9dd1fb32974da385(withMiddleware, $15d924278321bdfd$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $15d924278321bdfd$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $15d924278321bdfd$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$15d924278321bdfd$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $15d924278321bdfd$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $15d924278321bdfd$var$isStateProxy = (value)=>!!value && !!value[$15d924278321bdfd$var$ORIGINAL_STATE];
var $15d924278321bdfd$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $15d924278321bdfd$var$createStateProxy = (state, reducerMap, initialStateCache)=>$15d924278321bdfd$var$getOrInsertComputed($15d924278321bdfd$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $15d924278321bdfd$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $15d924278321bdfd$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($15d924278321bdfd$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $15d924278321bdfd$var$original = (state)=>{
    if (!$15d924278321bdfd$var$isStateProxy(state)) throw new Error($15d924278321bdfd$export$378fa86b259c0280(25));
    return state[$15d924278321bdfd$var$ORIGINAL_STATE];
};
var $15d924278321bdfd$var$emptyObject = {};
var $15d924278321bdfd$var$noopReducer = (state = $15d924278321bdfd$var$emptyObject)=>state;
function $15d924278321bdfd$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($15d924278321bdfd$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $78916fc80cd27125$export$66e4520cdb265d18)(reducerMap) : $15d924278321bdfd$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($15d924278321bdfd$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $15d924278321bdfd$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $15d924278321bdfd$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $485fd72a280fc37f$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$485fd72a280fc37f$export$c169aefb7330cccb["open"] = "0";
$485fd72a280fc37f$export$c169aefb7330cccb["close"] = "1";
$485fd72a280fc37f$export$c169aefb7330cccb["ping"] = "2";
$485fd72a280fc37f$export$c169aefb7330cccb["pong"] = "3";
$485fd72a280fc37f$export$c169aefb7330cccb["message"] = "4";
$485fd72a280fc37f$export$c169aefb7330cccb["upgrade"] = "5";
$485fd72a280fc37f$export$c169aefb7330cccb["noop"] = "6";
const $485fd72a280fc37f$export$47791e8004edd485 = Object.create(null);
Object.keys($485fd72a280fc37f$export$c169aefb7330cccb).forEach((key)=>{
    $485fd72a280fc37f$export$47791e8004edd485[$485fd72a280fc37f$export$c169aefb7330cccb[key]] = key;
});
const $485fd72a280fc37f$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $425b0969bba6880d$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $425b0969bba6880d$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $425b0969bba6880d$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $425b0969bba6880d$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($425b0969bba6880d$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $425b0969bba6880d$var$encodeBlobAsBase64(data, callback);
    } else if ($425b0969bba6880d$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $425b0969bba6880d$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $425b0969bba6880d$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $485fd72a280fc37f$export$c169aefb7330cccb)[type] + (data || ""));
};
const $425b0969bba6880d$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $425b0969bba6880d$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $425b0969bba6880d$var$TEXT_ENCODER;
function $425b0969bba6880d$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($425b0969bba6880d$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($425b0969bba6880d$var$toArray).then(callback);
    else if ($425b0969bba6880d$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $425b0969bba6880d$var$isView(packet.data))) return callback($425b0969bba6880d$var$toArray(packet.data));
    $425b0969bba6880d$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$425b0969bba6880d$var$TEXT_ENCODER) $425b0969bba6880d$var$TEXT_ENCODER = new TextEncoder();
        callback($425b0969bba6880d$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $318e51a2cd211ea8$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $318e51a2cd211ea8$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $318e51a2cd211ea8$var$chars.length; i++)$318e51a2cd211ea8$var$lookup[$318e51a2cd211ea8$var$chars.charCodeAt(i)] = i;
const $318e51a2cd211ea8$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $318e51a2cd211ea8$var$chars[bytes[i] >> 2];
        base64 += $318e51a2cd211ea8$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $318e51a2cd211ea8$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $318e51a2cd211ea8$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $318e51a2cd211ea8$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $318e51a2cd211ea8$var$lookup[base64.charCodeAt(i)];
        encoded2 = $318e51a2cd211ea8$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $318e51a2cd211ea8$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $318e51a2cd211ea8$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $96e194a32902c380$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $96e194a32902c380$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $96e194a32902c380$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $96e194a32902c380$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $485fd72a280fc37f$export$47791e8004edd485)[type];
    if (!packetType) return 0, $485fd72a280fc37f$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $485fd72a280fc37f$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $485fd72a280fc37f$export$47791e8004edd485)[type]
    };
};
const $96e194a32902c380$var$decodeBase64Packet = (data, binaryType)=>{
    if ($96e194a32902c380$var$withNativeArrayBuffer) {
        const decoded = (0, $318e51a2cd211ea8$export$2f872c0f2117be69)(data);
        return $96e194a32902c380$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $96e194a32902c380$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $25f9c19459bedd3a$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $25f9c19459bedd3a$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $425b0969bba6880d$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($25f9c19459bedd3a$var$SEPARATOR));
        });
    });
};
const $25f9c19459bedd3a$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($25f9c19459bedd3a$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $96e194a32902c380$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $25f9c19459bedd3a$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $425b0969bba6880d$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $25f9c19459bedd3a$var$TEXT_DECODER;
function $25f9c19459bedd3a$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $25f9c19459bedd3a$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $25f9c19459bedd3a$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$25f9c19459bedd3a$var$TEXT_DECODER) $25f9c19459bedd3a$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($25f9c19459bedd3a$var$totalLength(chunks) < 1) break;
                    const header = $25f9c19459bedd3a$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($25f9c19459bedd3a$var$totalLength(chunks) < 2) break;
                    const headerArray = $25f9c19459bedd3a$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($25f9c19459bedd3a$var$totalLength(chunks) < 8) break;
                    const headerArray = $25f9c19459bedd3a$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $485fd72a280fc37f$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($25f9c19459bedd3a$var$totalLength(chunks) < expectedLength) break;
                    const data = $25f9c19459bedd3a$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $96e194a32902c380$export$4647901878f33f31)(isBinary ? data : $25f9c19459bedd3a$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $485fd72a280fc37f$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $25f9c19459bedd3a$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $d2e16889eae8d3b3$export$4293555f241ae35a(obj) {
    if (obj) return $d2e16889eae8d3b3$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $d2e16889eae8d3b3$var$mixin(obj) {
    for(var key in $d2e16889eae8d3b3$export$4293555f241ae35a.prototype)obj[key] = $d2e16889eae8d3b3$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.on = $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.off = $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.removeListener = $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.removeAllListeners = $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$d2e16889eae8d3b3$export$4293555f241ae35a.prototype.emitReserved = $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $d2e16889eae8d3b3$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $04e0eba76f880398$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $04e0eba76f880398$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $04e0eba76f880398$export$790dcbc41e2d75d5 = "arraybuffer";
function $04e0eba76f880398$export$19413efcf2fac759() {}


function $e49ac1b9c8816397$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $e49ac1b9c8816397$var$NATIVE_SET_TIMEOUT = (0, $04e0eba76f880398$export$394f9358f6231289).setTimeout;
const $e49ac1b9c8816397$var$NATIVE_CLEAR_TIMEOUT = (0, $04e0eba76f880398$export$394f9358f6231289).clearTimeout;
function $e49ac1b9c8816397$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $e49ac1b9c8816397$var$NATIVE_SET_TIMEOUT.bind((0, $04e0eba76f880398$export$394f9358f6231289));
        obj.clearTimeoutFn = $e49ac1b9c8816397$var$NATIVE_CLEAR_TIMEOUT.bind((0, $04e0eba76f880398$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $04e0eba76f880398$export$394f9358f6231289).setTimeout.bind((0, $04e0eba76f880398$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $04e0eba76f880398$export$394f9358f6231289).clearTimeout.bind((0, $04e0eba76f880398$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $e49ac1b9c8816397$var$BASE64_OVERHEAD = 1.33;
function $e49ac1b9c8816397$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $e49ac1b9c8816397$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $e49ac1b9c8816397$var$BASE64_OVERHEAD);
}
function $e49ac1b9c8816397$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $e49ac1b9c8816397$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $8420df63678cd16a$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $8420df63678cd16a$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $4b70be94cb0aef60$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4b70be94cb0aef60$export$86495b081fef8e52 extends (0, $d2e16889eae8d3b3$export$4293555f241ae35a) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4b70be94cb0aef60$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $96e194a32902c380$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $8420df63678cd16a$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $e49ac1b9c8816397$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
}




class $75922ef231974f56$export$265ee5eefd4c309b extends (0, $4b70be94cb0aef60$export$86495b081fef8e52) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $25f9c19459bedd3a$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $25f9c19459bedd3a$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e49ac1b9c8816397$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    constructor(){
        super(...arguments);
        this._polling = false;
    }
}





// imported from https://github.com/component/has-cors
let $aa228a302de1aa6a$var$value = false;
try {
    $aa228a302de1aa6a$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $aa228a302de1aa6a$export$5235bbd4a1ef06e = $aa228a302de1aa6a$var$value;


function $fa71b6deaae7484b$var$empty() {}
class $fa71b6deaae7484b$export$c959f2344155d309 extends (0, $75922ef231974f56$export$265ee5eefd4c309b) {
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
}
class $fa71b6deaae7484b$export$7fa6c5b6f8193917 extends (0, $d2e16889eae8d3b3$export$4293555f241ae35a) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $e49ac1b9c8816397$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $fa71b6deaae7484b$export$7fa6c5b6f8193917.requestsCount++;
            $fa71b6deaae7484b$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $fa71b6deaae7484b$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $fa71b6deaae7484b$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $e49ac1b9c8816397$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
}
$fa71b6deaae7484b$export$7fa6c5b6f8193917.requestsCount = 0;
$fa71b6deaae7484b$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $fa71b6deaae7484b$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $04e0eba76f880398$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $fa71b6deaae7484b$var$unloadHandler, false);
    }
}
function $fa71b6deaae7484b$var$unloadHandler() {
    for(let i in $fa71b6deaae7484b$export$7fa6c5b6f8193917.requests)if ($fa71b6deaae7484b$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $fa71b6deaae7484b$export$7fa6c5b6f8193917.requests[i].abort();
}
const $fa71b6deaae7484b$var$hasXHR2 = function() {
    const xhr = $fa71b6deaae7484b$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $fa71b6deaae7484b$export$a2d42eb087c10497 extends $fa71b6deaae7484b$export$c959f2344155d309 {
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $fa71b6deaae7484b$export$7fa6c5b6f8193917($fa71b6deaae7484b$var$newRequest, this.uri(), opts);
    }
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $fa71b6deaae7484b$var$hasXHR2 && !forceBase64;
    }
}
function $fa71b6deaae7484b$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $aa228a302de1aa6a$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $04e0eba76f880398$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $c4570bf9c99083c3$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $c4570bf9c99083c3$export$570bf71d2367e261 extends (0, $4b70be94cb0aef60$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $c4570bf9c99083c3$var$isReactNative ? {} : (0, $e49ac1b9c8816397$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $425b0969bba6880d$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $04e0eba76f880398$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e49ac1b9c8816397$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $c4570bf9c99083c3$var$WebSocketCtor = (0, $04e0eba76f880398$export$394f9358f6231289).WebSocket || (0, $04e0eba76f880398$export$394f9358f6231289).MozWebSocket;
class $c4570bf9c99083c3$export$911baa0677ac404c extends $c4570bf9c99083c3$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$c4570bf9c99083c3$var$isReactNative ? protocols ? new $c4570bf9c99083c3$var$WebSocketCtor(uri, protocols) : new $c4570bf9c99083c3$var$WebSocketCtor(uri) : new $c4570bf9c99083c3$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $f3e4a0daba020920$export$961c930859384407 extends (0, $4b70be94cb0aef60$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $25f9c19459bedd3a$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $25f9c19459bedd3a$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $04e0eba76f880398$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $a2a0e6fec2a03a9c$export$46dec00755c1153b = {
    websocket: (0, $c4570bf9c99083c3$export$911baa0677ac404c),
    webtransport: (0, $f3e4a0daba020920$export$961c930859384407),
    polling: (0, $fa71b6deaae7484b$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $6a96bb0800d90136$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $6a96bb0800d90136$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $6a96bb0800d90136$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $6a96bb0800d90136$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$6a96bb0800d90136$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $6a96bb0800d90136$var$pathNames(uri, uri['path']);
    uri.queryKey = $6a96bb0800d90136$var$queryKey(uri, uri['query']);
    return uri;
}
function $6a96bb0800d90136$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $6a96bb0800d90136$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $17348c6e065c4f90$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $17348c6e065c4f90$var$OFFLINE_EVENT_LISTENERS = [];
if ($17348c6e065c4f90$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $17348c6e065c4f90$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $17348c6e065c4f90$export$3874118029a0ee0d extends (0, $d2e16889eae8d3b3$export$4293555f241ae35a) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $25f9c19459bedd3a$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $17348c6e065c4f90$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $17348c6e065c4f90$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $e49ac1b9c8816397$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $04e0eba76f880398$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $17348c6e065c4f90$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($17348c6e065c4f90$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $17348c6e065c4f90$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $17348c6e065c4f90$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $04e0eba76f880398$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $6a96bb0800d90136$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $6a96bb0800d90136$export$98e6a39c04603d36)(opts.host).host;
        (0, $e49ac1b9c8816397$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $8420df63678cd16a$export$2f872c0f2117be69)(this.opts.query);
        if ($17348c6e065c4f90$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $17348c6e065c4f90$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $04e0eba76f880398$export$19413efcf2fac759)();
        this._open();
    }
}
$17348c6e065c4f90$export$3874118029a0ee0d.protocol = (0, $25f9c19459bedd3a$export$a51d6b395ff4c65a);
class $17348c6e065c4f90$export$cc521fcb1004e85c extends $17348c6e065c4f90$export$3874118029a0ee0d {
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $17348c6e065c4f90$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $17348c6e065c4f90$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
}
class $17348c6e065c4f90$export$4798917dbf149b79 extends $17348c6e065c4f90$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $a2a0e6fec2a03a9c$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $2312bd8964260add$export$1e7deca84b429035 extends (0, $75922ef231974f56$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $cce71a260fce2427$export$a51d6b395ff4c65a = (0, $17348c6e065c4f90$export$4798917dbf149b79).protocol;


function $dd20113e7796e295$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $6a96bb0800d90136$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $0103acf7f77a549b$exports = {};

$parcel$export($0103acf7f77a549b$exports, "protocol", function () { return $0103acf7f77a549b$export$a51d6b395ff4c65a; });
$parcel$export($0103acf7f77a549b$exports, "PacketType", function () { return $0103acf7f77a549b$export$84d4095e16c6fc19; });
$parcel$export($0103acf7f77a549b$exports, "Encoder", function () { return $0103acf7f77a549b$export$a50aceb0e02a00aa; });
$parcel$export($0103acf7f77a549b$exports, "Decoder", function () { return $0103acf7f77a549b$export$f9de6ca0bc043724; });

const $7acef1e6b67f58c6$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $7acef1e6b67f58c6$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $7acef1e6b67f58c6$var$toString = Object.prototype.toString;
const $7acef1e6b67f58c6$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $7acef1e6b67f58c6$var$toString.call(Blob) === "[object BlobConstructor]";
const $7acef1e6b67f58c6$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $7acef1e6b67f58c6$var$toString.call(File) === "[object FileConstructor]";
function $7acef1e6b67f58c6$export$37488ff1135b1696(obj) {
    return $7acef1e6b67f58c6$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $7acef1e6b67f58c6$var$isView(obj)) || $7acef1e6b67f58c6$var$withNativeBlob && obj instanceof Blob || $7acef1e6b67f58c6$var$withNativeFile && obj instanceof File;
}
function $7acef1e6b67f58c6$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($7acef1e6b67f58c6$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($7acef1e6b67f58c6$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $7acef1e6b67f58c6$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $7acef1e6b67f58c6$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $a3fd9076d131385f$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $a3fd9076d131385f$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $a3fd9076d131385f$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $7acef1e6b67f58c6$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $a3fd9076d131385f$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $a3fd9076d131385f$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $a3fd9076d131385f$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $a3fd9076d131385f$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $a3fd9076d131385f$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $a3fd9076d131385f$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $a3fd9076d131385f$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $0103acf7f77a549b$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $0103acf7f77a549b$export$a51d6b395ff4c65a = 5;
var $0103acf7f77a549b$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($0103acf7f77a549b$export$84d4095e16c6fc19 || ($0103acf7f77a549b$export$84d4095e16c6fc19 = {}));
class $0103acf7f77a549b$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $0103acf7f77a549b$export$84d4095e16c6fc19.EVENT || obj.type === $0103acf7f77a549b$export$84d4095e16c6fc19.ACK) {
            if ((0, $7acef1e6b67f58c6$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $0103acf7f77a549b$export$84d4095e16c6fc19.EVENT ? $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_EVENT : $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $a3fd9076d131385f$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $0103acf7f77a549b$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $0103acf7f77a549b$export$f9de6ca0bc043724 extends (0, $d2e16889eae8d3b3$export$4293555f241ae35a) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $0103acf7f77a549b$export$84d4095e16c6fc19.EVENT : $0103acf7f77a549b$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $0103acf7f77a549b$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $7acef1e6b67f58c6$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($0103acf7f77a549b$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($0103acf7f77a549b$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $0103acf7f77a549b$export$84d4095e16c6fc19.CONNECT:
                return $0103acf7f77a549b$var$isObject(payload);
            case $0103acf7f77a549b$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $0103acf7f77a549b$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $0103acf7f77a549b$var$isObject(payload);
            case $0103acf7f77a549b$export$84d4095e16c6fc19.EVENT:
            case $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $0103acf7f77a549b$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $0103acf7f77a549b$export$84d4095e16c6fc19.ACK:
            case $0103acf7f77a549b$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $0103acf7f77a549b$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $a3fd9076d131385f$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}


function $16d4d545ce4752e7$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $ece112d329001cb3$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $ece112d329001cb3$export$4798917dbf149b79 extends (0, $d2e16889eae8d3b3$export$4293555f241ae35a) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $16d4d545ce4752e7$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $16d4d545ce4752e7$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $16d4d545ce4752e7$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $16d4d545ce4752e7$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($ece112d329001cb3$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $0103acf7f77a549b$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $0103acf7f77a549b$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).EVENT:
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).ACK:
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $0103acf7f77a549b$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $0103acf7f77a549b$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $0103acf7f77a549b$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $2c48f549c31bb4b5$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $2c48f549c31bb4b5$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $2c48f549c31bb4b5$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $2c48f549c31bb4b5$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $2c48f549c31bb4b5$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $2c48f549c31bb4b5$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $b265c47c8d15771f$export$d0d38e7dec7a1a61 extends (0, $d2e16889eae8d3b3$export$4293555f241ae35a) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $17348c6e065c4f90$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $16d4d545ce4752e7$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $16d4d545ce4752e7$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $16d4d545ce4752e7$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $16d4d545ce4752e7$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $16d4d545ce4752e7$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $16d4d545ce4752e7$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $16d4d545ce4752e7$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $04e0eba76f880398$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $ece112d329001cb3$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $e49ac1b9c8816397$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $2c48f549c31bb4b5$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $0103acf7f77a549b$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}





/**
 * Managers cache.
 */ const $d16c463a8e126d41$var$cache = {};
function $d16c463a8e126d41$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $dd20113e7796e295$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $d16c463a8e126d41$var$cache[id] && path in $d16c463a8e126d41$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $b265c47c8d15771f$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$d16c463a8e126d41$var$cache[id]) $d16c463a8e126d41$var$cache[id] = new (0, $b265c47c8d15771f$export$d0d38e7dec7a1a61)(source, opts);
        io = $d16c463a8e126d41$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($d16c463a8e126d41$export$841407ceb083bd74, {
    Manager: $b265c47c8d15771f$export$d0d38e7dec7a1a61,
    Socket: $ece112d329001cb3$export$4798917dbf149b79,
    io: $d16c463a8e126d41$export$841407ceb083bd74,
    connect: $d16c463a8e126d41$export$841407ceb083bd74
});


const $db60479c29b70331$var$socket = (0, $d16c463a8e126d41$export$841407ceb083bd74)("https://www.tug-of-logic.com:3000");
const $db60479c29b70331$var$createSocketMiddleware = ()=>{
    /**
	 * Data emitted from the server should be placed here.
	 * use storeAPI.dispatch to send the data into redux state
	 */ // returns a room code on app request
    return (storeAPI)=>{
        const tryReconnect = function() {
            if (!$db60479c29b70331$var$socket.connected) $db60479c29b70331$var$socket.connect();
        };
        let connectionInterval;
        // Handles socket connection event
        $db60479c29b70331$var$socket.on("connect", ()=>{
            clearInterval(connectionInterval);
            // const roomCode = storeAPI.getState().game.roomCode;
            storeAPI.dispatch({
                type: "app/setConnectedToSocket",
                payload: {
                    connectedToSocket: true
                }
            });
            const roomCode = sessionStorage.getItem("roomCode");
            const role = sessionStorage.getItem("role");
            const playerId = sessionStorage.getItem("playerId");
            const playerName = sessionStorage.getItem("playerName");
            if (role !== "undefined") storeAPI.dispatch({
                type: "game/setRole",
                payload: {
                    role: role
                }
            });
            if (roomCode) $db60479c29b70331$var$socket.emit("joinRoom", {
                roomCode: roomCode
            });
            if (playerId !== "undefined" && playerName !== "undefined") storeAPI.dispatch({
                type: "game/setPlayer",
                payload: {
                    id: playerId,
                    name: playerName
                }
            });
        });
        // Handle socket disconnection event. Set a timer to reconnect
        $db60479c29b70331$var$socket.on("disconnect", ()=>{
            connectionInterval = setInterval(tryReconnect, 750);
            storeAPI.dispatch({
                type: "app/setConnectedToSocket",
                payload: {
                    connectedToSocket: false
                }
            });
        });
        $db60479c29b70331$var$socket.on("room code", (data)=>{
            storeAPI.dispatch({
                type: "game/setRoomCode",
                payload: data
            });
        });
        // starts a game on player request
        $db60479c29b70331$var$socket.on("gameCreated", (data)=>{
            sessionStorage.setItem("roomCode", data.roomCode);
            storeAPI.dispatch({
                type: "game/initGame",
                payload: data
            });
        });
        // sets the validity of a player insertedroom code
        $db60479c29b70331$var$socket.on("game validity", (data)=>{
            storeAPI.dispatch({
                type: "app/setRoomCodeValid",
                payload: data
            });
        });
        // sets the validity of a player insertedroom code
        $db60479c29b70331$var$socket.on("name available", (data)=>{
            storeAPI.dispatch({
                type: "app/setPlayerNameAvailable",
                payload: data
            });
        });
        // sets the player details when player joins a game
        $db60479c29b70331$var$socket.on("player details", (data)=>{
            sessionStorage.setItem("playerId", data.id);
            sessionStorage.setItem("playerName", data.name);
            storeAPI.dispatch({
                type: "game/setPlayer",
                payload: data
            });
        });
        // send the player to a game room
        $db60479c29b70331$var$socket.on("send to room", (data)=>{
            sessionStorage.setItem("roomCode", data.roomCode);
            storeAPI.dispatch({
                type: "app/clearError"
            });
            storeAPI.dispatch({
                type: "game/setRoomCode",
                payload: data
            });
        });
        // used to update the game state
        $db60479c29b70331$var$socket.on("gameState", (data)=>{
            storeAPI.dispatch({
                type: "game/setGameState",
                payload: data
            });
        });
        // update the state of the main claim
        $db60479c29b70331$var$socket.on("setMainClaimState", (data)=>{
            storeAPI.dispatch({
                type: "game/setMainClaimState",
                payload: data
            });
        });
        // updates the main claim if edited
        $db60479c29b70331$var$socket.on("updateMainClaim", (data)=>{
            storeAPI.dispatch({
                type: "game/updateMainClaim",
                payload: data
            });
        });
        // changes the phase of the game
        $db60479c29b70331$var$socket.on("phaseChange", (data)=>{
            storeAPI.dispatch({
                type: "game/changeGamePhase",
                payload: data
            });
        });
        // adds a reason to play to the app state
        $db60479c29b70331$var$socket.on("add reason", (data)=>{
            storeAPI.dispatch({
                type: "game/addReasonToPlay",
                payload: data
            });
        });
        // sends a reason-to-play that has been edited to the redux store
        $db60479c29b70331$var$socket.on("updateReasonToPlay", (data)=>{
            storeAPI.dispatch({
                type: "game/updateReasonToPlay",
                payload: data
            });
        });
        // sends a reason-to-play to be deleted from the store
        $db60479c29b70331$var$socket.on("delete rtp", (data)=>{
            storeAPI.dispatch({
                type: "game/deleteReasonToPlay",
                payload: data
            });
        });
        // receives all game reasons to play
        $db60479c29b70331$var$socket.on("updateReasonsToPlay", (data)=>{
            storeAPI.dispatch({
                type: "game/updateReasonsToPlay",
                payload: data
            });
        });
        // recieves a reason in play to begin a bout of logical skirmish
        $db60479c29b70331$var$socket.on("moveToReasonInPlay", (data)=>{
            storeAPI.dispatch({
                type: "game/moveToReasonInPlay",
                payload: data
            });
        });
        // sends a reason-in-play that has been edited to the redux store
        $db60479c29b70331$var$socket.on("updateReasonInPlay", (data)=>{
            storeAPI.dispatch({
                type: "game/updateReasonInPlay",
                payload: data
            });
        });
        // update the ReasonInPlayVotes
        $db60479c29b70331$var$socket.on("updateReasonInPlayVotes", (data)=>{
            storeAPI.dispatch({
                type: "game/updateReasonInPlayVotes",
                payload: data
            });
        });
        // receives an updated common grounds and sends it to the redux store
        $db60479c29b70331$var$socket.on("updateCommonGrounds", (data)=>{
            storeAPI.dispatch({
                type: "game/updateCommonGrounds",
                payload: data
            });
        });
        // recieves the winners of the game and sends to redux store
        $db60479c29b70331$var$socket.on("setFinalResults", (data)=>{
            storeAPI.dispatch({
                type: "game/setFinalResults",
                payload: data
            });
        });
        // recieves an error message from the server
        $db60479c29b70331$var$socket.on("error", (data)=>{
            storeAPI.dispatch({
                type: "app/setError",
                payload: data
            });
        });
        /**
		 * Data to be set to the server should be placed here
		 * Check for the type of action to emit to the server
		 */ return (next)=>(action)=>{
                // tells the server to start a new game
                if (action.type === "game/emitStartGame") {
                    $db60479c29b70331$var$socket.emit("initGame", action.payload);
                    return;
                }
                // checks with server to see if room code is valid
                if (action.type === "app/emitIsRoomCodeValid") {
                    $db60479c29b70331$var$socket.emit("isRoomCodeValid", action.payload);
                    return;
                }
                // checks with server to see if player name valid
                if (action.type === "app/emitIsPlayerNameAvailable") {
                    $db60479c29b70331$var$socket.emit("isPlayerNameAvailable", action.payload);
                    return;
                }
                // puts player in the desired room to join the game
                if (action.type === "game/emitJoinGame") {
                    $db60479c29b70331$var$socket.emit("joinRoom", action.payload);
                    return;
                }
                if (action.type === "game/emitVoteConvinced") {
                    $db60479c29b70331$var$socket.emit("voteConvinced", action.payload);
                    return;
                }
                if (action.type === "game/emitVoteNotPersuaded") {
                    $db60479c29b70331$var$socket.emit("voteNotPersuaded", action.payload);
                    return;
                }
                // updates the main claim of the game
                if (action.type === "game/emitUpdateMainClaim") {
                    $db60479c29b70331$var$socket.emit("updateMainClaim", action.payload);
                    return;
                }
                // change the phase of the game
                if (action.type === "game/emitChangeGamePhase") $db60479c29b70331$var$socket.emit("changeGamePhase", action.payload);
                // sending a user added reason to play to the server
                if (action.type === "game/emitAddReasonToPlay") $db60479c29b70331$var$socket.emit("addReasonToPlay", action.payload);
                // send a reason to begin a bout or reason in play
                if (action.type === "game/emitMoveToReasonInPlay") $db60479c29b70331$var$socket.emit("moveToReasonInPlay", action.payload);
                // send an edited reason-to-play to the server
                if (action.type === "game/emitUpdateReasonToPlay") $db60479c29b70331$var$socket.emit("updateReasonToPlay", action.payload);
                // send an edited reason-to-play to the server
                if (action.type === "game/emitUpdateReasonToPlayPriorities") $db60479c29b70331$var$socket.emit("updateReasonToPlayPriorities", action.payload);
                // delete a reason-to-play to the server
                if (action.type === "game/emitDeleteReasonToPlay") $db60479c29b70331$var$socket.emit("deleteReasonToPlay", action.payload);
                // send an edited reason-in-play to the server
                if (action.type === "game/emitUpdateReasonInPlay") $db60479c29b70331$var$socket.emit("updateReasonInPlay", action.payload);
                // vote/unvote established for a ReasonInPlay
                if (action.type === "game/emitVoteEstablishedReasonInPlay") $db60479c29b70331$var$socket.emit("voteEstablishedReasonInPlay", action.payload);
                // vote/unvote contested for a ReasonInPlay
                if (action.type === "game/emitVoteContestedReasonInPlay") $db60479c29b70331$var$socket.emit("voteContestedReasonInPlay", action.payload);
                // vote/unvote non-germane for a ReasonInPlay
                if (action.type === "game/emitVoteNonGermaneReasonInPlay") $db60479c29b70331$var$socket.emit("voteNonGermaneReasonInPlay", action.payload);
                // move the current reason in play to common grounds
                if (action.type === "game/emitMoveRIPToCommonGround") $db60479c29b70331$var$socket.emit("moveRIPToCommonGround", action.payload);
                // move the current reason in play to dissensus list
                if (action.type === "game/emitMoveRIPToDissensus") $db60479c29b70331$var$socket.emit("moveRIPToDissensus", action.payload);
                // send a request to the server updating the common ground priorities/order
                if (action.type === "game/emitUpdateCommonGroundPriorities") $db60479c29b70331$var$socket.emit("updateCommonGroundPriorities", action.payload);
                // move the current reason in play to common grounds
                if (action.type === "game/emitMoveCommonGroundToReasonInPlay") $db60479c29b70331$var$socket.emit("moveCommonGroundToReasonInPlay", action.payload);
                // request the server return a list of winners
                if (action.type === "game/emitGetFinalResults") $db60479c29b70331$var$socket.emit("getFinalResults", action.payload);
                return next(action);
            };
    };
};
var $db60479c29b70331$export$2e2bcd8739ae039 = $db60479c29b70331$var$createSocketMiddleware;





const $f2680eb656f37408$export$7a3bdf7180628a3c = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: "app",
    initialState: {
        roomCodeValid: false,
        playerNameAvailable: true,
        error: null,
        connectedToSocket: false
    },
    reducers: {
        setRoomCodeValid: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                roomCodeValid: action.payload.isRoomCodeValid
            });
        },
        setPlayerNameAvailable: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                playerNameAvailable: action.payload.isPlayerNameAvailable
            });
        },
        setError: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                error: action.payload.message
            });
        },
        clearError: (state)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                error: null
            });
        },
        setConnectedToSocket: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                connectedToSocket: action.payload.connectedToSocket
            });
        },
        emitIsRoomCodeValid: ()=>{},
        emitIsPlayerNameAvailable: ()=>{}
    }
});
const { emitIsRoomCodeValid: $f2680eb656f37408$export$ca4ab7c6f120f859, emitIsPlayerNameAvailable: $f2680eb656f37408$export$b202a8d1240397c1, setConnectedToSocket: $f2680eb656f37408$export$d882115b4a654f48 } = $f2680eb656f37408$export$7a3bdf7180628a3c.actions;
var $f2680eb656f37408$export$2e2bcd8739ae039 = $f2680eb656f37408$export$7a3bdf7180628a3c.reducer;





const $a26b4bfe7e4a257c$export$134a1017f1b664f9 = (0, $15d924278321bdfd$export$4d8d9bd83c24ae8b)({
    name: "game",
    initialState: {
        role: null,
        roomCode: null,
        player: null,
        mainClaim: {
            mainClaim: "",
            phase: 'land',
            convinced: [],
            notPersuaded: []
        },
        reasonsToPlay: [],
        reasonInPlay: null,
        commonGrounds: [],
        results: null
    },
    reducers: {
        setRole: (state, action)=>{
            state.role = action.payload.role;
        },
        setRoomCode: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                roomCode: action.payload.roomCode
            });
        },
        initGame: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                roomCode: action.payload.roomCode,
                mainClaim: action.payload.mainClaim
            });
        },
        setMainClaimState: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                mainClaim: action.payload
            });
        },
        setPlayer: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                player: action.payload
            });
        },
        changeGamePhase: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                mainClaim: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.mainClaim), {
                    phase: action.payload.phase
                })
            });
        },
        setGameState: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                mainClaim: action.payload.mainClaim,
                reasonsToPlay: action.payload.reasonsToPlay,
                reasonInPlay: action.payload.reasonInPlay,
                commonGrounds: action.payload.commonGrounds
            });
        },
        updateReasonsToPlay: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                reasonsToPlay: action.payload
            });
        },
        addReasonToPlay: (state, action)=>{
            const index = state.reasonsToPlay.findIndex((element)=>element.id === action.payload.id);
            if (index >= 0) state.reasonsToPlay = [
                ...state.reasonsToPlay.slice(0, index),
                action.payload,
                ...state.reasonsToPlay.slice(index + 1)
            ];
            else state.reasonsToPlay = [
                ...state.reasonsToPlay,
                action.payload
            ];
        },
        updateReasonToPlay: (state, action)=>{
            const index = state.reasonsToPlay.findIndex((reasonToPlay)=>reasonToPlay.id === action.payload.id);
            if (index >= 0) state.reasonsToPlay = [
                ...state.reasonsToPlay.slice(0, index),
                action.payload,
                ...state.reasonsToPlay.slice(index + 1)
            ];
        },
        deleteReasonToPlay: (state, action)=>{
            if (action.payload.reasons.length > 0) {
                const index = state.reasonsToPlay.findIndex((element)=>element.id === action.payload.id);
                if (index >= 0) state.reasonsToPlay = [
                    ...state.reasonsToPlay.slice(0, index),
                    action.payload,
                    ...state.reasonsToPlay.slice(index + 1)
                ];
            } else {
                const filteredReasonsToPlay = state.reasonsToPlay.filter((reasonToPlay)=>reasonToPlay.id !== action.payload.id);
                state.reasonsToPlay = [
                    ...filteredReasonsToPlay
                ];
            }
        },
        moveToReasonInPlay: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                reasonInPlay: action.payload
            });
        },
        updateMainClaim: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                mainClaim: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.mainClaim), {
                    mainClaim: action.payload.mainClaim
                })
            });
        },
        updateReasonInPlay: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                reasonInPlay: action.payload ? Object.assign({}, state.reasonInPlay, action.payload) : null
            });
        },
        updateReasonInPlayVotes: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                reasonInPlay: Object.assign({}, state.reasonInPlay, action.payload)
            });
        },
        updateCommonGrounds: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                commonGrounds: [
                    ...action.payload
                ]
            });
        },
        setFinalResults: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                results: action.payload
            });
        },
        updatePriority: (state, action)=>{
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                reasonToPlay: action.payload
            });
        },
        emitStartGame: ()=>{},
        emitJoinGame: ()=>{},
        emitVote: ()=>{},
        emitUpdateMainClaim: ()=>{},
        emitVoteConvinced: ()=>{},
        emitVoteNotPersuaded: ()=>{},
        emitAddReasonToPlay: ()=>{},
        emitMoveToReasonInPlay: ()=>{},
        emitUpdateReasonToPlay: ()=>{},
        emitUpdateReasonToPlayPriorities: ()=>{},
        emitDeleteReasonToPlay: ()=>{},
        emitUpdateReasonInPlay: ()=>{},
        emitVoteEstablishedReasonInPlay: ()=>{},
        emitVoteContestedReasonInPlay: ()=>{},
        emitVoteNonGermaneReasonInPlay: ()=>{},
        emitMoveRIPToCommonGround: ()=>{},
        emitUpdateCommonGroundPriorities: ()=>{},
        emitMoveRIPToDissensus: ()=>{},
        emitMoveCommonGroundToReasonInPlay: ()=>{},
        emitChangeGamePhase: ()=>{},
        emitGetFinalResults: ()=>{},
        emitUpdatePriority: ()=>{}
    }
});
const { setRole: $a26b4bfe7e4a257c$export$6ab8d810c69bec6f, setRoomCode: $a26b4bfe7e4a257c$export$8f85e7d00f416470, initGame: $a26b4bfe7e4a257c$export$b8b10c7c42429e76, editMainClaim: $a26b4bfe7e4a257c$export$f4524d3d0bf378a7, addReasonToPlay: $a26b4bfe7e4a257c$export$9e4a78866e250074, updateReasonToPlay: $a26b4bfe7e4a257c$export$f4f7edb417abc381, changeGamePhase: $a26b4bfe7e4a257c$export$9c5fb575cf0490ae, emitStartGame: $a26b4bfe7e4a257c$export$284a6733115a6bf5, emitJoinGame: $a26b4bfe7e4a257c$export$c7bb17b5d1cc81b9, emitVote: $a26b4bfe7e4a257c$export$55b4a47c046feb05, emitUpdateMainClaim: $a26b4bfe7e4a257c$export$c3397011ff8da5b2, emitAddReasonToPlay: $a26b4bfe7e4a257c$export$e52e0a832b6f4c54, emitVoteConvinced: $a26b4bfe7e4a257c$export$1409869870cefe8c, emitVoteNotPersuaded: $a26b4bfe7e4a257c$export$445ea8ec1c323aba, emitMoveToReasonInPlay: $a26b4bfe7e4a257c$export$297493f7e4df20b6, emitUpdateReasonToPlay: $a26b4bfe7e4a257c$export$40981ebadab9551, emitUpdateReasonToPlayPriorities: $a26b4bfe7e4a257c$export$f8ffaed46e4f3d35, emitDeleteReasonToPlay: $a26b4bfe7e4a257c$export$8ef4aa709fe98f79, emitUpdateReasonInPlay: $a26b4bfe7e4a257c$export$c71770823bb3a007, emitVoteEstablishedReasonInPlay: $a26b4bfe7e4a257c$export$cd96b8d333c4327e, emitVoteContestedReasonInPlay: $a26b4bfe7e4a257c$export$9811782ba53e88cc, emitVoteNonGermaneReasonInPlay: $a26b4bfe7e4a257c$export$dd04a03564e7fb1e, emitMoveRIPToCommonGround: $a26b4bfe7e4a257c$export$afc79c335028004, emitMoveRIPToDissensus: $a26b4bfe7e4a257c$export$91215eb6e724e412, emitUpdateCommonGroundPriorities: $a26b4bfe7e4a257c$export$89b83d026404717f, emitMoveCommonGroundToReasonInPlay: $a26b4bfe7e4a257c$export$a140347ee0d8afff, emitChangeGamePhase: $a26b4bfe7e4a257c$export$c810c224a21da2d4, emitGetFinalResults: $a26b4bfe7e4a257c$export$b0f71b4afa02d235 } = $a26b4bfe7e4a257c$export$134a1017f1b664f9.actions;
var $a26b4bfe7e4a257c$export$2e2bcd8739ae039 = $a26b4bfe7e4a257c$export$134a1017f1b664f9.reducer;


const $34dc202a50408efe$var$socketMiddleware = (0, $db60479c29b70331$export$2e2bcd8739ae039)();
var $34dc202a50408efe$export$2e2bcd8739ae039 = (0, $15d924278321bdfd$export$7d8a5b498da695ac)({
    reducer: {
        app: (0, $f2680eb656f37408$export$2e2bcd8739ae039),
        game: (0, $a26b4bfe7e4a257c$export$2e2bcd8739ae039)
    },
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat($34dc202a50408efe$var$socketMiddleware),
    devTools: false
});



var $7fPBF = parcelRequire("7fPBF");
var $c1c6d595ff42d79c$exports = {};
'use strict';

$c1c6d595ff42d79c$exports = (parcelRequire("i5uoL"));


var $f30b917334351296$var$__defProp = Object.defineProperty;
var $f30b917334351296$var$__defProps = Object.defineProperties;
var $f30b917334351296$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f30b917334351296$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f30b917334351296$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f30b917334351296$var$__defNormalProp = (obj, key, value)=>key in obj ? $f30b917334351296$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f30b917334351296$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f30b917334351296$var$__hasOwnProp.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    if ($f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(b))if ($f30b917334351296$var$__propIsEnum.call(b, prop)) $f30b917334351296$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f30b917334351296$var$__spreadProps = (a, b)=>$f30b917334351296$var$__defProps(a, $f30b917334351296$var$__getOwnPropDescs(b));
var $f30b917334351296$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f30b917334351296$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f30b917334351296$var$__getOwnPropSymbols) {
        for (var prop of $f30b917334351296$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f30b917334351296$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $f30b917334351296$var$IS_REACT_19 = /* @__PURE__ */ $7fPBF.version.startsWith("19");
var $f30b917334351296$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($f30b917334351296$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $f30b917334351296$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $f30b917334351296$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $f30b917334351296$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $f30b917334351296$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $f30b917334351296$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $f30b917334351296$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $f30b917334351296$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $f30b917334351296$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $f30b917334351296$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $f30b917334351296$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $f30b917334351296$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $f30b917334351296$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $f30b917334351296$var$ForwardRef = $f30b917334351296$var$REACT_FORWARD_REF_TYPE;
var $f30b917334351296$var$Memo = $f30b917334351296$var$REACT_MEMO_TYPE;
function $f30b917334351296$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $f30b917334351296$var$REACT_FRAGMENT_TYPE || type === $f30b917334351296$var$REACT_PROFILER_TYPE || type === $f30b917334351296$var$REACT_STRICT_MODE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_TYPE || type === $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE || type === $f30b917334351296$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $f30b917334351296$var$REACT_LAZY_TYPE || type.$$typeof === $f30b917334351296$var$REACT_MEMO_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONTEXT_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CONSUMER_TYPE || type.$$typeof === $f30b917334351296$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $f30b917334351296$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $f30b917334351296$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $f30b917334351296$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $f30b917334351296$var$REACT_FRAGMENT_TYPE:
                    case $f30b917334351296$var$REACT_PROFILER_TYPE:
                    case $f30b917334351296$var$REACT_STRICT_MODE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_TYPE:
                    case $f30b917334351296$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $f30b917334351296$var$REACT_CONTEXT_TYPE:
                            case $f30b917334351296$var$REACT_FORWARD_REF_TYPE:
                            case $f30b917334351296$var$REACT_LAZY_TYPE:
                            case $f30b917334351296$var$REACT_MEMO_TYPE:
                                return object;
                            case $f30b917334351296$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $f30b917334351296$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $f30b917334351296$var$isContextConsumer(object) {
    return $f30b917334351296$var$IS_REACT_19 ? $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONSUMER_TYPE : $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_CONTEXT_TYPE;
}
function $f30b917334351296$var$isMemo(object) {
    return $f30b917334351296$var$typeOf(object) === $f30b917334351296$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $f30b917334351296$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $f30b917334351296$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $f30b917334351296$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $f30b917334351296$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $f30b917334351296$var$verify(mapStateToProps, "mapStateToProps");
    $f30b917334351296$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $f30b917334351296$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $f30b917334351296$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $f30b917334351296$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $f30b917334351296$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $f30b917334351296$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $f30b917334351296$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $f30b917334351296$var$verifyPlainObject(value, displayName, methodName) {
    if (!$f30b917334351296$var$isPlainObject(value)) $f30b917334351296$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $f30b917334351296$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $f30b917334351296$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $f30b917334351296$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f30b917334351296$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $f30b917334351296$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $f30b917334351296$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $f30b917334351296$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $f30b917334351296$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $f30b917334351296$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $f30b917334351296$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $f30b917334351296$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $f30b917334351296$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues($f30b917334351296$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $f30b917334351296$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $f30b917334351296$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$f30b917334351296$var$defaultMergeProps : typeof mergeProps === "function" ? $f30b917334351296$var$wrapMergePropsFunc(mergeProps) : $f30b917334351296$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $f30b917334351296$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $f30b917334351296$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $f30b917334351296$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $f30b917334351296$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $f30b917334351296$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $f30b917334351296$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $f30b917334351296$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $f30b917334351296$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $f30b917334351296$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $f30b917334351296$var$isDOM = /* @__PURE__ */ $f30b917334351296$var$canUseDOM();
var $f30b917334351296$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $f30b917334351296$var$isReactNative = /* @__PURE__ */ $f30b917334351296$var$isRunningInReactNative();
var $f30b917334351296$var$getUseIsomorphicLayoutEffect = ()=>$f30b917334351296$var$isDOM || $f30b917334351296$var$isReactNative ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $f30b917334351296$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $f30b917334351296$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $f30b917334351296$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $f30b917334351296$export$d36bdfa510afb180(objA, objB) {
    if ($f30b917334351296$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$f30b917334351296$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $f30b917334351296$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f30b917334351296$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f30b917334351296$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f30b917334351296$var$TYPE_STATICS = {
    [$f30b917334351296$var$ForwardRef]: $f30b917334351296$var$FORWARD_REF_STATICS,
    [$f30b917334351296$var$Memo]: $f30b917334351296$var$MEMO_STATICS
};
function $f30b917334351296$var$getStatics(component) {
    if ($f30b917334351296$var$isMemo(component)) return $f30b917334351296$var$MEMO_STATICS;
    return $f30b917334351296$var$TYPE_STATICS[component["$$typeof"]] || $f30b917334351296$var$REACT_STATICS;
}
var $f30b917334351296$var$defineProperty = Object.defineProperty;
var $f30b917334351296$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f30b917334351296$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f30b917334351296$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f30b917334351296$var$getPrototypeOf = Object.getPrototypeOf;
var $f30b917334351296$var$objectPrototype = Object.prototype;
function $f30b917334351296$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($f30b917334351296$var$objectPrototype) {
            const inheritedComponent = $f30b917334351296$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f30b917334351296$var$objectPrototype) $f30b917334351296$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $f30b917334351296$var$getOwnPropertyNames(sourceComponent);
        if ($f30b917334351296$var$getOwnPropertySymbols) keys = keys.concat($f30b917334351296$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $f30b917334351296$var$getStatics(targetComponent);
        const sourceStatics = $f30b917334351296$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$f30b917334351296$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $f30b917334351296$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $f30b917334351296$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $f30b917334351296$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $f30b917334351296$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $f30b917334351296$var$getContext() {
    var _a;
    if (!$7fPBF.createContext) return {};
    const contextMap = (_a = $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey]) != null ? _a : $f30b917334351296$var$gT[$f30b917334351296$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($7fPBF.createContext);
    if (!realContext) {
        realContext = $7fPBF.createContext(null);
        contextMap.set($7fPBF.createContext, realContext);
    }
    return realContext;
}
var $f30b917334351296$export$cc80c08dc91f1c00 = /* @__PURE__ */ $f30b917334351296$var$getContext();
// src/components/connect.tsx
var $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $f30b917334351296$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $f30b917334351296$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $f30b917334351296$var$strictEqual(a, b) {
    return a === b;
}
var $f30b917334351296$var$hasWarnedAboutDeprecatedPureOption = false;
function $f30b917334351296$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $f30b917334351296$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $f30b917334351296$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $f30b917334351296$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $f30b917334351296$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $f30b917334351296$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $f30b917334351296$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $f30b917334351296$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $f30b917334351296$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $7fPBF.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $f30b917334351296$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $7fPBF.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $7fPBF.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $7fPBF.useMemo(()=>{
                return $f30b917334351296$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $7fPBF.useMemo(()=>{
                if (!shouldHandleStateChanges) return $f30b917334351296$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $f30b917334351296$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $7fPBF.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $7fPBF.useRef(void 0);
            const lastWrapperProps = $7fPBF.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $7fPBF.useRef(void 0);
            const renderIsScheduled = $7fPBF.useRef(false);
            const isMounted = $7fPBF.useRef(false);
            const latestSubscriptionCallbackError = $7fPBF.useRef(void 0);
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $7fPBF.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $7fPBF.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $f30b917334351296$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $f30b917334351296$var$useIsomorphicLayoutEffectWithArgs($f30b917334351296$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $7fPBF.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $7fPBF.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $7fPBF.createElement(WrappedComponent, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $7fPBF.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $7fPBF.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $7fPBF.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $7fPBF.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $7fPBF.createElement(Connect, $f30b917334351296$var$__spreadProps($f30b917334351296$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $f30b917334351296$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $f30b917334351296$export$64605811ab45167f = $f30b917334351296$var$connect;
// src/components/Provider.tsx
function $f30b917334351296$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $7fPBF.useMemo(()=>{
        const subscription = $f30b917334351296$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $7fPBF.useMemo(()=>store.getState(), [
        store
    ]);
    $f30b917334351296$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $f30b917334351296$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $7fPBF.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $f30b917334351296$export$2881499e37b75b9a = $f30b917334351296$var$Provider;
// src/hooks/useReduxContext.ts
function $f30b917334351296$var$createReduxContextHook(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $7fPBF.useContext(context);
        return contextValue;
    };
}
var $f30b917334351296$var$useReduxContext = /* @__PURE__ */ $f30b917334351296$var$createReduxContextHook();
// src/hooks/useStore.ts
function $f30b917334351296$export$671dba69185d0304(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : // @ts-ignore
    $f30b917334351296$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $f30b917334351296$export$6ccbb43953eebf8 = /* @__PURE__ */ $f30b917334351296$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $f30b917334351296$export$bc9b55530897c558(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useStore2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$export$6ccbb43953eebf8 : $f30b917334351296$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $f30b917334351296$export$8ad76b76a4c905f8 = /* @__PURE__ */ $f30b917334351296$export$bc9b55530897c558();
var $f30b917334351296$var$refEquality = (a, b)=>a === b;
function $f30b917334351296$export$2b53f90d2bd1cbfb(context = $f30b917334351296$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $f30b917334351296$export$cc80c08dc91f1c00 ? $f30b917334351296$var$useReduxContext : $f30b917334351296$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $f30b917334351296$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $7fPBF.useRef(true);
        const wrappedSelector = $7fPBF.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $c1c6d595ff42d79c$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $7fPBF.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $f30b917334351296$export$2105062e25df4afe = /* @__PURE__ */ $f30b917334351296$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $f30b917334351296$export$712ea50be43a7858 = $f30b917334351296$var$defaultNoopBatch;






var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;




var $7fPBF = parcelRequire("7fPBF");






function $79c0c02b40f78101$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fill: "currentColor",
            d: "M6.225 4.811a1 1 0 0 0-1.414 1.414L10.586 12 4.81 17.775a1 1 0 1 0 1.414 1.414L12 13.414l5.775 5.775a1 1 0 0 0 1.414-1.414L13.414 12l5.775-5.775a1 1 0 0 0-1.414-1.414L12 10.586Z"
        })
    }));
}


function $5afcbdb517c602a0$var$CreateGame(props) {
    const dispatch = (0, $f30b917334351296$export$8ad76b76a4c905f8)();
    const claimLimit = 210;
    const [mainClaim, setMainClaim] = (0, $7fPBF.useState)("");
    const [displayLimit, setDisplayLimit] = (0, $7fPBF.useState)(claimLimit);
    const isMainClaimValid = mainClaim.length >= 20 ? true : false;
    function handleMainClaim(event) {
        setMainClaim(event.target.value);
        setDisplayLimit(claimLimit - event.target.value.length);
    }
    function createGame() {
        if (isMainClaimValid) {
            dispatch((0, $a26b4bfe7e4a257c$export$284a6733115a6bf5)({
                mainClaim: mainClaim
            }));
            dispatch((0, $a26b4bfe7e4a257c$export$6ab8d810c69bec6f)({
                role: "referee"
            }));
            sessionStorage.setItem("role", "referee");
        // props.startGame();
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: props.modalStyle.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: props.modalStyle.closeContainer,
                onClick: props.closeModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c0c02b40f78101$export$2e2bcd8739ae039), {
                    className: props.modalStyle.closeIcon
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col w-full h-7/10 justify-evenly",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: "text-3xl font-medium text-gray-600",
                        children: "Create a Game"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "flex flex-col",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "h-full text-center",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                        className: "text-lg font-medium",
                                        children: [
                                            "Main Claim (",
                                            displayLimit,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: "block",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("block w-9/10 lg:w-8/10 h-64 lg:h-32 resize-none bg-white whitespace-normal p-2 mt-2 mx-auto overflow-hidden rounded-md outline focus:outline-3 outline-blue-600", mainClaim.length > 0 && !isMainClaimValid ? "outline-red-600" : ""),
                                            onChange: handleMainClaim,
                                            maxLength: claimLimit,
                                            placeholder: "State your main claim"
                                        })
                                    }),
                                    mainClaim.length > 0 && !isMainClaimValid ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "mt-2 text-red-600 text-xs",
                                        children: "Main Claim must contain at least 20 characters"
                                    }) : null,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        disabled: !isMainClaimValid,
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("px-10 py-3 mt-5 text-base font-bold text-white  w-52 rounded-lg", isMainClaimValid ? "bg-blue-500 hover:bg-blue-600 cursor-pointer" : "bg-blue-800 hover:bg-blue-900 cursor-not-allowed"),
                                        onClick: createGame,
                                        children: "Start Game"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $5afcbdb517c602a0$export$2e2bcd8739ae039 = $5afcbdb517c602a0$var$CreateGame;




var $7fPBF = parcelRequire("7fPBF");





function $2342ba09c992a0b0$var$JoinGame(props) {
    const dispatch = (0, $f30b917334351296$export$8ad76b76a4c905f8)();
    const errorMessage = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.app.error);
    const [room, setRoom] = (0, $7fPBF.useState)("");
    const [playerName, setPlayerName] = (0, $7fPBF.useState)("");
    const isRoomCodeValid = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.app.roomCodeValid);
    const isPlayerNameAvailable = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.app.playerNameAvailable);
    const codeLimit = 6;
    const minNameLength = 5;
    const isPlayerNameValid = isPlayerNameAvailable && playerName.length >= minNameLength;
    const canJoin = isRoomCodeValid && isPlayerNameValid;
    const nameLimitString = "Name must be at least 5 characters";
    function handleRoomCode(event) {
        const code = event.target.value = event.target.value.toUpperCase();
        setRoom(code);
        dispatch((0, $f2680eb656f37408$export$ca4ab7c6f120f859)({
            roomCode: code
        }));
    }
    function handlePlayerNameChange(event) {
        const name = event.target.value;
        setPlayerName(name);
        dispatch((0, $f2680eb656f37408$export$b202a8d1240397c1)({
            roomCode: room,
            playerName: name
        }));
    }
    function joinGameRoom() {
        if (isPlayerNameValid) dispatch((0, $a26b4bfe7e4a257c$export$c7bb17b5d1cc81b9)({
            roomCode: room,
            playerName: playerName
        }));
        dispatch((0, $a26b4bfe7e4a257c$export$6ab8d810c69bec6f)({
            role: "player"
        }));
        sessionStorage.setItem("role", "player");
    }
    const style = {
        generateNameButton: "py-2 px-9 content-center text-slate-100 text-xl font-bold bg-blue-500 hover:bg-blue-600 rounded-md",
        errorText: "text-red-600 text-xs mt-2 self-end",
        form: {
            container: "flex flex-col lg:w-1/3 w-9/10",
            label: "mb-2 text-sm font-semibold self-start",
            input: "placeholder:italic text-center py-2 px-2 bg-white rounded outline focus:outline-3 outline-blue-600",
            inputError: "outline-red-600"
        }
    };
    // TODO: Check if playerName contains non alphanumeric characters
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: props.modalStyle.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: props.modalStyle.closeContainer,
                onClick: props.closeModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c0c02b40f78101$export$2e2bcd8739ae039), {
                    className: props.modalStyle.closeIcon
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col h-9/10 w-full px-4 justify-around",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: "my-4 text-3xl font-medium text-gray-600 w-full",
                        children: "Join Game"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex flex-col gap-y-4 items-center ",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: style.form.container,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: style.form.label,
                                        children: "Room Code"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.form.input, room.length > 0 && !isRoomCodeValid && style.form.inputError),
                                        type: "text",
                                        placeholder: "Room Code",
                                        name: "room-code",
                                        maxLength: codeLimit,
                                        onChange: handleRoomCode
                                    }),
                                    room.length > 0 && !isRoomCodeValid ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: style.errorText,
                                        children: "Room code is not valid"
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: style.form.container,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        className: style.form.label,
                                        children: "Player Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(`${style.form.input} py-2 px-2 rounded text-center`, playerName.length > 0 && playerName.length < minNameLength && !isPlayerNameAvailable ? style.form.inputError : ""),
                                        type: "text",
                                        placeholder: "Player Name",
                                        value: playerName,
                                        maxLength: 25,
                                        onChange: handlePlayerNameChange
                                    }),
                                    playerName.length > 0 && playerName.length < minNameLength ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: style.errorText,
                                        children: nameLimitString
                                    }) : null,
                                    !isPlayerNameAvailable ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: style.errorText,
                                        children: "Name already in use"
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                        className: "text-sm lg:text-base",
                        children: "Please choose a name to go by during the game (a name of at least 5 characters). Other players may want to call on you by name, so use your own name or chose a nickname you are comfortable with. Also, if you are playing for educational credit, your instructor needs to identify you; best to use the same name across all games you play in class."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "mt-4",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("py-2 px-10 content-center text-xl text-slate-100  font-bold rounded-md", canJoin ? "bg-blue-500 hover:bg-blue-600 cursor-pointer" : "bg-blue-800 hover:bg-blue-900 cursor-not-allowed"),
                            disabled: !canJoin,
                            onClick: joinGameRoom,
                            children: "Join"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "text-red-600",
                        children: errorMessage
                    })
                ]
            })
        ]
    });
}
var $2342ba09c992a0b0$export$2e2bcd8739ae039 = $2342ba09c992a0b0$var$JoinGame;


const $2dcf4923aae645a4$var$root = document.getElementById("root");
function $2dcf4923aae645a4$var$Home() {
    const [showCreateModal, setShowCreateModal] = (0, $7fPBF.useState)(false);
    const [showJoinModal, setJoinModal] = (0, $7fPBF.useState)(false);
    const style = {
        // modal: "mx-auto relative lg:w-1/2 md:w-2/3 w-full lg:h-4/6 h-full lg:my-28 rounded-lg overflow-hidden",
        info: "flex flex-col",
        article: {
            base: "lg:text-lg text-md",
            section: "text-center m-2"
        },
        modal: {
            container: "fixed top-1/2 left-1/2 -translate-1/2 h-9/10 w-full lg:h-4/6 lg:w-1/2 pt-2 flex items-center justify-center text-center bg-blue-200 border-2 border-blue-400 rounded-lg",
            closeContainer: "absolute top-[10px] right-[10px] p-1 border-2 border-zinc-700 bg-zinc-100 rounded-full cursor-pointer",
            closeIcon: "w-[25px]"
        },
        button: "w-52 px-10 py-3 text-xl font-bold text-white bg-blue-500 rounded-md hover:shadow hover:bg-blue-800 cursor-pointer"
    };
    function closeCreateModal() {
        setShowCreateModal(false);
    }
    function createGame() {
        closeCreateModal();
    }
    function closeJoinModal() {
        setJoinModal(false);
    }
    function joinGame() {
        closeJoinModal();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("h-screen bg-blue-50 overflow-hidden", (showCreateModal || showJoinModal) && "blur-xs"),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                className: "min-h-[15%] mt-16 lg:text-3xl text-2xl text-center",
                children: "Tug of Logic: A Philosophy Sports Game"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "min-h-[55%] flex flex-col items-center justify-center mx-auto gap-4 lg:gap-8 align-middle",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("article", {
                        className: style.article.base,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                className: style.article.section,
                                children: "Welcome to Tug of Logic, a competitive and collaborative game for building effective arguments together upon a shifting common-ground."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                className: style.article.section,
                                children: "To play, you need a group of people assembled together (e.g. in a caf\xe9 or classroom) with Internet connections."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        onClick: ()=>setShowCreateModal(true),
                        className: style.button,
                        children: "Create Game"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("article", {
                        className: style.article.base,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                            className: style.article.section,
                            children: "A Logic Referee creates the game, players Join a Game."
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        onClick: ()=>setJoinModal(true),
                        className: style.button,
                        children: "Join Game"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("article", {
                        className: style.article.base,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                                className: style.article.section,
                                children: "This web-app is virtual infrastructure for reasoning together."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                                className: style.article.section,
                                children: [
                                    "To learn how to play, visit ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                        href: "https://www.philosophy-sports.com",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "underline text-blue-500 cursor-pointer",
                                        children: "www.philosophy-sports.com"
                                    }),
                                    ", and watch the explainer there."
                                ]
                            })
                        ]
                    }),
                    showCreateModal && /*#__PURE__*/ (0, $fw0lo.createPortal)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5afcbdb517c602a0$export$2e2bcd8739ae039), {
                        modalStyle: style.modal,
                        createGame: createGame,
                        closeModal: closeCreateModal
                    }), $2dcf4923aae645a4$var$root),
                    showJoinModal && /*#__PURE__*/ (0, $fw0lo.createPortal)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2342ba09c992a0b0$export$2e2bcd8739ae039), {
                        modalStyle: style.modal,
                        joinGame: joinGame,
                        closeModal: closeJoinModal
                    }), $2dcf4923aae645a4$var$root)
                ]
            })
        ]
    });
}
var $2dcf4923aae645a4$export$2e2bcd8739ae039 = $2dcf4923aae645a4$var$Home;





var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");




function $98e47cf1bb91cc57$var$GameViewBar(props) {
    const style = {
        container: "flex justify-evenly border-1 m-2 p-1 rounded-full bg-zinc-100",
        button: "border-2 px-4 py-1 font-bold rounded-full cursor-pointer",
        selected: "text-white bg-sky-500 hover:bg-sky-600",
        neutral: "bg-gray-100 hover:text-sky-600 hover:border-sky-500"
    };
    function selectedView(view) {
        return props.gameView == view;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: style.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                "aria-label": "Reason to Play",
                className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, selectedView('rtp') && style.selected, !selectedView('rtp') && style.neutral),
                onClick: ()=>props.changeGameView('rtp'),
                children: "Reasons-2-Play"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                "aria-label": "Reason in Play",
                className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, selectedView('rip') && style.selected, !selectedView('rip') && style.neutral),
                onClick: ()=>props.changeGameView('rip'),
                children: "Reason-in-Play"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                "aria-label": "Common Ground",
                className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, selectedView('cg') && style.selected, !selectedView('cg') && style.neutral),
                onClick: ()=>props.changeGameView('cg'),
                children: "Common Ground"
            })
        ]
    });
}
var $98e47cf1bb91cc57$export$2e2bcd8739ae039 = $98e47cf1bb91cc57$var$GameViewBar;



/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 


/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $8fdc5607694d9308$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $8fdc5607694d9308$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $8fdc5607694d9308$export$bcc6e673dfa14d36(v) {
    return $8fdc5607694d9308$export$837ba5c449269406($8fdc5607694d9308$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $8fdc5607694d9308$export$869b26d4e1bbdb63(v) {
    return $8fdc5607694d9308$export$837ba5c449269406($8fdc5607694d9308$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $8fdc5607694d9308$export$ed9bd8dcaeba14f6(v) {
    return $8fdc5607694d9308$export$837ba5c449269406($8fdc5607694d9308$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $8fdc5607694d9308$export$dbf961a8d278dbef(v) {
    return $8fdc5607694d9308$export$837ba5c449269406($8fdc5607694d9308$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $8fdc5607694d9308$export$aa35ef1f24408ab9(v) {
    return $8fdc5607694d9308$export$837ba5c449269406($8fdc5607694d9308$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $8fdc5607694d9308$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $8fdc5607694d9308$var$hex = [
    ...'0123456789ABCDEF'
];
const $8fdc5607694d9308$var$h1 = (b)=>$8fdc5607694d9308$var$hex[b & 0xF];
const $8fdc5607694d9308$var$h2 = (b)=>$8fdc5607694d9308$var$hex[(b & 0xF0) >> 4] + $8fdc5607694d9308$var$hex[b & 0xF];
const $8fdc5607694d9308$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $8fdc5607694d9308$var$isShort = (v)=>$8fdc5607694d9308$var$eq(v.r) && $8fdc5607694d9308$var$eq(v.g) && $8fdc5607694d9308$var$eq(v.b) && $8fdc5607694d9308$var$eq(v.a);
function $8fdc5607694d9308$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $8fdc5607694d9308$var$map$1[str[1]] * 17,
            g: 255 & $8fdc5607694d9308$var$map$1[str[2]] * 17,
            b: 255 & $8fdc5607694d9308$var$map$1[str[3]] * 17,
            a: len === 5 ? $8fdc5607694d9308$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $8fdc5607694d9308$var$map$1[str[1]] << 4 | $8fdc5607694d9308$var$map$1[str[2]],
            g: $8fdc5607694d9308$var$map$1[str[3]] << 4 | $8fdc5607694d9308$var$map$1[str[4]],
            b: $8fdc5607694d9308$var$map$1[str[5]] << 4 | $8fdc5607694d9308$var$map$1[str[6]],
            a: len === 9 ? $8fdc5607694d9308$var$map$1[str[7]] << 4 | $8fdc5607694d9308$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $8fdc5607694d9308$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $8fdc5607694d9308$export$1b06654353ef9f67(v) {
    var f = $8fdc5607694d9308$var$isShort(v) ? $8fdc5607694d9308$var$h1 : $8fdc5607694d9308$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $8fdc5607694d9308$var$alpha(v.a, f) : undefined;
}
const $8fdc5607694d9308$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $8fdc5607694d9308$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $8fdc5607694d9308$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $8fdc5607694d9308$var$hwb2rgbn(h, w, b) {
    const rgb = $8fdc5607694d9308$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $8fdc5607694d9308$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $8fdc5607694d9308$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $8fdc5607694d9308$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $8fdc5607694d9308$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($8fdc5607694d9308$export$ed9bd8dcaeba14f6);
}
function $8fdc5607694d9308$export$4c15bd42559b811d(h, s, l) {
    return $8fdc5607694d9308$var$calln($8fdc5607694d9308$var$hsl2rgbn, h, s, l);
}
function $8fdc5607694d9308$export$e2710022c70fc9ee(h, w, b) {
    return $8fdc5607694d9308$var$calln($8fdc5607694d9308$var$hwb2rgbn, h, w, b);
}
function $8fdc5607694d9308$export$b785a357c84e4a04(h, s, v) {
    return $8fdc5607694d9308$var$calln($8fdc5607694d9308$var$hsv2rgbn, h, s, v);
}
function $8fdc5607694d9308$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $8fdc5607694d9308$export$5e91288c399be4f9(str) {
    const m = $8fdc5607694d9308$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $8fdc5607694d9308$export$bcc6e673dfa14d36(+m[5]) : $8fdc5607694d9308$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $8fdc5607694d9308$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $8fdc5607694d9308$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $8fdc5607694d9308$export$b785a357c84e4a04(h, p1, p2);
    else v = $8fdc5607694d9308$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $8fdc5607694d9308$export$bb628a54ab399bc9(v, deg) {
    var h = $8fdc5607694d9308$export$b5ba70b240f8f7f(v);
    h[0] = $8fdc5607694d9308$var$hue(h[0] + deg);
    h = $8fdc5607694d9308$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $8fdc5607694d9308$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $8fdc5607694d9308$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $8fdc5607694d9308$export$aa35ef1f24408ab9(a[1]);
    const l = $8fdc5607694d9308$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$8fdc5607694d9308$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $8fdc5607694d9308$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $8fdc5607694d9308$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $8fdc5607694d9308$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($8fdc5607694d9308$var$names$1);
    const tkeys = Object.keys($8fdc5607694d9308$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $8fdc5607694d9308$var$map[k]);
        }
        k = parseInt($8fdc5607694d9308$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $8fdc5607694d9308$var$names;
function $8fdc5607694d9308$export$b2f06b640faad956(str) {
    if (!$8fdc5607694d9308$var$names) {
        $8fdc5607694d9308$var$names = $8fdc5607694d9308$var$unpack();
        $8fdc5607694d9308$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $8fdc5607694d9308$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $8fdc5607694d9308$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $8fdc5607694d9308$export$91aedb20f296e541(str) {
    const m = $8fdc5607694d9308$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $8fdc5607694d9308$export$bcc6e673dfa14d36(v) : $8fdc5607694d9308$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $8fdc5607694d9308$export$bcc6e673dfa14d36(r) : $8fdc5607694d9308$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $8fdc5607694d9308$export$bcc6e673dfa14d36(g) : $8fdc5607694d9308$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $8fdc5607694d9308$export$bcc6e673dfa14d36(b) : $8fdc5607694d9308$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $8fdc5607694d9308$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$8fdc5607694d9308$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $8fdc5607694d9308$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $8fdc5607694d9308$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $8fdc5607694d9308$var$interpolate(rgb1, rgb2, t) {
    const r = $8fdc5607694d9308$var$from($8fdc5607694d9308$export$dbf961a8d278dbef(rgb1.r));
    const g = $8fdc5607694d9308$var$from($8fdc5607694d9308$export$dbf961a8d278dbef(rgb1.g));
    const b = $8fdc5607694d9308$var$from($8fdc5607694d9308$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $8fdc5607694d9308$export$ed9bd8dcaeba14f6($8fdc5607694d9308$var$to(r + t * ($8fdc5607694d9308$var$from($8fdc5607694d9308$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $8fdc5607694d9308$export$ed9bd8dcaeba14f6($8fdc5607694d9308$var$to(g + t * ($8fdc5607694d9308$var$from($8fdc5607694d9308$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $8fdc5607694d9308$export$ed9bd8dcaeba14f6($8fdc5607694d9308$var$to(b + t * ($8fdc5607694d9308$var$from($8fdc5607694d9308$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $8fdc5607694d9308$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $8fdc5607694d9308$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $8fdc5607694d9308$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $8fdc5607694d9308$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $8fdc5607694d9308$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $8fdc5607694d9308$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $8fdc5607694d9308$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $8fdc5607694d9308$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $8fdc5607694d9308$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $8fdc5607694d9308$export$91aedb20f296e541(str);
    return $8fdc5607694d9308$export$5e91288c399be4f9(str);
}
class $8fdc5607694d9308$export$892596cec99bc70e {
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $8fdc5607694d9308$var$clone(this._rgb);
        if (v) v.a = $8fdc5607694d9308$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $8fdc5607694d9308$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $8fdc5607694d9308$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $8fdc5607694d9308$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $8fdc5607694d9308$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $8fdc5607694d9308$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $8fdc5607694d9308$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $8fdc5607694d9308$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $8fdc5607694d9308$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $8fdc5607694d9308$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $8fdc5607694d9308$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $8fdc5607694d9308$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $8fdc5607694d9308$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $8fdc5607694d9308$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
    constructor(input){
        if (input instanceof $8fdc5607694d9308$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $8fdc5607694d9308$var$fromObject(input);
        else if (type === 'string') v = $8fdc5607694d9308$export$625a38b961e8b5e9(input) || $8fdc5607694d9308$export$b2f06b640faad956(input) || $8fdc5607694d9308$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
}
function $8fdc5607694d9308$export$2e2bcd8739ae039(input) {
    return new $8fdc5607694d9308$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $0fe0b44b83bcc75e$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $0fe0b44b83bcc75e$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $0fe0b44b83bcc75e$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $0fe0b44b83bcc75e$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $0fe0b44b83bcc75e$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $0fe0b44b83bcc75e$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $0fe0b44b83bcc75e$export$c4ce752e73470fba(value, defaultValue) {
    return $0fe0b44b83bcc75e$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $0fe0b44b83bcc75e$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $0fe0b44b83bcc75e$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $0fe0b44b83bcc75e$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $0fe0b44b83bcc75e$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $0fe0b44b83bcc75e$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($0fe0b44b83bcc75e$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($0fe0b44b83bcc75e$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $0fe0b44b83bcc75e$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $0fe0b44b83bcc75e$export$667d3bf0c5f83305(source) {
    if ($0fe0b44b83bcc75e$export$8b22cf2602fb60ce(source)) return source.map($0fe0b44b83bcc75e$export$667d3bf0c5f83305);
    if ($0fe0b44b83bcc75e$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $0fe0b44b83bcc75e$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $0fe0b44b83bcc75e$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $0fe0b44b83bcc75e$export$317a3d46287192d8(key, target, source, options) {
    if (!$0fe0b44b83bcc75e$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($0fe0b44b83bcc75e$export$23f2a1d2818174ef(tval) && $0fe0b44b83bcc75e$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $0fe0b44b83bcc75e$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $0fe0b44b83bcc75e$export$667d3bf0c5f83305(sval);
}
function $0fe0b44b83bcc75e$export$efca4cbe5dd06740(target, source, options) {
    const sources = $0fe0b44b83bcc75e$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$0fe0b44b83bcc75e$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $0fe0b44b83bcc75e$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$0fe0b44b83bcc75e$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $0fe0b44b83bcc75e$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $0fe0b44b83bcc75e$export$efca4cbe5dd06740(target, source, {
        merger: $0fe0b44b83bcc75e$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $0fe0b44b83bcc75e$export$1ee57be6f6687d2c(key, target, source) {
    if (!$0fe0b44b83bcc75e$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($0fe0b44b83bcc75e$export$23f2a1d2818174ef(tval) && $0fe0b44b83bcc75e$export$23f2a1d2818174ef(sval)) $0fe0b44b83bcc75e$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $0fe0b44b83bcc75e$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $0fe0b44b83bcc75e$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $0fe0b44b83bcc75e$var$_getKeyResolver(key) {
    const keys = $0fe0b44b83bcc75e$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $0fe0b44b83bcc75e$export$2d1720544b23b823(obj, key) {
    const resolver = $0fe0b44b83bcc75e$var$keyResolvers[key] || ($0fe0b44b83bcc75e$var$keyResolvers[key] = $0fe0b44b83bcc75e$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $0fe0b44b83bcc75e$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $0fe0b44b83bcc75e$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $0fe0b44b83bcc75e$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $0fe0b44b83bcc75e$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $0fe0b44b83bcc75e$export$56c0d5a1e737357d = Math.PI;
const $0fe0b44b83bcc75e$export$971d5caa766a69d7 = 2 * $0fe0b44b83bcc75e$export$56c0d5a1e737357d;
const $0fe0b44b83bcc75e$export$2ec5befb9e6c97d4 = $0fe0b44b83bcc75e$export$971d5caa766a69d7 + $0fe0b44b83bcc75e$export$56c0d5a1e737357d;
const $0fe0b44b83bcc75e$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $0fe0b44b83bcc75e$export$39c1cc7c062529d4 = $0fe0b44b83bcc75e$export$56c0d5a1e737357d / 180;
const $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd = $0fe0b44b83bcc75e$export$56c0d5a1e737357d / 2;
const $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88 = $0fe0b44b83bcc75e$export$56c0d5a1e737357d / 4;
const $0fe0b44b83bcc75e$export$c18d01048907ea92 = $0fe0b44b83bcc75e$export$56c0d5a1e737357d * 2 / 3;
const $0fe0b44b83bcc75e$export$faec65b429be379 = Math.log10;
const $0fe0b44b83bcc75e$export$2408f22a0fab9ae5 = Math.sign;
function $0fe0b44b83bcc75e$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $0fe0b44b83bcc75e$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $0fe0b44b83bcc75e$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($0fe0b44b83bcc75e$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $0fe0b44b83bcc75e$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $0fe0b44b83bcc75e$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $0fe0b44b83bcc75e$export$d141bba7fdc215a3(n) {
    return !$0fe0b44b83bcc75e$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $0fe0b44b83bcc75e$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $0fe0b44b83bcc75e$export$625550452a3fa3ec(degrees) {
    return degrees * ($0fe0b44b83bcc75e$export$56c0d5a1e737357d / 180);
}
function $0fe0b44b83bcc75e$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $0fe0b44b83bcc75e$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $0fe0b44b83bcc75e$export$91477dc880baac21(x) {
    if (!$0fe0b44b83bcc75e$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $0fe0b44b83bcc75e$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $0fe0b44b83bcc75e$export$56c0d5a1e737357d) angle += $0fe0b44b83bcc75e$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $0fe0b44b83bcc75e$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $0fe0b44b83bcc75e$export$f074adc9fbd50943(a, b) {
    return (a - b + $0fe0b44b83bcc75e$export$2ec5befb9e6c97d4) % $0fe0b44b83bcc75e$export$971d5caa766a69d7 - $0fe0b44b83bcc75e$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(a) {
    return (a % $0fe0b44b83bcc75e$export$971d5caa766a69d7 + $0fe0b44b83bcc75e$export$971d5caa766a69d7) % $0fe0b44b83bcc75e$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(angle);
    const s = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(start);
    const e = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(end);
    const angleToStart = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $0fe0b44b83bcc75e$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $0fe0b44b83bcc75e$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $0fe0b44b83bcc75e$export$71cec2538cb2c617(value) {
    return $0fe0b44b83bcc75e$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $0fe0b44b83bcc75e$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $0fe0b44b83bcc75e$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $0fe0b44b83bcc75e$export$ef35774e6d314e91 = (table, key, value, last)=>$0fe0b44b83bcc75e$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $0fe0b44b83bcc75e$export$ebd11618f299a286 = (table, key, value)=>$0fe0b44b83bcc75e$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $0fe0b44b83bcc75e$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $0fe0b44b83bcc75e$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $0fe0b44b83bcc75e$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $0fe0b44b83bcc75e$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $0fe0b44b83bcc75e$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $0fe0b44b83bcc75e$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $0fe0b44b83bcc75e$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $0fe0b44b83bcc75e$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $0fe0b44b83bcc75e$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $0fe0b44b83bcc75e$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $0fe0b44b83bcc75e$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $0fe0b44b83bcc75e$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $0fe0b44b83bcc75e$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $0fe0b44b83bcc75e$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $0fe0b44b83bcc75e$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $0fe0b44b83bcc75e$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $0fe0b44b83bcc75e$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($0fe0b44b83bcc75e$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $0fe0b44b83bcc75e$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$0fe0b44b83bcc75e$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $0fe0b44b83bcc75e$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($0fe0b44b83bcc75e$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $0fe0b44b83bcc75e$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$0fe0b44b83bcc75e$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $0fe0b44b83bcc75e$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $0fe0b44b83bcc75e$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $0fe0b44b83bcc75e$var$atEdge = (t)=>t === 0 || t === 1;
const $0fe0b44b83bcc75e$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $0fe0b44b83bcc75e$export$971d5caa766a69d7 / p));
const $0fe0b44b83bcc75e$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $0fe0b44b83bcc75e$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $0fe0b44b83bcc75e$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($0fe0b44b83bcc75e$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$0fe0b44b83bcc75e$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$0fe0b44b83bcc75e$var$atEdge(t) ? t : $0fe0b44b83bcc75e$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$0fe0b44b83bcc75e$var$atEdge(t) ? t : $0fe0b44b83bcc75e$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $0fe0b44b83bcc75e$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $0fe0b44b83bcc75e$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $0fe0b44b83bcc75e$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $0fe0b44b83bcc75e$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $0fe0b44b83bcc75e$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $0fe0b44b83bcc75e$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $0fe0b44b83bcc75e$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $0fe0b44b83bcc75e$export$db3b6bfb95261072(value) {
    return $0fe0b44b83bcc75e$export$738ab4df8bf92ae9(value) ? value : new (0, $8fdc5607694d9308$export$892596cec99bc70e)(value);
}
function $0fe0b44b83bcc75e$export$d377dcb2b61d6c4e(value) {
    return $0fe0b44b83bcc75e$export$738ab4df8bf92ae9(value) ? value : new (0, $8fdc5607694d9308$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $0fe0b44b83bcc75e$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $0fe0b44b83bcc75e$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $0fe0b44b83bcc75e$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $0fe0b44b83bcc75e$var$colors
        },
        numbers: {
            type: 'number',
            properties: $0fe0b44b83bcc75e$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $0fe0b44b83bcc75e$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $0fe0b44b83bcc75e$var$intlCache = new Map();
function $0fe0b44b83bcc75e$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $0fe0b44b83bcc75e$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $0fe0b44b83bcc75e$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $0fe0b44b83bcc75e$export$ae1af26003f05816(num, locale, options) {
    return $0fe0b44b83bcc75e$var$getNumberFormat(locale, options).format(num);
}
const $0fe0b44b83bcc75e$var$formatters = {
    values (value) {
        return $0fe0b44b83bcc75e$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $0fe0b44b83bcc75e$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $0fe0b44b83bcc75e$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $0fe0b44b83bcc75e$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($0fe0b44b83bcc75e$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $0fe0b44b83bcc75e$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $0fe0b44b83bcc75e$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $0fe0b44b83bcc75e$export$9f4f30ee63539e24 = {
    formatters: $0fe0b44b83bcc75e$var$formatters
};
function $0fe0b44b83bcc75e$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $0fe0b44b83bcc75e$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $0fe0b44b83bcc75e$export$6559d589eb85fbb6 = Object.create(null);
const $0fe0b44b83bcc75e$export$2e2af4578d910ddf = Object.create(null);
function $0fe0b44b83bcc75e$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $0fe0b44b83bcc75e$var$set(root, scope, values) {
    if (typeof scope === 'string') return $0fe0b44b83bcc75e$export$efca4cbe5dd06740($0fe0b44b83bcc75e$var$getScope$1(root, scope), values);
    return $0fe0b44b83bcc75e$export$efca4cbe5dd06740($0fe0b44b83bcc75e$var$getScope$1(root, ''), scope);
}
class $0fe0b44b83bcc75e$var$Defaults {
    set(scope, values) {
        return $0fe0b44b83bcc75e$var$set(this, scope, values);
    }
    get(scope) {
        return $0fe0b44b83bcc75e$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $0fe0b44b83bcc75e$var$set($0fe0b44b83bcc75e$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $0fe0b44b83bcc75e$var$set($0fe0b44b83bcc75e$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $0fe0b44b83bcc75e$var$getScope$1(this, scope);
        const targetScopeObject = $0fe0b44b83bcc75e$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($0fe0b44b83bcc75e$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $0fe0b44b83bcc75e$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$0fe0b44b83bcc75e$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$0fe0b44b83bcc75e$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$0fe0b44b83bcc75e$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
}
var $0fe0b44b83bcc75e$export$4368d992c4eafac0 = /* #__PURE__ */ new $0fe0b44b83bcc75e$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $0fe0b44b83bcc75e$var$applyAnimationsDefaults,
    $0fe0b44b83bcc75e$var$applyLayoutsDefaults,
    $0fe0b44b83bcc75e$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $0fe0b44b83bcc75e$export$e171bab687b50e0(font) {
    if (!font || $0fe0b44b83bcc75e$export$342063e11d6c3cad(font.size) || $0fe0b44b83bcc75e$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $0fe0b44b83bcc75e$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$0fe0b44b83bcc75e$export$8b22cf2602fb60ce(thing)) longest = $0fe0b44b83bcc75e$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($0fe0b44b83bcc75e$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$0fe0b44b83bcc75e$export$8b22cf2602fb60ce(nestedThing)) longest = $0fe0b44b83bcc75e$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $0fe0b44b83bcc75e$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $0fe0b44b83bcc75e$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $0fe0b44b83bcc75e$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $0fe0b44b83bcc75e$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $0fe0b44b83bcc75e$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $0fe0b44b83bcc75e$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $0fe0b44b83bcc75e$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $0fe0b44b83bcc75e$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $0fe0b44b83bcc75e$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $0fe0b44b83bcc75e$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $0fe0b44b83bcc75e$export$56c0d5a1e737357d, rad - $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd, rad + $0fe0b44b83bcc75e$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $0fe0b44b83bcc75e$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $0fe0b44b83bcc75e$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $0fe0b44b83bcc75e$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $0fe0b44b83bcc75e$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $0fe0b44b83bcc75e$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$0fe0b44b83bcc75e$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $0fe0b44b83bcc75e$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $0fe0b44b83bcc75e$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $0fe0b44b83bcc75e$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $0fe0b44b83bcc75e$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $0fe0b44b83bcc75e$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $0fe0b44b83bcc75e$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$0fe0b44b83bcc75e$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $0fe0b44b83bcc75e$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $0fe0b44b83bcc75e$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $0fe0b44b83bcc75e$export$56c0d5a1e737357d, $0fe0b44b83bcc75e$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $0fe0b44b83bcc75e$export$56c0d5a1e737357d, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $0fe0b44b83bcc75e$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $0fe0b44b83bcc75e$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $0fe0b44b83bcc75e$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($0fe0b44b83bcc75e$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $0fe0b44b83bcc75e$var$numberOrZero = (v)=>+v || 0;
function $0fe0b44b83bcc75e$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $0fe0b44b83bcc75e$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $0fe0b44b83bcc75e$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$0fe0b44b83bcc75e$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $0fe0b44b83bcc75e$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $0fe0b44b83bcc75e$export$9fa96a7d116ea3ce(value) {
    return $0fe0b44b83bcc75e$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $0fe0b44b83bcc75e$export$28f7fcd39efa255(value) {
    return $0fe0b44b83bcc75e$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca(value) {
    const obj = $0fe0b44b83bcc75e$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $0fe0b44b83bcc75e$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $0fe0b44b83bcc75e$export$4368d992c4eafac0.font;
    let size = $0fe0b44b83bcc75e$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $0fe0b44b83bcc75e$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($0fe0b44b83bcc75e$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $0fe0b44b83bcc75e$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $0fe0b44b83bcc75e$export$d29e374196577086($0fe0b44b83bcc75e$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $0fe0b44b83bcc75e$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $0fe0b44b83bcc75e$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $0fe0b44b83bcc75e$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $0fe0b44b83bcc75e$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $0fe0b44b83bcc75e$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $0fe0b44b83bcc75e$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $0fe0b44b83bcc75e$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $0fe0b44b83bcc75e$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $0fe0b44b83bcc75e$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$0fe0b44b83bcc75e$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $0fe0b44b83bcc75e$var$_cached(target, prop, ()=>$0fe0b44b83bcc75e$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $0fe0b44b83bcc75e$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $0fe0b44b83bcc75e$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $0fe0b44b83bcc75e$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $0fe0b44b83bcc75e$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$0fe0b44b83bcc75e$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$0fe0b44b83bcc75e$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $0fe0b44b83bcc75e$var$_cached(target, prop, ()=>$0fe0b44b83bcc75e$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $0fe0b44b83bcc75e$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $0fe0b44b83bcc75e$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $0fe0b44b83bcc75e$var$readKey = (prefix, name)=>prefix ? prefix + $0fe0b44b83bcc75e$export$a8550f7dbe79f93a(name) : name;
const $0fe0b44b83bcc75e$var$needsSubResolver = (prop, value)=>$0fe0b44b83bcc75e$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $0fe0b44b83bcc75e$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $0fe0b44b83bcc75e$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($0fe0b44b83bcc75e$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $0fe0b44b83bcc75e$var$_resolveScriptable(prop, value, target, receiver);
    if ($0fe0b44b83bcc75e$export$8b22cf2602fb60ce(value) && value.length) value = $0fe0b44b83bcc75e$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($0fe0b44b83bcc75e$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $0fe0b44b83bcc75e$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $0fe0b44b83bcc75e$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($0fe0b44b83bcc75e$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $0fe0b44b83bcc75e$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $0fe0b44b83bcc75e$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($0fe0b44b83bcc75e$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $0fe0b44b83bcc75e$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($0fe0b44b83bcc75e$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $0fe0b44b83bcc75e$var$resolveFallback(fallback, prop, value) {
    return $0fe0b44b83bcc75e$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $0fe0b44b83bcc75e$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $0fe0b44b83bcc75e$export$2d1720544b23b823(parent, key) : undefined;
function $0fe0b44b83bcc75e$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $0fe0b44b83bcc75e$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $0fe0b44b83bcc75e$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $0fe0b44b83bcc75e$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $0fe0b44b83bcc75e$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $0fe0b44b83bcc75e$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $0fe0b44b83bcc75e$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $0fe0b44b83bcc75e$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$0fe0b44b83bcc75e$var$subGetTarget(resolver, prop, value));
}
function $0fe0b44b83bcc75e$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $0fe0b44b83bcc75e$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $0fe0b44b83bcc75e$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($0fe0b44b83bcc75e$export$8b22cf2602fb60ce(target) && $0fe0b44b83bcc75e$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $0fe0b44b83bcc75e$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $0fe0b44b83bcc75e$var$_resolve($0fe0b44b83bcc75e$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $0fe0b44b83bcc75e$var$needsSubResolver(prop, value) ? $0fe0b44b83bcc75e$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $0fe0b44b83bcc75e$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $0fe0b44b83bcc75e$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $0fe0b44b83bcc75e$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $0fe0b44b83bcc75e$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $0fe0b44b83bcc75e$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($0fe0b44b83bcc75e$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $0fe0b44b83bcc75e$var$EPSILON = Number.EPSILON || 1e-14;
const $0fe0b44b83bcc75e$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $0fe0b44b83bcc75e$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $0fe0b44b83bcc75e$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $0fe0b44b83bcc75e$export$cf2f7c5792f80b46(current, previous);
    const d12 = $0fe0b44b83bcc75e$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $0fe0b44b83bcc75e$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $0fe0b44b83bcc75e$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $0fe0b44b83bcc75e$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($0fe0b44b83bcc75e$export$23ebac1979863676(deltaK[i], 0, $0fe0b44b83bcc75e$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $0fe0b44b83bcc75e$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $0fe0b44b83bcc75e$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $0fe0b44b83bcc75e$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $0fe0b44b83bcc75e$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $0fe0b44b83bcc75e$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $0fe0b44b83bcc75e$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $0fe0b44b83bcc75e$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $0fe0b44b83bcc75e$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $0fe0b44b83bcc75e$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $0fe0b44b83bcc75e$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $0fe0b44b83bcc75e$var$monotoneAdjust(points, deltaK, mK);
    $0fe0b44b83bcc75e$var$monotoneCompute(points, mK, indexAxis);
}
function $0fe0b44b83bcc75e$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $0fe0b44b83bcc75e$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $0fe0b44b83bcc75e$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $0fe0b44b83bcc75e$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $0fe0b44b83bcc75e$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $0fe0b44b83bcc75e$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $0fe0b44b83bcc75e$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $0fe0b44b83bcc75e$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $0fe0b44b83bcc75e$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $0fe0b44b83bcc75e$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $0fe0b44b83bcc75e$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $0fe0b44b83bcc75e$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $0fe0b44b83bcc75e$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $0fe0b44b83bcc75e$export$fef3dfd9bad05307(el, property) {
    return $0fe0b44b83bcc75e$var$getComputedStyle(el).getPropertyValue(property);
}
const $0fe0b44b83bcc75e$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $0fe0b44b83bcc75e$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $0fe0b44b83bcc75e$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $0fe0b44b83bcc75e$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $0fe0b44b83bcc75e$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($0fe0b44b83bcc75e$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $0fe0b44b83bcc75e$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $0fe0b44b83bcc75e$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $0fe0b44b83bcc75e$var$getPositionedStyle(style, 'padding');
    const borders = $0fe0b44b83bcc75e$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $0fe0b44b83bcc75e$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $0fe0b44b83bcc75e$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $0fe0b44b83bcc75e$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $0fe0b44b83bcc75e$var$getComputedStyle(container);
            const containerBorder = $0fe0b44b83bcc75e$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $0fe0b44b83bcc75e$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $0fe0b44b83bcc75e$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $0fe0b44b83bcc75e$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $0fe0b44b83bcc75e$export$53c86fa97d611818,
        maxHeight: maxHeight || $0fe0b44b83bcc75e$export$53c86fa97d611818
    };
}
const $0fe0b44b83bcc75e$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $0fe0b44b83bcc75e$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $0fe0b44b83bcc75e$var$getComputedStyle(canvas);
    const margins = $0fe0b44b83bcc75e$var$getPositionedStyle(style, 'margin');
    const maxWidth = $0fe0b44b83bcc75e$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $0fe0b44b83bcc75e$export$53c86fa97d611818;
    const maxHeight = $0fe0b44b83bcc75e$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $0fe0b44b83bcc75e$export$53c86fa97d611818;
    const containerSize = $0fe0b44b83bcc75e$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $0fe0b44b83bcc75e$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $0fe0b44b83bcc75e$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $0fe0b44b83bcc75e$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $0fe0b44b83bcc75e$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $0fe0b44b83bcc75e$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $0fe0b44b83bcc75e$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $0fe0b44b83bcc75e$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $0fe0b44b83bcc75e$var$round1(chart.height * pixelRatio);
    const deviceWidth = $0fe0b44b83bcc75e$var$round1(chart.width * pixelRatio);
    chart.height = $0fe0b44b83bcc75e$var$round1(chart.height);
    chart.width = $0fe0b44b83bcc75e$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $0fe0b44b83bcc75e$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($0fe0b44b83bcc75e$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $0fe0b44b83bcc75e$export$b4171a6734a65d42(element, property) {
    const value = $0fe0b44b83bcc75e$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $0fe0b44b83bcc75e$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $0fe0b44b83bcc75e$export$6554612db691658e(p1, cp1, t);
    const b = $0fe0b44b83bcc75e$export$6554612db691658e(cp1, cp2, t);
    const c = $0fe0b44b83bcc75e$export$6554612db691658e(cp2, p2, t);
    const d = $0fe0b44b83bcc75e$export$6554612db691658e(a, b, t);
    const e = $0fe0b44b83bcc75e$export$6554612db691658e(b, c, t);
    return $0fe0b44b83bcc75e$export$6554612db691658e(d, e, t);
}
const $0fe0b44b83bcc75e$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $0fe0b44b83bcc75e$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $0fe0b44b83bcc75e$var$getRightToLeftAdapter(rectX, width) : $0fe0b44b83bcc75e$var$getLeftToRightAdapter();
}
function $0fe0b44b83bcc75e$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $0fe0b44b83bcc75e$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $0fe0b44b83bcc75e$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $0fe0b44b83bcc75e$export$ffb5f4729a158638,
        compare: $0fe0b44b83bcc75e$export$f074adc9fbd50943,
        normalize: $0fe0b44b83bcc75e$export$ab83b03e4111b1d0
    };
    return {
        between: $0fe0b44b83bcc75e$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $0fe0b44b83bcc75e$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $0fe0b44b83bcc75e$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $0fe0b44b83bcc75e$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $0fe0b44b83bcc75e$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $0fe0b44b83bcc75e$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $0fe0b44b83bcc75e$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($0fe0b44b83bcc75e$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($0fe0b44b83bcc75e$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $0fe0b44b83bcc75e$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $0fe0b44b83bcc75e$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $0fe0b44b83bcc75e$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $0fe0b44b83bcc75e$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $0fe0b44b83bcc75e$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $0fe0b44b83bcc75e$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $0fe0b44b83bcc75e$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $0fe0b44b83bcc75e$var$splitByStyles(line, $0fe0b44b83bcc75e$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $0fe0b44b83bcc75e$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $0fe0b44b83bcc75e$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $0fe0b44b83bcc75e$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $0fe0b44b83bcc75e$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $0fe0b44b83bcc75e$var$readStyle(segmentOptions.setContext($0fe0b44b83bcc75e$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($0fe0b44b83bcc75e$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $0fe0b44b83bcc75e$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $0fe0b44b83bcc75e$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$0fe0b44b83bcc75e$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $0fe0b44b83bcc75e$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $0fe0b44b83bcc75e$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $0fe0b44b83bcc75e$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $0fe0b44b83bcc75e$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $0fe0b44b83bcc75e$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $0fe0b44b83bcc75e$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $0fe0b44b83bcc75e$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $0fe0b44b83bcc75e$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $9737f0faf91cd254$var$Animator {
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $0fe0b44b83bcc75e$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
}
var $9737f0faf91cd254$export$a424a0aa8f687495 = /* #__PURE__ */ new $9737f0faf91cd254$var$Animator();
const $9737f0faf91cd254$var$transparent = 'transparent';
const $9737f0faf91cd254$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $0fe0b44b83bcc75e$export$db3b6bfb95261072)(from || $9737f0faf91cd254$var$transparent);
        const c1 = c0.valid && (0, $0fe0b44b83bcc75e$export$db3b6bfb95261072)(to || $9737f0faf91cd254$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $9737f0faf91cd254$export$c35d437ae5945fcd {
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $0fe0b44b83bcc75e$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $0fe0b44b83bcc75e$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $0fe0b44b83bcc75e$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $0fe0b44b83bcc75e$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $9737f0faf91cd254$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $0fe0b44b83bcc75e$export$f1e1789686576879)[cfg.easing] || (0, $0fe0b44b83bcc75e$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
}
class $9737f0faf91cd254$export$8ab227dac26677d {
    configure(config) {
        if (!(0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $9737f0faf91cd254$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $9737f0faf91cd254$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $9737f0faf91cd254$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $9737f0faf91cd254$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
}
function $9737f0faf91cd254$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $9737f0faf91cd254$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $9737f0faf91cd254$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $9737f0faf91cd254$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $9737f0faf91cd254$var$scaleClip(xScale, allowedOverflow);
    const y = $9737f0faf91cd254$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $9737f0faf91cd254$var$toClip(value) {
    let t, r, b, l;
    if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $9737f0faf91cd254$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $9737f0faf91cd254$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(value) === (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $9737f0faf91cd254$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $9737f0faf91cd254$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $9737f0faf91cd254$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $9737f0faf91cd254$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $9737f0faf91cd254$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $9737f0faf91cd254$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $9737f0faf91cd254$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $9737f0faf91cd254$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $9737f0faf91cd254$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $9737f0faf91cd254$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $9737f0faf91cd254$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $9737f0faf91cd254$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $9737f0faf91cd254$var$createDatasetContext(parent, index) {
    return (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $9737f0faf91cd254$var$createDataContext(parent, index, element) {
    return (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $9737f0faf91cd254$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $9737f0faf91cd254$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $9737f0faf91cd254$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $9737f0faf91cd254$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $9737f0faf91cd254$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $9737f0faf91cd254$export$75572ec5c55b4048 {
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $9737f0faf91cd254$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $9737f0faf91cd254$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(dataset.xAxisID, $9737f0faf91cd254$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(dataset.yAxisID, $9737f0faf91cd254$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(dataset.rAxisID, $9737f0faf91cd254$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $0fe0b44b83bcc75e$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $9737f0faf91cd254$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $9737f0faf91cd254$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $0fe0b44b83bcc75e$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $9737f0faf91cd254$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $0fe0b44b83bcc75e$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $9737f0faf91cd254$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $9737f0faf91cd254$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $9737f0faf91cd254$var$updateStacks(this, meta._parsed);
            meta._stacked = $9737f0faf91cd254$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $9737f0faf91cd254$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $0fe0b44b83bcc75e$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $0fe0b44b83bcc75e$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $9737f0faf91cd254$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $9737f0faf91cd254$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $9737f0faf91cd254$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $9737f0faf91cd254$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $9737f0faf91cd254$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $9737f0faf91cd254$var$toClip((0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(this.options.clip, $9737f0faf91cd254$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $9737f0faf91cd254$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $9737f0faf91cd254$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $0fe0b44b83bcc75e$export$dda1d9f60106f0e9)(index);
        if (cached) return $9737f0faf91cd254$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($9737f0faf91cd254$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $9737f0faf91cd254$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $9737f0faf91cd254$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($9737f0faf91cd254$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$9737f0faf91cd254$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $9737f0faf91cd254$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$75572ec5c55b4048, "defaults", {});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$75572ec5c55b4048, "datasetElementType", null);
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$75572ec5c55b4048, "dataElementType", null);
function $9737f0faf91cd254$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $0fe0b44b83bcc75e$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $9737f0faf91cd254$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $9737f0faf91cd254$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $0fe0b44b83bcc75e$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $9737f0faf91cd254$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $9737f0faf91cd254$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $9737f0faf91cd254$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $9737f0faf91cd254$var$parseValue(entry, item, vScale, i) {
    if ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(entry)) $9737f0faf91cd254$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $9737f0faf91cd254$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($9737f0faf91cd254$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $9737f0faf91cd254$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $9737f0faf91cd254$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $9737f0faf91cd254$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $9737f0faf91cd254$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $9737f0faf91cd254$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$9737f0faf91cd254$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$9737f0faf91cd254$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $9737f0faf91cd254$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $9737f0faf91cd254$var$swap(edge, a, b);
        edge = $9737f0faf91cd254$var$startEnd(edge, b, a);
    } else edge = $9737f0faf91cd254$var$startEnd(edge, a, b);
    return edge;
}
function $9737f0faf91cd254$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $9737f0faf91cd254$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $9737f0faf91cd254$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $9737f0faf91cd254$export$e97d5dc64e999004 extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    parsePrimitiveData(meta, data, start, count) {
        return $9737f0faf91cd254$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $9737f0faf91cd254$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $0fe0b44b83bcc75e$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($9737f0faf91cd254$var$parseValue((0, $0fe0b44b83bcc75e$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $9737f0faf91cd254$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $9737f0faf91cd254$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $9737f0faf91cd254$var$setBorderSkipped(properties, options, stack, index);
            $9737f0faf91cd254$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $9737f0faf91cd254$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $9737f0faf91cd254$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(value) !== (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $9737f0faf91cd254$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $9737f0faf91cd254$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $9737f0faf91cd254$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e97d5dc64e999004, "id", 'bar');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e97d5dc64e999004, "defaults", {
    datasetElementType: false,
    dataElementType: 'bar',
    categoryPercentage: 0.8,
    barPercentage: 0.9,
    grouped: true,
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'base',
                'width',
                'height'
            ]
        }
    }
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e97d5dc64e999004, "overrides", {
    scales: {
        _index_: {
            type: 'category',
            offset: true,
            grid: {
                offset: true
            }
        },
        _value_: {
            type: 'linear',
            beginAtZero: true
        }
    }
});
class $9737f0faf91cd254$export$19b5c4773f17abe extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$19b5c4773f17abe, "id", 'bubble');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$19b5c4773f17abe, "defaults", {
    datasetElementType: false,
    dataElementType: 'point',
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'borderWidth',
                'radius'
            ]
        }
    }
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$19b5c4773f17abe, "overrides", {
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
});
function $9737f0faf91cd254$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $0fe0b44b83bcc75e$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $0fe0b44b83bcc75e$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) + (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $9737f0faf91cd254$export$e04603e7d8b77172 extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $0fe0b44b83bcc75e$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7);
        let max = -(0, $0fe0b44b83bcc75e$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $0fe0b44b83bcc75e$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $9737f0faf91cd254$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $0fe0b44b83bcc75e$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $0fe0b44b83bcc75e$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e04603e7d8b77172, "id", 'doughnut');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e04603e7d8b77172, "defaults", {
    datasetElementType: false,
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: false
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'circumference',
                'endAngle',
                'innerRadius',
                'outerRadius',
                'startAngle',
                'x',
                'y',
                'offset',
                'borderWidth',
                'spacing'
            ]
        }
    },
    cutout: '50%',
    rotation: 0,
    circumference: 360,
    radius: '100%',
    spacing: 0,
    indexAxis: 'r'
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e04603e7d8b77172, "descriptors", {
    _scriptable: (name)=>name !== 'spacing',
    _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e04603e7d8b77172, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                    if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                        const meta = chart.getDatasetMeta(0);
                        const style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            fontColor: color,
                            hidden: !chart.getDataVisibility(i),
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            textAlign: textAlign,
                            pointStyle: pointStyle,
                            borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    }
});
class $9737f0faf91cd254$export$3c9b5d28c11cbfd0 extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $0fe0b44b83bcc75e$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $0fe0b44b83bcc75e$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $0fe0b44b83bcc75e$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$3c9b5d28c11cbfd0, "id", 'line');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$3c9b5d28c11cbfd0, "defaults", {
    datasetElementType: 'line',
    dataElementType: 'point',
    showLine: true,
    spanGaps: false
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$3c9b5d28c11cbfd0, "overrides", {
    scales: {
        _index_: {
            type: 'category'
        },
        _value_: {
            type: 'linear'
        }
    }
});
class $9737f0faf91cd254$export$2a270b3a0d973c85 extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $0fe0b44b83bcc75e$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $0fe0b44b83bcc75e$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$2a270b3a0d973c85, "id", 'polarArea');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$2a270b3a0d973c85, "defaults", {
    dataElementType: 'arc',
    animation: {
        animateRotate: true,
        animateScale: true
    },
    animations: {
        numbers: {
            type: 'number',
            properties: [
                'x',
                'y',
                'startAngle',
                'endAngle',
                'innerRadius',
                'outerRadius'
            ]
        }
    },
    indexAxis: 'r',
    startAngle: 0
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$2a270b3a0d973c85, "overrides", {
    aspectRatio: 1,
    plugins: {
        legend: {
            labels: {
                generateLabels (chart) {
                    const data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                        return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                strokeStyle: style.borderColor,
                                fontColor: color,
                                lineWidth: style.borderWidth,
                                pointStyle: pointStyle,
                                hidden: !chart.getDataVisibility(i),
                                index: i
                            };
                        });
                    }
                    return [];
                }
            },
            onClick (e, legendItem, legend) {
                legend.chart.toggleDataVisibility(legendItem.index);
                legend.chart.update();
            }
        }
    },
    scales: {
        r: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            beginAtZero: true,
            grid: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            startAngle: 0
        }
    }
});
class $9737f0faf91cd254$export$b21a3f1286706191 extends $9737f0faf91cd254$export$e04603e7d8b77172 {
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$b21a3f1286706191, "id", 'pie');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$b21a3f1286706191, "defaults", {
    cutout: 0,
    rotation: 0,
    circumference: 360,
    radius: '100%'
});
class $9737f0faf91cd254$export$48dbc6ac651bf8be extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $0fe0b44b83bcc75e$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$48dbc6ac651bf8be, "id", 'radar');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$48dbc6ac651bf8be, "defaults", {
    datasetElementType: 'line',
    dataElementType: 'point',
    indexAxis: 'r',
    showLine: true,
    elements: {
        line: {
            fill: 'start'
        }
    }
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$48dbc6ac651bf8be, "overrides", {
    aspectRatio: 1,
    scales: {
        r: {
            type: 'radialLinear'
        }
    }
});
class $9737f0faf91cd254$export$b2f2bae6713db87 extends $9737f0faf91cd254$export$75572ec5c55b4048 {
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $0fe0b44b83bcc75e$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $0fe0b44b83bcc75e$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $0fe0b44b83bcc75e$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$b2f2bae6713db87, "id", 'scatter');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$b2f2bae6713db87, "defaults", {
    datasetElementType: false,
    dataElementType: 'point',
    showLine: false,
    fill: false
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$b2f2bae6713db87, "overrides", {
    interaction: {
        mode: 'point'
    },
    scales: {
        x: {
            type: 'linear'
        },
        y: {
            type: 'linear'
        }
    }
});
var $9737f0faf91cd254$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $9737f0faf91cd254$export$e97d5dc64e999004,
    BubbleController: $9737f0faf91cd254$export$19b5c4773f17abe,
    DoughnutController: $9737f0faf91cd254$export$e04603e7d8b77172,
    LineController: $9737f0faf91cd254$export$3c9b5d28c11cbfd0,
    PieController: $9737f0faf91cd254$export$b21a3f1286706191,
    PolarAreaController: $9737f0faf91cd254$export$2a270b3a0d973c85,
    RadarController: $9737f0faf91cd254$export$48dbc6ac651bf8be,
    ScatterController: $9737f0faf91cd254$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $9737f0faf91cd254$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $9737f0faf91cd254$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($9737f0faf91cd254$var$DateAdapterBase.prototype, members);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $9737f0faf91cd254$var$abstract();
    }
    parse() {
        return $9737f0faf91cd254$var$abstract();
    }
    format() {
        return $9737f0faf91cd254$var$abstract();
    }
    add() {
        return $9737f0faf91cd254$var$abstract();
    }
    diff() {
        return $9737f0faf91cd254$var$abstract();
    }
    startOf() {
        return $9737f0faf91cd254$var$abstract();
    }
    endOf() {
        return $9737f0faf91cd254$var$abstract();
    }
    constructor(options){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "options", void 0);
        this.options = options || {};
    }
}
var $9737f0faf91cd254$export$f32766ea09ec8bc4 = {
    _date: $9737f0faf91cd254$var$DateAdapterBase
};
function $9737f0faf91cd254$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $0fe0b44b83bcc75e$export$ebd11618f299a286) : (0, $0fe0b44b83bcc75e$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $9737f0faf91cd254$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $9737f0faf91cd254$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $9737f0faf91cd254$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $9737f0faf91cd254$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $9737f0faf91cd254$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $9737f0faf91cd254$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $0fe0b44b83bcc75e$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $0fe0b44b83bcc75e$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $9737f0faf91cd254$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $9737f0faf91cd254$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $9737f0faf91cd254$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $9737f0faf91cd254$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $9737f0faf91cd254$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $9737f0faf91cd254$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $9737f0faf91cd254$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $9737f0faf91cd254$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $9737f0faf91cd254$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $9737f0faf91cd254$export$a13296960cae0384 = {
    evaluateInteractionItems: $9737f0faf91cd254$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $9737f0faf91cd254$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $9737f0faf91cd254$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $9737f0faf91cd254$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $9737f0faf91cd254$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $9737f0faf91cd254$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $9737f0faf91cd254$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(e, chart);
            return $9737f0faf91cd254$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(e, chart);
            return $9737f0faf91cd254$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $9737f0faf91cd254$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $9737f0faf91cd254$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $9737f0faf91cd254$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$9737f0faf91cd254$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $9737f0faf91cd254$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $9737f0faf91cd254$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $9737f0faf91cd254$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$9737f0faf91cd254$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $9737f0faf91cd254$var$setLayoutDims(layouts, params) {
    const stacks = $9737f0faf91cd254$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $9737f0faf91cd254$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $9737f0faf91cd254$var$wrapBoxes(boxes);
    const fullSize = $9737f0faf91cd254$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $9737f0faf91cd254$var$sortByWeight($9737f0faf91cd254$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $9737f0faf91cd254$var$sortByWeight($9737f0faf91cd254$var$filterByPosition(layoutBoxes, 'right'));
    const top = $9737f0faf91cd254$var$sortByWeight($9737f0faf91cd254$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $9737f0faf91cd254$var$sortByWeight($9737f0faf91cd254$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $9737f0faf91cd254$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $9737f0faf91cd254$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $9737f0faf91cd254$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $9737f0faf91cd254$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $9737f0faf91cd254$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $9737f0faf91cd254$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $9737f0faf91cd254$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $9737f0faf91cd254$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $9737f0faf91cd254$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $9737f0faf91cd254$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $9737f0faf91cd254$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $9737f0faf91cd254$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $9737f0faf91cd254$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $9737f0faf91cd254$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $9737f0faf91cd254$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $9737f0faf91cd254$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $9737f0faf91cd254$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $0fe0b44b83bcc75e$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $9737f0faf91cd254$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $9737f0faf91cd254$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $0fe0b44b83bcc75e$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $9737f0faf91cd254$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $9737f0faf91cd254$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $9737f0faf91cd254$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $9737f0faf91cd254$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $9737f0faf91cd254$var$updateMaxPadding(maxPadding, (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $9737f0faf91cd254$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $9737f0faf91cd254$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $9737f0faf91cd254$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($9737f0faf91cd254$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $9737f0faf91cd254$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $9737f0faf91cd254$var$handleMaxPadding(chartArea);
        $9737f0faf91cd254$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $9737f0faf91cd254$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $9737f0faf91cd254$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $9737f0faf91cd254$export$a40a96b24b46cf35 extends $9737f0faf91cd254$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $9737f0faf91cd254$var$EXPANDO_KEY = '$chartjs';
const $9737f0faf91cd254$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $9737f0faf91cd254$var$isNullOrEmpty = (value)=>value === null || value === '';
function $9737f0faf91cd254$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$9737f0faf91cd254$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($9737f0faf91cd254$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $0fe0b44b83bcc75e$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($9737f0faf91cd254$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $0fe0b44b83bcc75e$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $9737f0faf91cd254$var$eventListenerOptions = (0, $0fe0b44b83bcc75e$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $9737f0faf91cd254$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $9737f0faf91cd254$var$eventListenerOptions);
}
function $9737f0faf91cd254$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $9737f0faf91cd254$var$eventListenerOptions);
}
function $9737f0faf91cd254$var$fromNativeEvent(event, chart) {
    const type = $9737f0faf91cd254$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $0fe0b44b83bcc75e$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $9737f0faf91cd254$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $9737f0faf91cd254$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $9737f0faf91cd254$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$9737f0faf91cd254$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $9737f0faf91cd254$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $9737f0faf91cd254$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$9737f0faf91cd254$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $9737f0faf91cd254$var$drpListeningCharts = new Map();
let $9737f0faf91cd254$var$oldDevicePixelRatio = 0;
function $9737f0faf91cd254$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $9737f0faf91cd254$var$oldDevicePixelRatio) return;
    $9737f0faf91cd254$var$oldDevicePixelRatio = dpr;
    $9737f0faf91cd254$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $9737f0faf91cd254$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$9737f0faf91cd254$var$drpListeningCharts.size) window.addEventListener('resize', $9737f0faf91cd254$var$onWindowResize);
    $9737f0faf91cd254$var$drpListeningCharts.set(chart, resize);
}
function $9737f0faf91cd254$var$unlistenDevicePixelRatioChanges(chart) {
    $9737f0faf91cd254$var$drpListeningCharts.delete(chart);
    if (!$9737f0faf91cd254$var$drpListeningCharts.size) window.removeEventListener('resize', $9737f0faf91cd254$var$onWindowResize);
}
function $9737f0faf91cd254$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $0fe0b44b83bcc75e$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $0fe0b44b83bcc75e$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $9737f0faf91cd254$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $9737f0faf91cd254$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $9737f0faf91cd254$var$unlistenDevicePixelRatioChanges(chart);
}
function $9737f0faf91cd254$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $0fe0b44b83bcc75e$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($9737f0faf91cd254$var$fromNativeEvent(event, chart));
    }, chart);
    $9737f0faf91cd254$var$addListener(canvas, type, proxy);
    return proxy;
}
class $9737f0faf91cd254$export$f02da7f882cf6b2e extends $9737f0faf91cd254$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $9737f0faf91cd254$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$9737f0faf91cd254$var$EXPANDO_KEY]) return false;
        const initial = canvas[$9737f0faf91cd254$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$9737f0faf91cd254$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $9737f0faf91cd254$var$createAttachObserver,
            detach: $9737f0faf91cd254$var$createDetachObserver,
            resize: $9737f0faf91cd254$var$createResizeObserver
        };
        const handler = handlers[type] || $9737f0faf91cd254$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $9737f0faf91cd254$var$releaseObserver,
            detach: $9737f0faf91cd254$var$releaseObserver,
            resize: $9737f0faf91cd254$var$releaseObserver
        };
        const handler = handlers[type] || $9737f0faf91cd254$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $0fe0b44b83bcc75e$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $0fe0b44b83bcc75e$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $9737f0faf91cd254$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $0fe0b44b83bcc75e$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $9737f0faf91cd254$export$a40a96b24b46cf35;
    return $9737f0faf91cd254$export$f02da7f882cf6b2e;
}
class $9737f0faf91cd254$export$db77ccec0bb4ccac {
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $0fe0b44b83bcc75e$export$d141bba7fdc215a3)(this.x) && (0, $0fe0b44b83bcc75e$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "x", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "y", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "active", false);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "options", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "$animations", void 0);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$db77ccec0bb4ccac, "defaults", {});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$db77ccec0bb4ccac, "defaultRoutes", undefined);
function $9737f0faf91cd254$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $9737f0faf91cd254$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $9737f0faf91cd254$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $9737f0faf91cd254$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $9737f0faf91cd254$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $9737f0faf91cd254$var$skip(ticks, newTicks, spacing, (0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$9737f0faf91cd254$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $9737f0faf91cd254$var$skip(ticks, newTicks, spacing, last, (0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $9737f0faf91cd254$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $9737f0faf91cd254$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $9737f0faf91cd254$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $9737f0faf91cd254$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $0fe0b44b83bcc75e$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $9737f0faf91cd254$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $9737f0faf91cd254$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $9737f0faf91cd254$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $9737f0faf91cd254$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $9737f0faf91cd254$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $9737f0faf91cd254$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $9737f0faf91cd254$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $9737f0faf91cd254$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $9737f0faf91cd254$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $9737f0faf91cd254$var$garbageCollect(caches, length) {
    (0, $0fe0b44b83bcc75e$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $9737f0faf91cd254$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $9737f0faf91cd254$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $9737f0faf91cd254$var$createScaleContext(parent, scale) {
    return (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $9737f0faf91cd254$var$createTickContext(parent, index, tick) {
    return (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $9737f0faf91cd254$var$titleAlign(align, position, reverse) {
    let ret = (0, $0fe0b44b83bcc75e$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $9737f0faf91cd254$var$reverseAlign(ret);
    return ret;
}
function $9737f0faf91cd254$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $9737f0faf91cd254$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $9737f0faf91cd254$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd) : (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $9737f0faf91cd254$export$d60cfc58d3c358b6 extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(min, (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(max, min)),
            max: (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(max, (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $0fe0b44b83bcc75e$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $9737f0faf91cd254$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $9737f0faf91cd254$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $9737f0faf91cd254$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $9737f0faf91cd254$var$getTickMarkLength(options.grid) - tickOpts.padding - $9737f0faf91cd254$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $0fe0b44b83bcc75e$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $9737f0faf91cd254$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $9737f0faf91cd254$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $9737f0faf91cd254$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $9737f0faf91cd254$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $9737f0faf91cd254$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(label) && !(0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(label)) {
                width = (0, $0fe0b44b83bcc75e$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(nestedLabel) && !(0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $0fe0b44b83bcc75e$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $9737f0faf91cd254$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $0fe0b44b83bcc75e$export$71cec2538cb2c617)(this._alignToPixels ? (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $9737f0faf91cd254$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $9737f0faf91cd254$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $9737f0faf91cd254$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $9737f0faf91cd254$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $9737f0faf91cd254$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $0fe0b44b83bcc75e$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $0fe0b44b83bcc75e$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $0fe0b44b83bcc75e$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(title.font);
        const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $9737f0faf91cd254$var$titleArgs(this, offset, position, align);
        (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $9737f0faf91cd254$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $9737f0faf91cd254$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
}
class $9737f0faf91cd254$var$TypedRegistry {
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($9737f0faf91cd254$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $9737f0faf91cd254$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0)[scope]) {
            delete (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $0fe0b44b83bcc75e$export$6559d589eb85fbb6)[id];
        }
    }
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
}
function $9737f0faf91cd254$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $0fe0b44b83bcc75e$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $9737f0faf91cd254$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $9737f0faf91cd254$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $9737f0faf91cd254$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $9737f0faf91cd254$var$Registry {
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $0fe0b44b83bcc75e$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $0fe0b44b83bcc75e$export$a8550f7dbe79f93a)(method);
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
    constructor(){
        this.controllers = new $9737f0faf91cd254$var$TypedRegistry($9737f0faf91cd254$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $9737f0faf91cd254$var$TypedRegistry($9737f0faf91cd254$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $9737f0faf91cd254$var$TypedRegistry(Object, 'plugins');
        this.scales = new $9737f0faf91cd254$var$TypedRegistry($9737f0faf91cd254$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
}
var $9737f0faf91cd254$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $9737f0faf91cd254$var$Registry();
class $9737f0faf91cd254$var$PluginService {
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $9737f0faf91cd254$var$allPlugins(config);
        return options === false && !all ? [] : $9737f0faf91cd254$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
    constructor(){
        this._init = undefined;
    }
}
function $9737f0faf91cd254$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($9737f0faf91cd254$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($9737f0faf91cd254$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $9737f0faf91cd254$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $9737f0faf91cd254$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $9737f0faf91cd254$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $9737f0faf91cd254$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $9737f0faf91cd254$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $9737f0faf91cd254$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $9737f0faf91cd254$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $9737f0faf91cd254$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $9737f0faf91cd254$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $9737f0faf91cd254$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $9737f0faf91cd254$var$determineAxis(id, ...scaleOptions) {
    if ($9737f0faf91cd254$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $9737f0faf91cd254$var$axisFromPosition(opts.position) || id.length > 1 && $9737f0faf91cd254$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $9737f0faf91cd254$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $9737f0faf91cd254$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $9737f0faf91cd254$var$getAxisFromDataset(id, 'x', boundDs[0]) || $9737f0faf91cd254$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $9737f0faf91cd254$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $0fe0b44b83bcc75e$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $9737f0faf91cd254$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $9737f0faf91cd254$var$determineAxis(id, scaleConf, $9737f0faf91cd254$var$retrieveAxisFromDatasets(id, config), (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $9737f0faf91cd254$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $0fe0b44b83bcc75e$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $9737f0faf91cd254$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $0fe0b44b83bcc75e$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $9737f0faf91cd254$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $0fe0b44b83bcc75e$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $0fe0b44b83bcc75e$export$555508cbc6add439)(scale, [
            (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).scales[scale.type],
            (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $9737f0faf91cd254$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $9737f0faf91cd254$var$mergeScaleConfig(config, options);
}
function $9737f0faf91cd254$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $9737f0faf91cd254$var$initConfig(config) {
    config = config || {};
    config.data = $9737f0faf91cd254$var$initData(config.data);
    $9737f0faf91cd254$var$initOptions(config);
    return config;
}
const $9737f0faf91cd254$var$keyCache = new Map();
const $9737f0faf91cd254$var$keysCached = new Set();
function $9737f0faf91cd254$var$cachedKeys(cacheKey, generate) {
    let keys = $9737f0faf91cd254$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $9737f0faf91cd254$var$keyCache.set(cacheKey, keys);
        $9737f0faf91cd254$var$keysCached.add(keys);
    }
    return keys;
}
const $9737f0faf91cd254$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $0fe0b44b83bcc75e$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $9737f0faf91cd254$var$Config {
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $9737f0faf91cd254$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $9737f0faf91cd254$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $9737f0faf91cd254$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $9737f0faf91cd254$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $9737f0faf91cd254$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $9737f0faf91cd254$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$9737f0faf91cd254$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$9737f0faf91cd254$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$9737f0faf91cd254$var$addIfFound(scopes, (0, $0fe0b44b83bcc75e$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$9737f0faf91cd254$var$addIfFound(scopes, (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$9737f0faf91cd254$var$addIfFound(scopes, (0, $0fe0b44b83bcc75e$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($9737f0faf91cd254$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $0fe0b44b83bcc75e$export$6559d589eb85fbb6)[type] || {},
            (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0),
            (0, $0fe0b44b83bcc75e$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $9737f0faf91cd254$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($9737f0faf91cd254$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $0fe0b44b83bcc75e$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $0fe0b44b83bcc75e$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $9737f0faf91cd254$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(context) ? (0, $0fe0b44b83bcc75e$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
    constructor(config){
        this._config = $9737f0faf91cd254$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
}
function $9737f0faf91cd254$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $0fe0b44b83bcc75e$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $9737f0faf91cd254$var$hasFunction = (value)=>(0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $0fe0b44b83bcc75e$export$a93c5207d687da10)(value[key]));
function $9737f0faf91cd254$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $0fe0b44b83bcc75e$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $0fe0b44b83bcc75e$export$a93c5207d687da10)(value) || $9737f0faf91cd254$var$hasFunction(value)) || indexable && (0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $9737f0faf91cd254$var$version = "4.5.1";
const $9737f0faf91cd254$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $9737f0faf91cd254$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $9737f0faf91cd254$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $9737f0faf91cd254$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $9737f0faf91cd254$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $9737f0faf91cd254$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $9737f0faf91cd254$var$getCanvas(item) {
    if ((0, $0fe0b44b83bcc75e$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $9737f0faf91cd254$var$instances = {};
const $9737f0faf91cd254$var$getChart = (key)=>{
    const canvas = $9737f0faf91cd254$var$getCanvas(key);
    return Object.values($9737f0faf91cd254$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $9737f0faf91cd254$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $9737f0faf91cd254$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $9737f0faf91cd254$export$acaa6426d77a227e {
    static register(...items) {
        $9737f0faf91cd254$export$4bb7493d241fd8a5.add(...items);
        $9737f0faf91cd254$var$invalidatePlugins();
    }
    static unregister(...items) {
        $9737f0faf91cd254$export$4bb7493d241fd8a5.remove(...items);
        $9737f0faf91cd254$var$invalidatePlugins();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $9737f0faf91cd254$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $0fe0b44b83bcc75e$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $0fe0b44b83bcc75e$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $9737f0faf91cd254$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$9737f0faf91cd254$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $0fe0b44b83bcc75e$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $9737f0faf91cd254$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $9737f0faf91cd254$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $9737f0faf91cd254$var$positionIsHorizontal(scaleOptions.position, axis) !== $9737f0faf91cd254$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $9737f0faf91cd254$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(scales, (scale)=>{
            $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $9737f0faf91cd254$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($9737f0faf91cd254$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $9737f0faf91cd254$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $9737f0faf91cd254$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $9737f0faf91cd254$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $9737f0faf91cd254$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $0fe0b44b83bcc75e$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($9737f0faf91cd254$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this.scales, (scale)=>{
            $9737f0faf91cd254$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $0fe0b44b83bcc75e$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $9737f0faf91cd254$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $0fe0b44b83bcc75e$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $9737f0faf91cd254$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $0fe0b44b83bcc75e$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($9737f0faf91cd254$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$9737f0faf91cd254$export$a424a0aa8f687495.running(this)) $9737f0faf91cd254$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $9737f0faf91cd254$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $0fe0b44b83bcc75e$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $0fe0b44b83bcc75e$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $0fe0b44b83bcc75e$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $9737f0faf91cd254$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $0fe0b44b83bcc75e$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $9737f0faf91cd254$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $0fe0b44b83bcc75e$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $9737f0faf91cd254$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $0fe0b44b83bcc75e$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $0fe0b44b83bcc75e$export$3b513254972cfc9c)(e);
        const lastEvent = $9737f0faf91cd254$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $0fe0b44b83bcc75e$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
    constructor(item, userConfig){
        const config = this.config = new $9737f0faf91cd254$var$Config(userConfig);
        const initialCanvas = $9737f0faf91cd254$var$getCanvas(item);
        const existingChart = $9737f0faf91cd254$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $9737f0faf91cd254$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $0fe0b44b83bcc75e$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $9737f0faf91cd254$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $0fe0b44b83bcc75e$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $9737f0faf91cd254$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $9737f0faf91cd254$export$a424a0aa8f687495.listen(this, 'complete', $9737f0faf91cd254$var$onAnimationsComplete);
        $9737f0faf91cd254$export$a424a0aa8f687495.listen(this, 'progress', $9737f0faf91cd254$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$acaa6426d77a227e, "defaults", (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0));
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$acaa6426d77a227e, "instances", $9737f0faf91cd254$var$instances);
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$acaa6426d77a227e, "overrides", (0, $0fe0b44b83bcc75e$export$6559d589eb85fbb6));
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$acaa6426d77a227e, "registry", $9737f0faf91cd254$export$4bb7493d241fd8a5);
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$acaa6426d77a227e, "version", $9737f0faf91cd254$var$version);
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$acaa6426d77a227e, "getChart", $9737f0faf91cd254$var$getChart);
function $9737f0faf91cd254$var$invalidatePlugins() {
    return (0, $0fe0b44b83bcc75e$export$d66501df72047452)($9737f0faf91cd254$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $9737f0faf91cd254$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / 2, startAngle + (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $9737f0faf91cd254$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd), startAngle - (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $9737f0faf91cd254$var$toRadiusCorners(value) {
    return (0, $0fe0b44b83bcc75e$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $9737f0faf91cd254$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $9737f0faf91cd254$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $9737f0faf91cd254$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $9737f0faf91cd254$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $9737f0faf91cd254$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $9737f0faf91cd254$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $9737f0faf91cd254$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $9737f0faf91cd254$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $9737f0faf91cd254$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $9737f0faf91cd254$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $9737f0faf91cd254$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $9737f0faf91cd254$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $9737f0faf91cd254$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7) || (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7));
    }
    $9737f0faf91cd254$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $9737f0faf91cd254$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $9737f0faf91cd254$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7) || (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7));
    }
    if (inner) $9737f0faf91cd254$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $9737f0faf91cd254$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $9737f0faf91cd254$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $9737f0faf91cd254$export$d48203c759d6a1fc extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $0fe0b44b83bcc75e$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $0fe0b44b83bcc75e$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $0fe0b44b83bcc75e$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $9737f0faf91cd254$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $9737f0faf91cd254$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
    constructor(cfg){
        super(), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "circumference", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "endAngle", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "fullCircles", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "innerRadius", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "outerRadius", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "pixelMargin", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "startAngle", void 0);
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$d48203c759d6a1fc, "id", 'arc');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$d48203c759d6a1fc, "defaults", {
    borderAlign: 'center',
    borderColor: '#fff',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: undefined,
    borderRadius: 0,
    borderWidth: 2,
    offset: 0,
    spacing: 0,
    angle: undefined,
    circular: true,
    selfJoin: false
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$d48203c759d6a1fc, "defaultRoutes", {
    backgroundColor: 'backgroundColor'
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$d48203c759d6a1fc, "descriptors", {
    _scriptable: true,
    _indexable: (name)=>name !== 'borderDash'
});
function $9737f0faf91cd254$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $9737f0faf91cd254$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $9737f0faf91cd254$var$getLineMethod(options) {
    if (options.stepped) return 0, $0fe0b44b83bcc75e$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $0fe0b44b83bcc75e$export$1fbe638ecf81657e;
    return $9737f0faf91cd254$var$lineTo;
}
function $9737f0faf91cd254$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $9737f0faf91cd254$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $9737f0faf91cd254$var$pathVars(points, segment, params);
    const lineMethod = $9737f0faf91cd254$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $9737f0faf91cd254$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $9737f0faf91cd254$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $9737f0faf91cd254$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $9737f0faf91cd254$var$fastPathSegment : $9737f0faf91cd254$var$pathSegment;
}
function $9737f0faf91cd254$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $0fe0b44b83bcc75e$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $0fe0b44b83bcc75e$export$d24c54395ce0c509;
    return 0, $0fe0b44b83bcc75e$export$6554612db691658e;
}
function $9737f0faf91cd254$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $9737f0faf91cd254$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $9737f0faf91cd254$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $9737f0faf91cd254$var$_getSegmentMethod(line);
    for (const segment of segments){
        $9737f0faf91cd254$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $9737f0faf91cd254$var$usePath2D = typeof Path2D === 'function';
function $9737f0faf91cd254$var$draw(ctx, line, start, count) {
    if ($9737f0faf91cd254$var$usePath2D && !line.options.segment) $9737f0faf91cd254$var$strokePathWithCache(ctx, line, start, count);
    else $9737f0faf91cd254$var$strokePathDirect(ctx, line, start, count);
}
class $9737f0faf91cd254$export$55e463fa7bcd3469 extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $0fe0b44b83bcc75e$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $0fe0b44b83bcc75e$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $0fe0b44b83bcc75e$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $9737f0faf91cd254$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $9737f0faf91cd254$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $9737f0faf91cd254$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $9737f0faf91cd254$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$55e463fa7bcd3469, "id", 'line');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$55e463fa7bcd3469, "defaults", {
    borderCapStyle: 'butt',
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: 'miter',
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: 'default',
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$55e463fa7bcd3469, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$55e463fa7bcd3469, "descriptors", {
    _scriptable: true,
    _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
});
function $9737f0faf91cd254$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $9737f0faf91cd254$export$bd159b522b230b7a extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $9737f0faf91cd254$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $9737f0faf91cd254$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $0fe0b44b83bcc75e$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
    constructor(cfg){
        super(), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "parsed", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "skip", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "stop", void 0);
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$bd159b522b230b7a, "id", 'point');
/**
   * @type {any}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$bd159b522b230b7a, "defaults", {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: 'circle',
    radius: 3,
    rotation: 0
});
/**
   * @type {any}
   */ (0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$bd159b522b230b7a, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
function $9737f0faf91cd254$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $9737f0faf91cd254$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(value, min, max);
}
function $9737f0faf91cd254$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $0fe0b44b83bcc75e$export$9fa96a7d116ea3ce)(value);
    return {
        t: $9737f0faf91cd254$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $9737f0faf91cd254$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $9737f0faf91cd254$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $9737f0faf91cd254$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $9737f0faf91cd254$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $9737f0faf91cd254$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $9737f0faf91cd254$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $9737f0faf91cd254$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $9737f0faf91cd254$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $9737f0faf91cd254$var$boundingRects(bar) {
    const bounds = $9737f0faf91cd254$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $9737f0faf91cd254$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $9737f0faf91cd254$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $9737f0faf91cd254$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $9737f0faf91cd254$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $0fe0b44b83bcc75e$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $0fe0b44b83bcc75e$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $9737f0faf91cd254$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $9737f0faf91cd254$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $9737f0faf91cd254$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $9737f0faf91cd254$export$a16ed71bf4b07672 extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $9737f0faf91cd254$var$boundingRects(this);
        const addRectPath = $9737f0faf91cd254$var$hasRadius(outer.radius) ? (0, $0fe0b44b83bcc75e$export$92108d983e8ee699) : $9737f0faf91cd254$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $9737f0faf91cd254$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $9737f0faf91cd254$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $9737f0faf91cd254$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $9737f0faf91cd254$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $9737f0faf91cd254$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $9737f0faf91cd254$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$a16ed71bf4b07672, "id", 'bar');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$a16ed71bf4b07672, "defaults", {
    borderSkipped: 'start',
    borderWidth: 0,
    borderRadius: 0,
    inflateAmount: 'auto',
    pointStyle: undefined
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$a16ed71bf4b07672, "defaultRoutes", {
    backgroundColor: 'backgroundColor',
    borderColor: 'borderColor'
});
var $9737f0faf91cd254$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $9737f0faf91cd254$export$d48203c759d6a1fc,
    BarElement: $9737f0faf91cd254$export$a16ed71bf4b07672,
    LineElement: $9737f0faf91cd254$export$55e463fa7bcd3469,
    PointElement: $9737f0faf91cd254$export$bd159b522b230b7a
});
const $9737f0faf91cd254$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $9737f0faf91cd254$var$BACKGROUND_COLORS = /* #__PURE__ */ $9737f0faf91cd254$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $9737f0faf91cd254$var$getBorderColor(i) {
    return $9737f0faf91cd254$var$BORDER_COLORS[i % $9737f0faf91cd254$var$BORDER_COLORS.length];
}
function $9737f0faf91cd254$var$getBackgroundColor(i) {
    return $9737f0faf91cd254$var$BACKGROUND_COLORS[i % $9737f0faf91cd254$var$BACKGROUND_COLORS.length];
}
function $9737f0faf91cd254$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $9737f0faf91cd254$var$getBorderColor(i);
    dataset.backgroundColor = $9737f0faf91cd254$var$getBackgroundColor(i);
    return ++i;
}
function $9737f0faf91cd254$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$9737f0faf91cd254$var$getBorderColor(i++));
    return i;
}
function $9737f0faf91cd254$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$9737f0faf91cd254$var$getBackgroundColor(i++));
    return i;
}
function $9737f0faf91cd254$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $9737f0faf91cd254$export$e04603e7d8b77172) i = $9737f0faf91cd254$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $9737f0faf91cd254$export$2a270b3a0d973c85) i = $9737f0faf91cd254$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $9737f0faf91cd254$var$colorizeDefaultDataset(dataset, i);
    };
}
function $9737f0faf91cd254$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $9737f0faf91cd254$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $9737f0faf91cd254$var$containsDefaultColorsDefenitions() {
    return (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $9737f0faf91cd254$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $9737f0faf91cd254$var$containsColorsDefinitions(datasets) || $9737f0faf91cd254$var$containsColorsDefinition(chartOptions) || elements && $9737f0faf91cd254$var$containsColorsDefinitions(elements) || $9737f0faf91cd254$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $9737f0faf91cd254$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $9737f0faf91cd254$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $9737f0faf91cd254$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(minIndex) && !(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data[intermediateIndex1]), {
                    x: avgX
                }));
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data[intermediateIndex2]), {
                    x: avgX
                }));
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $9737f0faf91cd254$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $9737f0faf91cd254$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $9737f0faf91cd254$var$cleanDecimatedDataset(dataset);
    });
}
function $9737f0faf91cd254$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)((0, $0fe0b44b83bcc75e$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)((0, $0fe0b44b83bcc75e$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $9737f0faf91cd254$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $9737f0faf91cd254$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $0fe0b44b83bcc75e$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $9737f0faf91cd254$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $9737f0faf91cd254$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $9737f0faf91cd254$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $9737f0faf91cd254$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $9737f0faf91cd254$var$cleanDecimatedData(chart);
    }
};
function $9737f0faf91cd254$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $9737f0faf91cd254$var$_findSegmentEnd(start, end, points);
        const bounds = $9737f0faf91cd254$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $0fe0b44b83bcc75e$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $9737f0faf91cd254$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $0fe0b44b83bcc75e$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $9737f0faf91cd254$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $9737f0faf91cd254$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $9737f0faf91cd254$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(start);
        end = (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $9737f0faf91cd254$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $9737f0faf91cd254$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $9737f0faf91cd254$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $9737f0faf91cd254$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $9737f0faf91cd254$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $9737f0faf91cd254$var$_pointsFromSegments(boundary, line);
    return points.length ? new $9737f0faf91cd254$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $9737f0faf91cd254$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $9737f0faf91cd254$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $9737f0faf91cd254$var$_decodeFill(line, index, count) {
    const fill = $9737f0faf91cd254$var$parseFillOption(line);
    if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $9737f0faf91cd254$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $9737f0faf91cd254$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $9737f0faf91cd254$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $9737f0faf91cd254$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $9737f0faf91cd254$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $9737f0faf91cd254$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $9737f0faf91cd254$var$getLinesBelow(scale, index);
    linesBelow.push($9737f0faf91cd254$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$9737f0faf91cd254$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $9737f0faf91cd254$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $9737f0faf91cd254$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $9737f0faf91cd254$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $9737f0faf91cd254$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $9737f0faf91cd254$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $0fe0b44b83bcc75e$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $9737f0faf91cd254$var$simpleArc {
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
}
function $9737f0faf91cd254$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(fill)) return $9737f0faf91cd254$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $9737f0faf91cd254$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $9737f0faf91cd254$var$computeBoundary(source);
    if (boundary instanceof $9737f0faf91cd254$var$simpleArc) return boundary;
    return $9737f0faf91cd254$var$_createBoundaryLine(boundary, line);
}
function $9737f0faf91cd254$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $9737f0faf91cd254$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $9737f0faf91cd254$var$computeCircularBoundary(source);
    return $9737f0faf91cd254$var$computeLinearBoundary(source);
}
function $9737f0faf91cd254$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $9737f0faf91cd254$var$_getTargetPixel(fill, scale);
    if ((0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $9737f0faf91cd254$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $9737f0faf91cd254$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $9737f0faf91cd254$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $9737f0faf91cd254$var$_drawfill(ctx, source, area) {
    const target = $9737f0faf91cd254$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $0fe0b44b83bcc75e$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $0fe0b44b83bcc75e$export$8743009a87fcb00f)(ctx, area);
        $9737f0faf91cd254$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $0fe0b44b83bcc75e$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $9737f0faf91cd254$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $9737f0faf91cd254$var$clipVertical(ctx, target, area.top);
            $9737f0faf91cd254$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $9737f0faf91cd254$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $9737f0faf91cd254$var$clipHorizontal(ctx, target, area.left);
            $9737f0faf91cd254$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $9737f0faf91cd254$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $9737f0faf91cd254$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $9737f0faf91cd254$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$9737f0faf91cd254$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $9737f0faf91cd254$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$9737f0faf91cd254$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $9737f0faf91cd254$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $9737f0faf91cd254$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $9737f0faf91cd254$var$clipBounds(ctx, scale, clip, notShape && $9737f0faf91cd254$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $9737f0faf91cd254$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $9737f0faf91cd254$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $9737f0faf91cd254$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $9737f0faf91cd254$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $9737f0faf91cd254$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $9737f0faf91cd254$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $9737f0faf91cd254$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $9737f0faf91cd254$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $9737f0faf91cd254$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($9737f0faf91cd254$var$_shouldApplyFill(source)) $9737f0faf91cd254$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$9737f0faf91cd254$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $9737f0faf91cd254$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $9737f0faf91cd254$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $9737f0faf91cd254$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $9737f0faf91cd254$var$Legend extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $9737f0faf91cd254$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $9737f0faf91cd254$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $0fe0b44b83bcc75e$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $0fe0b44b83bcc75e$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $9737f0faf91cd254$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $0fe0b44b83bcc75e$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $0fe0b44b83bcc75e$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $0fe0b44b83bcc75e$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $0fe0b44b83bcc75e$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $9737f0faf91cd254$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $0fe0b44b83bcc75e$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $0fe0b44b83bcc75e$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $0fe0b44b83bcc75e$export$21579262ef46735b)(x, this.left, this.right) && (0, $0fe0b44b83bcc75e$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $0fe0b44b83bcc75e$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $0fe0b44b83bcc75e$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$9737f0faf91cd254$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $9737f0faf91cd254$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $9737f0faf91cd254$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $9737f0faf91cd254$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $9737f0faf91cd254$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $9737f0faf91cd254$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $9737f0faf91cd254$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $9737f0faf91cd254$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $9737f0faf91cd254$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $9737f0faf91cd254$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $9737f0faf91cd254$export$ed247974535929c7 = {
    id: 'legend',
    _element: $9737f0faf91cd254$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $9737f0faf91cd254$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $9737f0faf91cd254$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $9737f0faf91cd254$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $9737f0faf91cd254$var$Title extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $0fe0b44b83bcc75e$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $0fe0b44b83bcc75e$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
}
function $9737f0faf91cd254$var$createTitle(chart, titleOpts) {
    const title = new $9737f0faf91cd254$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $9737f0faf91cd254$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $9737f0faf91cd254$export$f99233281efd08a0 = {
    id: 'title',
    _element: $9737f0faf91cd254$var$Title,
    start (chart, _args, options) {
        $9737f0faf91cd254$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $9737f0faf91cd254$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $9737f0faf91cd254$var$map = new WeakMap();
var $9737f0faf91cd254$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $9737f0faf91cd254$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(chart, title, options);
        $9737f0faf91cd254$export$1ecca0613f5e56d2.addBox(chart, title);
        $9737f0faf91cd254$var$map.set(chart, title);
    },
    stop (chart) {
        $9737f0faf91cd254$export$1ecca0613f5e56d2.removeBox(chart, $9737f0faf91cd254$var$map.get(chart));
        $9737f0faf91cd254$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $9737f0faf91cd254$var$map.get(chart);
        $9737f0faf91cd254$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $9737f0faf91cd254$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $0fe0b44b83bcc75e$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $9737f0faf91cd254$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $9737f0faf91cd254$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $9737f0faf91cd254$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $9737f0faf91cd254$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $0fe0b44b83bcc75e$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $0fe0b44b83bcc75e$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $0fe0b44b83bcc75e$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $0fe0b44b83bcc75e$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $9737f0faf91cd254$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $9737f0faf91cd254$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $9737f0faf91cd254$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($9737f0faf91cd254$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $9737f0faf91cd254$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $9737f0faf91cd254$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $9737f0faf91cd254$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $9737f0faf91cd254$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $9737f0faf91cd254$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $9737f0faf91cd254$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(cornerRadius);
    let x = $9737f0faf91cd254$var$alignX(size, xAlign);
    const y = $9737f0faf91cd254$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $9737f0faf91cd254$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $9737f0faf91cd254$var$getBeforeAfterBodyLines(callback) {
    return $9737f0faf91cd254$var$pushOrConcat([], $9737f0faf91cd254$var$splitNewlines(callback));
}
function $9737f0faf91cd254$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $9737f0faf91cd254$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $9737f0faf91cd254$var$defaultCallbacks = {
    beforeTitle: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    beforeBody: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    beforeLabel: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    afterBody: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    beforeFooter: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    footer: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346),
    afterFooter: (0, $0fe0b44b83bcc75e$export$53a70dd1ebbae346)
};
function $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $9737f0faf91cd254$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $9737f0faf91cd254$var$Tooltip extends $9737f0faf91cd254$export$db77ccec0bb4ccac {
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $9737f0faf91cd254$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $9737f0faf91cd254$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $9737f0faf91cd254$var$pushOrConcat(lines, $9737f0faf91cd254$var$splitNewlines(beforeTitle));
        lines = $9737f0faf91cd254$var$pushOrConcat(lines, $9737f0faf91cd254$var$splitNewlines(title));
        lines = $9737f0faf91cd254$var$pushOrConcat(lines, $9737f0faf91cd254$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $9737f0faf91cd254$var$getBeforeAfterBodyLines($9737f0faf91cd254$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $9737f0faf91cd254$var$overrideCallbacks(callbacks, context);
            $9737f0faf91cd254$var$pushOrConcat(bodyItem.before, $9737f0faf91cd254$var$splitNewlines($9737f0faf91cd254$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $9737f0faf91cd254$var$pushOrConcat(bodyItem.lines, $9737f0faf91cd254$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $9737f0faf91cd254$var$pushOrConcat(bodyItem.after, $9737f0faf91cd254$var$splitNewlines($9737f0faf91cd254$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $9737f0faf91cd254$var$getBeforeAfterBodyLines($9737f0faf91cd254$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $9737f0faf91cd254$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $9737f0faf91cd254$var$pushOrConcat(lines, $9737f0faf91cd254$var$splitNewlines(beforeFooter));
        lines = $9737f0faf91cd254$var$pushOrConcat(lines, $9737f0faf91cd254$var$splitNewlines(footer));
        lines = $9737f0faf91cd254$var$pushOrConcat(lines, $9737f0faf91cd254$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($9737f0faf91cd254$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $9737f0faf91cd254$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($9737f0faf91cd254$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($9737f0faf91cd254$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($9737f0faf91cd254$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $9737f0faf91cd254$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $9737f0faf91cd254$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $9737f0faf91cd254$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $9737f0faf91cd254$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $9737f0faf91cd254$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.bodyFont);
        const colorX = $9737f0faf91cd254$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $0fe0b44b83bcc75e$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $0fe0b44b83bcc75e$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $0fe0b44b83bcc75e$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $0fe0b44b83bcc75e$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $0fe0b44b83bcc75e$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $9737f0faf91cd254$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $0fe0b44b83bcc75e$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $0fe0b44b83bcc75e$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $0fe0b44b83bcc75e$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $0fe0b44b83bcc75e$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $9737f0faf91cd254$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $9737f0faf91cd254$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $9737f0faf91cd254$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $9737f0faf91cd254$var$determineAlignment(chart, options, positionAndSize);
            const point = $9737f0faf91cd254$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $0fe0b44b83bcc75e$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $0fe0b44b83bcc75e$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $0fe0b44b83bcc75e$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $0fe0b44b83bcc75e$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $9737f0faf91cd254$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$var$Tooltip, "positioners", $9737f0faf91cd254$var$positioners);
var $9737f0faf91cd254$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $9737f0faf91cd254$var$Tooltip,
    positioners: $9737f0faf91cd254$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $9737f0faf91cd254$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, args), {
                cancelable: true
            })) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $9737f0faf91cd254$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $9737f0faf91cd254$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $9737f0faf91cd254$export$c537fa0d021d010b,
    Decimation: $9737f0faf91cd254$export$be17f937e9aa7533,
    Filler: $9737f0faf91cd254$export$d19ba4d812bed757,
    Legend: $9737f0faf91cd254$export$ed247974535929c7,
    SubTitle: $9737f0faf91cd254$export$d5c56664638992a4,
    Title: $9737f0faf91cd254$export$f99233281efd08a0,
    Tooltip: $9737f0faf91cd254$export$28c660c63b792dea
});
const $9737f0faf91cd254$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $9737f0faf91cd254$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $9737f0faf91cd254$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $9737f0faf91cd254$var$validIndex = (index, max)=>index === null ? null : (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $9737f0faf91cd254$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $9737f0faf91cd254$export$29e663ba4d09fe7 extends $9737f0faf91cd254$export$d60cfc58d3c358b6 {
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $9737f0faf91cd254$var$findOrAddLabel(labels, raw, (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $9737f0faf91cd254$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $9737f0faf91cd254$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$29e663ba4d09fe7, "id", 'category');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$29e663ba4d09fe7, "defaults", {
    ticks: {
        callback: $9737f0faf91cd254$var$_getLabelForValue
    }
});
function $9737f0faf91cd254$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $0fe0b44b83bcc75e$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $0fe0b44b83bcc75e$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $0fe0b44b83bcc75e$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $0fe0b44b83bcc75e$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $0fe0b44b83bcc75e$export$91477dc880baac21)(spacing), (0, $0fe0b44b83bcc75e$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $0fe0b44b83bcc75e$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $9737f0faf91cd254$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $0fe0b44b83bcc75e$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $9737f0faf91cd254$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $9737f0faf91cd254$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $9737f0faf91cd254$var$LinearScaleBase extends $9737f0faf91cd254$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $0fe0b44b83bcc75e$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $9737f0faf91cd254$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $0fe0b44b83bcc75e$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $0fe0b44b83bcc75e$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
}
class $9737f0faf91cd254$export$e7f4e5e8656f0b93 extends $9737f0faf91cd254$var$LinearScaleBase {
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e7f4e5e8656f0b93, "id", 'linear');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$e7f4e5e8656f0b93, "defaults", {
    ticks: {
        callback: (0, $0fe0b44b83bcc75e$export$9f4f30ee63539e24).formatters.numeric
    }
});
const $9737f0faf91cd254$var$log10Floor = (v)=>Math.floor((0, $0fe0b44b83bcc75e$export$faec65b429be379)(v));
const $9737f0faf91cd254$var$changeExponent = (v, m)=>Math.pow(10, $9737f0faf91cd254$var$log10Floor(v) + m);
function $9737f0faf91cd254$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $9737f0faf91cd254$var$log10Floor(tickVal));
    return remain === 1;
}
function $9737f0faf91cd254$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $9737f0faf91cd254$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $9737f0faf91cd254$var$log10Floor(range);
    while($9737f0faf91cd254$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($9737f0faf91cd254$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $9737f0faf91cd254$var$log10Floor(min));
}
function $9737f0faf91cd254$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $9737f0faf91cd254$var$log10Floor(min);
    let exp = $9737f0faf91cd254$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $9737f0faf91cd254$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $0fe0b44b83bcc75e$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $9737f0faf91cd254$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $9737f0faf91cd254$export$85295eaf7cb3ac3e extends $9737f0faf91cd254$export$d60cfc58d3c358b6 {
    parse(raw, index) {
        const value = $9737f0faf91cd254$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(this._userMin)) this.min = min === $9737f0faf91cd254$var$changeExponent(this.min, 0) ? $9737f0faf91cd254$var$changeExponent(this.min, -1) : $9737f0faf91cd254$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($9737f0faf91cd254$var$changeExponent(min, -1));
                setMax($9737f0faf91cd254$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($9737f0faf91cd254$var$changeExponent(max, -1));
        if (max <= 0) setMax($9737f0faf91cd254$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $9737f0faf91cd254$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $0fe0b44b83bcc75e$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $0fe0b44b83bcc75e$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $0fe0b44b83bcc75e$export$faec65b429be379)(start);
        this._valueRange = (0, $0fe0b44b83bcc75e$export$faec65b429be379)(this.max) - (0, $0fe0b44b83bcc75e$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $0fe0b44b83bcc75e$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$85295eaf7cb3ac3e, "id", 'logarithmic');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$85295eaf7cb3ac3e, "defaults", {
    ticks: {
        callback: (0, $0fe0b44b83bcc75e$export$9f4f30ee63539e24).formatters.logarithmic,
        major: {
            enabled: true
        }
    }
});
function $9737f0faf91cd254$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $0fe0b44b83bcc75e$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $9737f0faf91cd254$var$measureLabelSize(ctx, font, label) {
    label = (0, $0fe0b44b83bcc75e$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $0fe0b44b83bcc75e$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $9737f0faf91cd254$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $9737f0faf91cd254$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(opts.font);
        const textSize = $9737f0faf91cd254$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $0fe0b44b83bcc75e$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $9737f0faf91cd254$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $9737f0faf91cd254$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $9737f0faf91cd254$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $9737f0faf91cd254$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $9737f0faf91cd254$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $9737f0faf91cd254$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $0fe0b44b83bcc75e$export$3a6d5c9ae78a2c08)((0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd))));
    const y = $9737f0faf91cd254$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $9737f0faf91cd254$var$getTextAlignForAngle(angle);
    const left = $9737f0faf91cd254$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $9737f0faf91cd254$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $0fe0b44b83bcc75e$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $9737f0faf91cd254$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $9737f0faf91cd254$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $0fe0b44b83bcc75e$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $9737f0faf91cd254$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $9737f0faf91cd254$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $9737f0faf91cd254$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $9737f0faf91cd254$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $9737f0faf91cd254$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $9737f0faf91cd254$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $0fe0b44b83bcc75e$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $0fe0b44b83bcc75e$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $9737f0faf91cd254$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $9737f0faf91cd254$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $9737f0faf91cd254$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $9737f0faf91cd254$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $9737f0faf91cd254$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $9737f0faf91cd254$var$createPointLabelContext(parent, index, label) {
    return (0, $0fe0b44b83bcc75e$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $9737f0faf91cd254$export$cfafc36d95386d38 extends $9737f0faf91cd254$var$LinearScaleBase {
    setDimensions() {
        const padding = this._padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)($9737f0faf91cd254$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $9737f0faf91cd254$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $9737f0faf91cd254$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $9737f0faf91cd254$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $0fe0b44b83bcc75e$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $0fe0b44b83bcc75e$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $9737f0faf91cd254$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $0fe0b44b83bcc75e$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $9737f0faf91cd254$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $9737f0faf91cd254$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $9737f0faf91cd254$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $0fe0b44b83bcc75e$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $0fe0b44b83bcc75e$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $0fe0b44b83bcc75e$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$cfafc36d95386d38, "id", 'radialLinear');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$cfafc36d95386d38, "defaults", {
    display: true,
    animate: true,
    position: 'chartArea',
    angleLines: {
        display: true,
        lineWidth: 1,
        borderDash: [],
        borderDashOffset: 0.0
    },
    grid: {
        circular: false
    },
    startAngle: 0,
    ticks: {
        showLabelBackdrop: true,
        callback: (0, $0fe0b44b83bcc75e$export$9f4f30ee63539e24).formatters.numeric
    },
    pointLabels: {
        backdropColor: undefined,
        backdropPadding: 2,
        display: true,
        font: {
            size: 10
        },
        callback (label) {
            return label;
        },
        padding: 5,
        centerPointLabels: false
    }
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$cfafc36d95386d38, "defaultRoutes", {
    'angleLines.color': 'borderColor',
    'pointLabels.color': 'color',
    'ticks.color': 'color'
});
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$cfafc36d95386d38, "descriptors", {
    angleLines: {
        _fallback: 'grid'
    }
});
const $9737f0faf91cd254$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $9737f0faf91cd254$var$UNITS = /* #__PURE__ */ Object.keys($9737f0faf91cd254$var$INTERVALS);
function $9737f0faf91cd254$var$sorter(a, b) {
    return a - b;
}
function $9737f0faf91cd254$var$parse(scale, input) {
    if ((0, $0fe0b44b83bcc75e$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $0fe0b44b83bcc75e$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $9737f0faf91cd254$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $9737f0faf91cd254$var$UNITS.length;
    for(let i = $9737f0faf91cd254$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $9737f0faf91cd254$var$INTERVALS[$9737f0faf91cd254$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $9737f0faf91cd254$var$UNITS[i];
    }
    return $9737f0faf91cd254$var$UNITS[ilen - 1];
}
function $9737f0faf91cd254$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $9737f0faf91cd254$var$UNITS.length - 1; i >= $9737f0faf91cd254$var$UNITS.indexOf(minUnit); i--){
        const unit = $9737f0faf91cd254$var$UNITS[i];
        if ($9737f0faf91cd254$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $9737f0faf91cd254$var$UNITS[minUnit ? $9737f0faf91cd254$var$UNITS.indexOf(minUnit) : 0];
}
function $9737f0faf91cd254$var$determineMajorUnit(unit) {
    for(let i = $9737f0faf91cd254$var$UNITS.indexOf(unit) + 1, ilen = $9737f0faf91cd254$var$UNITS.length; i < ilen; ++i){
        if ($9737f0faf91cd254$var$INTERVALS[$9737f0faf91cd254$var$UNITS[i]].common) return $9737f0faf91cd254$var$UNITS[i];
    }
}
function $9737f0faf91cd254$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $0fe0b44b83bcc75e$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $9737f0faf91cd254$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $9737f0faf91cd254$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $9737f0faf91cd254$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $9737f0faf91cd254$export$a894c72689ff3ec extends $9737f0faf91cd254$export$d60cfc58d3c358b6 {
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $9737f0faf91cd254$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $0fe0b44b83bcc75e$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $9737f0faf91cd254$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $0fe0b44b83bcc75e$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $0fe0b44b83bcc75e$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $9737f0faf91cd254$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $9737f0faf91cd254$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $9737f0faf91cd254$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $9737f0faf91cd254$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $0fe0b44b83bcc75e$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $9737f0faf91cd254$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $0fe0b44b83bcc75e$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $0fe0b44b83bcc75e$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$9737f0faf91cd254$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $9737f0faf91cd254$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($9737f0faf91cd254$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $0fe0b44b83bcc75e$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $0fe0b44b83bcc75e$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $9737f0faf91cd254$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($9737f0faf91cd254$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $0fe0b44b83bcc75e$export$71511d61b312f219)(values.sort($9737f0faf91cd254$var$sorter));
    }
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$a894c72689ff3ec, "id", 'time');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$a894c72689ff3ec, "defaults", {
    bounds: 'data',
    adapters: {},
    time: {
        parser: false,
        unit: false,
        round: false,
        isoWeekday: false,
        minUnit: 'millisecond',
        displayFormats: {}
    },
    ticks: {
        source: 'auto',
        callback: false,
        major: {
            enabled: false
        }
    }
});
function $9737f0faf91cd254$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $0fe0b44b83bcc75e$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $0fe0b44b83bcc75e$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $9737f0faf91cd254$export$85df64a8eb6dc986 extends $9737f0faf91cd254$export$a894c72689ff3ec {
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $9737f0faf91cd254$var$interpolate(table, this.min);
        this._tableRange = $9737f0faf91cd254$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($9737f0faf91cd254$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $9737f0faf91cd254$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$85df64a8eb6dc986, "id", 'timeseries');
(0, $919ebf39980bf8f3$export$71511d61b312f219)($9737f0faf91cd254$export$85df64a8eb6dc986, "defaults", $9737f0faf91cd254$export$a894c72689ff3ec.defaults);
var $9737f0faf91cd254$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $9737f0faf91cd254$export$29e663ba4d09fe7,
    LinearScale: $9737f0faf91cd254$export$e7f4e5e8656f0b93,
    LogarithmicScale: $9737f0faf91cd254$export$85295eaf7cb3ac3e,
    RadialLinearScale: $9737f0faf91cd254$export$cfafc36d95386d38,
    TimeScale: $9737f0faf91cd254$export$a894c72689ff3ec,
    TimeSeriesScale: $9737f0faf91cd254$export$85df64a8eb6dc986
});
const $9737f0faf91cd254$export$e8959e79e3af550f = [
    $9737f0faf91cd254$export$a6506504f799c5d5,
    $9737f0faf91cd254$export$7a5d735b2ab6389d,
    $9737f0faf91cd254$export$8b3ca321c77fdea6,
    $9737f0faf91cd254$export$bcac1c16f1530ec2
];




function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}




var $7fPBF = parcelRequire("7fPBF");

const $7452992c2225c418$var$defaultDatasetIdKey = 'label';
function $7452992c2225c418$var$reforwardRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $7452992c2225c418$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $7452992c2225c418$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $7452992c2225c418$var$setDatasets(currentData, nextDatasets, datasetIdKey = $7452992c2225c418$var$defaultDatasetIdKey) {
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nextDataset);
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $7452992c2225c418$var$cloneData(data, datasetIdKey = $7452992c2225c418$var$defaultDatasetIdKey) {
    const nextData = {
        labels: [],
        datasets: []
    };
    $7452992c2225c418$var$setLabels(nextData, data.labels);
    $7452992c2225c418$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $7452992c2225c418$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $7452992c2225c418$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $7452992c2225c418$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}
function $7452992c2225c418$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode } = props, canvasProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "height",
        "width",
        "redraw",
        "datasetIdKey",
        "type",
        "data",
        "options",
        "plugins",
        "fallbackContent",
        "updateMode"
    ]);
    const canvasRef = (0, $7fPBF.useRef)(null);
    const chartRef = (0, $7fPBF.useRef)(null);
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $9737f0faf91cd254$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $7452992c2225c418$var$cloneData(data, datasetIdKey),
            options: options && (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options),
            plugins: plugins
        });
        $7452992c2225c418$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $7452992c2225c418$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $7452992c2225c418$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!redraw && chartRef.current) $7452992c2225c418$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $7452992c2225c418$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $7fPBF.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("canvas", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), {
        children: fallbackContent
    }));
}
const $7452992c2225c418$export$acaa6426d77a227e = /*#__PURE__*/ (0, $7fPBF.forwardRef)($7452992c2225c418$var$ChartComponent);
function $7452992c2225c418$var$createTypedChart(type, registerables) {
    (0, $9737f0faf91cd254$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7452992c2225c418$export$acaa6426d77a227e, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            ref: ref,
            type: type
        })));
}
const $7452992c2225c418$export$17d680238e50603e = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('line', (0, $9737f0faf91cd254$export$3c9b5d28c11cbfd0));
const $7452992c2225c418$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('bar', (0, $9737f0faf91cd254$export$e97d5dc64e999004));
const $7452992c2225c418$export$bace472c466fdd25 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('radar', (0, $9737f0faf91cd254$export$48dbc6ac651bf8be));
const $7452992c2225c418$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('doughnut', (0, $9737f0faf91cd254$export$e04603e7d8b77172));
const $7452992c2225c418$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('polarArea', (0, $9737f0faf91cd254$export$2a270b3a0d973c85));
const $7452992c2225c418$export$646feb54fbadbe06 = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('bubble', (0, $9737f0faf91cd254$export$19b5c4773f17abe));
const $7452992c2225c418$export$2ae8800cf67c848c = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('pie', (0, $9737f0faf91cd254$export$b21a3f1286706191));
const $7452992c2225c418$export$1c460fb4285edadc = /* #__PURE__ */ $7452992c2225c418$var$createTypedChart('scatter', (0, $9737f0faf91cd254$export$b2f2bae6713db87));


(0, $9737f0faf91cd254$export$acaa6426d77a227e).register((0, $9737f0faf91cd254$export$d48203c759d6a1fc), (0, $9737f0faf91cd254$export$28c660c63b792dea), (0, $9737f0faf91cd254$export$ed247974535929c7));
function $68b215d46e696e86$var$Scrimmage(props) {
    const data = {
        // labels: ["Established", "Contested", "Non-Germane"],
        labels: [
            "Established",
            "Contested"
        ],
        datasets: [
            {
                label: "Votes",
                // data: [props.established, props.contested, props.nonGermane],
                data: [
                    props.established,
                    props.contested
                ],
                // backgroundColor: ["#129BFB", "#FF0000", "#8E8D8A"],
                backgroundColor: [
                    "#129BFB",
                    "#FF0000"
                ],
                // borderColor: ["#129BFB", "#FF0000", "#8E8D8A"],
                borderColor: [
                    "#129BFB",
                    "#FF0000"
                ],
                borderWidth: 1
            }
        ]
    };
    // const total = props.established + props.contested + props.nonGermane;
    const total = props.established + props.contested;
    // These calculations have the possibility of NaN if there are 0 votes. Return 0 if there are no votes
    const establishedPc = Math.round(props.established / total * 100) || 0;
    const contestedPc = Math.round(props.contested / total * 100) || 0;
    // const nonGermanePc = Math.round((props.nonGermane/total) * 100) || 0;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "w-2/6 rounded-lg shadow-lg pb-2 hidden lg:block",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "mb-1 text-2xl font-bold text-center text-gray-800",
                children: "Scrimmage Score"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex gap-4 justify-center ",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                        className: "text-established-blue",
                        children: [
                            establishedPc,
                            "% Established"
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                        className: "text-contested-red",
                        children: [
                            contestedPc,
                            "% Contested"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7452992c2225c418$export$b8b3cfdc3fe36b10), {
                    data: data,
                    width: 200,
                    height: 300,
                    options: {
                        maintainAspectRatio: false
                    }
                })
            })
        ]
    });
}
var $68b215d46e696e86$export$2e2bcd8739ae039 = $68b215d46e696e86$var$Scrimmage;




var $7fPBF = parcelRequire("7fPBF");



function $d1341d22117654d3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m15.232 5.232 3.536 3.536m-2.036-5.036a2.5 2.5 0 1 1 3.536 3.536L6.5 21.036H3v-3.572Z"
        })
    }));
}





var $7fPBF = parcelRequire("7fPBF");
function $3fa646c5531497dd$var$EditMainClaim(props) {
    const [editedMainClaim, setEditedMainClaim] = (0, $7fPBF.useState)("");
    const isMainClaimValid = editedMainClaim && editedMainClaim.length >= 20 ? true : false;
    const style = {
        button: "py-1.5 px-5 rounded font-bold text-white"
    };
    (0, $7fPBF.useEffect)(()=>{
        if (props.mainClaim) setEditedMainClaim(props.mainClaim);
    }, [
        props.mainClaim
    ]);
    function handleEditMainClaim(event) {
        setEditedMainClaim(event.target.value);
    }
    function handleUpdateMainClaim() {
        if (isMainClaimValid) props.updateMainClaim(editedMainClaim);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                className: "m-2 p-2 w-[95%] border-2 border-slate-400 rounded-md",
                value: editedMainClaim,
                onChange: handleEditMainClaim
            }),
            !isMainClaimValid ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "text-red-600",
                children: "Main claim must be at least 20 characters in length"
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex justify-center gap-5 pt-2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: `${style.button} cursor-pointer bg-blue-600 hover:bg-blue-700`,
                        onClick: handleUpdateMainClaim,
                        children: "Update"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: `${style.button} cursor-pointer bg-red-600 hover:bg-red-700`,
                        onClick: props.switchEditing,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}
var $3fa646c5531497dd$export$2e2bcd8739ae039 = $3fa646c5531497dd$var$EditMainClaim;


function $eeeecb757944802c$var$MainClaim(props) {
    const [editingMainClaim, setEditingMainClaim] = (0, $7fPBF.useState)(false);
    const convincedVotes = props.mainClaim.convinced.length;
    const notPersuadedVotes = props.mainClaim.notPersuaded.length;
    const convincedPercentage = convincedVotes !== 0 ? Math.round(convincedVotes / (convincedVotes + notPersuadedVotes) * 100) : 0;
    const notPersuadedPercentage = notPersuadedVotes !== 0 ? Math.floor(notPersuadedVotes / (notPersuadedVotes + convincedVotes) * 100) : 0;
    const isVotingEnabled = props.mainClaim.phase === "strawpoll" || props.mainClaim.phase === "endpoll";
    const didVoteConvinced = props.mainClaim.convinced.includes(props.player.id);
    const didVoteNotPersuaded = props.mainClaim.notPersuaded.includes(props.player.id);
    // TODO: Centralise Phase Changes Buttons
    const style = {
        select: "py-1 block text-center text-gray-700 bg-white border-[2px] border-sky-500 rounded-md focus:border-[3px] focus:border-sky-500",
        button: "py-1.5 px-5 rounded font-bold text-white",
        // phasesContainer: "w-[30em] h-[6em] p-0 m-0 flex flex-col justify-around items-center",
        phasesBar: "w-96 h-[1.8em] flex justify-between items-center border-2 border-black-200 rounded-full",
        phasesCircle: "w-[1.7em] h-full border-2 border-green-400 rounded-full",
        phaseActive: "bg-green-400",
        phaseInactive: "border-green-400 bg-green-50",
        // phaseButtonContainer: "w-[80%] h-[30%] flex justify-center gap-x-4",
        phaseButton: "w-[30%] px-2 py-1 font-bold px-4 text-sm text-slate-50 rounded-full",
        endpollBtn: "m-auto py-1.5 px-5 rounded font-bold text-white bg-indigo-400 hover:bg-indigo-500 cursor-pointer",
        zIndex: "z-2"
    };
    function switchEditing() {
        setEditingMainClaim(!editingMainClaim);
    }
    function updateMainClaim(editedMainClaim) {
        props.handleUpdateMainClaim(editedMainClaim);
        switchEditing();
    }
    function moveToPreviousPhase() {
        let index = getCurrentPhaseIndex();
        if (index > 0) {
            index--;
            const phaseValue = props.phases.at(index).value;
            props.handleChangeGamePhase(phaseValue);
        }
    }
    function moveToNextPhase() {
        let index = getCurrentPhaseIndex();
        if (index < props.phases.length - 1) {
            index++;
            const phaseValue = props.phases.at(index).value;
            props.handleChangeGamePhase(phaseValue);
        }
    }
    function getCurrentPhaseIndex() {
        return props.phases.findIndex((element)=>element.value === props.mainClaim.phase);
    }
    function isFirstPhase() {
        const index = getCurrentPhaseIndex();
        return index == 0;
    }
    function isLastPhase() {
        const index = getCurrentPhaseIndex();
        return index == props.phases.length - 1;
    }
    function getPreviousPhaseLabel() {
        const index = getCurrentPhaseIndex();
        if (index > 0) return props.phases.at(index - 1).text;
        return "";
    }
    function getCurrentPhaseLabel() {
        const index = getCurrentPhaseIndex();
        return props.phases.at(index).text;
    }
    function getNextPhaseLabel() {
        const index = getCurrentPhaseIndex();
        if (index < props.phases.length - 1) return props.phases.at(index + 1).text;
        return "";
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.zIndex, "sticky top-0 text-center border rounded-lg shadow-lg pb-2 bg-gray-50"),
        children: [
            editingMainClaim !== true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        props.mainClaim.phase === "endpoll" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "p-2 text-2xl shadow-lg border rounded-md font-bold",
                            children: "Final Poll"
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "w-[90%] m-auto text-center mt-2 lg:text-2xl text-lg font-semibold text-pure-black",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                        className: "lg:inline hidden lg:text-base",
                                        children: "MainClaim:"
                                    }),
                                    " ",
                                    props.mainClaim.mainClaim
                                ]
                            })
                        }),
                        props.role === "referee" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex justify-center mx-auto my-2 w-[22%]",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    "aria-label": "Show Results",
                                    hidden: props.mainClaim.phase !== "endpoll",
                                    className: style.endpollBtn,
                                    onClick: props.handleGetFinalResults,
                                    children: "Show Results"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    "aria-label": "Download Results",
                                    hidden: props.mainClaim.phase !== "endpoll",
                                    className: style.endpollBtn,
                                    onClick: props.handleDownloadResults,
                                    children: "Download Results"
                                }),
                                props.mainClaim.phase !== 'endpoll' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    "aria-label": "Edit MainClaim",
                                    className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.zIndex, "absolute top-2 right-2 p-1 border-1 border-slate-400 hover:bg-slate-300 rounded-lg cursor-pointer"),
                                    onClick: switchEditing,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1341d22117654d3$export$2e2bcd8739ae039), {
                                        className: "w-[18px]"
                                    })
                                }) : null
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex justify-center gap-1",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "w-[30em] p-0 m-0 flex flex-col justify-around items-center",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "w-[80%] flex justify-center gap-x-4",
                                    children: props.role === "referee" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: [
                                            isFirstPhase() ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: `${style.phaseButton} bg-emerald-500 hover:bg-emerald-600 cursor-pointer`,
                                                    onClick: moveToPreviousPhase,
                                                    children: `< ${getPreviousPhaseLabel()}`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                className: `${style.phaseButton} bg-slate-400`,
                                                disabled: true,
                                                children: getCurrentPhaseLabel()
                                            }),
                                            isLastPhase() ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: `${style.phaseButton} bg-emerald-500 hover:bg-emerald-600 cursor-pointer`,
                                                    onClick: moveToNextPhase,
                                                    children: `${getNextPhaseLabel()} >`
                                                })
                                            })
                                        ]
                                    }) : null
                                })
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3fa646c5531497dd$export$2e2bcd8739ae039), {
                mainClaim: props.mainClaim.mainClaim,
                switchEditing: switchEditing,
                updateMainClaim: updateMainClaim
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex flex-col pt-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "flex flex-row mb-1 items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "text-left mr-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                        className: "text-xs lg:font-semibold inline-block text-lighter-blue",
                                        children: [
                                            convincedPercentage,
                                            "% Convinced (",
                                            convincedVotes,
                                            ") Votes"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "text-right ml-2",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                        className: "text-xs lg:font-semibold inline-block text-persuaded-green",
                                        children: [
                                            notPersuadedPercentage,
                                            "% Not Persuaded (",
                                            notPersuadedVotes,
                                            ") Votes"
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: `h-4 w-full mb-2 text-xs flex rounded-lg ${notPersuadedPercentage ? "bg-persuaded-green" : "bg-neutral-gray"}`,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    width: `${convincedPercentage}%`
                                },
                                className: "shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center rounded-lg bg-lighter-blue"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: props.role === "player" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex justify-center gap-9 p-2",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, isVotingEnabled && "cursor-pointer", didVoteConvinced && "bg-gray-600 inset-ring-2 inset-ring-lighter-blue/50", !didVoteConvinced && "bg-lighter-blue"),
                            disabled: !isVotingEnabled,
                            onClick: props.handleConvincedVote,
                            children: "Convinced"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, isVotingEnabled && "cursor-pointer", didVoteNotPersuaded && "bg-gray-600 inset-ring-2 inset-ring-persuaded-green/50", !didVoteNotPersuaded && "bg-persuaded-green"),
                            disabled: !isVotingEnabled,
                            onClick: props.handleNotPersuadedVote,
                            children: props.mainClaim.phase === "endpoll" ? "(Still) Not Persuaded" : "Not Persuaded"
                        })
                    ]
                }) : null
            }),
            props.player.name ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                className: "lg:text-lg text-base px-4",
                children: [
                    "Player: ",
                    props.player.name
                ]
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                className: "lg:text-lg text-base px-4",
                children: [
                    "Match Code: ",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "px-1 ring-2 bg-blue-50 select-all rounded",
                        children: props.roomCode
                    }),
                    " "
                ]
            })
        ]
    });
}
var $eeeecb757944802c$export$2e2bcd8739ae039 = $eeeecb757944802c$var$MainClaim;






function $ee5e0c44e56cee9f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            fillRule: "evenodd",
            d: "M11 2v9H2v2h9v9h2v-9h9v-2h-9V2Z"
        })
    }));
}






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $7fPBF = parcelRequire("7fPBF");
function $0fcec64c9b7e118d$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0fcec64c9b7e118d$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $0fcec64c9b7e118d$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $0fcec64c9b7e118d$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0fcec64c9b7e118d$export$5a096129d439f843(target)) return target;
    if (!$0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0fcec64c9b7e118d$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0fcec64c9b7e118d$export$1b3bfaa9684536aa(node) {
    if ($0fcec64c9b7e118d$export$5a096129d439f843(node)) return false;
    return node instanceof $0fcec64c9b7e118d$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0fcec64c9b7e118d$export$17eda790a720ec57(node) {
    return node instanceof $0fcec64c9b7e118d$export$38b2d434cce3ea22(node).SVGElement;
}
function $0fcec64c9b7e118d$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0fcec64c9b7e118d$export$5a096129d439f843(target)) return target.document;
    if (!$0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0fcec64c9b7e118d$export$62858bae88b53fd0(target)) return target;
    if ($0fcec64c9b7e118d$export$1b3bfaa9684536aa(target) || $0fcec64c9b7e118d$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0fcec64c9b7e118d$export$700979bc83e7db82 = $0fcec64c9b7e118d$export$71594e8a50f746f4 ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $0fcec64c9b7e118d$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $7fPBF.useRef)(handler);
    $0fcec64c9b7e118d$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $7fPBF.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0fcec64c9b7e118d$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $7fPBF.useRef)(null);
    const set = (0, $7fPBF.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $7fPBF.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0fcec64c9b7e118d$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $7fPBF.useRef)(value);
    $0fcec64c9b7e118d$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $7fPBF.useRef)();
    return (0, $7fPBF.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0fcec64c9b7e118d$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0fcec64c9b7e118d$export$90fc3a17d93f704c(onChange);
    const node = (0, $7fPBF.useRef)(null);
    const setNodeRef = (0, $7fPBF.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0fcec64c9b7e118d$export$5cae361ad82dce8b(value) {
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0fcec64c9b7e118d$var$ids = {};
function $0fcec64c9b7e118d$export$c485849f2e393253(prefix, value) {
    return (0, $7fPBF.useMemo)(()=>{
        if (value) return value;
        const id = $0fcec64c9b7e118d$var$ids[prefix] == null ? 0 : $0fcec64c9b7e118d$var$ids[prefix] + 1;
        $0fcec64c9b7e118d$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0fcec64c9b7e118d$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, object));
    };
}
const $0fcec64c9b7e118d$export$e16d8520af44a096 = /*#__PURE__*/ $0fcec64c9b7e118d$var$createAdjustmentFn(1);
const $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0fcec64c9b7e118d$var$createAdjustmentFn(-1);
function $0fcec64c9b7e118d$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $0fcec64c9b7e118d$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0fcec64c9b7e118d$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0fcec64c9b7e118d$export$36195c8aa1517e04(event) {
    if ($0fcec64c9b7e118d$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0fcec64c9b7e118d$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0fcec64c9b7e118d$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0fcec64c9b7e118d$export$c4ffa16951855e28.Translate.toString(transform),
                $0fcec64c9b7e118d$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0fcec64c9b7e118d$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $0fcec64c9b7e118d$export$44f71d798fd0a62b(element) {
    if (element.matches($0fcec64c9b7e118d$var$SELECTOR)) return element;
    return element.querySelector($0fcec64c9b7e118d$var$SELECTOR);
}



var $7fPBF = parcelRequire("7fPBF");
const $eceb84cdc2b532ec$var$hiddenStyles = {
    display: 'none'
};
function $eceb84cdc2b532ec$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id,
        style: $eceb84cdc2b532ec$var$hiddenStyles
    }, value);
}
function $eceb84cdc2b532ec$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $eceb84cdc2b532ec$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $7fPBF.useState)('');
    const announce = (0, $7fPBF.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $ecddad0aaeff3d51$var$DndMonitorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
function $ecddad0aaeff3d51$export$1182af90218a7b81(listener) {
    const registerListener = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$DndMonitorContext);
    (0, $7fPBF.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $ecddad0aaeff3d51$var$useDndMonitorProvider() {
    const [listeners] = (0, $7fPBF.useState)(()=>new Set());
    const registerListener = (0, $7fPBF.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $7fPBF.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $ecddad0aaeff3d51$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $ecddad0aaeff3d51$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $ecddad0aaeff3d51$var$Accessibility(_ref) {
    let { announcements: announcements = $ecddad0aaeff3d51$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $ecddad0aaeff3d51$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $eceb84cdc2b532ec$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $0fcec64c9b7e118d$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setMounted(true);
    }, []);
    $ecddad0aaeff3d51$export$1182af90218a7b81((0, $7fPBF.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eceb84cdc2b532ec$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $eceb84cdc2b532ec$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $fw0lo.createPortal)(markup, container) : markup;
}
var $ecddad0aaeff3d51$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($ecddad0aaeff3d51$var$Action || ($ecddad0aaeff3d51$var$Action = {}));
function $ecddad0aaeff3d51$var$noop() {}
function $ecddad0aaeff3d51$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $7fPBF.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $ecddad0aaeff3d51$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $ecddad0aaeff3d51$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $ecddad0aaeff3d51$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $ecddad0aaeff3d51$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $0fcec64c9b7e118d$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $ecddad0aaeff3d51$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $ecddad0aaeff3d51$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $ecddad0aaeff3d51$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $ecddad0aaeff3d51$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $ecddad0aaeff3d51$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $ecddad0aaeff3d51$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $ecddad0aaeff3d51$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $ecddad0aaeff3d51$var$distanceBetween($ecddad0aaeff3d51$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $ecddad0aaeff3d51$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $ecddad0aaeff3d51$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $ecddad0aaeff3d51$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $ecddad0aaeff3d51$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $ecddad0aaeff3d51$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $ecddad0aaeff3d51$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $ecddad0aaeff3d51$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $ecddad0aaeff3d51$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $ecddad0aaeff3d51$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $ecddad0aaeff3d51$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $ecddad0aaeff3d51$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $ecddad0aaeff3d51$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
function $ecddad0aaeff3d51$var$adjustScale(transform, rect1, rect2) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transform), {
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    });
}
function $ecddad0aaeff3d51$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
}
function $ecddad0aaeff3d51$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, acc), {
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rect));
    };
}
const $ecddad0aaeff3d51$var$getAdjustedRect = /*#__PURE__*/ $ecddad0aaeff3d51$var$createRectAdjustmentFn(1);
function $ecddad0aaeff3d51$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $ecddad0aaeff3d51$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $ecddad0aaeff3d51$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $ecddad0aaeff3d51$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $ecddad0aaeff3d51$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $ecddad0aaeff3d51$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $ecddad0aaeff3d51$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $ecddad0aaeff3d51$var$getTransformAgnosticClientRect(element) {
    return $ecddad0aaeff3d51$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $ecddad0aaeff3d51$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $ecddad0aaeff3d51$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $ecddad0aaeff3d51$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $ecddad0aaeff3d51$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $0fcec64c9b7e118d$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $0fcec64c9b7e118d$export$1b3bfaa9684536aa)(node) || (0, $0fcec64c9b7e118d$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($ecddad0aaeff3d51$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($ecddad0aaeff3d51$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $ecddad0aaeff3d51$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $ecddad0aaeff3d51$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $ecddad0aaeff3d51$var$getScrollableElement(element) {
    if (!(0, $0fcec64c9b7e118d$export$71594e8a50f746f4) || !element) return null;
    if ((0, $0fcec64c9b7e118d$export$5a096129d439f843)(element)) return element;
    if (!(0, $0fcec64c9b7e118d$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $0fcec64c9b7e118d$export$62858bae88b53fd0)(element) || element === (0, $0fcec64c9b7e118d$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $0fcec64c9b7e118d$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $ecddad0aaeff3d51$var$getScrollXCoordinate(element) {
    if ((0, $0fcec64c9b7e118d$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $ecddad0aaeff3d51$var$getScrollYCoordinate(element) {
    if ((0, $0fcec64c9b7e118d$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $ecddad0aaeff3d51$var$getScrollCoordinates(element) {
    return {
        x: $ecddad0aaeff3d51$var$getScrollXCoordinate(element),
        y: $ecddad0aaeff3d51$var$getScrollYCoordinate(element)
    };
}
var $ecddad0aaeff3d51$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($ecddad0aaeff3d51$var$Direction || ($ecddad0aaeff3d51$var$Direction = {}));
function $ecddad0aaeff3d51$var$isDocumentScrollingElement(element) {
    if (!(0, $0fcec64c9b7e118d$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $ecddad0aaeff3d51$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $ecddad0aaeff3d51$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $ecddad0aaeff3d51$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $ecddad0aaeff3d51$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $ecddad0aaeff3d51$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $ecddad0aaeff3d51$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $ecddad0aaeff3d51$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $ecddad0aaeff3d51$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $ecddad0aaeff3d51$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $ecddad0aaeff3d51$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $ecddad0aaeff3d51$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $ecddad0aaeff3d51$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $0fcec64c9b7e118d$export$e16d8520af44a096)(acc, $ecddad0aaeff3d51$var$getScrollCoordinates(node));
    }, $ecddad0aaeff3d51$export$597cbd7bbd10deb4);
}
function $ecddad0aaeff3d51$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $ecddad0aaeff3d51$var$getScrollXCoordinate(node);
    }, 0);
}
function $ecddad0aaeff3d51$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $ecddad0aaeff3d51$var$getScrollYCoordinate(node);
    }, 0);
}
function $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $ecddad0aaeff3d51$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $ecddad0aaeff3d51$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $ecddad0aaeff3d51$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $ecddad0aaeff3d51$var$getScrollYOffset
    ]
];
class $ecddad0aaeff3d51$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $ecddad0aaeff3d51$export$e4864aa91b5ed091(element);
        const scrollOffsets = $ecddad0aaeff3d51$var$getScrollOffsets(scrollableAncestors);
        this.rect = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rect);
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $ecddad0aaeff3d51$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $ecddad0aaeff3d51$var$Listeners {
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
}
function $ecddad0aaeff3d51$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $0fcec64c9b7e118d$export$b204af158042fbac)(target);
}
function $ecddad0aaeff3d51$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $ecddad0aaeff3d51$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($ecddad0aaeff3d51$var$EventName || ($ecddad0aaeff3d51$var$EventName = {}));
function $ecddad0aaeff3d51$var$preventDefault(event) {
    event.preventDefault();
}
function $ecddad0aaeff3d51$var$stopPropagation(event) {
    event.stopPropagation();
}
var $ecddad0aaeff3d51$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($ecddad0aaeff3d51$export$a8b1916dba3ae88b || ($ecddad0aaeff3d51$export$a8b1916dba3ae88b = {}));
const $ecddad0aaeff3d51$var$defaultKeyboardCodes = {
    start: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Space,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Space,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Enter,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Tab
    ]
};
const $ecddad0aaeff3d51$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentCoordinates), {
                x: currentCoordinates.x + 25
            });
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentCoordinates), {
                x: currentCoordinates.x - 25
            });
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentCoordinates), {
                y: currentCoordinates.y + 25
            });
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentCoordinates), {
                y: currentCoordinates.y - 25
            });
    }
    return undefined;
};
class $ecddad0aaeff3d51$export$44d67f2a438aeba9 {
    attach() {
        this.handleStart();
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($ecddad0aaeff3d51$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(node);
        onStart($ecddad0aaeff3d51$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $0fcec64c9b7e118d$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $ecddad0aaeff3d51$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $ecddad0aaeff3d51$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $ecddad0aaeff3d51$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $ecddad0aaeff3d51$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right && !isRight || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down && !isBottom || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $0fcec64c9b7e118d$export$e16d8520af44a096)((0, $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $ecddad0aaeff3d51$var$Listeners((0, $0fcec64c9b7e118d$export$b204af158042fbac)(target));
        this.windowListeners = new $ecddad0aaeff3d51$var$Listeners((0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
}
$ecddad0aaeff3d51$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $ecddad0aaeff3d51$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $ecddad0aaeff3d51$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $ecddad0aaeff3d51$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $ecddad0aaeff3d51$var$AbstractPointerSensor {
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.DragStart, $ecddad0aaeff3d51$var$preventDefault);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.ContextMenu, $ecddad0aaeff3d51$var$preventDefault);
        this.documentListeners.add($ecddad0aaeff3d51$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($ecddad0aaeff3d51$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($ecddad0aaeff3d51$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($ecddad0aaeff3d51$var$EventName.Click, $ecddad0aaeff3d51$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($ecddad0aaeff3d51$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $0fcec64c9b7e118d$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        const delta = (0, $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($ecddad0aaeff3d51$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($ecddad0aaeff3d51$var$isDelayConstraint(activationConstraint)) {
                if ($ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $ecddad0aaeff3d51$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $0fcec64c9b7e118d$export$b204af158042fbac)(target);
        this.documentListeners = new $ecddad0aaeff3d51$var$Listeners(this.document);
        this.listeners = new $ecddad0aaeff3d51$var$Listeners(listenerTarget);
        this.windowListeners = new $ecddad0aaeff3d51$var$Listeners((0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $0fcec64c9b7e118d$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
}
const $ecddad0aaeff3d51$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $ecddad0aaeff3d51$export$b26af955418d6638 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $0fcec64c9b7e118d$export$b204af158042fbac)(event.target);
        super(props, $ecddad0aaeff3d51$var$events, listenerTarget);
    }
}
$ecddad0aaeff3d51$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $ecddad0aaeff3d51$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $ecddad0aaeff3d51$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($ecddad0aaeff3d51$var$MouseButton || ($ecddad0aaeff3d51$var$MouseButton = {}));
class $ecddad0aaeff3d51$export$b28554b50bf7f273 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        super(props, $ecddad0aaeff3d51$var$events$1, (0, $0fcec64c9b7e118d$export$b204af158042fbac)(props.event.target));
    }
}
$ecddad0aaeff3d51$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $ecddad0aaeff3d51$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $ecddad0aaeff3d51$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $ecddad0aaeff3d51$export$19b41baf2e1bcdc0 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($ecddad0aaeff3d51$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($ecddad0aaeff3d51$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
    constructor(props){
        super(props, $ecddad0aaeff3d51$var$events$2);
    }
}
$ecddad0aaeff3d51$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $ecddad0aaeff3d51$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($ecddad0aaeff3d51$export$eefe60e26f04c318 || ($ecddad0aaeff3d51$export$eefe60e26f04c318 = {}));
var $ecddad0aaeff3d51$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($ecddad0aaeff3d51$export$f93aa492a37e1b0e || ($ecddad0aaeff3d51$export$f93aa492a37e1b0e = {}));
function $ecddad0aaeff3d51$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $ecddad0aaeff3d51$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $ecddad0aaeff3d51$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $ecddad0aaeff3d51$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $0fcec64c9b7e118d$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $7fPBF.useMemo)(()=>{
        switch(activator){
            case $ecddad0aaeff3d51$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $ecddad0aaeff3d51$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $7fPBF.useRef)(null);
    const autoScroll = (0, $7fPBF.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $7fPBF.useMemo)(()=>order === $ecddad0aaeff3d51$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $ecddad0aaeff3d51$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $ecddad0aaeff3d51$var$defaultScrollIntent = {
    x: {
        [$ecddad0aaeff3d51$var$Direction.Backward]: false,
        [$ecddad0aaeff3d51$var$Direction.Forward]: false
    },
    y: {
        [$ecddad0aaeff3d51$var$Direction.Backward]: false,
        [$ecddad0aaeff3d51$var$Direction.Forward]: false
    }
};
function $ecddad0aaeff3d51$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $0fcec64c9b7e118d$export$5cae361ad82dce8b)(delta);
    return (0, $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $ecddad0aaeff3d51$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$ecddad0aaeff3d51$var$Direction.Backward]: previousIntent.x[$ecddad0aaeff3d51$var$Direction.Backward] || direction.x === -1,
                [$ecddad0aaeff3d51$var$Direction.Forward]: previousIntent.x[$ecddad0aaeff3d51$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$ecddad0aaeff3d51$var$Direction.Backward]: previousIntent.y[$ecddad0aaeff3d51$var$Direction.Backward] || direction.y === -1,
                [$ecddad0aaeff3d51$var$Direction.Forward]: previousIntent.y[$ecddad0aaeff3d51$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $ecddad0aaeff3d51$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $ecddad0aaeff3d51$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $7fPBF.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $ecddad0aaeff3d51$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($ecddad0aaeff3d51$export$571c10ffffe014ab || ($ecddad0aaeff3d51$export$571c10ffffe014ab = {}));
var $ecddad0aaeff3d51$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($ecddad0aaeff3d51$export$8e062c3160beefd5 || ($ecddad0aaeff3d51$export$8e062c3160beefd5 = {}));
const $ecddad0aaeff3d51$var$defaultValue = /*#__PURE__*/ new Map();
function $ecddad0aaeff3d51$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $7fPBF.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $7fPBF.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $0fcec64c9b7e118d$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $7fPBF.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $7fPBF.useRef)(null);
    const droppableRects = (0, $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $ecddad0aaeff3d51$var$defaultValue;
        if (!previousValue || previousValue === $ecddad0aaeff3d51$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $ecddad0aaeff3d51$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $7fPBF.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $ecddad0aaeff3d51$export$571c10ffffe014ab.Always:
                return false;
            case $ecddad0aaeff3d51$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $ecddad0aaeff3d51$var$useInitialValue(value, computeFn) {
    return (0, $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $ecddad0aaeff3d51$var$useInitialRect(node, measure) {
    return $ecddad0aaeff3d51$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $ecddad0aaeff3d51$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $0fcec64c9b7e118d$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $7fPBF.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $ecddad0aaeff3d51$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $0fcec64c9b7e118d$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $7fPBF.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $ecddad0aaeff3d51$var$defaultMeasure(element) {
    return new $ecddad0aaeff3d51$var$Rect($ecddad0aaeff3d51$export$b6aa1f30c53d7454(element), element);
}
function $ecddad0aaeff3d51$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$var$defaultMeasure;
    const [rect, setRect] = (0, $7fPBF.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $ecddad0aaeff3d51$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: measureRect
    });
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $ecddad0aaeff3d51$var$useRectDelta(rect) {
    const initialRect = $ecddad0aaeff3d51$var$useInitialValue(rect);
    return $ecddad0aaeff3d51$var$getRectDelta(rect, initialRect);
}
const $ecddad0aaeff3d51$var$defaultValue$1 = [];
function $ecddad0aaeff3d51$var$useScrollableAncestors(node) {
    const previousNode = (0, $7fPBF.useRef)(node);
    const ancestors = (0, $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $ecddad0aaeff3d51$var$defaultValue$1;
        if (previousValue && previousValue !== $ecddad0aaeff3d51$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $ecddad0aaeff3d51$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $7fPBF.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $ecddad0aaeff3d51$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $7fPBF.useState)(null);
    const prevElements = (0, $7fPBF.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $7fPBF.useCallback)((event)=>{
        const scrollingElement = $ecddad0aaeff3d51$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $ecddad0aaeff3d51$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $ecddad0aaeff3d51$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $ecddad0aaeff3d51$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $ecddad0aaeff3d51$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $7fPBF.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $0fcec64c9b7e118d$export$e16d8520af44a096)(acc, coordinates), $ecddad0aaeff3d51$export$597cbd7bbd10deb4) : $ecddad0aaeff3d51$var$getScrollOffsets(elements);
        return $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $7fPBF.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
}
function $ecddad0aaeff3d51$var$useSensorSetup(sensors) {
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $0fcec64c9b7e118d$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $ecddad0aaeff3d51$var$useSyntheticListeners(listeners, id) {
    return (0, $7fPBF.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $ecddad0aaeff3d51$var$useWindowRect(element) {
    return (0, $7fPBF.useMemo)(()=>element ? $ecddad0aaeff3d51$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $ecddad0aaeff3d51$var$defaultValue$2 = [];
function $ecddad0aaeff3d51$var$useRects(elements, measure) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $ecddad0aaeff3d51$var$useWindowRect(firstElement ? (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $7fPBF.useState)($ecddad0aaeff3d51$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $ecddad0aaeff3d51$var$defaultValue$2;
            return elements.map((element)=>$ecddad0aaeff3d51$var$isDocumentScrollingElement(element) ? windowRect : new $ecddad0aaeff3d51$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: measureRects
    });
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $ecddad0aaeff3d51$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $0fcec64c9b7e118d$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $ecddad0aaeff3d51$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $7fPBF.useState)(null);
    const handleResize = (0, $7fPBF.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $0fcec64c9b7e118d$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rect), {
                    width: newRect.width,
                    height: newRect.height
                }) : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $7fPBF.useCallback)((element)=>{
        const node = $ecddad0aaeff3d51$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $0fcec64c9b7e118d$export$bc23c270f170c912)(handleNodeChange);
    return (0, $7fPBF.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $ecddad0aaeff3d51$var$defaultSensors = [
    {
        sensor: $ecddad0aaeff3d51$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $ecddad0aaeff3d51$export$44d67f2a438aeba9,
        options: {}
    }
];
const $ecddad0aaeff3d51$var$defaultData = {
    current: {}
};
const $ecddad0aaeff3d51$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $ecddad0aaeff3d51$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $ecddad0aaeff3d51$var$getTransformAgnosticClientRect,
        strategy: $ecddad0aaeff3d51$export$571c10ffffe014ab.WhileDragging,
        frequency: $ecddad0aaeff3d51$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $ecddad0aaeff3d51$export$b6aa1f30c53d7454
    }
};
class $ecddad0aaeff3d51$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $ecddad0aaeff3d51$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $ecddad0aaeff3d51$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $ecddad0aaeff3d51$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $ecddad0aaeff3d51$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $ecddad0aaeff3d51$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $ecddad0aaeff3d51$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $ecddad0aaeff3d51$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $ecddad0aaeff3d51$var$noop
};
const $ecddad0aaeff3d51$var$InternalContext = /*#__PURE__*/ (0, $7fPBF.createContext)($ecddad0aaeff3d51$var$defaultInternalContext);
const $ecddad0aaeff3d51$var$PublicContext = /*#__PURE__*/ (0, $7fPBF.createContext)($ecddad0aaeff3d51$var$defaultPublicContext);
function $ecddad0aaeff3d51$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $ecddad0aaeff3d51$var$DroppableContainersMap()
        }
    };
}
function $ecddad0aaeff3d51$var$reducer(state, action) {
    switch(action.type){
        case $ecddad0aaeff3d51$var$Action.DragStart:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                draggable: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.draggable), {
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                })
            });
        case $ecddad0aaeff3d51$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                draggable: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.draggable), {
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                })
            });
        case $ecddad0aaeff3d51$var$Action.DragEnd:
        case $ecddad0aaeff3d51$var$Action.DragCancel:
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                draggable: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.draggable), {
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                })
            });
        case $ecddad0aaeff3d51$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    droppable: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.droppable), {
                        containers: containers
                    })
                });
            }
        case $ecddad0aaeff3d51$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, element), {
                    disabled: disabled
                }));
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    droppable: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.droppable), {
                        containers: containers
                    })
                });
            }
        case $ecddad0aaeff3d51$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                    droppable: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.droppable), {
                        containers: containers
                    })
                });
            }
        default:
            return state;
    }
}
function $ecddad0aaeff3d51$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const previousActivatorEvent = (0, $0fcec64c9b7e118d$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $0fcec64c9b7e118d$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $7fPBF.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $0fcec64c9b7e118d$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $0fcec64c9b7e118d$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform } = _ref, args = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
        "transform"
    ]);
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            transform: accumulator
        }, args));
    }, transform) : transform;
}
function $ecddad0aaeff3d51$var$useMeasuringConfiguration(config) {
    return (0, $7fPBF.useMemo)(()=>({
            draggable: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$var$defaultMeasuringConfiguration.draggable, config == null ? void 0 : config.draggable),
            droppable: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$var$defaultMeasuringConfiguration.droppable, config == null ? void 0 : config.droppable),
            dragOverlay: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$var$defaultMeasuringConfiguration.dragOverlay, config == null ? void 0 : config.dragOverlay)
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $ecddad0aaeff3d51$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $7fPBF.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $ecddad0aaeff3d51$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $ecddad0aaeff3d51$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $ecddad0aaeff3d51$var$ActiveDraggableContext = /*#__PURE__*/ (0, $7fPBF.createContext)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$export$597cbd7bbd10deb4), {
    scaleX: 1,
    scaleY: 1
}));
var $ecddad0aaeff3d51$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($ecddad0aaeff3d51$var$Status || ($ecddad0aaeff3d51$var$Status = {}));
const $ecddad0aaeff3d51$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $7fPBF.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $ecddad0aaeff3d51$var$defaultSensors, collisionDetection: collisionDetection = $ecddad0aaeff3d51$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers } = _ref, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
        "id",
        "accessibility",
        "autoScroll",
        "children",
        "sensors",
        "collisionDetection",
        "measuring",
        "modifiers"
    ]);
    const store = (0, $7fPBF.useReducer)($ecddad0aaeff3d51$var$reducer, undefined, $ecddad0aaeff3d51$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $ecddad0aaeff3d51$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $7fPBF.useState)($ecddad0aaeff3d51$var$Status.Uninitialized);
    const isInitialized = status === $ecddad0aaeff3d51$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $7fPBF.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $7fPBF.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $ecddad0aaeff3d51$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $7fPBF.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $7fPBF.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $7fPBF.useState)(null);
    const latestProps = (0, $0fcec64c9b7e118d$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $0fcec64c9b7e118d$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $7fPBF.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $ecddad0aaeff3d51$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $ecddad0aaeff3d51$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $ecddad0aaeff3d51$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $7fPBF.useMemo)(()=>activatorEvent ? (0, $0fcec64c9b7e118d$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $ecddad0aaeff3d51$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $ecddad0aaeff3d51$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $ecddad0aaeff3d51$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $ecddad0aaeff3d51$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $7fPBF.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $ecddad0aaeff3d51$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $ecddad0aaeff3d51$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $ecddad0aaeff3d51$var$useWindowRect(draggingNode ? (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $ecddad0aaeff3d51$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $ecddad0aaeff3d51$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $0fcec64c9b7e118d$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $ecddad0aaeff3d51$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $0fcec64c9b7e118d$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $ecddad0aaeff3d51$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $ecddad0aaeff3d51$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $7fPBF.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $0fcec64c9b7e118d$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $ecddad0aaeff3d51$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $7fPBF.useRef)(null);
    const instantiateSensor = (0, $7fPBF.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $fw0lo.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($ecddad0aaeff3d51$var$Status.Initializing);
                    dispatch({
                        type: $ecddad0aaeff3d51$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $ecddad0aaeff3d51$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($ecddad0aaeff3d51$var$Action.DragEnd),
            onCancel: createHandler($ecddad0aaeff3d51$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $ecddad0aaeff3d51$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $ecddad0aaeff3d51$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $fw0lo.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($ecddad0aaeff3d51$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $ecddad0aaeff3d51$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $7fPBF.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $ecddad0aaeff3d51$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $ecddad0aaeff3d51$var$useSensorSetup(sensors);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $ecddad0aaeff3d51$var$Status.Initializing) setStatus($ecddad0aaeff3d51$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $ecddad0aaeff3d51$var$useAutoScroller((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, autoScrollOptions), {
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    }));
    const publicContext = (0, $7fPBF.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $7fPBF.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$Accessibility, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, accessibility), {
        hiddenTextDescribedById: draggableDescribedById
    })));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, autoScroll), {
            enabled: enabled
        });
        return {
            enabled: enabled
        };
    }
});
const $ecddad0aaeff3d51$var$NullContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $ecddad0aaeff3d51$var$defaultRole = 'button';
const $ecddad0aaeff3d51$var$ID_PREFIX = 'Draggable';
function $ecddad0aaeff3d51$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $0fcec64c9b7e118d$export$c485849f2e393253)($ecddad0aaeff3d51$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const { role: role = $ecddad0aaeff3d51$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $7fPBF.useContext)(isDragging ? $ecddad0aaeff3d51$var$ActiveDraggableContext : $ecddad0aaeff3d51$var$NullContext);
    const [node, setNodeRef] = (0, $0fcec64c9b7e118d$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $0fcec64c9b7e118d$export$bc23c270f170c912)();
    const listeners = $ecddad0aaeff3d51$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $0fcec64c9b7e118d$export$86c4283a11f23f95)(data);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $7fPBF.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $ecddad0aaeff3d51$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $ecddad0aaeff3d51$export$4930f6bf413be70e() {
    return (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$PublicContext);
}
const $ecddad0aaeff3d51$var$ID_PREFIX$1 = 'Droppable';
const $ecddad0aaeff3d51$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $ecddad0aaeff3d51$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $0fcec64c9b7e118d$export$c485849f2e393253)($ecddad0aaeff3d51$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const previous = (0, $7fPBF.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $7fPBF.useRef)(false);
    const rect = (0, $7fPBF.useRef)(null);
    const callbackId = (0, $7fPBF.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$var$defaultResizeObserverConfig, resizeObserverConfig);
    const ids = (0, $0fcec64c9b7e118d$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $7fPBF.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $7fPBF.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $0fcec64c9b7e118d$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $0fcec64c9b7e118d$export$86c4283a11f23f95)(data);
    (0, $7fPBF.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $7fPBF.useEffect)(()=>{
        dispatch({
            type: $ecddad0aaeff3d51$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $ecddad0aaeff3d51$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $ecddad0aaeff3d51$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $ecddad0aaeff3d51$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $7fPBF.useState)(null);
    const [element, setElement] = (0, $7fPBF.useState)(null);
    const previousChildren = (0, $0fcec64c9b7e118d$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children, clonedChildren ? (0, $7fPBF.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $ecddad0aaeff3d51$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $ecddad0aaeff3d51$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$InternalContext.Provider, {
        value: $ecddad0aaeff3d51$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$ActiveDraggableContext.Provider, {
        value: $ecddad0aaeff3d51$var$defaultTransform
    }, children));
}
const $ecddad0aaeff3d51$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $ecddad0aaeff3d51$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $0fcec64c9b7e118d$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $ecddad0aaeff3d51$var$PositionedOverlay = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $ecddad0aaeff3d51$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transform), {
        scaleX: 1,
        scaleY: 1
    });
    const styles = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$var$baseStyles), {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $ecddad0aaeff3d51$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition
    }), style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $ecddad0aaeff3d51$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $ecddad0aaeff3d51$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $ecddad0aaeff3d51$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $ecddad0aaeff3d51$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $ecddad0aaeff3d51$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $ecddad0aaeff3d51$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $0fcec64c9b7e118d$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $ecddad0aaeff3d51$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $0fcec64c9b7e118d$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $ecddad0aaeff3d51$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $ecddad0aaeff3d51$var$createDefaultDropAnimation(config);
        $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $ecddad0aaeff3d51$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $ecddad0aaeff3d51$export$10f7ab1c653bb60e, options);
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform } = _ref4, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref4, [
            "active",
            "dragOverlay",
            "transform"
        ]);
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            x: transform.x - delta.x,
            y: transform.y - delta.y
        }, scale);
        const animationKeyframes = keyframes((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        }));
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            active: active,
            dragOverlay: dragOverlay
        }, rest));
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $ecddad0aaeff3d51$var$key = 0;
function $ecddad0aaeff3d51$var$useKey(id) {
    return (0, $7fPBF.useMemo)(()=>{
        if (id == null) return;
        $ecddad0aaeff3d51$var$key++;
        return $ecddad0aaeff3d51$var$key;
    }, [
        id
    ]);
}
const $ecddad0aaeff3d51$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $ecddad0aaeff3d51$export$4930f6bf413be70e();
    const transform = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$ActiveDraggableContext);
    const key = $ecddad0aaeff3d51$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $ecddad0aaeff3d51$var$useInitialValue(activeNodeRect);
    const dropAnimation = $ecddad0aaeff3d51$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            zIndex: zIndex
        }, style),
        transform: modifiedTransform
    }, children) : null));
});





var $7fPBF = parcelRequire("7fPBF");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $a14476affb27f7d7$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $a14476affb27f7d7$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $a14476affb27f7d7$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $a14476affb27f7d7$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $a14476affb27f7d7$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $a14476affb27f7d7$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $a14476affb27f7d7$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $a14476affb27f7d7$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $a14476affb27f7d7$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0
        }, $a14476affb27f7d7$var$defaultScale);
    }
    if (index > activeIndex && index <= overIndex) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        x: -activeNodeRect.width - itemGap,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale);
    if (index < activeIndex && index >= overIndex) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        x: activeNodeRect.width + itemGap,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        x: 0,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale);
};
function $a14476affb27f7d7$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $a14476affb27f7d7$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $a14476affb27f7d7$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $a14476affb27f7d7$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $a14476affb27f7d7$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $a14476affb27f7d7$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top
        }, $a14476affb27f7d7$var$defaultScale$1);
    }
    const itemGap = $a14476affb27f7d7$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        x: 0,
        y: -activeNodeRect.height - itemGap
    }, $a14476affb27f7d7$var$defaultScale$1);
    if (index < activeIndex && index >= overIndex) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        x: 0,
        y: activeNodeRect.height + itemGap
    }, $a14476affb27f7d7$var$defaultScale$1);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        x: 0,
        y: 0
    }, $a14476affb27f7d7$var$defaultScale$1);
};
function $a14476affb27f7d7$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $a14476affb27f7d7$var$ID_PREFIX = 'Sortable';
const $a14476affb27f7d7$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    activeIndex: -1,
    containerId: $a14476affb27f7d7$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $a14476affb27f7d7$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $a14476affb27f7d7$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $a14476affb27f7d7$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $ecddad0aaeff3d51$export$4930f6bf413be70e)();
    const containerId = (0, $0fcec64c9b7e118d$export$c485849f2e393253)($a14476affb27f7d7$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $7fPBF.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $7fPBF.useRef)(items);
    const itemsHaveChanged = !$a14476affb27f7d7$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $a14476affb27f7d7$var$normalizeDisabled(disabledProp);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $a14476affb27f7d7$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a14476affb27f7d7$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $a14476affb27f7d7$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $a14476affb27f7d7$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $a14476affb27f7d7$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $a14476affb27f7d7$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $a14476affb27f7d7$var$transitionProperty = 'transform';
const $a14476affb27f7d7$var$disabledTransition = /*#__PURE__*/ (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transition.toString({
    property: $a14476affb27f7d7$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $a14476affb27f7d7$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $a14476affb27f7d7$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $7fPBF.useState)(null);
    const previousIndex = (0, $7fPBF.useRef)(index);
    (0, $0fcec64c9b7e118d$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $ecddad0aaeff3d51$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $a14476affb27f7d7$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $a14476affb27f7d7$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $a14476affb27f7d7$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $a14476affb27f7d7$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $7fPBF.useContext)($a14476affb27f7d7$var$Context);
    const disabled = $a14476affb27f7d7$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $7fPBF.useMemo)(()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            }
        }, customData), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $7fPBF.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $ecddad0aaeff3d51$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            updateMeasurementsFor: itemsAfterCurrentSortable
        }, resizeObserverConfig)
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $ecddad0aaeff3d51$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $a14476affb27f7d7$var$defaultAttributes, userDefinedAttributes),
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $0fcec64c9b7e118d$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $a14476affb27f7d7$var$isValidIndex(activeIndex) && $a14476affb27f7d7$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $a14476affb27f7d7$var$isValidIndex(activeIndex) && $a14476affb27f7d7$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $7fPBF.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $a14476affb27f7d7$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $7fPBF.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $a14476affb27f7d7$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $0fcec64c9b7e118d$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transition.toString((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, transition), {
            property: $a14476affb27f7d7$var$transitionProperty
        }));
        return undefined;
    }
}
function $a14476affb27f7d7$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $a14476affb27f7d7$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $a14476affb27f7d7$var$directions = [
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Down,
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Right,
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Up,
    (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Left
];
const $a14476affb27f7d7$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($a14476affb27f7d7$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $ecddad0aaeff3d51$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $ecddad0aaeff3d51$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $ecddad0aaeff3d51$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $ecddad0aaeff3d51$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $a14476affb27f7d7$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $a14476affb27f7d7$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $a14476affb27f7d7$var$isSameContainer(a, b) {
    if (!$a14476affb27f7d7$export$6424ec8a0d450b09(a) || !$a14476affb27f7d7$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $a14476affb27f7d7$var$isAfter(a, b) {
    if (!$a14476affb27f7d7$export$6424ec8a0d450b09(a) || !$a14476affb27f7d7$export$6424ec8a0d450b09(b)) return false;
    if (!$a14476affb27f7d7$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}












function $448dc6a495bf7e71$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M14 5.75c0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5.68 1.5 1.5 1.5 1.5-.68 1.5-1.5m0 4.5c0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5.68 1.5 1.5 1.5 1.5-.68 1.5-1.5m-4.5-4.5c0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5.68 1.5 1.5 1.5 1.5-.68 1.5-1.5m0 4.5c0-.82-.68-1.5-1.5-1.5s-1.5.68-1.5 1.5.68 1.5 1.5 1.5 1.5-.68 1.5-1.5M5 5.75c0-.82-.68-1.5-1.5-1.5S2 4.93 2 5.75s.68 1.5 1.5 1.5S5 6.57 5 5.75m0 4.5c0-.82-.68-1.5-1.5-1.5S2 9.43 2 10.25s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5"
        })
    }));
}






function $919053d79f8175e5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
        })
    }));
}





function $6de5b66c88af01fe$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0Z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M17.457 3 21 3.003l.002 3.523-5.467 5.466 2.828 2.829 1.415-1.414 1.414 1.414-2.474 2.475 2.828 2.829-1.414 1.414-2.829-2.829-2.475 2.475-1.414-1.414 1.414-1.415-2.829-2.828-2.828 2.828 1.415 1.415-1.414 1.414-2.475-2.475-2.829 2.829-1.414-1.414 2.829-2.83-2.475-2.474 1.414-1.414 1.414 1.413 2.827-2.828-5.46-5.46L3 3l3.546.003 5.453 5.454Zm-7.58 10.406L7.05 16.234l.708.707 2.827-2.828Zm9.124-8.405h-.717l-4.87 4.869.706.707 4.881-4.879Zm-14 0v.7l11.241 11.241.707-.707L5.716 5.002Z"
            })
        ]
    }));
}


function $1051ea8fd7b386e4$var$Reason(props) {
    const { setNodeRef: setNodeRef, setActivatorNodeRef: setActivatorNodeRef, attributes: attributes, listeners: listeners, transform: transform, transition: transition } = (0, $a14476affb27f7d7$export$4ebcb6201122185a)({
        id: props.reason.id
    });
    const sortableStyle = {
        transform: (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    const reasonType = props.reason.type === "for" ? "For" : props.reason.type === "against" ? "Against" : "For/Against";
    const nonEditStatus = [
        'CG',
        'DS'
    ];
    const beginBoutStatus = [
        'Default',
        'Moot'
    ];
    const style = {
        reasonContainer: "relative p-2 border-t-2 border-zinc-900",
        reasonType: "font-semibold",
        reasonFlexBox: "my-2 flex flex-col",
        reasonControls: "absolute top-2 right-1 flex justify-center gap-x-2",
        reasonControlItem: "cursor-pointer",
        status: {
            container: "flex absolute top-3 left-2 gap-x-2 items-center",
            text: "text-xs"
        },
        icon: {
            moveButton: "w-[22px] cursor-grab",
            button: "p-0.5 border border-black/50 rounded-md w-[24px] cursor-pointer",
            edit: "hover:bg-slate-300",
            delete: "hover:bg-red-600"
        },
        controlGroup: "flex justify-center gap-2.5",
        button: "font-bold mb-2 px-4 py-1 text-sm text-slate-50 rounded-full bg-violet-700 hover:bg-violet-800 cursor-pointer"
    };
    function openConfirmationModal(type) {
        let action = {
            type: type
        };
        if (type == 'delRtp') action.data = {
            playerId: props.playerId,
            reasonId: props.reason.id,
            reason: props.reason.reason
        };
        if (type == 'moveRip') action.data = {
            playerId: props.ownerId,
            reasonId: props.reason.id,
            reason: props.reason.reason
        };
        props.openConfirmActionModal(action);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.reasonContainer, props.reason.type === "for" && "bg-lighter-blue/10", props.reason.type === "against" && "bg-persuaded-green/10"),
        ref: setNodeRef,
        style: sortableStyle
    }, attributes), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: style.reasonType,
                children: reasonType
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: props.reason.reason
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: style.status.container,
                children: [
                    props.playerId === props.ownerId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        ref: setActivatorNodeRef
                    }, listeners), {
                        "aria-label": "Move Reason",
                        className: style.icon.moveButton,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $448dc6a495bf7e71$export$2e2bcd8739ae039), {})
                    })) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: style.status.text,
                        children: [
                            "[",
                            props.reason.status,
                            "]"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: style.reasonControls,
                children: [
                    props.ownerId === props.playerId && !nonEditStatus.includes(props.reason.status) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                "aria-label": "Edit Reason",
                                className: `${style.icon.button} ${style.icon.edit}`,
                                onClick: ()=>props.openEditReasonForm("rtp", props.playerId, props.reason),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1341d22117654d3$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                "aria-label": "Delete Reason",
                                className: `${style.icon.button} ${style.icon.delete}`,
                                onClick: ()=>openConfirmationModal('delRtp'),
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $919053d79f8175e5$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }) : null,
                    props.role === "referee" && beginBoutStatus.includes(props.reason.status) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            "aria-label": "Begin Bout",
                            className: `${style.icon.button} ${style.icon.edit}`,
                            onClick: ()=>openConfirmationModal('moveRip'),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de5b66c88af01fe$export$2e2bcd8739ae039), {})
                        })
                    }) : null
                ]
            })
        ]
    }));
}
var $1051ea8fd7b386e4$export$2e2bcd8739ae039 = $1051ea8fd7b386e4$var$Reason;


function $7b7c6285051fe553$var$PlayerReasonsToPlay(props) {
    const [activeId, setActiveId] = (0, $7fPBF.useState)(null);
    const style = {
        reasonContainer: "relative m-1 p-1 w-96 flex flex-col justify-between border border-gray-400 text-center shadow rounded-lg hover:bg-gray-200",
        author: "font-bold",
        modal: "mx-auto my-44 relative w-[30%] h-60 rounded-lg overflow-hidden border-4",
        icon: {
            container: "absolute top-2 right-3 m-auto p-[3px] size-fit border border-black/90 text-center rounded-full cursor-pointer",
            icon: "w-[12px]"
        },
        reasons: "max-h-96 p-2 overflow-y-scroll"
    };
    const sensors = (0, $ecddad0aaeff3d51$export$19012f58216d597f)((0, $ecddad0aaeff3d51$export$cc72dd71f4ec69eb)((0, $ecddad0aaeff3d51$export$b26af955418d6638)), (0, $ecddad0aaeff3d51$export$cc72dd71f4ec69eb)((0, $ecddad0aaeff3d51$export$19b41baf2e1bcdc0)));
    function handleDragStart(event) {
        const { active: active } = event;
        setActiveId(active.id);
    }
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        if (active.id !== over.id) {
            const oldIndex = props.reasonToPlay.reasons.findIndex((reason)=>reason.id === active.id);
            const newIndex = props.reasonToPlay.reasons.findIndex((reason)=>reason.id === over.id);
            const reasons = (0, $a14476affb27f7d7$export$5d49d615ad5ea2b0)(props.reasonToPlay.reasons, oldIndex, newIndex);
            const updatedReasons = reasons.map((reason, index)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, reason), {
                    priority: index
                }));
            const priorityList = updatedReasons.map((reason)=>({
                    reasonId: reason.id,
                    priority: reason.priority
                }));
            const newReasonToPlay = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.reasonToPlay), {
                reasons: updatedReasons
            });
            props.updateReasonPriorities(newReasonToPlay, priorityList);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: style.reasonContainer,
        children: [
            props.playerId === props.reasonToPlay.id ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                "aria-label": "Add Reason",
                className: style.icon.container,
                onClick: props.openEditReasonModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee5e0c44e56cee9f$export$2e2bcd8739ae039), {
                    className: style.icon.icon
                })
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col flex-wrap justify-around",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: style.author,
                        children: props.reasonToPlay.playerName
                    }),
                    props.playerId === props.reasonToPlay.id ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$2d5c5ceac203fc1e), {
                                sensors: sensors,
                                collisionDetection: (0, $ecddad0aaeff3d51$export$c8e785ae6b74bab8),
                                onDragStart: handleDragStart,
                                onDragEnd: handleDragEnd,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a14476affb27f7d7$export$86155fde54f06e6a), {
                                    items: props.reasonToPlay.reasons,
                                    strategy: (0, $a14476affb27f7d7$export$fe2be640df2ffb9e),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: style.reasons,
                                        children: props.reasonToPlay.reasons.map((reason)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1051ea8fd7b386e4$export$2e2bcd8739ae039), {
                                                role: props.role,
                                                playerId: props.playerId,
                                                ownerId: props.reasonToPlay.id,
                                                reason: reason,
                                                openEditReasonForm: props.openEditReasonForm,
                                                openConfirmActionModal: props.openConfirmActionModal
                                            }, reason.id))
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$aca73479aa40659d), {
                                children: activeId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1051ea8fd7b386e4$export$2e2bcd8739ae039), {
                                    id: activeId
                                }) : null
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: style.reasons,
                        children: props.reasonToPlay.reasons.map((reason)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1051ea8fd7b386e4$export$2e2bcd8739ae039), {
                                role: props.role,
                                playerId: props.playerId,
                                ownerId: props.reasonToPlay.id,
                                reason: reason,
                                openEditReasonForm: props.openEditReasonForm,
                                openConfirmActionModal: props.openConfirmActionModal,
                                handlePin: props.handlePin
                            }, reason.id))
                    })
                ]
            })
        ]
    });
}
var $7b7c6285051fe553$export$2e2bcd8739ae039 = $7b7c6285051fe553$var$PlayerReasonsToPlay;


const $5a1822bcd7b64d6a$var$style = {
    main: "relative",
    icon: {
        plusContainer: "m-auto p-[3px] size-fit border-2 text-center rounded-full cursor-pointer",
        plus: "w-[12px]"
    },
    setContainer: "m-3 flex flex-row flex-wrap justify-between gap-3",
    header: "mb-2 mt-1 text-2xl font-bold text-center text-gray-800",
    reasonContainer: "m-1 p-2 w-96 h-fit flex flex-col justify-between border border-gray-400 text-center shadow rounded-lg hover:bg-gray-200"
};
function $5a1822bcd7b64d6a$var$ReasonsToPlay(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: $5a1822bcd7b64d6a$var$style.header,
                children: "Reasons-2-Play (R2P)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                "aria-label": "Add Reason",
                className: $5a1822bcd7b64d6a$var$style.icon.plusContainer,
                onClick: props.openEditReasonModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ee5e0c44e56cee9f$export$2e2bcd8739ae039), {
                    className: $5a1822bcd7b64d6a$var$style.icon.plus
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: $5a1822bcd7b64d6a$var$style.setContainer,
                children: props.reasonsToPlay.map((reasonToPlay)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7b7c6285051fe553$export$2e2bcd8739ae039), {
                        role: props.role,
                        playerId: props.playerId,
                        reasonToPlay: reasonToPlay,
                        updateReasonPriorities: props.updateReasonPriorities,
                        openEditReasonForm: props.openEditReasonForm,
                        openEditReasonModal: props.openEditReasonModal,
                        openConfirmActionModal: props.openConfirmActionModal
                    }, reasonToPlay.id))
            })
        ]
    });
}
var $5a1822bcd7b64d6a$export$2e2bcd8739ae039 = $5a1822bcd7b64d6a$var$ReasonsToPlay;





function $f64ccf377a426465$var$ReasonInPlay(props) {
    const style = {
        button: {
            base: "px-4 py-2 font-bold text-white rounded-lg cursor-pointer",
            moveCG: "bg-green-500 hover:bg-green-700",
            moveDS: "bg-red-500 hover:bg-red-700"
        },
        controls: "absolute top-2 right-2",
        icon: {
            button: "p-1 border border-black/50 rounded-md w-[28px] cursor-pointer",
            edit: "hover:bg-slate-300"
        },
        reasonType: "font-semibold text-xl",
        reasonText: "text-lg"
    };
    const reasonType = props.reason.type === "for" ? "For" : props.reason.type === "against" ? "Against" : "For/Against";
    const didVoteEstablished = props.reason.established.includes(props.player.id);
    const didVoteContested = props.reason.contested.includes(props.player.id);
    const didVoteNonGermane = props.reason.nonGermane.includes(props.player.id);
    function triggerOpenEditReasonForm() {
        props.openEditReasonForm("rip");
    }
    function voteEstablished(playerId) {
        props.handleEstablished(playerId);
    }
    function voteContested(playerId) {
        props.handleContested(playerId);
    }
    // function voteNonGermane(playerId) {
    // 	props.handleNonGermane(playerId);
    // }
    function openConfirmationModal(type) {
        const action = {
            type: type
        };
        props.openConfirmActionModal(action);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "relative lg:w-4/6 w-full mt-1 mr-1 mb-1 flex flex-col items-center justify-between border rounded-md",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "text-2xl font-bold text-gray-800",
                children: "Reason-in-Play"
            }),
            props.role === "referee" || props.reason.playerId === props.player.id ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: style.controls,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    "aria-label": "Edit Reason",
                    className: `${style.icon.button} ${style.icon.edit}`,
                    onClick: triggerOpenEditReasonForm,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d1341d22117654d3$export$2e2bcd8739ae039), {})
                })
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "mx-6 flex flex-col h-4/5 items-center gap-y-6",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: style.reasonType,
                        children: reasonType
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: style.reasonText,
                        children: props.reason.reason
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex justify-center gap-6",
                        children: [
                            props.role === "player" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        "aria-label": "Established",
                                        onClick: ()=>voteEstablished(props.player.id),
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button.base, !didVoteEstablished && "bg-true-blue/80 hover:bg-true-blue", didVoteEstablished && "bg-gray-600 ring-2 ring-true-blue"),
                                        children: "Established"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        "aria-label": "Contested",
                                        onClick: ()=>voteContested(props.player.id),
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button.base, !didVoteContested && "bg-primary-red/80 hover:bg-primary-red", didVoteContested && "bg-gray-600 ring-2 ring-primary-red"),
                                        children: "Contested"
                                    })
                                ]
                            }) : null,
                            props.role === "referee" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        "aria-label": "Common Ground",
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button.base, style.button.moveCG),
                                        onClick: ()=>openConfirmationModal('moveCG'),
                                        children: "Common Ground"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        "aria-label": "End Bout",
                                        className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button.base, style.button.moveDS),
                                        onClick: ()=>openConfirmationModal('moveDS'),
                                        children: "End Bout"
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
}
var $f64ccf377a426465$export$2e2bcd8739ae039 = $f64ccf377a426465$var$ReasonInPlay;







var $7fPBF = parcelRequire("7fPBF");







function $8ba7696cfcda741e$var$CommonGroundReason(props) {
    const { setNodeRef: setNodeRef, setActivatorNodeRef: setActivatorNodeRef, attributes: attributes, listeners: listeners, transform: transform, transition: transition } = (0, $a14476affb27f7d7$export$4ebcb6201122185a)({
        id: props.commonGround.id
    });
    const sortableStyle = {
        transform: (0, $0fcec64c9b7e118d$export$c4ffa16951855e28).Transform.toString(transform),
        transition: transition
    };
    const style = {
        reason: {
            item: "relative m-1 px-5 pt-5 pb-2 border-1 border-gray-800 rounded-md"
        },
        icon: {
            moveButton: "w-[22px] absolute top-1 left-1 cursor-grab",
            boutButton: "w-[24px] absolute top-1 right-1 p-0.5 border border-black/50 rounded-md hover:bg-slate-300 cursor-pointer"
        }
    };
    function openConfirmationModal(type) {
        const action = {
            type: type,
            data: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.commonGround)
        };
        props.openConfirmActionModal(action);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: setNodeRef,
        style: sortableStyle
    }, attributes), {
        className: style.reason.item,
        children: [
            props.role === "referee" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        ref: setActivatorNodeRef
                    }, listeners), {
                        "aria-label": "Move Button",
                        className: style.icon.moveButton,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $448dc6a495bf7e71$export$2e2bcd8739ae039), {})
                    })),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        "aria-label": "Begin Bout",
                        className: style.icon.boutButton,
                        onClick: ()=>openConfirmationModal('moveCG-Rip'),
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de5b66c88af01fe$export$2e2bcd8739ae039), {})
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: props.commonGround.reason
            })
        ]
    }));
}
var $8ba7696cfcda741e$export$2e2bcd8739ae039 = $8ba7696cfcda741e$var$CommonGroundReason;




function $028726ef34d110f0$var$CommonGroundGroup(props) {
    const [activeId, setActiveId] = (0, $7fPBF.useState)(null);
    const style = {
        container: "border border-gray-400 text-center rounded-lg",
        title: "rounded-md p-1.5 text-2xl font-bold text-center text-gray-800 bg-yellow-200",
        list: "max-h-128 overflow-y-scroll"
    };
    const sensors = (0, $ecddad0aaeff3d51$export$19012f58216d597f)((0, $ecddad0aaeff3d51$export$cc72dd71f4ec69eb)((0, $ecddad0aaeff3d51$export$b26af955418d6638)), (0, $ecddad0aaeff3d51$export$cc72dd71f4ec69eb)((0, $ecddad0aaeff3d51$export$19b41baf2e1bcdc0)));
    function handleDragStart(event) {
        const { active: active } = event;
        setActiveId(active.id);
    }
    let title = "";
    if (props.type === "for") title = "Case for MainClaim";
    else if (props.type === "against") title = "Case against MainClaim";
    else title = "Case for/against MainClaim";
    function handleDragStart(event) {
        const { active: active } = event;
        setActiveId(active.id);
    }
    function handleDragEnd(event) {
        const { active: active, over: over } = event;
        if (active.id !== over.id) {
            const oldIndex = props.commonGrounds.findIndex((cg)=>cg.id === active.id);
            const newIndex = props.commonGrounds.findIndex((cg)=>cg.id === over.id);
            const commonGrounds = (0, $a14476affb27f7d7$export$5d49d615ad5ea2b0)(props.commonGrounds, oldIndex, newIndex);
            const updatedCommonGrounds = commonGrounds.map((cg, index)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cg), {
                    priority: index
                }));
            const priorities = updatedCommonGrounds.map((cg)=>({
                    id: cg.id,
                    priority: cg.priority
                }));
            props.updateCommonGroundPriorities(priorities);
        }
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: style.container,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: style.title,
                children: title
            }),
            props.role == "referee" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$2d5c5ceac203fc1e), {
                        sensors: sensors,
                        collisionDetection: (0, $ecddad0aaeff3d51$export$c8e785ae6b74bab8),
                        onDragStart: handleDragStart,
                        onDragEnd: handleDragEnd,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a14476affb27f7d7$export$86155fde54f06e6a), {
                            items: props.commonGrounds,
                            strategy: (0, $a14476affb27f7d7$export$fe2be640df2ffb9e),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                                className: style.list,
                                children: props.commonGrounds.map((commonGround)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ba7696cfcda741e$export$2e2bcd8739ae039), {
                                        role: props.role,
                                        commonGround: commonGround,
                                        openConfirmActionModal: props.openConfirmActionModal
                                    }, commonGround.id))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ecddad0aaeff3d51$export$aca73479aa40659d), {
                        children: activeId ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ba7696cfcda741e$export$2e2bcd8739ae039), {
                            id: activeId
                        }) : null
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                className: style.list,
                children: props.commonGrounds.map((commonGround)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8ba7696cfcda741e$export$2e2bcd8739ae039), {
                        role: props.role,
                        commonGround: commonGround
                    }, commonGround.id))
            })
        ]
    });
}
var $028726ef34d110f0$export$2e2bcd8739ae039 = $028726ef34d110f0$var$CommonGroundGroup;


function $0d84401b8c5934a0$var$CommonGrounds(props) {
    const cgFor = props.commonGrounds.filter((cg)=>cg.type === "for");
    const cgAgainst = props.commonGrounds.filter((cg)=>cg.type === "against");
    const cgBoth = props.commonGrounds.filter((cg)=>cg.type === "both");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "m-4 flex justify-evenly gap-4",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $028726ef34d110f0$export$2e2bcd8739ae039), {
                type: "for",
                role: props.role,
                commonGrounds: cgFor,
                updateCommonGroundPriorities: props.updateCommonGroundPriorities,
                openConfirmActionModal: props.openConfirmActionModal
            }, "for"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $028726ef34d110f0$export$2e2bcd8739ae039), {
                type: "against",
                role: props.role,
                commonGrounds: cgAgainst,
                updateCommonGroundPriorities: props.updateCommonGroundPriorities,
                openConfirmActionModal: props.openConfirmActionModal
            }, "against"),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $028726ef34d110f0$export$2e2bcd8739ae039), {
                type: "both",
                role: props.role,
                commonGrounds: cgBoth,
                updateCommonGroundPriorities: props.updateCommonGroundPriorities,
                openConfirmActionModal: props.openConfirmActionModal
            }, "both")
        ]
    });
}
var $0d84401b8c5934a0$export$2e2bcd8739ae039 = $0d84401b8c5934a0$var$CommonGrounds;



function $570b8124da093576$var$Results(props) {
    const style = {
        pollsGroup: "m-4 flex flex-wrap justify-center gap-4 p-0",
        pollContainer: "flex flex-column justify-center border-2 border-zinc-800/60 shadow-lg rounded gap-2 p-2 lg:w-96 sm:shrink-0 w-[100%]",
        pollParent: "w-[100%]",
        pollTitle: "text-xl font-semibold text-center m-0 pt-0 pb-2 border-b-2 border-zinc-900",
        voteTitleGroup: "font-semibold pt-2 pb-2 flex flex-column justify-around border-b-2 border-zinc-900/50",
        votersGroup: "flex flex-column",
        votersListGroup: "flex justify-center w-[100%]",
        votersList: "text-center w-[95%]",
        voter: "py-1.5 border-b-2 border-zinc-700/50"
    };
    return props.results ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: style.pollsGroup,
                children: props.results.game.polls.map((poll, index)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: style.pollContainer,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: style.pollParent,
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: style.pollTitle,
                                    children: poll.poll === "strawpoll" ? `Strawpoll (${poll.convinced.length + poll.notPersuaded.length})` : `Endpoll (${poll.convinced.length + poll.notPersuaded.length})`
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: style.voteTitleGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                "Convinced (",
                                                poll.convinced.length,
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            children: [
                                                "Not Persuaded (",
                                                poll.notPersuaded.length,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: style.votersGroup,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: style.votersListGroup,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                className: style.votersList,
                                                children: poll.convinced.map((voter, index)=>{
                                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                        className: style.voter,
                                                        children: voter
                                                    }, index);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: style.votersListGroup,
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                className: style.votersList,
                                                children: poll.notPersuaded.map((voter, index)=>{
                                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                                        className: style.voter,
                                                        children: voter
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-column flex-wrap justify-center shadow-lg p-4 rounded mt-2 gap-4",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "bg-green-50 shadow-lg rounded-lg p-2 border-2 lg:w-96 sm:shrink-0 w-[100%]",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-xl text-center font-semibold py-1",
                                children: "Not Persuaded to Convinced"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex flex-col text-center",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                    className: "text-lg font-serif",
                                    children: props.results.winners && props.results.winners.convinced ? props.results.winners.convinced.map((winner, index)=>{
                                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                            className: "my-2.5 py-1 hover:bg-green-200 focus:ring-2 hover:shadow-lg rounded-md border-2",
                                            children: winner
                                        }, index);
                                    }) : null
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "bg-red-50 shadow-lg rounded-lg p-2 border-2 lg:w-96 sm:shrink-0 w-[100%]",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "text-xl text-center font-semibold py-1",
                                children: "Convinced to Not Persuaded"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "flex flex-col text-center",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                    className: "text-lg font-serif",
                                    children: props.results.winners && props.results.winners.notPersuaded ? props.results.winners.notPersuaded.map((winner, index)=>{
                                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                            className: "my-2.5 py-1 hover:bg-red-200 focus:ring-2 hover:shadow-lg rounded-md border-2",
                                            children: winner
                                        }, index);
                                    }) : null
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }) : null;
}
var $570b8124da093576$export$2e2bcd8739ae039 = $570b8124da093576$var$Results;




var $7fPBF = parcelRequire("7fPBF");

function $69ef09815302c66d$var$EditReason(props) {
    const maxReasonLimit = 210;
    const [editedReason, setEditedReason] = (0, $7fPBF.useState)("");
    const [editedType, setEditedType] = (0, $7fPBF.useState)("for");
    const [displayLimit, setDisplayLimit] = (0, $7fPBF.useState)(maxReasonLimit);
    const reasonTextareaRef = (0, $7fPBF.useRef)(null);
    const isReasonValid = editedReason && editedReason.length >= 20 ? true : false;
    const style = {
        main: "z-4 fixed top-1/2 left-1/2 -translate-1/2 h-6/10 w-[95%] lg:h-6/10 lg:w-5/10 p-2 text-center bg-slate-50 border-2 border-blue-400 rounded-lg",
        icon: {
            container: "absolute top-[10px] right-[10px] p-1 border-2 border-zinc-700 bg-zinc-200 hover:bg-zinc-400 rounded-full cursor-pointer",
            icon: "w-[18px]"
        },
        select: "p-1 block text-center text-gray-700 bg-white border-[2px] rounded-md border-sky-500 focus:border-sky-500 focus:border-[3px]",
        caseContainer: "m-1 p-1 flex flex-row justify-center items-center gap-2",
        button: "px-4 py-2 rounded font-bold text-slate-100 cursor-pointer",
        textarea: "lg:h-52 h-64 w-[85%] resize-none mt-1 mb-1 p-3 form-textarea rounded border-2 border-cyan-600 focus:border-3 focus:border-cyan-700",
        radio: "cursor-pointer",
        option: "flex items-start gap-x-[10px]",
        optionTitle: "font-semibold"
    };
    (0, $7fPBF.useEffect)(()=>{
        if (props.reason) {
            setEditedReason(props.reason.reason);
            setEditedType(props.reason.type);
        }
        if (reasonTextareaRef.current) reasonTextareaRef.current.focus();
    }, [
        props.reason
    ]);
    function handleEditReason(event) {
        setEditedReason(event.target.value);
        setDisplayLimit(maxReasonLimit - event.target.value.length);
    }
    function updateReason() {
        if (isReasonValid) {
            const _reason = {
                reason: editedReason,
                type: editedType
            };
            if (props.reason) {
                if (props.reasonType === "rtp") props.updateReasonToPlay(props.player.id, props.reason.id, _reason);
                else props.updateReasonInPlay(props.reason.playerId, props.reason.id, _reason);
            } else props.sendNewReasonToPlay(_reason);
            setEditedReason("");
            setEditedType("for");
            setDisplayLimit(maxReasonLimit);
            props.removeReasonToEdit();
            props.closeModal();
        }
    }
    function changeEditedType(event) {
        setEditedType(event.target.value);
    }
    function clearReasonToPlay() {
        setEditedReason("");
        setEditedType("for");
        props.removeReasonToEdit();
        props.closeModal();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: style.main,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: style.icon.container,
                onClick: props.closeModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c0c02b40f78101$export$2e2bcd8739ae039), {
                    className: style.icon.icon
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "mt-[5%] mb-2 lg:text-2xl text-base font-bold text-center text-gray-800",
                children: "Suggest/Edit a Reason-2-Play (R2P)"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex-col text-center",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("legend", {
                        className: "block mb-2 text-center text-gray-700 lg:text-base text-xs",
                        children: [
                            "Enter Reason for or against the main claim (",
                            displayLimit,
                            "). Submit reasons one-by-one so each can be voted on individually"
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                        className: style.textarea,
                        value: editedReason,
                        onChange: handleEditReason,
                        maxLength: maxReasonLimit,
                        ref: reasonTextareaRef,
                        placeholder: "Submit your Reason for or against the Main Claim. Use only one single sentence (truth-claim) per Reason"
                    }),
                    editedReason && !isReasonValid ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        children: "Reason must be at least 20 characters in length"
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: style.caseContainer,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: style.optionTitle,
                                children: "Argument: "
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: style.option,
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "radio",
                                                name: "argumentType",
                                                value: "for",
                                                className: style.radio,
                                                checked: editedType === "for",
                                                onChange: changeEditedType
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                children: " For"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "radio",
                                                name: "argumentType",
                                                value: "against",
                                                className: style.radio,
                                                checked: editedType === "against",
                                                onChange: changeEditedType
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                children: " Against"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "radio",
                                                name: "argumentType",
                                                value: "both",
                                                className: style.radio,
                                                checked: editedType === "both",
                                                onChange: changeEditedType
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                                children: " For/Against"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex my-2 gap-6 justify-center",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                className: `${style.button} bg-blue-600 hover:bg-blue-700`,
                                onClick: updateReason,
                                children: "Submit"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: clearReasonToPlay,
                                className: `${style.button} bg-red-600 hover:bg-red-700`,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $69ef09815302c66d$export$2e2bcd8739ae039 = $69ef09815302c66d$var$EditReason;





function $d6dafcd4d41f63b9$var$ConfirmAction(props) {
    const style = {
        reason: "m-2",
        button: "py-1 px-4 font-bold text-slate-100 rounded-full cursor-pointer"
    };
    const actionsToDisplayReasons = [
        'delRtp',
        'moveRip'
    ];
    const type = props.action.type;
    let confirmMsg = "";
    let confirmBtn = "";
    let reasonTxt = "";
    let confirmBtnStyle = "bg-red-500 hover:bg-red-700";
    let cancelBtnStyle = "bg-zinc-400 hover:bg-zinc-600";
    switch(type){
        case 'delRtp':
            confirmMsg = "Are you sure you want to delete:";
            confirmBtn = "Delete";
            reasonTxt = props.action.data.reason;
            confirmBtnStyle = "bg-red-500 hover:bg-red-700";
            cancelBtnStyle = "bg-green-500 hover:bg-green-700";
            break;
        case 'moveRip':
            confirmMsg = "Do you want to move this Reason to a Reason-in-Play?";
            confirmBtn = "Begin Bout";
            reasonTxt = props.action.data.reason;
            confirmBtnStyle = "bg-blue-500 hover:bg-blue-700";
            break;
        case 'moveCG':
            confirmMsg = "Do you want to move the Reason-in-Play to Common Ground?";
            confirmBtn = "Common Ground";
            confirmBtnStyle = "bg-green-500 hover:bg-green-700";
            break;
        case 'moveDS':
            confirmMsg = "Do you want to end this bout?";
            confirmBtn = "End Bout";
            break;
        case 'moveCG-Rip':
            confirmMsg = "Do you want to move this Common Ground back in Play?";
            confirmBtn = "Reason-in-Play";
            reasonTxt = props.action.data.reason;
            confirmBtnStyle = "bg-green-500 hover:bg-green-700";
            break;
        default:
            confirmMsg = "Are you sure you want to perform this action";
            confirmBtn = "Confirm";
    }
    function handleAction() {
        switch(type){
            case 'delRtp':
                props.deleteReason(props.action.data);
                break;
            case 'moveRip':
                props.moveToReasonInPlay(props.action.data.playerId, props.action.data.reasonId);
                break;
            case 'moveCG':
                props.handleMoveRIPToCommonGround();
                break;
            case 'moveDS':
                props.handleMoveRIPToDissensus();
                break;
            case 'moveCG-Rip':
                props.handleMoveCommonGroundToReasonInPlay(props.action.data.id);
                break;
            default:
                confirmMsg = "Are you sure you want to perform this action";
                confirmBtn = "Confirm";
        }
        props.closeModal();
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "fixed top-1/2 left-1/2 -translate-1/2 h-6/10 w-[95%] lg:h-3/10 lg:w-4/10 p-2 text-center bg-slate-50 border-2 border-blue-400 rounded-lg",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "absolute top-[10px] right-[10px] p-1 border-2 border-zinc-700 bg-zinc-200 rounded-full cursor-pointer",
                onClick: props.closeModal,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $79c0c02b40f78101$export$2e2bcd8739ae039), {
                    className: "w-[15px]"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "flex flex-col justify-around h-full",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "font-bold",
                        children: confirmMsg
                    }),
                    reasonTxt ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: style.reason,
                            children: reasonTxt
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "flex flex-row justify-center gap-8",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                "aria-label": confirmBtn,
                                className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, confirmBtnStyle),
                                onClick: ()=>handleAction(),
                                children: confirmBtn
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                "aria-label": "Cancel",
                                className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(style.button, cancelBtnStyle),
                                onClick: ()=>props.closeModal(),
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $d6dafcd4d41f63b9$export$2e2bcd8739ae039 = $d6dafcd4d41f63b9$var$ConfirmAction;


const $d43a348d2cd73662$var$root = document.getElementById("root");
function $d43a348d2cd73662$var$Game() {
    const dispatch = (0, $f30b917334351296$export$8ad76b76a4c905f8)();
    const roomCode = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.roomCode);
    const role = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.role);
    const player = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.player);
    const mainClaim = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.mainClaim);
    const reasonsToPlay = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.reasonsToPlay);
    const reasonInPlay = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.reasonInPlay);
    const commonGrounds = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.commonGrounds);
    const results = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.results);
    const [gameView, setGameView] = (0, $7fPBF.useState)('rtp');
    const [reasonToEdit, setReasonToEdit] = (0, $7fPBF.useState)(null);
    const [reasonToEditType, setReasonToEditType] = (0, $7fPBF.useState)(null);
    const [sortedReasonsToPlay, setSortedReasonsToPlay] = (0, $7fPBF.useState)([]);
    const [confirmActionData, setConfirmActionData] = (0, $7fPBF.useState)({});
    const [showConfirmActionModal, setShowConfirmActionModal] = (0, $7fPBF.useState)(false);
    const [showEditReasonModal, setShowEditReasonModal] = (0, $7fPBF.useState)(false);
    const phases = [
        {
            value: "land",
            text: "Land"
        },
        {
            value: "strawpoll",
            text: "Strawpoll"
        },
        {
            value: "saywhy",
            text: "SayWhy"
        },
        {
            value: "bout",
            text: "Bout"
        },
        {
            value: "endpoll",
            text: "Endpoll"
        }
    ];
    const phase = mainClaim ? mainClaim.phase : "";
    (0, $7fPBF.useEffect)(()=>{
        // Ensure the current user reasonsToPlay appear first on the list of reasonsToPlay
        const currentUserReasonToPlay = reasonsToPlay.find((reasonsToPlaySet)=>reasonsToPlaySet.id === player.id);
        if (currentUserReasonToPlay) {
            const sortedReasons = reasonsToPlay.filter((reasonToPlaySet)=>reasonToPlaySet.id !== currentUserReasonToPlay.id);
            sortedReasons.sort((a, b)=>{
                return a.id.localeCompare(b.id);
            });
            setSortedReasonsToPlay([
                currentUserReasonToPlay,
                ...sortedReasons
            ]);
        } else setSortedReasonsToPlay(reasonsToPlay);
    }, [
        reasonsToPlay,
        player
    ]);
    function handleConvincedVote() {
        const data = {
            roomCode: roomCode,
            playerId: player.id
        };
        dispatch((0, $a26b4bfe7e4a257c$export$1409869870cefe8c)(data));
    }
    function handleNotPersuadedVote() {
        const data = {
            roomCode: roomCode,
            playerId: player.id
        };
        dispatch((0, $a26b4bfe7e4a257c$export$445ea8ec1c323aba)(data));
    }
    function handleUpdateMainClaim(mainClaim) {
        dispatch((0, $a26b4bfe7e4a257c$export$c3397011ff8da5b2)({
            roomCode: roomCode,
            mainClaim: mainClaim
        }));
    }
    function sendNewReasonToPlay(reason) {
        dispatch((0, $a26b4bfe7e4a257c$export$e52e0a832b6f4c54)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            roomCode: roomCode,
            playerId: player.id
        }, reason)));
    }
    function moveToReasonInPlay(playerId, reasonId) {
        if (phase !== "bout") handleChangeGamePhase("bout");
        dispatch((0, $a26b4bfe7e4a257c$export$297493f7e4df20b6)({
            roomCode: roomCode,
            playerId: playerId,
            reasonId: reasonId
        }));
    }
    function updateReasonPriorities(reasonsToPlay, priorityList) {
        dispatch((0, $a26b4bfe7e4a257c$export$f4f7edb417abc381)(reasonsToPlay));
        dispatch((0, $a26b4bfe7e4a257c$export$f8ffaed46e4f3d35)({
            roomCode: roomCode,
            playerId: player.id,
            priorities: priorityList
        }));
    }
    function updateReasonsToPlay(playerId, reasonId, reason) {
        dispatch((0, $a26b4bfe7e4a257c$export$40981ebadab9551)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            roomCode: roomCode,
            playerId: playerId,
            reasonId: reasonId
        }, reason)));
    }
    function deleteReasonToPlay(reasonToDelete) {
        dispatch((0, $a26b4bfe7e4a257c$export$8ef4aa709fe98f79)({
            roomCode: roomCode,
            playerId: reasonToDelete.playerId,
            reasonId: reasonToDelete.reasonId
        }));
    }
    function updateReasonInPlay(playerId, reasonId, reason) {
        dispatch((0, $a26b4bfe7e4a257c$export$c71770823bb3a007)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            roomCode: roomCode,
            playerId: playerId,
            reasonId: reasonId
        }, reason)));
    }
    function openEditReasonForm(reasonType, playerId, reason) {
        let reasonToEdit;
        if (reasonType === "rip") reasonToEdit = reasonInPlay;
        else {
            const reasonToPlay = reasonsToPlay.find((reasonToPlay)=>reasonToPlay.id === playerId);
            reasonToEdit = reasonToPlay.reasons.find((element)=>element.id === reason.id);
        }
        setReasonToEdit(reasonToEdit);
        setReasonToEditType(reasonType);
        openEditReasonModal();
    }
    function removeReasonToEdit() {
        setReasonToEdit(null);
        setReasonToEditType(null);
    }
    function openEditReasonModal() {
        setShowEditReasonModal(true);
    }
    function closeEditReasonModal() {
        removeReasonToEdit();
        setShowEditReasonModal(false);
    }
    function openConfirmActionModal(actionData) {
        setConfirmActionData(actionData);
        setShowConfirmActionModal(true);
    }
    function closeConfirmActionModal() {
        setShowConfirmActionModal(false);
        setConfirmActionData({});
    }
    function handleEstablished(playerId) {
        dispatch((0, $a26b4bfe7e4a257c$export$cd96b8d333c4327e)({
            roomCode: roomCode,
            playerId: playerId
        }));
    }
    function handleContested(playerId) {
        dispatch((0, $a26b4bfe7e4a257c$export$9811782ba53e88cc)({
            roomCode: roomCode,
            playerId: playerId
        }));
    }
    function handleNonGermane(playerId) {
        dispatch((0, $a26b4bfe7e4a257c$export$dd04a03564e7fb1e)({
            roomCode: roomCode,
            playerId: playerId
        }));
    }
    function handleMoveRIPToCommonGround() {
        dispatch((0, $a26b4bfe7e4a257c$export$afc79c335028004)({
            roomCode: roomCode
        }));
    }
    function handleMoveRIPToDissensus() {
        dispatch((0, $a26b4bfe7e4a257c$export$91215eb6e724e412)({
            roomCode: roomCode
        }));
    }
    function handleUpdateCommonGroundPriorities(priorities) {
        dispatch((0, $a26b4bfe7e4a257c$export$89b83d026404717f)({
            roomCode: roomCode,
            priorities: priorities
        }));
    }
    function handleMoveCommonGroundToReasonInPlay(commonGroundId) {
        dispatch((0, $a26b4bfe7e4a257c$export$a140347ee0d8afff)({
            roomCode: roomCode,
            id: commonGroundId
        }));
    }
    function handleChangeGamePhase(value) {
        dispatch((0, $a26b4bfe7e4a257c$export$9c5fb575cf0490ae)({
            phase: value
        }));
        dispatch((0, $a26b4bfe7e4a257c$export$c810c224a21da2d4)({
            roomCode: roomCode,
            phase: value
        }));
    }
    function changeGameView(view) {
        setGameView(view);
    }
    function requestFinalResults() {
        return new Promise((resolve)=>{
            dispatch((0, $a26b4bfe7e4a257c$export$b0f71b4afa02d235)({
                roomCode: roomCode
            }));
            const interval = setInterval(()=>{
                if (results !== null) {
                    clearInterval(interval);
                    resolve(results);
                }
            }, 150);
        });
    }
    function handleGetFinalResults() {
        dispatch((0, $a26b4bfe7e4a257c$export$b0f71b4afa02d235)({
            roomCode: roomCode
        }));
    }
    async function handleDownloadResults() {
        const res = await requestFinalResults();
        const blob = new Blob([
            JSON.stringify(results, null, 4)
        ], {
            type: "application/json"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `tug-o-logic-${roomCode}.json`;
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "lg:relative lg:flex lg:min-h-screen",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "m-1 w-full",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eeeecb757944802c$export$2e2bcd8739ae039), {
                            role: role,
                            phases: phases,
                            roomCode: roomCode,
                            mainClaim: mainClaim,
                            player: player,
                            results: results,
                            handleUpdateMainClaim: handleUpdateMainClaim,
                            handleConvincedVote: handleConvincedVote,
                            handleNotPersuadedVote: handleNotPersuadedVote,
                            handleChangeGamePhase: handleChangeGamePhase,
                            handleGetFinalResults: handleGetFinalResults,
                            handleDownloadResults: handleDownloadResults
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $98e47cf1bb91cc57$export$2e2bcd8739ae039), {
                            gameView: gameView,
                            changeGameView: changeGameView
                        }),
                        gameView === "rtp" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a1822bcd7b64d6a$export$2e2bcd8739ae039), {
                            role: role,
                            playerId: player.id,
                            reasonsToPlay: sortedReasonsToPlay,
                            updateReasonPriorities: updateReasonPriorities,
                            openEditReasonForm: openEditReasonForm,
                            openEditReasonModal: openEditReasonModal,
                            openConfirmActionModal: openConfirmActionModal
                        }) : null,
                        gameView === "rip" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "flex flex-row w-full",
                            children: reasonInPlay && phase !== "endpoll" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f64ccf377a426465$export$2e2bcd8739ae039), {
                                        role: role,
                                        player: player,
                                        reason: reasonInPlay,
                                        openEditReasonForm: openEditReasonForm,
                                        handleEstablished: handleEstablished,
                                        handleContested: handleContested,
                                        handleNonGermane: handleNonGermane,
                                        openConfirmActionModal: openConfirmActionModal,
                                        handleMoveRIPToCommonGround: handleMoveRIPToCommonGround,
                                        handleMoveRIPToDissensus: handleMoveRIPToDissensus
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68b215d46e696e86$export$2e2bcd8739ae039), {
                                        established: reasonInPlay.established.length,
                                        contested: reasonInPlay.contested.length,
                                        nonGermane: reasonInPlay.nonGermane.length
                                    })
                                ]
                            }) : null
                        }) : null,
                        gameView === "cg" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0d84401b8c5934a0$export$2e2bcd8739ae039), {
                            role: role,
                            commonGrounds: commonGrounds,
                            updateCommonGroundPriorities: handleUpdateCommonGroundPriorities,
                            openConfirmActionModal: openConfirmActionModal
                        }) : null,
                        results !== null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $570b8124da093576$export$2e2bcd8739ae039), {
                            results: results
                        }) : null
                    ]
                })
            }),
            showEditReasonModal && /*#__PURE__*/ (0, $fw0lo.createPortal)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69ef09815302c66d$export$2e2bcd8739ae039), {
                player: player,
                reason: reasonToEdit,
                reasonType: reasonToEditType,
                updateReasonToPlay: updateReasonsToPlay,
                updateReasonInPlay: updateReasonInPlay,
                sendNewReasonToPlay: sendNewReasonToPlay,
                removeReasonToEdit: removeReasonToEdit,
                closeModal: closeEditReasonModal
            }), $d43a348d2cd73662$var$root),
            showConfirmActionModal && /*#__PURE__*/ (0, $fw0lo.createPortal)(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d6dafcd4d41f63b9$export$2e2bcd8739ae039), {
                action: confirmActionData,
                deleteReason: deleteReasonToPlay,
                moveToReasonInPlay: moveToReasonInPlay,
                handleMoveRIPToCommonGround: handleMoveRIPToCommonGround,
                handleMoveRIPToDissensus: handleMoveRIPToDissensus,
                handleMoveCommonGroundToReasonInPlay: handleMoveCommonGroundToReasonInPlay,
                closeModal: closeConfirmActionModal
            }), $d43a348d2cd73662$var$root)
        ]
    });
}
var $d43a348d2cd73662$export$2e2bcd8739ae039 = $d43a348d2cd73662$var$Game;



function $4a1d2e5a2b4744b2$var$Disconnected() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "flex flex-col justify-center items-center  h-screen bg-green-300",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "animate-spin rounded-full h-44 w-44 border-t-4 border-b-4 border-purple-600"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "font-bold text-5xl my-4",
                children: "404"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "pb-3 text-3xl",
                children: "Connecting to server..."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "pb-3 text-3xl",
                children: "Please ensure you have an Internet Connection"
            })
        ]
    });
}
var $4a1d2e5a2b4744b2$export$2e2bcd8739ae039 = $4a1d2e5a2b4744b2$var$Disconnected;


function $6aaba76260e26777$var$App() {
    const connectedToSocket = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.app.connectedToSocket);
    const roomCode = (0, $f30b917334351296$export$2105062e25df4afe)((state)=>state.game.roomCode);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: connectedToSocket ? roomCode ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d43a348d2cd73662$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2dcf4923aae645a4$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a1d2e5a2b4744b2$export$2e2bcd8739ae039), {})
    });
}
var $6aaba76260e26777$export$2e2bcd8739ae039 = $6aaba76260e26777$var$App;



const $5a0342ebaab9f2d7$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("lzq3r")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $5a0342ebaab9f2d7$export$2e2bcd8739ae039 = $5a0342ebaab9f2d7$var$reportWebVitals;


const $4a5191623062d5ff$var$container = document.getElementById('root');
if ($4a5191623062d5ff$var$container) {
    const root = (0, $f11ec298ebcca059$exports.createRoot)($4a5191623062d5ff$var$container);
    root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f30b917334351296$export$2881499e37b75b9a), {
        store: (0, $34dc202a50408efe$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aaba76260e26777$export$2e2bcd8739ae039), {})
    }));
} else throw new Error("Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $5a0342ebaab9f2d7$export$2e2bcd8739ae039)();


//# sourceMappingURL=public.25d6ad2d.js.map
